/* eslint-disable */
import React from 'react';
import { createRoot } from 'react-dom/client';
import {
    TextField,
    Calendar,
    DayOfWeek,
    Label as Label$1,
    ChoiceGroup
} from '@fluentui/react';
import markdown from 'markdown-it';

function _typeof(obj) {
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function (obj) {
            return typeof obj;
        };
    } else {
        _typeof = function (obj) {
            return obj &&
                typeof Symbol === 'function' &&
                obj.constructor === Symbol &&
                obj !== Symbol.prototype
                ? 'symbol'
                : typeof obj;
        };
    }

    return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }

    return obj;
}

function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }

    return keys;
}

function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};

        if (i % 2) {
            ownKeys(source, true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(
                target,
                Object.getOwnPropertyDescriptors(source)
            );
        } else {
            ownKeys(source).forEach(function (key) {
                Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                );
            });
        }
    }

    return target;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError(
            'Super expression must either be null or a function'
        );
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
    return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
    _setPrototypeOf =
        Object.setPrototypeOf ||
        function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };

    return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
        );
    }

    return self;
}

function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === 'object' || typeof call === 'function')) {
        return call;
    }

    return _assertThisInitialized(self);
}

function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null) break;
    }

    return object;
}

function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);

            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);

            if (desc.get) {
                return desc.get.call(receiver);
            }

            return desc.value;
        };
    }

    return _get(target, property, receiver || target);
}

var commonjsGlobal =
    typeof globalThis !== 'undefined'
        ? globalThis
        : typeof window !== 'undefined'
            ? window
            : typeof global !== 'undefined'
                ? global
                : typeof self !== 'undefined'
                    ? self
                    : {};

function unwrapExports(x) {
    return x &&
        x.__esModule &&
        Object.prototype.hasOwnProperty.call(x, 'default')
        ? x['default']
        : x;
}

function createCommonjsModule(fn, module) {
    return (
        (module = { exports: {} }), fn(module, module.exports), module.exports
    );
}

var enums = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, '__esModule', { value: true });
    var Size;
    (function (Size) {
        Size[(Size['Auto'] = 0)] = 'Auto';
        Size[(Size['Stretch'] = 1)] = 'Stretch';
        Size[(Size['Small'] = 2)] = 'Small';
        Size[(Size['Medium'] = 3)] = 'Medium';
        Size[(Size['Large'] = 4)] = 'Large';
    })((Size = exports.Size || (exports.Size = {})));
    var SizeUnit;
    (function (SizeUnit) {
        SizeUnit[(SizeUnit['Weight'] = 0)] = 'Weight';
        SizeUnit[(SizeUnit['Pixel'] = 1)] = 'Pixel';
    })((SizeUnit = exports.SizeUnit || (exports.SizeUnit = {})));
    var TextSize;
    (function (TextSize) {
        TextSize[(TextSize['Small'] = 0)] = 'Small';
        TextSize[(TextSize['Default'] = 1)] = 'Default';
        TextSize[(TextSize['Medium'] = 2)] = 'Medium';
        TextSize[(TextSize['Large'] = 3)] = 'Large';
        TextSize[(TextSize['ExtraLarge'] = 4)] = 'ExtraLarge';
    })((TextSize = exports.TextSize || (exports.TextSize = {})));
    var Spacing;
    (function (Spacing) {
        Spacing[(Spacing['None'] = 0)] = 'None';
        Spacing[(Spacing['Small'] = 1)] = 'Small';
        Spacing[(Spacing['Default'] = 2)] = 'Default';
        Spacing[(Spacing['Medium'] = 3)] = 'Medium';
        Spacing[(Spacing['Large'] = 4)] = 'Large';
        Spacing[(Spacing['ExtraLarge'] = 5)] = 'ExtraLarge';
        Spacing[(Spacing['Padding'] = 6)] = 'Padding';
    })((Spacing = exports.Spacing || (exports.Spacing = {})));
    var TextWeight;
    (function (TextWeight) {
        TextWeight[(TextWeight['Lighter'] = 0)] = 'Lighter';
        TextWeight[(TextWeight['Default'] = 1)] = 'Default';
        TextWeight[(TextWeight['Bolder'] = 2)] = 'Bolder';
    })((TextWeight = exports.TextWeight || (exports.TextWeight = {})));
    var TextColor;
    (function (TextColor) {
        TextColor[(TextColor['Default'] = 0)] = 'Default';
        TextColor[(TextColor['Dark'] = 1)] = 'Dark';
        TextColor[(TextColor['Light'] = 2)] = 'Light';
        TextColor[(TextColor['Accent'] = 3)] = 'Accent';
        TextColor[(TextColor['Good'] = 4)] = 'Good';
        TextColor[(TextColor['Warning'] = 5)] = 'Warning';
        TextColor[(TextColor['Attention'] = 6)] = 'Attention';
    })((TextColor = exports.TextColor || (exports.TextColor = {})));
    var HorizontalAlignment;
    (function (HorizontalAlignment) {
        HorizontalAlignment[(HorizontalAlignment['Left'] = 0)] = 'Left';
        HorizontalAlignment[(HorizontalAlignment['Center'] = 1)] = 'Center';
        HorizontalAlignment[(HorizontalAlignment['Right'] = 2)] = 'Right';
    })(
        (HorizontalAlignment =
            exports.HorizontalAlignment || (exports.HorizontalAlignment = {}))
    );
    var VerticalAlignment;
    (function (VerticalAlignment) {
        VerticalAlignment[(VerticalAlignment['Top'] = 0)] = 'Top';
        VerticalAlignment[(VerticalAlignment['Center'] = 1)] = 'Center';
        VerticalAlignment[(VerticalAlignment['Bottom'] = 2)] = 'Bottom';
    })(
        (VerticalAlignment =
            exports.VerticalAlignment || (exports.VerticalAlignment = {}))
    );
    var ActionAlignment;
    (function (ActionAlignment) {
        ActionAlignment[(ActionAlignment['Left'] = 0)] = 'Left';
        ActionAlignment[(ActionAlignment['Center'] = 1)] = 'Center';
        ActionAlignment[(ActionAlignment['Right'] = 2)] = 'Right';
        ActionAlignment[(ActionAlignment['Stretch'] = 3)] = 'Stretch';
    })(
        (ActionAlignment =
            exports.ActionAlignment || (exports.ActionAlignment = {}))
    );
    var ImageStyle;
    (function (ImageStyle) {
        ImageStyle[(ImageStyle['Default'] = 0)] = 'Default';
        ImageStyle[(ImageStyle['Person'] = 1)] = 'Person';
    })((ImageStyle = exports.ImageStyle || (exports.ImageStyle = {})));
    var ShowCardActionMode;
    (function (ShowCardActionMode) {
        ShowCardActionMode[(ShowCardActionMode['Inline'] = 0)] = 'Inline';
        ShowCardActionMode[(ShowCardActionMode['Popup'] = 1)] = 'Popup';
    })(
        (ShowCardActionMode =
            exports.ShowCardActionMode || (exports.ShowCardActionMode = {}))
    );
    var Orientation;
    (function (Orientation) {
        Orientation[(Orientation['Horizontal'] = 0)] = 'Horizontal';
        Orientation[(Orientation['Vertical'] = 1)] = 'Vertical';
    })((Orientation = exports.Orientation || (exports.Orientation = {})));
    var BackgroundImageMode;
    (function (BackgroundImageMode) {
        BackgroundImageMode[(BackgroundImageMode['Stretch'] = 0)] = 'Stretch';
        BackgroundImageMode[(BackgroundImageMode['RepeatHorizontally'] = 1)] =
            'RepeatHorizontally';
        BackgroundImageMode[(BackgroundImageMode['RepeatVertically'] = 2)] =
            'RepeatVertically';
        BackgroundImageMode[(BackgroundImageMode['Repeat'] = 3)] = 'Repeat';
    })(
        (BackgroundImageMode =
            exports.BackgroundImageMode || (exports.BackgroundImageMode = {}))
    );
    var ActionIconPlacement;
    (function (ActionIconPlacement) {
        ActionIconPlacement[(ActionIconPlacement['LeftOfTitle'] = 0)] =
            'LeftOfTitle';
        ActionIconPlacement[(ActionIconPlacement['AboveTitle'] = 1)] =
            'AboveTitle';
    })(
        (ActionIconPlacement =
            exports.ActionIconPlacement || (exports.ActionIconPlacement = {}))
    );
    var InputTextStyle;
    (function (InputTextStyle) {
        InputTextStyle[(InputTextStyle['Text'] = 0)] = 'Text';
        InputTextStyle[(InputTextStyle['Tel'] = 1)] = 'Tel';
        InputTextStyle[(InputTextStyle['Url'] = 2)] = 'Url';
        InputTextStyle[(InputTextStyle['Email'] = 3)] = 'Email';
    })(
        (InputTextStyle =
            exports.InputTextStyle || (exports.InputTextStyle = {}))
    );
    /*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.
*/
    var ContainerStyle = /** @class */ (function () {
        function ContainerStyle() { }
        ContainerStyle.Default = 'default';
        ContainerStyle.Emphasis = 'emphasis';
        return ContainerStyle;
    })();
    exports.ContainerStyle = ContainerStyle;
    var ValidationError;
    (function (ValidationError) {
        ValidationError[(ValidationError['Hint'] = 0)] = 'Hint';
        ValidationError[(ValidationError['ActionTypeNotAllowed'] = 1)] =
            'ActionTypeNotAllowed';
        ValidationError[(ValidationError['CollectionCantBeEmpty'] = 2)] =
            'CollectionCantBeEmpty';
        ValidationError[(ValidationError['Deprecated'] = 3)] = 'Deprecated';
        ValidationError[(ValidationError['ElementTypeNotAllowed'] = 4)] =
            'ElementTypeNotAllowed';
        ValidationError[(ValidationError['InteractivityNotAllowed'] = 5)] =
            'InteractivityNotAllowed';
        ValidationError[(ValidationError['InvalidPropertyValue'] = 6)] =
            'InvalidPropertyValue';
        ValidationError[(ValidationError['MissingCardType'] = 7)] =
            'MissingCardType';
        ValidationError[(ValidationError['PropertyCantBeNull'] = 8)] =
            'PropertyCantBeNull';
        ValidationError[(ValidationError['TooManyActions'] = 9)] =
            'TooManyActions';
        ValidationError[(ValidationError['UnknownActionType'] = 10)] =
            'UnknownActionType';
        ValidationError[(ValidationError['UnknownElementType'] = 11)] =
            'UnknownElementType';
        ValidationError[(ValidationError['UnsupportedCardVersion'] = 12)] =
            'UnsupportedCardVersion';
    })(
        (ValidationError =
            exports.ValidationError || (exports.ValidationError = {}))
    );
    var ContainerFitStatus;
    (function (ContainerFitStatus) {
        ContainerFitStatus[(ContainerFitStatus['FullyInContainer'] = 0)] =
            'FullyInContainer';
        ContainerFitStatus[(ContainerFitStatus['Overflowing'] = 1)] =
            'Overflowing';
        ContainerFitStatus[(ContainerFitStatus['FullyOutOfContainer'] = 2)] =
            'FullyOutOfContainer';
    })(
        (ContainerFitStatus =
            exports.ContainerFitStatus || (exports.ContainerFitStatus = {}))
    );
});

unwrapExports(enums);
var enums_1 = enums.Size;
var enums_2 = enums.SizeUnit;
var enums_3 = enums.TextSize;
var enums_4 = enums.Spacing;
var enums_5 = enums.TextWeight;
var enums_6 = enums.TextColor;
var enums_7 = enums.HorizontalAlignment;
var enums_8 = enums.VerticalAlignment;
var enums_9 = enums.ActionAlignment;
var enums_10 = enums.ImageStyle;
var enums_11 = enums.ShowCardActionMode;
var enums_12 = enums.Orientation;
var enums_13 = enums.BackgroundImageMode;
var enums_14 = enums.ActionIconPlacement;
var enums_15 = enums.InputTextStyle;
var enums_16 = enums.ContainerStyle;
var enums_17 = enums.ValidationError;
var enums_18 = enums.ContainerFitStatus;

var utils = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, '__esModule', { value: true });

    /**
     * Fast UUID generator, RFC4122 version 4 compliant.
     * @author Jeff Ward (jcward.com).
     * @license MIT license
     * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
     **/
    var UUID = /** @class */ (function () {
        function UUID() { }
        UUID.generate = function () {
            var d0 = (Math.random() * 0xffffffff) | 0;
            var d1 = (Math.random() * 0xffffffff) | 0;
            var d2 = (Math.random() * 0xffffffff) | 0;
            var d3 = (Math.random() * 0xffffffff) | 0;
            return (
                UUID.lut[d0 & 0xff] +
                UUID.lut[(d0 >> 8) & 0xff] +
                UUID.lut[(d0 >> 16) & 0xff] +
                UUID.lut[(d0 >> 24) & 0xff] +
                '-' +
                UUID.lut[d1 & 0xff] +
                UUID.lut[(d1 >> 8) & 0xff] +
                '-' +
                UUID.lut[((d1 >> 16) & 0x0f) | 0x40] +
                UUID.lut[(d1 >> 24) & 0xff] +
                '-' +
                UUID.lut[(d2 & 0x3f) | 0x80] +
                UUID.lut[(d2 >> 8) & 0xff] +
                '-' +
                UUID.lut[(d2 >> 16) & 0xff] +
                UUID.lut[(d2 >> 24) & 0xff] +
                UUID.lut[d3 & 0xff] +
                UUID.lut[(d3 >> 8) & 0xff] +
                UUID.lut[(d3 >> 16) & 0xff] +
                UUID.lut[(d3 >> 24) & 0xff]
            );
        };
        UUID.initialize = function () {
            for (var i = 0; i < 256; i++) {
                UUID.lut[i] = (i < 16 ? '0' : '') + i.toString(16);
            }
        };
        UUID.lut = [];
        return UUID;
    })();
    exports.UUID = UUID;
    UUID.initialize();
    exports.ContentTypes = {
        applicationJson: 'application/json',
        applicationXWwwFormUrlencoded: 'application/x-www-form-urlencoded'
    };
    function getValueOrDefault(obj, defaultValue) {
        return obj ? obj : defaultValue;
    }
    exports.getValueOrDefault = getValueOrDefault;
    function isNullOrEmpty(value) {
        return value === undefined || value === null || value === '';
    }
    exports.isNullOrEmpty = isNullOrEmpty;
    function appendChild(node, child) {
        if (child != null && child != undefined) {
            node.appendChild(child);
        }
    }
    exports.appendChild = appendChild;
    function setProperty(target, propertyName, propertyValue, defaultValue) {
        if (defaultValue === void 0) {
            defaultValue = undefined;
        }
        if (
            propertyValue &&
            (!defaultValue || defaultValue !== propertyValue)
        ) {
            target[propertyName] = propertyValue;
        }
    }
    exports.setProperty = setProperty;
    function setEnumProperty(
        enumType,
        target,
        propertyName,
        propertyValue,
        defaultValue
    ) {
        if (defaultValue === undefined || defaultValue !== propertyValue) {
            target[propertyName] = enumType[propertyValue];
        }
    }
    exports.setEnumProperty = setEnumProperty;
    function getEnumValueOrDefault(targetEnum, name, defaultValue) {
        if (isNullOrEmpty(name)) {
            return defaultValue;
        }
        for (var key in targetEnum) {
            var isValueProperty = parseInt(key, 10) >= 0;
            if (isValueProperty) {
                var value = targetEnum[key];
                if (value && typeof value === 'string') {
                    if (value.toLowerCase() === name.toLowerCase()) {
                        return parseInt(key, 10);
                    }
                }
            }
        }
        return defaultValue;
    }
    exports.getEnumValueOrDefault = getEnumValueOrDefault;
    function parseHostConfigEnum(targetEnum, value, defaultValue) {
        if (typeof value === 'string') {
            return getEnumValueOrDefault(targetEnum, value, defaultValue);
        } else if (typeof value === 'number') {
            return getValueOrDefault(value, defaultValue);
        } else {
            return defaultValue;
        }
    }
    exports.parseHostConfigEnum = parseHostConfigEnum;
    function renderSeparation(separationDefinition, orientation) {
        if (
            separationDefinition.spacing > 0 ||
            separationDefinition.lineThickness > 0
        ) {
            var separator = document.createElement('div');
            if (orientation == enums.Orientation.Horizontal) {
                if (separationDefinition.lineThickness) {
                    separator.style.marginTop =
                        separationDefinition.spacing / 2 + 'px';
                    separator.style.paddingTop =
                        separationDefinition.spacing / 2 + 'px';
                    separator.style.borderTop =
                        separationDefinition.lineThickness +
                        'px solid ' +
                        stringToCssColor(separationDefinition.lineColor);
                } else {
                    separator.style.height =
                        separationDefinition.spacing + 'px';
                }
            } else {
                if (separationDefinition.lineThickness) {
                    separator.style.marginLeft =
                        separationDefinition.spacing / 2 + 'px';
                    separator.style.paddingLeft =
                        separationDefinition.spacing / 2 + 'px';
                    separator.style.borderLeft =
                        separationDefinition.lineThickness +
                        'px solid ' +
                        stringToCssColor(separationDefinition.lineColor);
                } else {
                    separator.style.width = separationDefinition.spacing + 'px';
                }
            }
            separator.style.overflow = 'hidden';
            return separator;
        } else {
            return null;
        }
    }
    exports.renderSeparation = renderSeparation;
    function stringToCssColor(color) {
        var regEx = /#([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/gi;
        var matches = regEx.exec(color);
        if (matches && matches[4]) {
            var a = parseInt(matches[1], 16) / 255;
            var r = parseInt(matches[2], 16);
            var g = parseInt(matches[3], 16);
            var b = parseInt(matches[4], 16);
            return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
        } else {
            return color;
        }
    }
    exports.stringToCssColor = stringToCssColor;
    var StringWithSubstitutions = /** @class */ (function () {
        function StringWithSubstitutions() {
            this._isProcessed = false;
            this._original = null;
            this._processed = null;
        }
        StringWithSubstitutions.prototype.substituteInputValues = function (
            inputs,
            contentType
        ) {
            this._processed = this._original;
            var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
            var matches;
            while ((matches = regEx.exec(this._original)) != null) {
                var matchedInput = null;
                for (var i = 0; i < inputs.length; i++) {
                    if (
                        inputs[i].id.toLowerCase() == matches[1].toLowerCase()
                    ) {
                        matchedInput = inputs[i];
                        break;
                    }
                }
                if (matchedInput) {
                    var valueForReplace = '';
                    if (matchedInput.value) {
                        valueForReplace = matchedInput.value;
                    }
                    if (contentType === exports.ContentTypes.applicationJson) {
                        valueForReplace = JSON.stringify(valueForReplace);
                        valueForReplace = valueForReplace.slice(1, -1);
                    } else if (
                        contentType ===
                        exports.ContentTypes.applicationXWwwFormUrlencoded
                    ) {
                        valueForReplace = encodeURIComponent(valueForReplace);
                    }
                    this._processed = this._processed.replace(
                        matches[0],
                        valueForReplace
                    );
                }
            }
            this._isProcessed = true;
        };
        StringWithSubstitutions.prototype.getOriginal = function () {
            return this._original;
        };
        StringWithSubstitutions.prototype.get = function () {
            if (!this._isProcessed) {
                return this._original;
            } else {
                return this._processed;
            }
        };
        StringWithSubstitutions.prototype.set = function (value) {
            this._original = value;
            this._isProcessed = false;
        };
        return StringWithSubstitutions;
    })();
    exports.StringWithSubstitutions = StringWithSubstitutions;
    var SizeAndUnit = /** @class */ (function () {
        function SizeAndUnit(physicalSize, unit) {
            this.physicalSize = physicalSize;
            this.unit = unit;
        }
        SizeAndUnit.parse = function (input) {
            var result = new SizeAndUnit(0, enums.SizeUnit.Weight);
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            if (matches && matches.length >= 2) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length == 3) {
                    if (matches[2] == 'px') {
                        result.unit = enums.SizeUnit.Pixel;
                    }
                }
                return result;
            }
            throw new Error('Invalid size: ' + input);
        };
        return SizeAndUnit;
    })();
    exports.SizeAndUnit = SizeAndUnit;
    function truncate(element, maxHeight, lineHeight) {
        var fits = function () {
            // Allow a one pixel overflow to account for rounding differences
            // between browsers
            return maxHeight - element.scrollHeight >= -1.0;
        };
        if (fits()) return;
        var fullText = element.innerHTML;
        var truncateAt = function (idx) {
            element.innerHTML = fullText.substring(0, idx) + '...';
        };
        var breakableIndices = findBreakableIndices(fullText);
        var lo = 0;
        var hi = breakableIndices.length;
        var bestBreakIdx = 0;
        // Do a binary search for the longest string that fits
        while (lo < hi) {
            var mid = Math.floor((lo + hi) / 2);
            truncateAt(breakableIndices[mid]);
            if (fits()) {
                bestBreakIdx = breakableIndices[mid];
                lo = mid + 1;
            } else {
                hi = mid;
            }
        }
        truncateAt(bestBreakIdx);
        // If we have extra room, try to expand the string letter by letter
        // (covers the case where we have to break in the middle of a long word)
        if (
            lineHeight &&
            maxHeight - element.scrollHeight >= lineHeight - 1.0
        ) {
            var idx = findNextCharacter(fullText, bestBreakIdx);
            while (idx < fullText.length) {
                truncateAt(idx);
                if (fits()) {
                    bestBreakIdx = idx;
                    idx = findNextCharacter(fullText, idx);
                } else {
                    break;
                }
            }
            truncateAt(bestBreakIdx);
        }
    }
    exports.truncate = truncate;
    function findBreakableIndices(html) {
        var results = [];
        var idx = findNextCharacter(html, -1);
        while (idx < html.length) {
            if (html[idx] == ' ') {
                results.push(idx);
            }
            idx = findNextCharacter(html, idx);
        }
        return results;
    }
    function findNextCharacter(html, currIdx) {
        currIdx += 1;
        // If we found the start of an HTML tag, keep advancing until we get
        // past it, so we don't end up truncating in the middle of the tag
        while (currIdx < html.length && html[currIdx] == '<') {
            while (currIdx < html.length && html[currIdx++] != '>');
        }
        return currIdx;
    }
    function getFitStatus(element, containerEnd) {
        var start = element.offsetTop;
        var end = start + element.clientHeight;
        if (end <= containerEnd) {
            return enums.ContainerFitStatus.FullyInContainer;
        } else if (start < containerEnd) {
            return enums.ContainerFitStatus.Overflowing;
        } else {
            return enums.ContainerFitStatus.FullyOutOfContainer;
        }
    }
    exports.getFitStatus = getFitStatus;
});

unwrapExports(utils);
var utils_1 = utils.UUID;
var utils_2 = utils.ContentTypes;
var utils_3 = utils.getValueOrDefault;
var utils_4 = utils.isNullOrEmpty;
var utils_5 = utils.appendChild;
var utils_6 = utils.setProperty;
var utils_7 = utils.setEnumProperty;
var utils_8 = utils.getEnumValueOrDefault;
var utils_9 = utils.parseHostConfigEnum;
var utils_10 = utils.renderSeparation;
var utils_11 = utils.stringToCssColor;
var utils_12 = utils.StringWithSubstitutions;
var utils_13 = utils.SizeAndUnit;
var utils_14 = utils.truncate;
var utils_15 = utils.getFitStatus;

var hostConfig = createCommonjsModule(function (module, exports) {
    var __extends =
        (commonjsGlobal && commonjsGlobal.__extends) ||
        (function () {
            var extendStatics = function (d, b) {
                extendStatics =
                    Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array &&
                        function (d, b) {
                            d.__proto__ = b;
                        }) ||
                    function (d, b) {
                        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                return extendStatics(d, b);
            };
            return function (d, b) {
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype =
                    b === null
                        ? Object.create(b)
                        : ((__.prototype = b.prototype), new __());
            };
        })();
    Object.defineProperty(exports, '__esModule', { value: true });

    var TextColorDefinition = /** @class */ (function () {
        function TextColorDefinition(obj) {
            this.default = '#000000';
            this.subtle = '#666666';
            if (obj) {
                this.default = obj['default'] || this.default;
                this.subtle = obj['subtle'] || this.subtle;
            }
        }
        return TextColorDefinition;
    })();
    exports.TextColorDefinition = TextColorDefinition;
    var AdaptiveCardConfig = /** @class */ (function () {
        function AdaptiveCardConfig(obj) {
            this.allowCustomStyle = false;
            if (obj) {
                this.allowCustomStyle =
                    obj['allowCustomStyle'] || this.allowCustomStyle;
            }
        }
        return AdaptiveCardConfig;
    })();
    exports.AdaptiveCardConfig = AdaptiveCardConfig;
    var ImageSetConfig = /** @class */ (function () {
        function ImageSetConfig(obj) {
            this.imageSize = enums.Size.Medium;
            this.maxImageHeight = 100;
            if (obj) {
                this.imageSize =
                    obj['imageSize'] != null
                        ? obj['imageSize']
                        : this.imageSize;
                this.maxImageHeight = utils.getValueOrDefault(
                    obj['maxImageHeight'],
                    100
                );
            }
        }
        ImageSetConfig.prototype.toJSON = function () {
            return {
                imageSize: enums.Size[this.imageSize],
                maxImageHeight: this.maxImageHeight
            };
        };
        return ImageSetConfig;
    })();
    exports.ImageSetConfig = ImageSetConfig;
    var MediaConfig = /** @class */ (function () {
        function MediaConfig(obj) {
            this.allowInlinePlayback = true;
            if (obj) {
                this.defaultPoster = obj['defaultPoster'];
                this.allowInlinePlayback =
                    obj['allowInlinePlayback'] || this.allowInlinePlayback;
            }
        }
        MediaConfig.prototype.toJSON = function () {
            return {
                defaultPoster: this.defaultPoster,
                allowInlinePlayback: this.allowInlinePlayback
            };
        };
        return MediaConfig;
    })();
    exports.MediaConfig = MediaConfig;
    var FactTextDefinition = /** @class */ (function () {
        function FactTextDefinition(obj) {
            this.size = enums.TextSize.Default;
            this.color = enums.TextColor.Default;
            this.isSubtle = false;
            this.weight = enums.TextWeight.Default;
            this.wrap = true;
            if (obj) {
                this.size = utils.parseHostConfigEnum(
                    enums.TextSize,
                    obj['size'],
                    enums.TextSize.Default
                );
                this.color = utils.parseHostConfigEnum(
                    enums.TextColor,
                    obj['color'],
                    enums.TextColor.Default
                );
                this.isSubtle = obj['isSubtle'] || this.isSubtle;
                this.weight = utils.parseHostConfigEnum(
                    enums.TextWeight,
                    obj['weight'],
                    this.getDefaultWeight()
                );
                this.wrap = obj['wrap'] != null ? obj['wrap'] : this.wrap;
            }
        }
        FactTextDefinition.prototype.getDefaultWeight = function () {
            return enums.TextWeight.Default;
        };
        FactTextDefinition.prototype.toJSON = function () {
            return {
                size: enums.TextSize[this.size],
                color: enums.TextColor[this.color],
                isSubtle: this.isSubtle,
                weight: enums.TextWeight[this.weight],
                wrap: this.wrap
            };
        };
        return FactTextDefinition;
    })();
    exports.FactTextDefinition = FactTextDefinition;
    var FactTitleDefinition = /** @class */ (function (_super) {
        __extends(FactTitleDefinition, _super);
        function FactTitleDefinition(obj) {
            var _this = _super.call(this, obj) || this;
            _this.maxWidth = 150;
            _this.weight = enums.TextWeight.Bolder;
            if (obj) {
                _this.maxWidth =
                    obj['maxWidth'] != null ? obj['maxWidth'] : _this.maxWidth;
                _this.weight = utils.parseHostConfigEnum(
                    enums.TextWeight,
                    obj['weight'],
                    enums.TextWeight.Bolder
                );
            }
            return _this;
        }
        FactTitleDefinition.prototype.getDefaultWeight = function () {
            return enums.TextWeight.Bolder;
        };
        return FactTitleDefinition;
    })(FactTextDefinition);
    exports.FactTitleDefinition = FactTitleDefinition;
    var FactSetConfig = /** @class */ (function () {
        function FactSetConfig(obj) {
            this.title = new FactTitleDefinition();
            this.value = new FactTextDefinition();
            this.spacing = 10;
            if (obj) {
                this.title = new FactTitleDefinition(obj['title']);
                this.value = new FactTextDefinition(obj['value']);
                this.spacing =
                    obj.spacing && obj.spacing != null
                        ? obj.spacing && obj.spacing
                        : this.spacing;
            }
        }
        return FactSetConfig;
    })();
    exports.FactSetConfig = FactSetConfig;
    var ShowCardActionConfig = /** @class */ (function () {
        function ShowCardActionConfig(obj) {
            this.actionMode = enums.ShowCardActionMode.Inline;
            this.inlineTopMargin = 16;
            this.style = enums.ContainerStyle.Emphasis;
            if (obj) {
                this.actionMode = utils.parseHostConfigEnum(
                    enums.ShowCardActionMode,
                    obj['actionMode'],
                    enums.ShowCardActionMode.Inline
                );
                this.inlineTopMargin =
                    obj['inlineTopMargin'] != null
                        ? obj['inlineTopMargin']
                        : this.inlineTopMargin;
                this.style =
                    obj['style'] && typeof obj['style'] === 'string'
                        ? obj['style']
                        : enums.ContainerStyle.Emphasis;
            }
        }
        ShowCardActionConfig.prototype.toJSON = function () {
            return {
                actionMode: enums.ShowCardActionMode[this.actionMode],
                inlineTopMargin: this.inlineTopMargin,
                style: this.style
            };
        };
        return ShowCardActionConfig;
    })();
    exports.ShowCardActionConfig = ShowCardActionConfig;
    var ActionsConfig = /** @class */ (function () {
        function ActionsConfig(obj) {
            this.maxActions = 5;
            this.spacing = enums.Spacing.Default;
            this.buttonSpacing = 20;
            this.showCard = new ShowCardActionConfig();
            this.preExpandSingleShowCardAction = false;
            this.actionsOrientation = enums.Orientation.Horizontal;
            this.actionAlignment = enums.ActionAlignment.Left;
            this.iconPlacement = enums.ActionIconPlacement.LeftOfTitle;
            this.allowTitleToWrap = false;
            this.iconSize = 24;
            if (obj) {
                this.maxActions =
                    obj['maxActions'] != null
                        ? obj['maxActions']
                        : this.maxActions;
                this.spacing = utils.parseHostConfigEnum(
                    enums.Spacing,
                    obj.spacing && obj.spacing,
                    enums.Spacing.Default
                );
                this.buttonSpacing =
                    obj['buttonSpacing'] != null
                        ? obj['buttonSpacing']
                        : this.buttonSpacing;
                this.showCard = new ShowCardActionConfig(obj['showCard']);
                this.preExpandSingleShowCardAction = utils.getValueOrDefault(
                    obj['preExpandSingleShowCardAction'],
                    false
                );
                this.actionsOrientation = utils.parseHostConfigEnum(
                    enums.Orientation,
                    obj['actionsOrientation'],
                    enums.Orientation.Horizontal
                );
                this.actionAlignment = utils.parseHostConfigEnum(
                    enums.ActionAlignment,
                    obj['actionAlignment'],
                    enums.ActionAlignment.Left
                );
                this.iconPlacement = utils.parseHostConfigEnum(
                    enums.ActionIconPlacement,
                    obj['iconPlacement'],
                    enums.ActionIconPlacement.LeftOfTitle
                );
                this.allowTitleToWrap =
                    obj['allowTitleToWrap'] != null
                        ? obj['allowTitleToWrap']
                        : this.allowTitleToWrap;
                try {
                    var sizeAndUnit = utils.SizeAndUnit.parse(obj['iconSize']);
                    if (sizeAndUnit.unit == enums.SizeUnit.Pixel) {
                        this.iconSize = sizeAndUnit.physicalSize;
                    }
                } catch (e) {
                    // Swallow this, keep default icon size
                }
            }
        }
        ActionsConfig.prototype.toJSON = function () {
            return {
                maxActions: this.maxActions,
                spacing: enums.Spacing[this.spacing],
                buttonSpacing: this.buttonSpacing,
                showCard: this.showCard,
                preExpandSingleShowCardAction: this
                    .preExpandSingleShowCardAction,
                actionsOrientation: enums.Orientation[this.actionsOrientation],
                actionAlignment: enums.ActionAlignment[this.actionAlignment]
            };
        };
        return ActionsConfig;
    })();
    exports.ActionsConfig = ActionsConfig;
    var ContainerStyleDefinition = /** @class */ (function () {
        function ContainerStyleDefinition(obj) {
            this.foregroundColors = {
                default: new TextColorDefinition(),
                dark: new TextColorDefinition(),
                light: new TextColorDefinition(),
                accent: new TextColorDefinition(),
                good: new TextColorDefinition(),
                warning: new TextColorDefinition(),
                attention: new TextColorDefinition()
            };
            this.parse(obj);
        }
        ContainerStyleDefinition.prototype.getTextColorDefinitionOrDefault = function (
            obj,
            defaultValue
        ) {
            return new TextColorDefinition(obj ? obj : defaultValue);
        };
        ContainerStyleDefinition.prototype.parse = function (obj) {
            if (obj) {
                this.backgroundColor = obj['backgroundColor'];
                if (obj.foregroundColors) {
                    this.foregroundColors.default = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['default'],
                        { default: '#333333', subtle: '#EE333333' }
                    );
                    this.foregroundColors.dark = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['dark'],
                        { default: '#000000', subtle: '#66000000' }
                    );
                    this.foregroundColors.light = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['light'],
                        { default: '#FFFFFF', subtle: '#33000000' }
                    );
                    this.foregroundColors.accent = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['accent'],
                        { default: '#2E89FC', subtle: '#882E89FC' }
                    );
                    this.foregroundColors.good = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['good'],
                        { default: '#54A254', subtle: '#DD54A254' }
                    );
                    this.foregroundColors.warning = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['warning'],
                        { default: '#E69500', subtle: '#DDE69500' }
                    );
                    this.foregroundColors.attention = this.getTextColorDefinitionOrDefault(
                        obj.foregroundColors['attention'],
                        { default: '#CC3300', subtle: '#DDCC3300' }
                    );
                }
                this.highlightBackgroundColor = obj['highlightBackgroundColor'];
                this.highlightForegroundColor = obj['highlightForegroundColor'];
            }
        };
        Object.defineProperty(ContainerStyleDefinition.prototype, 'isBuiltIn', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        return ContainerStyleDefinition;
    })();
    exports.ContainerStyleDefinition = ContainerStyleDefinition;
    var BuiltInContainerStyleDefinition = /** @class */ (function (_super) {
        __extends(BuiltInContainerStyleDefinition, _super);
        function BuiltInContainerStyleDefinition() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        Object.defineProperty(
            BuiltInContainerStyleDefinition.prototype,
            'isBuiltIn',
            {
                get: function () {
                    return true;
                },
                enumerable: true,
                configurable: true
            }
        );
        return BuiltInContainerStyleDefinition;
    })(ContainerStyleDefinition);
    var ContainerStyleSet = /** @class */ (function () {
        function ContainerStyleSet(obj) {
            this._allStyles = {};
            this._allStyles[
                enums.ContainerStyle.Default
            ] = new BuiltInContainerStyleDefinition();
            this._allStyles[
                enums.ContainerStyle.Emphasis
            ] = new BuiltInContainerStyleDefinition();
            if (obj) {
                this._allStyles[enums.ContainerStyle.Default].parse(
                    obj[enums.ContainerStyle.Default]
                );
                this._allStyles[enums.ContainerStyle.Emphasis].parse(
                    obj[enums.ContainerStyle.Emphasis]
                );
                var customStyleArray = obj['customStyles'];
                if (customStyleArray && Array.isArray(customStyleArray)) {
                    for (
                        var _i = 0, customStyleArray_1 = customStyleArray;
                        _i < customStyleArray_1.length;
                        _i++
                    ) {
                        var customStyle = customStyleArray_1[_i];
                        if (customStyle) {
                            var styleName = customStyle['name'];
                            if (styleName && typeof styleName === 'string') {
                                if (this._allStyles.hasOwnProperty(styleName)) {
                                    this._allStyles[styleName].parse(
                                        customStyle['style']
                                    );
                                } else {
                                    this._allStyles[
                                        styleName
                                    ] = new ContainerStyleDefinition(
                                        customStyle['style']
                                    );
                                }
                            }
                        }
                    }
                }
            }
        }
        ContainerStyleSet.prototype.toJSON = function () {
            var _this = this;
            var customStyleArray = [];
            Object.keys(this._allStyles).forEach(function (key) {
                if (!_this._allStyles[key].isBuiltIn) {
                    customStyleArray.push({
                        name: key,
                        style: _this._allStyles[key]
                    });
                }
            });
            var result = {
                default: this.default,
                emphasis: this.emphasis
            };
            if (customStyleArray.length > 0) {
                result.customStyles = customStyleArray;
            }
            return result;
        };
        ContainerStyleSet.prototype.getStyleByName = function (
            name,
            defaultValue
        ) {
            if (defaultValue === void 0) {
                defaultValue = null;
            }
            return this._allStyles.hasOwnProperty(name)
                ? this._allStyles[name]
                : defaultValue;
        };
        Object.defineProperty(ContainerStyleSet.prototype, 'default', {
            get: function () {
                return this._allStyles[enums.ContainerStyle.Default];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ContainerStyleSet.prototype, 'emphasis', {
            get: function () {
                return this._allStyles[enums.ContainerStyle.Emphasis];
            },
            enumerable: true,
            configurable: true
        });
        return ContainerStyleSet;
    })();
    exports.ContainerStyleSet = ContainerStyleSet;
    var Version = /** @class */ (function () {
        function Version(major, minor) {
            if (major === void 0) {
                major = 1;
            }
            if (minor === void 0) {
                minor = 1;
            }
            this._isValid = true;
            this._major = major;
            this._minor = minor;
        }
        Version.parse = function (versionString, errors) {
            if (!versionString) {
                return null;
            }
            var result = new Version();
            result._versionString = versionString;
            var regEx = /(\d+).(\d+)/gi;
            var matches = regEx.exec(versionString);
            if (matches != null && matches.length == 3) {
                result._major = parseInt(matches[1]);
                result._minor = parseInt(matches[2]);
            } else {
                result._isValid = false;
            }
            if (!result._isValid && errors) {
                errors.push({
                    error: enums.ValidationError.InvalidPropertyValue,
                    message: 'Invalid version string: ' + result._versionString
                });
            }
            return result;
        };
        Version.prototype.toString = function () {
            return !this._isValid
                ? this._versionString
                : this._major + '.' + this._minor;
        };
        Version.prototype.compareTo = function (otherVersion) {
            if (!this.isValid || !otherVersion.isValid) {
                throw new Error('Cannot compare invalid version.');
            }
            if (this.major > otherVersion.major) {
                return 1;
            } else if (this.major < otherVersion.major) {
                return -1;
            } else if (this.minor > otherVersion.minor) {
                return 1;
            } else if (this.minor < otherVersion.minor) {
                return -1;
            }
            return 0;
        };
        Object.defineProperty(Version.prototype, 'major', {
            get: function () {
                return this._major;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Version.prototype, 'minor', {
            get: function () {
                return this._minor;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Version.prototype, 'isValid', {
            get: function () {
                return this._isValid;
            },
            enumerable: true,
            configurable: true
        });
        return Version;
    })();
    exports.Version = Version;
    var HostCapabilities = /** @class */ (function () {
        function HostCapabilities() {
            this.capabilities = null;
        }
        HostCapabilities.prototype.setCapability = function (name, version) {
            if (!this.capabilities) {
                this.capabilities = {};
            }
            this.capabilities[name] = version;
        };
        HostCapabilities.prototype.parse = function (json, errors) {
            if (json) {
                for (var name_1 in json) {
                    var jsonVersion = json[name_1];
                    if (typeof jsonVersion === 'string') {
                        if (jsonVersion == '*') {
                            this.setCapability(name_1, '*');
                        } else {
                            var version = Version.parse(jsonVersion, errors);
                            if (version.isValid) {
                                this.setCapability(name_1, version);
                            }
                        }
                    }
                }
            }
        };
        HostCapabilities.prototype.hasCapability = function (name, version) {
            if (this.capabilities && this.capabilities.hasOwnProperty(name)) {
                if (version == '*' || this.capabilities[name] == '*') {
                    return true;
                }
                return version.compareTo(this.capabilities[name]) <= 0;
            }
            return false;
        };
        HostCapabilities.prototype.areAllMet = function (hostCapabilities) {
            if (this.capabilities) {
                for (var capabilityName in this.capabilities) {
                    if (
                        !hostCapabilities.hasCapability(
                            capabilityName,
                            this.capabilities[capabilityName]
                        )
                    ) {
                        return false;
                    }
                }
            }
            return true;
        };
        return HostCapabilities;
    })();
    exports.HostCapabilities = HostCapabilities;
    var HostConfig = /** @class */ (function () {
        function HostConfig(obj) {
            this.hostCapabilities = new HostCapabilities();
            this.choiceSetInputValueSeparator = ',';
            this.supportsInteractivity = true;
            this.fontFamily =
                'Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif';
            this.spacing = {
                small: 3,
                default: 8,
                medium: 20,
                large: 30,
                extraLarge: 40,
                padding: 15
            };
            this.separator = {
                lineThickness: 1,
                lineColor: '#EEEEEE'
            };
            this.fontSizes = {
                small: 12,
                default: 14,
                medium: 17,
                large: 21,
                extraLarge: 26
            };
            this.fontWeights = {
                lighter: 200,
                default: 400,
                bolder: 600
            };
            this.imageSizes = {
                small: 40,
                medium: 80,
                large: 160
            };
            this.containerStyles = new ContainerStyleSet();
            this.actions = new ActionsConfig();
            this.adaptiveCard = new AdaptiveCardConfig();
            this.imageSet = new ImageSetConfig();
            this.media = new MediaConfig();
            this.factSet = new FactSetConfig();
            this.cssClassNamePrefix = null;
            if (obj) {
                if (typeof obj === 'string' || obj instanceof String) {
                    obj = JSON.parse(obj);
                }
                this.choiceSetInputValueSeparator =
                    obj &&
                        typeof obj['choiceSetInputValueSeparator'] === 'string'
                        ? obj['choiceSetInputValueSeparator']
                        : this.choiceSetInputValueSeparator;
                this.supportsInteractivity =
                    obj && typeof obj['supportsInteractivity'] === 'boolean'
                        ? obj['supportsInteractivity']
                        : this.supportsInteractivity;
                this.fontFamily = obj['fontFamily'] || this.fontFamily;
                this.fontSizes = {
                    small:
                        (obj.fontSizes && obj.fontSizes['small']) ||
                        this.fontSizes.small,
                    default:
                        (obj.fontSizes && obj.fontSizes['default']) ||
                        this.fontSizes.default,
                    medium:
                        (obj.fontSizes && obj.fontSizes['medium']) ||
                        this.fontSizes.medium,
                    large:
                        (obj.fontSizes && obj.fontSizes['large']) ||
                        this.fontSizes.large,
                    extraLarge:
                        (obj.fontSizes && obj.fontSizes['extraLarge']) ||
                        this.fontSizes.extraLarge
                };
                if (obj.lineHeights) {
                    this.lineHeights = {
                        small: obj.lineHeights['small'],
                        default: obj.lineHeights['default'],
                        medium: obj.lineHeights['medium'],
                        large: obj.lineHeights['large'],
                        extraLarge: obj.lineHeights['extraLarge']
                    };
                }
                this.fontWeights = {
                    lighter:
                        (obj.fontWeights && obj.fontWeights['lighter']) ||
                        this.fontWeights.lighter,
                    default:
                        (obj.fontWeights && obj.fontWeights['default']) ||
                        this.fontWeights.default,
                    bolder:
                        (obj.fontWeights && obj.fontWeights['bolder']) ||
                        this.fontWeights.bolder
                };
                this.imageSizes = {
                    small:
                        (obj.imageSizes && obj.imageSizes['small']) ||
                        this.imageSizes.small,
                    medium:
                        (obj.imageSizes && obj.imageSizes['medium']) ||
                        this.imageSizes.medium,
                    large:
                        (obj.imageSizes && obj.imageSizes['large']) ||
                        this.imageSizes.large
                };
                this.containerStyles = new ContainerStyleSet(
                    obj['containerStyles']
                );
                this.spacing = {
                    small:
                        (obj.spacing && obj.spacing['small']) ||
                        this.spacing.small,
                    default:
                        (obj.spacing && obj.spacing['default']) ||
                        this.spacing.default,
                    medium:
                        (obj.spacing && obj.spacing['medium']) ||
                        this.spacing.medium,
                    large:
                        (obj.spacing && obj.spacing['large']) ||
                        this.spacing.large,
                    extraLarge:
                        (obj.spacing && obj.spacing['extraLarge']) ||
                        this.spacing.extraLarge,
                    padding:
                        (obj.spacing && obj.spacing['padding']) ||
                        this.spacing.padding
                };
                this.separator = {
                    lineThickness:
                        (obj.separator && obj.separator['lineThickness']) ||
                        this.separator.lineThickness,
                    lineColor:
                        (obj.separator && obj.separator['lineColor']) ||
                        this.separator.lineColor
                };
                this.actions = new ActionsConfig(obj.actions || this.actions);
                this.adaptiveCard = new AdaptiveCardConfig(
                    obj.adaptiveCard || this.adaptiveCard
                );
                this.imageSet = new ImageSetConfig(obj['imageSet']);
                this.factSet = new FactSetConfig(obj['factSet']);
            }
        }
        HostConfig.prototype.getEffectiveSpacing = function (spacing) {
            switch (spacing) {
                case enums.Spacing.Small:
                    return this.spacing.small;
                case enums.Spacing.Default:
                    return this.spacing.default;
                case enums.Spacing.Medium:
                    return this.spacing.medium;
                case enums.Spacing.Large:
                    return this.spacing.large;
                case enums.Spacing.ExtraLarge:
                    return this.spacing.extraLarge;
                case enums.Spacing.Padding:
                    return this.spacing.padding;
                default:
                    return 0;
            }
        };
        HostConfig.prototype.makeCssClassName = function () {
            var classNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                classNames[_i] = arguments[_i];
            }
            var result = '';
            for (var i = 0; i < classNames.length; i++) {
                if (i > 0) {
                    result += ' ';
                }
                if (this.cssClassNamePrefix) {
                    result += this.cssClassNamePrefix + '-';
                }
                result += classNames[i];
            }
            return result;
        };
        return HostConfig;
    })();
    exports.HostConfig = HostConfig;
});

unwrapExports(hostConfig);
var hostConfig_1 = hostConfig.TextColorDefinition;
var hostConfig_2 = hostConfig.AdaptiveCardConfig;
var hostConfig_3 = hostConfig.ImageSetConfig;
var hostConfig_4 = hostConfig.MediaConfig;
var hostConfig_5 = hostConfig.FactTextDefinition;
var hostConfig_6 = hostConfig.FactTitleDefinition;
var hostConfig_7 = hostConfig.FactSetConfig;
var hostConfig_8 = hostConfig.ShowCardActionConfig;
var hostConfig_9 = hostConfig.ActionsConfig;
var hostConfig_10 = hostConfig.ContainerStyleDefinition;
var hostConfig_11 = hostConfig.ContainerStyleSet;
var hostConfig_12 = hostConfig.Version;
var hostConfig_13 = hostConfig.HostCapabilities;
var hostConfig_14 = hostConfig.HostConfig;

var textFormatters = createCommonjsModule(function (module, exports) {
    var __extends =
        (commonjsGlobal && commonjsGlobal.__extends) ||
        (function () {
            var extendStatics = function (d, b) {
                extendStatics =
                    Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array &&
                        function (d, b) {
                            d.__proto__ = b;
                        }) ||
                    function (d, b) {
                        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                return extendStatics(d, b);
            };
            return function (d, b) {
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype =
                    b === null
                        ? Object.create(b)
                        : ((__.prototype = b.prototype), new __());
            };
        })();
    Object.defineProperty(exports, '__esModule', { value: true });
    var AbstractTextFormatter = /** @class */ (function () {
        function AbstractTextFormatter(regularExpression) {
            this._regularExpression = regularExpression;
        }
        AbstractTextFormatter.prototype.format = function (lang, input) {
            var matches;
            var result = input;
            while ((matches = this._regularExpression.exec(input)) != null) {
                result = result.replace(
                    matches[0],
                    this.internalFormat(lang, matches)
                );
            }
            return result;
        };
        return AbstractTextFormatter;
    })();
    var DateFormatter = /** @class */ (function (_super) {
        __extends(DateFormatter, _super);
        function DateFormatter() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        DateFormatter.prototype.internalFormat = function (lang, matches) {
            var date = new Date(Date.parse(matches[1]));
            var format =
                matches[2] != undefined ? matches[2].toLowerCase() : 'compact';
            if (format != 'compact') {
                return date.toLocaleDateString(lang, {
                    day: 'numeric',
                    weekday: format,
                    month: format,
                    year: 'numeric'
                });
            } else {
                return date.toLocaleDateString();
            }
        };
        return DateFormatter;
    })(AbstractTextFormatter);
    var TimeFormatter = /** @class */ (function (_super) {
        __extends(TimeFormatter, _super);
        function TimeFormatter() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        TimeFormatter.prototype.internalFormat = function (lang, matches) {
            var date = new Date(Date.parse(matches[1]));
            return date.toLocaleTimeString(lang, {
                hour: 'numeric',
                minute: '2-digit'
            });
        };
        return TimeFormatter;
    })(AbstractTextFormatter);
    function formatText(lang, text) {
        var formatters = [
            new DateFormatter(
                /\{{2}DATE\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))(?:, ?(COMPACT|LONG|SHORT))?\)\}{2}/g
            ),
            new TimeFormatter(
                /\{{2}TIME\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|(?:(?:-|\+)\d{2}:\d{2})))\)\}{2}/g
            )
        ];
        var result = text;
        for (var i = 0; i < formatters.length; i++) {
            result = formatters[i].format(lang, result);
        }
        return result;
    }
    exports.formatText = formatText;
});

unwrapExports(textFormatters);
var textFormatters_1 = textFormatters.formatText;

var cardElements = createCommonjsModule(function (module, exports) {
    var __extends =
        (commonjsGlobal && commonjsGlobal.__extends) ||
        (function () {
            var extendStatics = function (d, b) {
                extendStatics =
                    Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array &&
                        function (d, b) {
                            d.__proto__ = b;
                        }) ||
                    function (d, b) {
                        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                return extendStatics(d, b);
            };
            return function (d, b) {
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype =
                    b === null
                        ? Object.create(b)
                        : ((__.prototype = b.prototype), new __());
            };
        })();
    Object.defineProperty(exports, '__esModule', { value: true });

    function invokeSetCollection(action, collection) {
        if (action) {
            // Closest emulation of "internal" in TypeScript.
            action['setCollection'](collection);
        }
    }
    function isActionAllowed(action, forbiddenActionTypes) {
        if (forbiddenActionTypes) {
            for (var i = 0; i < forbiddenActionTypes.length; i++) {
                if (action.getJsonTypeName() === forbiddenActionTypes[i]) {
                    return false;
                }
            }
        }
        return true;
    }
    function generateUniqueId() {
        return '__ac-' + utils.UUID.generate();
    }
    function createCardObjectInstance(
        parent,
        json,
        createInstanceCallback,
        createValidationErrorCallback,
        errors
    ) {
        var result = null;
        if (json && typeof json === 'object') {
            var tryToFallback = false;
            var typeName = json['type'];
            result = createInstanceCallback(typeName);
            if (!result) {
                tryToFallback = true;
                raiseParseError(
                    createValidationErrorCallback(typeName),
                    errors
                );
            } else {
                result.setParent(parent);
                result.parse(json);
                tryToFallback = result.shouldFallback();
            }
            if (tryToFallback) {
                var fallback = json['fallback'];
                if (!fallback) {
                    parent.setShouldFallback(true);
                }
                if (
                    typeof fallback === 'string' &&
                    fallback.toLowerCase() === 'drop'
                ) {
                    result = null;
                } else if (typeof fallback === 'object') {
                    result = createCardObjectInstance(
                        parent,
                        fallback,
                        createInstanceCallback,
                        createValidationErrorCallback,
                        errors
                    );
                }
            }
        }
        return result;
    }
    function createActionInstance(parent, json, errors) {
        return createCardObjectInstance(
            parent,
            json,
            function (typeName) {
                return AdaptiveCard.actionTypeRegistry.createInstance(typeName);
            },
            function (typeName) {
                return {
                    error: enums.ValidationError.UnknownActionType,
                    message:
                        'Unknown action type: ' +
                        typeName +
                        '. Attempting to fall back.'
                };
            },
            errors
        );
    }
    exports.createActionInstance = createActionInstance;
    function createElementInstance(parent, json, errors) {
        return createCardObjectInstance(
            parent,
            json,
            function (typeName) {
                return AdaptiveCard.elementTypeRegistry.createInstance(
                    typeName
                );
            },
            function (typeName) {
                return {
                    error: enums.ValidationError.UnknownElementType,
                    message:
                        'Unknown element type: ' +
                        typeName +
                        '. Attempting to fall back.'
                };
            },
            errors
        );
    }
    exports.createElementInstance = createElementInstance;
    var SpacingDefinition = /** @class */ (function () {
        function SpacingDefinition(top, right, bottom, left) {
            if (top === void 0) {
                top = 0;
            }
            if (right === void 0) {
                right = 0;
            }
            if (bottom === void 0) {
                bottom = 0;
            }
            if (left === void 0) {
                left = 0;
            }
            this.left = 0;
            this.top = 0;
            this.right = 0;
            this.bottom = 0;
            this.top = top;
            this.right = right;
            this.bottom = bottom;
            this.left = left;
        }
        return SpacingDefinition;
    })();
    exports.SpacingDefinition = SpacingDefinition;
    var PaddingDefinition = /** @class */ (function () {
        function PaddingDefinition(top, right, bottom, left) {
            if (top === void 0) {
                top = enums.Spacing.None;
            }
            if (right === void 0) {
                right = enums.Spacing.None;
            }
            if (bottom === void 0) {
                bottom = enums.Spacing.None;
            }
            if (left === void 0) {
                left = enums.Spacing.None;
            }
            this.top = enums.Spacing.None;
            this.right = enums.Spacing.None;
            this.bottom = enums.Spacing.None;
            this.left = enums.Spacing.None;
            this.top = top;
            this.right = right;
            this.bottom = bottom;
            this.left = left;
        }
        PaddingDefinition.prototype.toSpacingDefinition = function (hostConfig) {
            return new SpacingDefinition(
                hostConfig.getEffectiveSpacing(this.top),
                hostConfig.getEffectiveSpacing(this.right),
                hostConfig.getEffectiveSpacing(this.bottom),
                hostConfig.getEffectiveSpacing(this.left)
            );
        };
        return PaddingDefinition;
    })();
    exports.PaddingDefinition = PaddingDefinition;
    var SizeAndUnit = /** @class */ (function () {
        function SizeAndUnit(physicalSize, unit) {
            this.physicalSize = physicalSize;
            this.unit = unit;
        }
        SizeAndUnit.parse = function (input) {
            var result = new SizeAndUnit(0, enums.SizeUnit.Weight);
            var regExp = /^([0-9]+)(px|\*)?$/g;
            var matches = regExp.exec(input);
            if (matches && matches.length >= 2) {
                result.physicalSize = parseInt(matches[1]);
                if (matches.length == 3) {
                    if (matches[2] == 'px') {
                        result.unit = enums.SizeUnit.Pixel;
                    }
                }
                return result;
            }
            throw new Error('Invalid size: ' + input);
        };
        return SizeAndUnit;
    })();
    exports.SizeAndUnit = SizeAndUnit;
    var CardElement = /** @class */ (function () {
        function CardElement() {
            this._shouldFallback = false;
            this._lang = undefined;
            this._hostConfig = null;
            this._internalPadding = null;
            this._parent = null;
            this._renderedElement = null;
            this._separatorElement = null;
            this._isVisible = true;
            this._truncatedDueToOverflow = false;
            this._defaultRenderedElementDisplayMode = null;
            this._padding = null;
            this.requires = new hostConfig.HostCapabilities();
            this.horizontalAlignment = null;
            this.spacing = enums.Spacing.Default;
            this.separator = false;
            this.height = 'auto';
            this.customCssSelector = null;
        }
        CardElement.prototype.internalRenderSeparator = function () {
            return utils.renderSeparation(
                {
                    spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
                    lineThickness: this.separator
                        ? this.hostConfig.separator.lineThickness
                        : null,
                    lineColor: this.separator
                        ? this.hostConfig.separator.lineColor
                        : null
                },
                this.separatorOrientation
            );
        };
        CardElement.prototype.updateRenderedElementVisibility = function () {
            if (this._renderedElement) {
                this._renderedElement.style.display = this._isVisible
                    ? this._defaultRenderedElementDisplayMode
                    : 'none';
            }
            if (this._separatorElement) {
                if (this.parent && this.parent.isFirstElement(this)) {
                    this._separatorElement.style.display = 'none';
                } else {
                    this._separatorElement.style.display = this._isVisible
                        ? this._defaultRenderedElementDisplayMode
                        : 'none';
                }
            }
        };
        CardElement.prototype.hideElementDueToOverflow = function () {
            if (this._renderedElement && this._isVisible) {
                this._renderedElement.style.visibility = 'hidden';
                this._isVisible = false;
                raiseElementVisibilityChangedEvent(this, false);
            }
        };
        CardElement.prototype.showElementHiddenDueToOverflow = function () {
            if (this._renderedElement && !this._isVisible) {
                this._renderedElement.style.visibility = null;
                this._isVisible = true;
                raiseElementVisibilityChangedEvent(this, false);
            }
        };
        // Marked private to emulate internal access
        CardElement.prototype.handleOverflow = function (maxHeight) {
            if (this.isVisible || this.isHiddenDueToOverflow()) {
                var handled = this.truncateOverflow(maxHeight);
                // Even if we were unable to truncate the element to fit this time,
                // it still could have been previously truncated
                this._truncatedDueToOverflow =
                    handled || this._truncatedDueToOverflow;
                if (!handled) {
                    this.hideElementDueToOverflow();
                } else if (handled && !this._isVisible) {
                    this.showElementHiddenDueToOverflow();
                }
            }
        };
        // Marked private to emulate internal access
        CardElement.prototype.resetOverflow = function () {
            var sizeChanged = false;
            if (this._truncatedDueToOverflow) {
                this.undoOverflowTruncation();
                this._truncatedDueToOverflow = false;
                sizeChanged = true;
            }
            if (this.isHiddenDueToOverflow) {
                this.showElementHiddenDueToOverflow();
            }
            return sizeChanged;
        };
        CardElement.prototype.createPlaceholderElement = function () {
            var element = document.createElement('div');
            element.style.border = '1px dashed #DDDDDD';
            element.style.padding = '4px';
            element.style.minHeight = '32px';
            element.style.fontSize = '10px';
            element.innerText = 'Empty ' + this.getJsonTypeName();
            return element;
        };
        CardElement.prototype.internalGetNonZeroPadding = function (
            padding,
            processTop,
            processRight,
            processBottom,
            processLeft
        ) {
            if (processTop === void 0) {
                processTop = true;
            }
            if (processRight === void 0) {
                processRight = true;
            }
            if (processBottom === void 0) {
                processBottom = true;
            }
            if (processLeft === void 0) {
                processLeft = true;
            }
            if (processTop) {
                if (padding.top == enums.Spacing.None) {
                    padding.top = this.internalPadding.top;
                }
            }
            if (processRight) {
                if (padding.right == enums.Spacing.None) {
                    padding.right = this.internalPadding.right;
                }
            }
            if (processBottom) {
                if (padding.bottom == enums.Spacing.None) {
                    padding.bottom = this.internalPadding.bottom;
                }
            }
            if (processLeft) {
                if (padding.left == enums.Spacing.None) {
                    padding.left = this.internalPadding.left;
                }
            }
            if (this.parent) {
                this.parent.internalGetNonZeroPadding(
                    padding,
                    processTop && this.isAtTheVeryTop(),
                    processRight && this.isAtTheVeryRight(),
                    processBottom && this.isAtTheVeryBottom(),
                    processLeft && this.isAtTheVeryLeft()
                );
            }
        };
        CardElement.prototype.adjustRenderedElementSize = function (
            renderedElement
        ) {
            if (this.height === 'auto') {
                renderedElement.style.flex = '0 0 auto';
            } else {
                renderedElement.style.flex = '1 1 auto';
            }
        };
        /*
         * Called when this element overflows the bottom of the card.
         * maxHeight will be the amount of space still available on the card (0 if
         * the element is fully off the card).
         */
        CardElement.prototype.truncateOverflow = function (maxHeight) {
            // Child implementations should return true if the element handled
            // the truncation request such that its content fits within maxHeight,
            // false if the element should fall back to being hidden
            return false;
        };
        /*
         * This should reverse any changes performed in truncateOverflow().
         */
        CardElement.prototype.undoOverflowTruncation = function () { };
        CardElement.prototype.isDesignMode = function () {
            var rootElement = this.getRootElement();
            return (
                rootElement instanceof AdaptiveCard && rootElement.designMode
            );
        };
        Object.defineProperty(CardElement.prototype, 'useDefaultSizing', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'allowCustomPadding', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'defaultPadding', {
            get: function () {
                return new PaddingDefinition();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'internalPadding', {
            get: function () {
                if (this._padding) {
                    return this._padding;
                } else {
                    return this._internalPadding && this.allowCustomPadding
                        ? this._internalPadding
                        : this.defaultPadding;
                }
            },
            set: function (value) {
                this._internalPadding = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'separatorOrientation', {
            get: function () {
                return enums.Orientation.Horizontal;
            },
            enumerable: true,
            configurable: true
        });
        CardElement.prototype.getPadding = function () {
            return this._padding;
        };
        CardElement.prototype.setPadding = function (value) {
            this._padding = value;
            if (this._padding) {
                AdaptiveCard.useAutomaticContainerBleeding = false;
            }
        };
        CardElement.prototype.toJSON = function () {
            var result = {};
            utils.setProperty(result, 'type', this.getJsonTypeName());
            utils.setProperty(result, 'id', this.id);
            if (this.horizontalAlignment !== null) {
                utils.setEnumProperty(
                    enums.HorizontalAlignment,
                    result,
                    'horizontalAlignment',
                    this.horizontalAlignment
                );
            }
            utils.setEnumProperty(
                enums.Spacing,
                result,
                'spacing',
                this.spacing,
                enums.Spacing.Default
            );
            utils.setProperty(result, 'separator', this.separator, false);
            utils.setProperty(result, 'height', this.height, 'auto');
            return result;
        };
        CardElement.prototype.setParent = function (value) {
            this._parent = value;
        };
        CardElement.prototype.getNonZeroPadding = function () {
            var padding = new PaddingDefinition();
            this.internalGetNonZeroPadding(padding);
            return padding;
        };
        CardElement.prototype.getForbiddenElementTypes = function () {
            return null;
        };
        CardElement.prototype.getForbiddenActionTypes = function () {
            return null;
        };
        CardElement.prototype.parse = function (json, errors) {
            raiseParseElementEvent(this, json, errors);
            this.requires.parse(json['requires'], errors);
            this.id = json['id'];
            this.speak = json['speak'];
            this.horizontalAlignment = utils.getEnumValueOrDefault(
                enums.HorizontalAlignment,
                json['horizontalAlignment'],
                null
            );
            this.spacing = utils.getEnumValueOrDefault(
                enums.Spacing,
                json['spacing'],
                enums.Spacing.Default
            );
            this.separator = json['separator'];
            var jsonSeparation = json['separation'];
            if (jsonSeparation !== undefined) {
                if (jsonSeparation === 'none') {
                    this.spacing = enums.Spacing.None;
                    this.separator = false;
                } else if (jsonSeparation === 'strong') {
                    this.spacing = enums.Spacing.Large;
                    this.separator = true;
                } else if (jsonSeparation === 'default') {
                    this.spacing = enums.Spacing.Default;
                    this.separator = false;
                }
                raiseParseError(
                    {
                        error: enums.ValidationError.Deprecated,
                        message:
                            'The "separation" property is deprecated and will be removed. Use the "spacing" and "separator" properties instead.'
                    },
                    errors
                );
            }
            var jsonHeight = json['height'];
            if (jsonHeight === 'auto' || jsonHeight === 'stretch') {
                this.height = jsonHeight;
            }
        };
        CardElement.prototype.getActionCount = function () {
            return 0;
        };
        CardElement.prototype.getActionAt = function (index) {
            throw new Error('Index out of range.');
        };
        CardElement.prototype.validate = function () {
            return [];
        };
        CardElement.prototype.remove = function () {
            if (this.parent && this.parent instanceof CardElementContainer) {
                return this.parent.removeItem(this);
            }
            return false;
        };
        CardElement.prototype.render = function () {
            this._renderedElement = this.internalRender();
            this._separatorElement = this.internalRenderSeparator();
            if (this._renderedElement) {
                if (this.customCssSelector) {
                    this._renderedElement.classList.add(this.customCssSelector);
                }
                this._renderedElement.style.boxSizing = 'border-box';
                this._defaultRenderedElementDisplayMode = this._renderedElement.style.display;
                this.adjustRenderedElementSize(this._renderedElement);
                this.updateLayout(false);
            } else if (this.isDesignMode()) {
                this._renderedElement = this.createPlaceholderElement();
            }
            return this._renderedElement;
        };
        CardElement.prototype.updateLayout = function (processChildren) {
            this.updateRenderedElementVisibility();
        };
        CardElement.prototype.indexOf = function (cardElement) {
            return -1;
        };
        CardElement.prototype.isRendered = function () {
            return (
                this._renderedElement && this._renderedElement.offsetHeight > 0
            );
        };
        CardElement.prototype.isAtTheVeryTop = function () {
            return this.parent
                ? this.parent.isFirstElement(this) &&
                this.parent.isAtTheVeryTop()
                : true;
        };
        CardElement.prototype.isFirstElement = function (element) {
            return true;
        };
        CardElement.prototype.isAtTheVeryBottom = function () {
            return this.parent
                ? this.parent.isLastElement(this) &&
                this.parent.isAtTheVeryBottom()
                : true;
        };
        CardElement.prototype.isLastElement = function (element) {
            return true;
        };
        CardElement.prototype.isAtTheVeryLeft = function () {
            return this.parent
                ? this.parent.isLeftMostElement(this) &&
                this.parent.isAtTheVeryLeft()
                : true;
        };
        CardElement.prototype.isBleeding = function () {
            return false;
        };
        CardElement.prototype.isLeftMostElement = function (element) {
            return true;
        };
        CardElement.prototype.isAtTheVeryRight = function () {
            return this.parent
                ? this.parent.isRightMostElement(this) &&
                this.parent.isAtTheVeryRight()
                : true;
        };
        CardElement.prototype.isRightMostElement = function (element) {
            return true;
        };
        CardElement.prototype.isHiddenDueToOverflow = function () {
            return (
                this._renderedElement &&
                this._renderedElement.style.visibility == 'hidden'
            );
        };
        CardElement.prototype.canContentBleed = function () {
            return this.parent ? this.parent.canContentBleed() : true;
        };
        CardElement.prototype.getRootElement = function () {
            var rootElement = this;
            while (rootElement.parent) {
                rootElement = rootElement.parent;
            }
            return rootElement;
        };
        CardElement.prototype.getParentContainer = function () {
            var currentElement = this.parent;
            while (currentElement) {
                if (currentElement instanceof Container) {
                    return currentElement;
                }
                currentElement = currentElement.parent;
            }
            return null;
        };
        CardElement.prototype.getAllInputs = function () {
            return [];
        };
        CardElement.prototype.getResourceInformation = function () {
            return [];
        };
        CardElement.prototype.getElementById = function (id) {
            return this.id === id ? this : null;
        };
        CardElement.prototype.getActionById = function (id) {
            return null;
        };
        CardElement.prototype.shouldFallback = function () {
            return (
                this._shouldFallback ||
                !this.requires.areAllMet(this.hostConfig.hostCapabilities)
            );
        };
        CardElement.prototype.setShouldFallback = function (value) {
            this._shouldFallback = value;
        };
        Object.defineProperty(CardElement.prototype, 'lang', {
            get: function () {
                if (this._lang) {
                    return this._lang;
                } else {
                    if (this.parent) {
                        return this.parent.lang;
                    } else {
                        return undefined;
                    }
                }
            },
            set: function (value) {
                if (value && value != '') {
                    var regEx = /^[a-z]{2,3}$/gi;
                    var matches = regEx.exec(value);
                    if (!matches) {
                        throw new Error(
                            'Invalid language identifier: ' + value
                        );
                    }
                }
                this._lang = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'hostConfig', {
            get: function () {
                if (this._hostConfig) {
                    return this._hostConfig;
                } else {
                    if (this.parent) {
                        return this.parent.hostConfig;
                    } else {
                        return defaultHostConfig;
                    }
                }
            },
            set: function (value) {
                this._hostConfig = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'index', {
            get: function () {
                if (this.parent) {
                    return this.parent.indexOf(this);
                } else {
                    return 0;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'isInteractive', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'isStandalone', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'parent', {
            get: function () {
                return this._parent;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'isVisible', {
            get: function () {
                return this._isVisible;
            },
            set: function (value) {
                // If the element is going to be hidden, reset any changes that were due
                // to overflow truncation (this ensures that if the element is later
                // un-hidden it has the right content)
                if (AdaptiveCard.useAdvancedCardBottomTruncation && !value) {
                    this.undoOverflowTruncation();
                }
                if (this._isVisible != value) {
                    this._isVisible = value;
                    this.updateRenderedElementVisibility();
                    if (this._renderedElement) {
                        raiseElementVisibilityChangedEvent(this);
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'hasVisibleSeparator', {
            get: function () {
                var parentContainer = this.getParentContainer();
                if (parentContainer) {
                    return (
                        this.separatorElement &&
                        !parentContainer.isFirstElement(this)
                    );
                } else {
                    return false;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'renderedElement', {
            get: function () {
                return this._renderedElement;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CardElement.prototype, 'separatorElement', {
            get: function () {
                return this._separatorElement;
            },
            enumerable: true,
            configurable: true
        });
        return CardElement;
    })();
    exports.CardElement = CardElement;
    var CardElementContainer = /** @class */ (function (_super) {
        __extends(CardElementContainer, _super);
        function CardElementContainer() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        return CardElementContainer;
    })(CardElement);
    exports.CardElementContainer = CardElementContainer;
    var TextBlock = /** @class */ (function (_super) {
        __extends(TextBlock, _super);
        function TextBlock() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._processedText = null;
            _this._treatAsPlainText = true;
            _this._selectAction = null;
            _this._effectiveStyleDefinition = null;
            _this.size = enums.TextSize.Default;
            _this.weight = enums.TextWeight.Default;
            _this.color = enums.TextColor.Default;
            _this.isSubtle = false;
            _this.wrap = false;
            _this.useMarkdown = true;
            return _this;
        }
        TextBlock.prototype.restoreOriginalContent = function () {
            var maxHeight = this.maxLines
                ? this._computedLineHeight * this.maxLines + 'px'
                : null;
            this.renderedElement.style.maxHeight = maxHeight;
            this.renderedElement.innerHTML = this._originalInnerHtml;
        };
        TextBlock.prototype.truncateIfSupported = function (maxHeight) {
            // For now, only truncate TextBlocks that contain just a single
            // paragraph -- since the maxLines calculation doesn't take into
            // account Markdown lists
            var children = this.renderedElement.children;
            var isTextOnly = !children.length;
            var truncationSupported =
                isTextOnly ||
                (children.length == 1 &&
                    children[0].tagName.toLowerCase() == 'p');
            if (truncationSupported) {
                var element = isTextOnly ? this.renderedElement : children[0];
                utils.truncate(element, maxHeight, this._computedLineHeight);
                return true;
            }
            return false;
        };
        TextBlock.prototype.getEffectiveStyleDefinition = function () {
            if (!this._effectiveStyleDefinition) {
                this._effectiveStyleDefinition = this.hostConfig.containerStyles.default;
                var parentContainer = this.getParentContainer();
                while (parentContainer) {
                    if (parentContainer.style) {
                        this._effectiveStyleDefinition = this.hostConfig.containerStyles.getStyleByName(
                            parentContainer.style
                        );
                        break;
                    }
                    parentContainer = parentContainer.getParentContainer();
                }
            }
            return this._effectiveStyleDefinition;
        };
        TextBlock.prototype.getRenderedDomElementType = function () {
            return 'div';
        };
        TextBlock.prototype.internalRender = function () {
            var _this = this;
            this._effectiveStyleDefinition = null;
            this._processedText = null;
            if (!utils.isNullOrEmpty(this.text)) {
                var hostConfig = this.hostConfig;
                var element = document.createElement(
                    this.getRenderedDomElementType()
                );
                element.classList.add(
                    hostConfig.makeCssClassName('ac-textBlock')
                );
                element.style.overflow = 'hidden';
                this.applyStylesTo(element);
                if (this.selectAction) {
                    element.onclick = function (e) {
                        _this.selectAction.execute();
                        e.cancelBubble = true;
                    };
                }
                if (!this._processedText) {
                    this._treatAsPlainText = true;
                    var formattedText = textFormatters.formatText(
                        this.lang,
                        this.text
                    );
                    if (this.useMarkdown) {
                        if (AdaptiveCard.allowMarkForTextHighlighting) {
                            formattedText = formattedText
                                .replace(/<mark>/g, '===')
                                .replace(/<\/mark>/g, '/==');
                        }
                        var markdownProcessingResult = AdaptiveCard.applyMarkdown(
                            formattedText
                        );
                        if (
                            markdownProcessingResult.didProcess &&
                            markdownProcessingResult.outputHtml
                        ) {
                            this._processedText =
                                markdownProcessingResult.outputHtml;
                            this._treatAsPlainText = false;
                            // Only process <mark> tag if markdown processing was applied because
                            // markdown processing is also responsible for sanitizing the input string
                            if (AdaptiveCard.allowMarkForTextHighlighting) {
                                var markStyle = '';
                                var effectiveStyle = this.getEffectiveStyleDefinition();
                                if (effectiveStyle.highlightBackgroundColor) {
                                    markStyle +=
                                        'background-color: ' +
                                        effectiveStyle.highlightBackgroundColor +
                                        ';';
                                }
                                if (effectiveStyle.highlightForegroundColor) {
                                    markStyle +=
                                        'color: ' +
                                        effectiveStyle.highlightForegroundColor +
                                        ';';
                                }
                                if (!utils.isNullOrEmpty(markStyle)) {
                                    markStyle = 'style="' + markStyle + '"';
                                }
                                this._processedText = this._processedText
                                    .replace(/===/g, '<mark ' + markStyle + '>')
                                    .replace(/\/==/g, '</mark>');
                            }
                        } else {
                            this._processedText = formattedText;
                            this._treatAsPlainText = true;
                        }
                    } else {
                        this._processedText = formattedText;
                        this._treatAsPlainText = true;
                    }
                }
                if (this._treatAsPlainText) {
                    element.innerText = this._processedText;
                } else {
                    element.innerHTML = this._processedText;
                }
                if (element.firstElementChild instanceof HTMLElement) {
                    var firstElementChild = element.firstElementChild;
                    firstElementChild.style.marginTop = '0px';
                    firstElementChild.style.width = '100%';
                    if (!this.wrap) {
                        firstElementChild.style.overflow = 'hidden';
                        firstElementChild.style.textOverflow = 'ellipsis';
                    }
                }
                if (element.lastElementChild instanceof HTMLElement) {
                    element.lastElementChild.style.marginBottom = '0px';
                }
                var anchors = element.getElementsByTagName('a');
                for (var i = 0; i < anchors.length; i++) {
                    var anchor = anchors[i];
                    anchor.classList.add(
                        this.hostConfig.makeCssClassName('ac-anchor')
                    );
                    anchor.target = '_blank';
                    anchor.onclick = function (e) {
                        if (raiseAnchorClickedEvent(_this, e.target)) {
                            e.preventDefault();
                        }
                    };
                }
                if (this.wrap) {
                    element.style.wordWrap = 'break-word';
                    if (this.maxLines > 0) {
                        element.style.maxHeight =
                            this._computedLineHeight * this.maxLines + 'px';
                        element.style.overflow = 'hidden';
                    }
                } else {
                    element.style.whiteSpace = 'nowrap';
                    element.style.textOverflow = 'ellipsis';
                }
                if (
                    AdaptiveCard.useAdvancedTextBlockTruncation ||
                    AdaptiveCard.useAdvancedCardBottomTruncation
                ) {
                    this._originalInnerHtml = element.innerHTML;
                }
                if (
                    this.selectAction != null &&
                    hostConfig.supportsInteractivity
                ) {
                    element.tabIndex = 0;
                    element.setAttribute('role', 'button');
                    element.setAttribute('aria-label', this.selectAction.title);
                    element.classList.add(
                        hostConfig.makeCssClassName('ac-selectable')
                    );
                }
                return element;
            } else {
                return null;
            }
        };
        TextBlock.prototype.truncateOverflow = function (maxHeight) {
            if (maxHeight >= this._computedLineHeight) {
                return this.truncateIfSupported(maxHeight);
            }
            return false;
        };
        TextBlock.prototype.undoOverflowTruncation = function () {
            this.restoreOriginalContent();
            if (AdaptiveCard.useAdvancedTextBlockTruncation && this.maxLines) {
                var maxHeight = this._computedLineHeight * this.maxLines;
                this.truncateIfSupported(maxHeight);
            }
        };
        TextBlock.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setEnumProperty(
                enums.TextSize,
                result,
                'size',
                this.size,
                enums.TextSize.Default
            );
            utils.setEnumProperty(
                enums.TextWeight,
                result,
                'weight',
                this.weight,
                enums.TextWeight.Default
            );
            utils.setEnumProperty(
                enums.TextColor,
                result,
                'color',
                this.color,
                enums.TextColor.Default
            );
            utils.setProperty(result, 'text', this.text);
            utils.setProperty(result, 'isSubtle', this.isSubtle, false);
            utils.setProperty(result, 'wrap', this.wrap, false);
            utils.setProperty(result, 'maxLines', this.maxLines, 0);
            return result;
        };
        TextBlock.prototype.applyStylesTo = function (targetElement) {
            if (this.hostConfig.fontFamily) {
                targetElement.style.fontFamily = this.hostConfig.fontFamily;
            }
            var parentContainer = this.getParentContainer();
            var isRtl = parentContainer ? parentContainer.isRtl() : false;
            switch (this.horizontalAlignment) {
                case enums.HorizontalAlignment.Center:
                    targetElement.style.textAlign = 'center';
                    break;
                case enums.HorizontalAlignment.Right:
                    targetElement.style.textAlign = isRtl ? 'left' : 'right';
                    break;
                default:
                    targetElement.style.textAlign = isRtl ? 'right' : 'left';
                    break;
            }
            var fontSize;
            switch (this.size) {
                case enums.TextSize.Small:
                    fontSize = this.hostConfig.fontSizes.small;
                    break;
                case enums.TextSize.Medium:
                    fontSize = this.hostConfig.fontSizes.medium;
                    break;
                case enums.TextSize.Large:
                    fontSize = this.hostConfig.fontSizes.large;
                    break;
                case enums.TextSize.ExtraLarge:
                    fontSize = this.hostConfig.fontSizes.extraLarge;
                    break;
                default:
                    fontSize = this.hostConfig.fontSizes.default;
                    break;
            }
            if (this.hostConfig.lineHeights) {
                switch (this.size) {
                    case enums.TextSize.Small:
                        this._computedLineHeight = this.hostConfig.lineHeights.small;
                        break;
                    case enums.TextSize.Medium:
                        this._computedLineHeight = this.hostConfig.lineHeights.medium;
                        break;
                    case enums.TextSize.Large:
                        this._computedLineHeight = this.hostConfig.lineHeights.large;
                        break;
                    case enums.TextSize.ExtraLarge:
                        this._computedLineHeight = this.hostConfig.lineHeights.extraLarge;
                        break;
                    default:
                        this._computedLineHeight = this.hostConfig.lineHeights.default;
                        break;
                }
            } else {
                // Looks like 1.33 is the magic number to compute line-height
                // from font size.
                this._computedLineHeight = fontSize * 1.33;
            }
            targetElement.style.fontSize = fontSize + 'px';
            targetElement.style.lineHeight = this._computedLineHeight + 'px';
            var styleDefinition = this.getEffectiveStyleDefinition();
            var actualTextColor = this.color
                ? this.color
                : enums.TextColor.Default;
            var colorDefinition;
            switch (actualTextColor) {
                case enums.TextColor.Accent:
                    colorDefinition = styleDefinition.foregroundColors.accent;
                    break;
                case enums.TextColor.Dark:
                    colorDefinition = styleDefinition.foregroundColors.dark;
                    break;
                case enums.TextColor.Light:
                    colorDefinition = styleDefinition.foregroundColors.light;
                    break;
                case enums.TextColor.Good:
                    colorDefinition = styleDefinition.foregroundColors.good;
                    break;
                case enums.TextColor.Warning:
                    colorDefinition = styleDefinition.foregroundColors.warning;
                    break;
                case enums.TextColor.Attention:
                    colorDefinition =
                        styleDefinition.foregroundColors.attention;
                    break;
                default:
                    colorDefinition = styleDefinition.foregroundColors.default;
                    break;
            }
            targetElement.style.color = utils.stringToCssColor(
                this.isSubtle ? colorDefinition.subtle : colorDefinition.default
            );
            var fontWeight;
            switch (this.weight) {
                case enums.TextWeight.Lighter:
                    fontWeight = this.hostConfig.fontWeights.lighter;
                    break;
                case enums.TextWeight.Bolder:
                    fontWeight = this.hostConfig.fontWeights.bolder;
                    break;
                default:
                    fontWeight = this.hostConfig.fontWeights.default;
                    break;
            }
            targetElement.style.fontWeight = fontWeight.toString();
        };
        TextBlock.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.text = json['text'];
            var sizeString = json['size'];
            if (
                sizeString &&
                typeof sizeString === 'string' &&
                sizeString.toLowerCase() === 'normal'
            ) {
                this.size = enums.TextSize.Default;
                raiseParseError(
                    {
                        error: enums.ValidationError.Deprecated,
                        message:
                            'The TextBlock.size value "normal" is deprecated and will be removed. Use "default" instead.'
                    },
                    errors
                );
            } else {
                this.size = utils.getEnumValueOrDefault(
                    enums.TextSize,
                    sizeString,
                    this.size
                );
            }
            var weightString = json['weight'];
            if (
                weightString &&
                typeof weightString === 'string' &&
                weightString.toLowerCase() === 'normal'
            ) {
                this.weight = enums.TextWeight.Default;
                raiseParseError(
                    {
                        error: enums.ValidationError.Deprecated,
                        message:
                            'The TextBlock.weight value "normal" is deprecated and will be removed. Use "default" instead.'
                    },
                    errors
                );
            } else {
                this.weight = utils.getEnumValueOrDefault(
                    enums.TextWeight,
                    weightString,
                    this.weight
                );
            }
            this.color = utils.getEnumValueOrDefault(
                enums.TextColor,
                json['color'],
                this.color
            );
            this.isSubtle = json['isSubtle'];
            this.wrap = json['wrap'] === undefined ? false : json['wrap'];
            if (typeof json['maxLines'] === 'number') {
                this.maxLines = json['maxLines'];
            }
        };
        TextBlock.prototype.getJsonTypeName = function () {
            return 'TextBlock';
        };
        TextBlock.prototype.renderSpeech = function () {
            if (this.speak != null) return this.speak + '\n';
            if (this.text) return '<s>' + this.text + '</s>\n';
            return null;
        };
        TextBlock.prototype.updateLayout = function (processChildren) {
            if (processChildren === void 0) {
                processChildren = false;
            }
            _super.prototype.updateLayout.call(this, processChildren);
            if (
                AdaptiveCard.useAdvancedTextBlockTruncation &&
                this.maxLines &&
                this.isRendered()
            ) {
                // Reset the element's innerHTML in case the available room for
                // content has increased
                this.restoreOriginalContent();
                var maxHeight = this._computedLineHeight * this.maxLines;
                this.truncateIfSupported(maxHeight);
            }
        };
        Object.defineProperty(TextBlock.prototype, 'text', {
            get: function () {
                return this._text;
            },
            set: function (value) {
                if (this._text != value) {
                    this._text = value;
                    this._processedText = null;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TextBlock.prototype, 'selectAction', {
            get: function () {
                return this._selectAction;
            },
            set: function (value) {
                this._selectAction = value;
                if (this._selectAction) {
                    this._selectAction.setParent(this);
                }
            },
            enumerable: true,
            configurable: true
        });
        return TextBlock;
    })(CardElement);
    exports.TextBlock = TextBlock;
    var Label = /** @class */ (function (_super) {
        __extends(Label, _super);
        function Label() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        Label.prototype.getRenderedDomElementType = function () {
            return 'label';
        };
        Label.prototype.internalRender = function () {
            var renderedElement = _super.prototype.internalRender.call(this);
            if (!utils.isNullOrEmpty(this.forElementId)) {
                renderedElement.htmlFor = this.forElementId;
            }
            return renderedElement;
        };
        return Label;
    })(TextBlock);
    var Fact = /** @class */ (function () {
        function Fact(name, value) {
            if (name === void 0) {
                name = undefined;
            }
            if (value === void 0) {
                value = undefined;
            }
            this.name = name;
            this.value = value;
        }
        Fact.prototype.toJSON = function () {
            return { title: this.name, value: this.value };
        };
        Fact.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak + '\n';
            }
            return '<s>' + this.name + ' ' + this.value + '</s>\n';
        };
        return Fact;
    })();
    exports.Fact = Fact;
    var FactSet = /** @class */ (function (_super) {
        __extends(FactSet, _super);
        function FactSet() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.facts = [];
            return _this;
        }
        Object.defineProperty(FactSet.prototype, 'useDefaultSizing', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        FactSet.prototype.internalRender = function () {
            var element = null;
            var hostConfig = this.hostConfig;
            if (this.facts.length > 0) {
                element = document.createElement('table');
                element.style.borderWidth = '0px';
                element.style.borderSpacing = '0px';
                element.style.borderStyle = 'none';
                element.style.borderCollapse = 'collapse';
                element.style.display = 'block';
                element.style.overflow = 'hidden';
                element.classList.add(
                    hostConfig.makeCssClassName('ac-factset')
                );
                for (var i = 0; i < this.facts.length; i++) {
                    var trElement = document.createElement('tr');
                    if (i > 0) {
                        trElement.style.marginTop =
                            this.hostConfig.factSet.spacing + 'px';
                    }
                    // Title column
                    var tdElement = document.createElement('td');
                    tdElement.style.padding = '0';
                    tdElement.classList.add(
                        hostConfig.makeCssClassName('ac-fact-title')
                    );
                    if (this.hostConfig.factSet.title.maxWidth) {
                        tdElement.style.maxWidth =
                            this.hostConfig.factSet.title.maxWidth + 'px';
                    }
                    tdElement.style.verticalAlign = 'top';
                    var textBlock = new TextBlock();
                    textBlock.setParent(this);
                    textBlock.text = utils.isNullOrEmpty(this.facts[i].name)
                        ? 'Title'
                        : this.facts[i].name;
                    textBlock.size = this.hostConfig.factSet.title.size;
                    textBlock.color = this.hostConfig.factSet.title.color;
                    textBlock.isSubtle = this.hostConfig.factSet.title.isSubtle;
                    textBlock.weight = this.hostConfig.factSet.title.weight;
                    textBlock.wrap = this.hostConfig.factSet.title.wrap;
                    textBlock.spacing = enums.Spacing.None;
                    utils.appendChild(tdElement, textBlock.render());
                    utils.appendChild(trElement, tdElement);
                    // Spacer column
                    tdElement = document.createElement('td');
                    tdElement.style.width = '10px';
                    utils.appendChild(trElement, tdElement);
                    // Value column
                    tdElement = document.createElement('td');
                    tdElement.style.verticalAlign = 'top';
                    tdElement.classList.add(
                        hostConfig.makeCssClassName('ac-fact-value')
                    );
                    textBlock = new TextBlock();
                    textBlock.setParent(this);
                    textBlock.text = utils.isNullOrEmpty(this.facts[i].value)
                        ? 'Value'
                        : this.facts[i].value;
                    textBlock.size = this.hostConfig.factSet.value.size;
                    textBlock.color = this.hostConfig.factSet.value.color;
                    textBlock.isSubtle = this.hostConfig.factSet.value.isSubtle;
                    textBlock.weight = this.hostConfig.factSet.value.weight;
                    textBlock.wrap = this.hostConfig.factSet.value.wrap;
                    textBlock.spacing = enums.Spacing.None;
                    utils.appendChild(tdElement, textBlock.render());
                    utils.appendChild(trElement, tdElement);
                    utils.appendChild(element, trElement);
                }
            }
            return element;
        };
        FactSet.prototype.getJsonTypeName = function () {
            return 'FactSet';
        };
        FactSet.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            var facts = [];
            for (var _i = 0, _a = this.facts; _i < _a.length; _i++) {
                var fact = _a[_i];
                facts.push(fact.toJSON());
            }
            utils.setProperty(result, 'facts', facts);
            return result;
        };
        FactSet.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.facts = [];
            if (json['facts'] != null) {
                var jsonFacts = json['facts'];
                this.facts = [];
                for (var i = 0; i < jsonFacts.length; i++) {
                    var fact = new Fact();
                    fact.name = jsonFacts[i]['title'];
                    fact.value = jsonFacts[i]['value'];
                    fact.speak = jsonFacts[i]['speak'];
                    this.facts.push(fact);
                }
            }
        };
        FactSet.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak + '\n';
            }
            // render each fact
            var speak = null;
            if (this.facts.length > 0) {
                speak = '';
                for (var i = 0; i < this.facts.length; i++) {
                    var speech = this.facts[i].renderSpeech();
                    if (speech) {
                        speak += speech;
                    }
                }
            }
            return '<p>' + speak + '\n</p>\n';
        };
        return FactSet;
    })(CardElement);
    exports.FactSet = FactSet;
    var Image = /** @class */ (function (_super) {
        __extends(Image, _super);
        function Image() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.style = enums.ImageStyle.Default;
            _this.size = enums.Size.Auto;
            _this.pixelWidth = null;
            _this.pixelHeight = null;
            _this.altText = '';
            return _this;
        }
        Image.prototype.parseDimension = function (name, value, errors) {
            if (value) {
                if (typeof value === 'string') {
                    try {
                        var size = utils.SizeAndUnit.parse(value);
                        if (size.unit == enums.SizeUnit.Pixel) {
                            return size.physicalSize;
                        }
                    } catch (_a) {
                        // Ignore error
                    }
                }
                raiseParseError(
                    {
                        error: enums.ValidationError.InvalidPropertyValue,
                        message: 'Invalid image ' + name + ': ' + value
                    },
                    errors
                );
            }
            return 0;
        };
        Image.prototype.applySize = function (element) {
            if (this.pixelWidth || this.pixelHeight) {
                if (this.pixelWidth) {
                    element.style.width = this.pixelWidth + 'px';
                }
                if (this.pixelHeight) {
                    element.style.height = this.pixelHeight + 'px';
                }
            } else {
                switch (this.size) {
                    case enums.Size.Stretch:
                        element.style.width = '100%';
                        break;
                    case enums.Size.Auto:
                        element.style.maxWidth = '100%';
                        break;
                    case enums.Size.Small:
                        element.style.width =
                            this.hostConfig.imageSizes.small + 'px';
                        break;
                    case enums.Size.Large:
                        element.style.width =
                            this.hostConfig.imageSizes.large + 'px';
                        break;
                    case enums.Size.Medium:
                        element.style.width =
                            this.hostConfig.imageSizes.medium + 'px';
                        break;
                }
            }
        };
        Object.defineProperty(Image.prototype, 'useDefaultSizing', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Image.prototype.internalRender = function () {
            var _this = this;
            var element = null;
            if (!utils.isNullOrEmpty(this.url)) {
                element = document.createElement('div');
                element.style.display = 'flex';
                element.style.alignItems = 'flex-start';
                element.onkeypress = function (e) {
                    if (_this.selectAction) {
                        if (e.keyCode == 13 || e.keyCode == 32) {
                            // enter or space pressed
                            _this.selectAction.execute();
                        }
                    }
                };
                element.onclick = function (e) {
                    if (_this.selectAction) {
                        _this.selectAction.execute();
                        e.cancelBubble = true;
                    }
                };
                switch (this.horizontalAlignment) {
                    case enums.HorizontalAlignment.Center:
                        element.style.justifyContent = 'center';
                        break;
                    case enums.HorizontalAlignment.Right:
                        element.style.justifyContent = 'flex-end';
                        break;
                    default:
                        element.style.justifyContent = 'flex-start';
                        break;
                }
                // Cache hostConfig to avoid walking the parent hierarchy multiple times
                var hostConfig = this.hostConfig;
                var imageElement = document.createElement('img');
                imageElement.onload = function (e) {
                    raiseImageLoadedEvent(_this);
                };
                imageElement.onerror = function (e) {
                    var card = _this.getRootElement();
                    _this.renderedElement.innerHTML = '';
                    if (card && card.designMode) {
                        var errorElement = document.createElement('div');
                        errorElement.style.display = 'flex';
                        errorElement.style.alignItems = 'center';
                        errorElement.style.justifyContent = 'center';
                        errorElement.style.backgroundColor = '#EEEEEE';
                        errorElement.style.color = 'black';
                        errorElement.innerText = ':-(';
                        errorElement.style.padding = '10px';
                        _this.applySize(errorElement);
                        _this.renderedElement.appendChild(errorElement);
                    }
                    raiseImageLoadedEvent(_this);
                };
                imageElement.style.maxHeight = '100%';
                imageElement.style.minWidth = '0';
                imageElement.classList.add(
                    hostConfig.makeCssClassName('ac-image')
                );
                if (
                    this.selectAction != null &&
                    hostConfig.supportsInteractivity
                ) {
                    imageElement.tabIndex = 0;
                    imageElement.setAttribute('role', 'button');
                    imageElement.setAttribute(
                        'aria-label',
                        this.selectAction.title
                    );
                    imageElement.classList.add(
                        hostConfig.makeCssClassName('ac-selectable')
                    );
                }
                this.applySize(imageElement);
                if (this.style === enums.ImageStyle.Person) {
                    imageElement.style.borderRadius = '50%';
                    imageElement.style.backgroundPosition = '50% 50%';
                    imageElement.style.backgroundRepeat = 'no-repeat';
                }
                if (!utils.isNullOrEmpty(this.backgroundColor)) {
                    imageElement.style.backgroundColor = utils.stringToCssColor(
                        this.backgroundColor
                    );
                }
                imageElement.src = this.url;
                imageElement.alt = this.altText;
                element.appendChild(imageElement);
            }
            return element;
        };
        Image.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            if (this._selectAction) {
                utils.setProperty(
                    result,
                    'selectAction',
                    this._selectAction.toJSON()
                );
            }
            utils.setEnumProperty(
                enums.ImageStyle,
                result,
                'style',
                this.style,
                enums.ImageStyle.Default
            );
            utils.setProperty(result, 'backgroundColor', this.backgroundColor);
            utils.setProperty(result, 'url', this.url);
            utils.setEnumProperty(
                enums.Size,
                result,
                'size',
                this.size,
                enums.Size.Auto
            );
            if (this.pixelWidth) {
                utils.setProperty(result, 'width', this.pixelWidth + 'px');
            }
            if (this.pixelHeight) {
                utils.setProperty(result, 'height', this.pixelHeight + 'px');
            }
            utils.setProperty(result, 'altText', this.altText);
            return result;
        };
        Image.prototype.getJsonTypeName = function () {
            return 'Image';
        };
        Image.prototype.getActionById = function (id) {
            var result = _super.prototype.getActionById.call(this, id);
            if (!result && this.selectAction) {
                result = this.selectAction.getActionById(id);
            }
            return result;
        };
        Image.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.url = json['url'];
            this.backgroundColor = json['backgroundColor'];
            var styleString = json['style'];
            if (
                styleString &&
                typeof styleString === 'string' &&
                styleString.toLowerCase() === 'normal'
            ) {
                this.style = enums.ImageStyle.Default;
                raiseParseError(
                    {
                        error: enums.ValidationError.Deprecated,
                        message:
                            'The Image.style value "normal" is deprecated and will be removed. Use "default" instead.'
                    },
                    errors
                );
            } else {
                this.style = utils.getEnumValueOrDefault(
                    enums.ImageStyle,
                    styleString,
                    this.style
                );
            }
            this.size = utils.getEnumValueOrDefault(
                enums.Size,
                json['size'],
                this.size
            );
            this.altText = json['altText'];
            // pixelWidth and pixelHeight are only parsed for backwards compatibility.
            // Payloads should use the width and height proerties instead.
            if (json['pixelWidth'] && typeof json['pixelWidth'] === 'number') {
                this.pixelWidth = json['pixelWidth'];
                raiseParseError(
                    {
                        error: enums.ValidationError.Deprecated,
                        message:
                            'The pixelWidth property is deprecated and will be removed. Use the width property instead.'
                    },
                    errors
                );
            }
            if (
                json['pixelHeight'] &&
                typeof json['pixelHeight'] === 'number'
            ) {
                this.pixelHeight = json['pixelHeight'];
                raiseParseError(
                    {
                        error: enums.ValidationError.Deprecated,
                        message:
                            'The pixelHeight property is deprecated and will be removed. Use the height property instead.'
                    },
                    errors
                );
            }
            var size = this.parseDimension('width', json['width'], errors);
            if (size > 0) {
                this.pixelWidth = size;
            }
            size = this.parseDimension('height', json['height'], errors);
            if (size > 0) {
                this.pixelHeight = size;
            }
            this.selectAction = createActionInstance(
                this,
                json['selectAction'],
                errors
            );
        };
        Image.prototype.getResourceInformation = function () {
            if (!utils.isNullOrEmpty(this.url)) {
                return [{ url: this.url, mimeType: 'image' }];
            } else {
                return [];
            }
        };
        Image.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak + '\n';
            }
            return null;
        };
        Object.defineProperty(Image.prototype, 'selectAction', {
            get: function () {
                return this._selectAction;
            },
            set: function (value) {
                this._selectAction = value;
                if (this._selectAction) {
                    this._selectAction.setParent(this);
                }
            },
            enumerable: true,
            configurable: true
        });
        return Image;
    })(CardElement);
    exports.Image = Image;
    var ImageSet = /** @class */ (function (_super) {
        __extends(ImageSet, _super);
        function ImageSet() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._images = [];
            _this.imageSize = enums.Size.Medium;
            return _this;
        }
        ImageSet.prototype.internalRender = function () {
            var element = null;
            if (this._images.length > 0) {
                element = document.createElement('div');
                element.style.display = 'flex';
                element.style.flexWrap = 'wrap';
                for (var i = 0; i < this._images.length; i++) {
                    this._images[i].size = this.imageSize;
                    var renderedImage = this._images[i].render();
                    renderedImage.style.display = 'inline-flex';
                    renderedImage.style.margin = '0px';
                    renderedImage.style.marginRight = '10px';
                    renderedImage.style.maxHeight =
                        this.hostConfig.imageSet.maxImageHeight + 'px';
                    utils.appendChild(element, renderedImage);
                }
            }
            return element;
        };
        ImageSet.prototype.getItemCount = function () {
            return this._images.length;
        };
        ImageSet.prototype.getItemAt = function (index) {
            return this._images[index];
        };
        ImageSet.prototype.getResourceInformation = function () {
            var result = [];
            for (var _i = 0, _a = this._images; _i < _a.length; _i++) {
                var image = _a[_i];
                result = result.concat(image.getResourceInformation());
            }
            return result;
        };
        ImageSet.prototype.removeItem = function (item) {
            if (item instanceof Image) {
                var itemIndex = this._images.indexOf(item);
                if (itemIndex >= 0) {
                    this._images.splice(itemIndex, 1);
                    item.setParent(null);
                    this.updateLayout();
                    return true;
                }
            }
            return false;
        };
        ImageSet.prototype.getJsonTypeName = function () {
            return 'ImageSet';
        };
        ImageSet.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setEnumProperty(
                enums.Size,
                result,
                'imageSize',
                this.imageSize,
                enums.Size.Medium
            );
            if (this._images.length > 0) {
                var images = [];
                for (var _i = 0, _a = this._images; _i < _a.length; _i++) {
                    var image = _a[_i];
                    images.push(image.toJSON());
                }
                utils.setProperty(result, 'images', images);
            }
            return result;
        };
        ImageSet.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.imageSize = utils.getEnumValueOrDefault(
                enums.Size,
                json['imageSize'],
                enums.Size.Medium
            );
            if (json['images'] != null) {
                var jsonImages = json['images'];
                this._images = [];
                for (var i = 0; i < jsonImages.length; i++) {
                    var image = new Image();
                    image.parse(jsonImages[i], errors);
                    this.addImage(image);
                }
            }
        };
        ImageSet.prototype.addImage = function (image) {
            if (!image.parent) {
                this._images.push(image);
                image.setParent(this);
            } else {
                throw new Error(
                    'This image already belongs to another ImageSet'
                );
            }
        };
        ImageSet.prototype.indexOf = function (cardElement) {
            return cardElement instanceof Image
                ? this._images.indexOf(cardElement)
                : -1;
        };
        ImageSet.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak;
            }
            var speak = null;
            if (this._images.length > 0) {
                speak = '';
                for (var i = 0; i < this._images.length; i++) {
                    speak += this._images[i].renderSpeech();
                }
            }
            return speak;
        };
        return ImageSet;
    })(CardElementContainer);
    exports.ImageSet = ImageSet;
    var MediaSource = /** @class */ (function () {
        function MediaSource(url, mimeType) {
            if (url === void 0) {
                url = undefined;
            }
            if (mimeType === void 0) {
                mimeType = undefined;
            }
            this.url = url;
            this.mimeType = mimeType;
        }
        MediaSource.prototype.parse = function (json, errors) {
            this.mimeType = json['mimeType'];
            this.url = json['url'];
        };
        MediaSource.prototype.toJSON = function () {
            return {
                mimeType: this.mimeType,
                url: this.url
            };
        };
        return MediaSource;
    })();
    exports.MediaSource = MediaSource;
    var Media = /** @class */ (function (_super) {
        __extends(Media, _super);
        function Media() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.sources = [];
            return _this;
        }
        Media.prototype.getPosterUrl = function () {
            return this.poster
                ? this.poster
                : this.hostConfig.media.defaultPoster;
        };
        Media.prototype.processSources = function () {
            this._selectedSources = [];
            this._selectedMediaType = undefined;
            for (var _i = 0, _a = this.sources; _i < _a.length; _i++) {
                var source = _a[_i];
                var mimeComponents = source.mimeType.split('/');
                if (mimeComponents.length == 2) {
                    if (!this._selectedMediaType) {
                        var index = Media.supportedMediaTypes.indexOf(
                            mimeComponents[0]
                        );
                        if (index >= 0) {
                            this._selectedMediaType =
                                Media.supportedMediaTypes[index];
                        }
                    }
                    if (mimeComponents[0] == this._selectedMediaType) {
                        this._selectedSources.push(source);
                    }
                }
            }
        };
        Media.prototype.renderPoster = function () {
            var _this = this;
            var playButtonArrowWidth = 12;
            var playButtonArrowHeight = 15;
            var posterRootElement = document.createElement('div');
            posterRootElement.className = 'ac-media-poster';
            posterRootElement.setAttribute('role', 'contentinfo');
            posterRootElement.setAttribute(
                'aria-label',
                this.altText ? this.altText : 'Media content'
            );
            posterRootElement.style.position = 'relative';
            posterRootElement.style.display = 'flex';
            var posterUrl = this.getPosterUrl();
            if (posterUrl) {
                var posterImageElement_1 = document.createElement('img');
                posterImageElement_1.style.width = '100%';
                posterImageElement_1.style.height = '100%';
                posterImageElement_1.onerror = function (e) {
                    posterImageElement_1.parentNode.removeChild(
                        posterImageElement_1
                    );
                    posterRootElement.classList.add('empty');
                    posterRootElement.style.minHeight = '150px';
                };
                posterImageElement_1.src = posterUrl;
                posterRootElement.appendChild(posterImageElement_1);
            } else {
                posterRootElement.classList.add('empty');
                posterRootElement.style.minHeight = '150px';
            }
            if (
                this.hostConfig.supportsInteractivity &&
                this._selectedSources.length > 0
            ) {
                var playButtonOuterElement = document.createElement('div');
                playButtonOuterElement.setAttribute('role', 'button');
                playButtonOuterElement.setAttribute('aria-label', 'Play media');
                playButtonOuterElement.className = 'ac-media-playButton';
                playButtonOuterElement.style.display = 'flex';
                playButtonOuterElement.style.alignItems = 'center';
                playButtonOuterElement.style.justifyContent = 'center';
                playButtonOuterElement.onclick = function (e) {
                    if (_this.hostConfig.media.allowInlinePlayback) {
                        var mediaPlayerElement = _this.renderMediaPlayer();
                        _this.renderedElement.innerHTML = '';
                        _this.renderedElement.appendChild(mediaPlayerElement);
                        mediaPlayerElement.play();
                    } else {
                        if (Media.onPlay) {
                            Media.onPlay(_this);
                        }
                    }
                };
                var playButtonInnerElement = document.createElement('div');
                playButtonInnerElement.className = 'ac-media-playButton-arrow';
                playButtonInnerElement.style.width =
                    playButtonArrowWidth + 'px';
                playButtonInnerElement.style.height =
                    playButtonArrowHeight + 'px';
                playButtonInnerElement.style.borderTopWidth =
                    playButtonArrowHeight / 2 + 'px';
                playButtonInnerElement.style.borderBottomWidth =
                    playButtonArrowHeight / 2 + 'px';
                playButtonInnerElement.style.borderLeftWidth =
                    playButtonArrowWidth + 'px';
                playButtonInnerElement.style.borderRightWidth = '0';
                playButtonInnerElement.style.borderStyle = 'solid';
                playButtonInnerElement.style.borderTopColor = 'transparent';
                playButtonInnerElement.style.borderRightColor = 'transparent';
                playButtonInnerElement.style.borderBottomColor = 'transparent';
                playButtonInnerElement.style.transform =
                    'translate(' + playButtonArrowWidth / 10 + 'px,0px)';
                playButtonOuterElement.appendChild(playButtonInnerElement);
                var playButtonContainer = document.createElement('div');
                playButtonContainer.style.position = 'absolute';
                playButtonContainer.style.left = '0';
                playButtonContainer.style.top = '0';
                playButtonContainer.style.width = '100%';
                playButtonContainer.style.height = '100%';
                playButtonContainer.style.display = 'flex';
                playButtonContainer.style.justifyContent = 'center';
                playButtonContainer.style.alignItems = 'center';
                playButtonContainer.appendChild(playButtonOuterElement);
                posterRootElement.appendChild(playButtonContainer);
            }
            return posterRootElement;
        };
        Media.prototype.renderMediaPlayer = function () {
            var mediaElement;
            if (this._selectedMediaType == 'video') {
                var videoPlayer = document.createElement('video');
                var posterUrl = this.getPosterUrl();
                if (posterUrl) {
                    videoPlayer.poster = posterUrl;
                }
                mediaElement = videoPlayer;
            } else {
                mediaElement = document.createElement('audio');
            }
            mediaElement.controls = true;
            mediaElement.preload = 'none';
            mediaElement.style.width = '100%';
            for (var _i = 0, _a = this.sources; _i < _a.length; _i++) {
                var source = _a[_i];
                var src = document.createElement('source');
                src.src = source.url;
                src.type = source.mimeType;
                mediaElement.appendChild(src);
            }
            return mediaElement;
        };
        Media.prototype.internalRender = function () {
            var element = document.createElement('div');
            element.className = this.hostConfig.makeCssClassName('ac-media');
            this.processSources();
            element.appendChild(this.renderPoster());
            return element;
        };
        Media.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.poster = json['poster'];
            this.altText = json['altText'];
            if (json['sources'] != null) {
                var jsonSources = json['sources'];
                this.sources = [];
                for (var i = 0; i < jsonSources.length; i++) {
                    var source = new MediaSource();
                    source.parse(jsonSources[i], errors);
                    this.sources.push(source);
                }
            }
        };
        Media.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'poster', this.poster);
            utils.setProperty(result, 'altText', this.altText);
            if (this.sources.length > 0) {
                var serializedSources = [];
                for (var _i = 0, _a = this.sources; _i < _a.length; _i++) {
                    var source = _a[_i];
                    serializedSources.push(source.toJSON());
                }
                utils.setProperty(result, 'sources', serializedSources);
            }
            return result;
        };
        Media.prototype.getJsonTypeName = function () {
            return 'Media';
        };
        Media.prototype.getResourceInformation = function () {
            var result = [];
            var posterUrl = this.getPosterUrl();
            if (!utils.isNullOrEmpty(posterUrl)) {
                result.push({ url: posterUrl, mimeType: 'image' });
            }
            for (var _i = 0, _a = this.sources; _i < _a.length; _i++) {
                var mediaSource = _a[_i];
                if (!utils.isNullOrEmpty(mediaSource.url)) {
                    result.push({
                        url: mediaSource.url,
                        mimeType: mediaSource.mimeType
                    });
                }
            }
            return result;
        };
        Media.prototype.renderSpeech = function () {
            return this.altText;
        };
        Object.defineProperty(Media.prototype, 'selectedMediaType', {
            get: function () {
                return this._selectedMediaType;
            },
            enumerable: true,
            configurable: true
        });
        Media.supportedMediaTypes = ['audio', 'video'];
        return Media;
    })(CardElement);
    exports.Media = Media;
    var Input = /** @class */ (function (_super) {
        __extends(Input, _super);
        function Input() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        Input.prototype.valueChanged = function () {
            if (this.onValueChanged) {
                this.onValueChanged(this);
            }
        };
        Input.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'title', this.title);
            utils.setProperty(
                result,
                'value',
                this.renderedElement ? this.value : this.defaultValue
            );
            return result;
        };
        Input.prototype.validate = function () {
            if (!this.id) {
                return [
                    {
                        error: enums.ValidationError.PropertyCantBeNull,
                        message: 'All inputs must have a unique Id'
                    }
                ];
            } else {
                return [];
            }
        };
        Input.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.id = json['id'];
            this.defaultValue = json['value'];
        };
        Input.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak;
            }
            if (this.title) {
                return '<s>' + this.title + '</s>\n';
            }
            return null;
        };
        Input.prototype.getAllInputs = function () {
            return [this];
        };
        Object.defineProperty(Input.prototype, 'isInteractive', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        return Input;
    })(CardElement);
    exports.Input = Input;
    var TextInput = /** @class */ (function (_super) {
        __extends(TextInput, _super);
        function TextInput() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.style = enums.InputTextStyle.Text;
            return _this;
        }
        TextInput.prototype.internalRender = function () {
            var _this = this;
            if (this.isMultiline) {
                this._textareaElement = document.createElement('textarea');
                this._textareaElement.className = this.hostConfig.makeCssClassName(
                    'ac-input',
                    'ac-textInput',
                    'ac-multiline'
                );
                this._textareaElement.style.width = '100%';
                this._textareaElement.tabIndex = 0;
                if (!utils.isNullOrEmpty(this.placeholder)) {
                    this._textareaElement.placeholder = this.placeholder;
                    this._textareaElement.setAttribute(
                        'aria-label',
                        this.placeholder
                    );
                }
                if (!utils.isNullOrEmpty(this.defaultValue)) {
                    this._textareaElement.value = this.defaultValue;
                }
                if (this.maxLength > 0) {
                    this._textareaElement.maxLength = this.maxLength;
                }
                this._textareaElement.oninput = function () {
                    _this.valueChanged();
                };
                return this._textareaElement;
            } else {
                this._inputElement = document.createElement('input');
                this._inputElement.type = enums.InputTextStyle[
                    this.style
                ].toLowerCase();
                this._inputElement.className = this.hostConfig.makeCssClassName(
                    'ac-input',
                    'ac-textInput'
                );
                this._inputElement.style.width = '100%';
                this._inputElement.tabIndex = 0;
                if (!utils.isNullOrEmpty(this.placeholder)) {
                    this._inputElement.placeholder = this.placeholder;
                    this._inputElement.setAttribute(
                        'aria-label',
                        this.placeholder
                    );
                }
                if (!utils.isNullOrEmpty(this.defaultValue)) {
                    this._inputElement.value = this.defaultValue;
                }
                if (this.maxLength > 0) {
                    this._inputElement.maxLength = this.maxLength;
                }
                this._inputElement.oninput = function () {
                    _this.valueChanged();
                };
                return this._inputElement;
            }
        };
        TextInput.prototype.getJsonTypeName = function () {
            return 'Input.Text';
        };
        TextInput.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'placeholder', this.placeholder);
            utils.setProperty(result, 'maxLength', this.maxLength, 0);
            utils.setProperty(result, 'isMultiline', this.isMultiline, false);
            utils.setEnumProperty(
                enums.InputTextStyle,
                result,
                'style',
                this.style,
                enums.InputTextStyle.Text
            );
            return result;
        };
        TextInput.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.maxLength = json['maxLength'];
            this.isMultiline = json['isMultiline'];
            this.placeholder = json['placeholder'];
            this.style = utils.getEnumValueOrDefault(
                enums.InputTextStyle,
                json['style'],
                this.style
            );
        };
        Object.defineProperty(TextInput.prototype, 'value', {
            get: function () {
                if (this.isMultiline) {
                    return this._textareaElement
                        ? this._textareaElement.value
                        : null;
                } else {
                    return this._inputElement ? this._inputElement.value : null;
                }
            },
            enumerable: true,
            configurable: true
        });
        return TextInput;
    })(Input);
    exports.TextInput = TextInput;
    var ToggleInput = /** @class */ (function (_super) {
        __extends(ToggleInput, _super);
        function ToggleInput() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.valueOn = 'true';
            _this.valueOff = 'false';
            return _this;
        }
        ToggleInput.prototype.internalRender = function () {
            var _this = this;
            var element = document.createElement('div');
            element.className = this.hostConfig.makeCssClassName('ac-input');
            element.style.width = '100%';
            element.style.display = 'flex';
            element.style.alignItems = 'center';
            this._checkboxInputElement = document.createElement('input');
            this._checkboxInputElement.id = generateUniqueId();
            this._checkboxInputElement.type = 'checkbox';
            this._checkboxInputElement.style.display = 'inline-block';
            this._checkboxInputElement.style.verticalAlign = 'middle';
            this._checkboxInputElement.style.margin = '0';
            this._checkboxInputElement.style.flex = '0 0 auto';
            this._checkboxInputElement.setAttribute('aria-label', this.title);
            this._checkboxInputElement.tabIndex = 0;
            if (this.defaultValue == this.valueOn) {
                this._checkboxInputElement.checked = true;
            }
            this._checkboxInputElement.onchange = function () {
                _this.valueChanged();
            };
            utils.appendChild(element, this._checkboxInputElement);
            if (!utils.isNullOrEmpty(this.title) || this.isDesignMode()) {
                var label = new Label();
                label.setParent(this);
                label.forElementId = this._checkboxInputElement.id;
                label.hostConfig = this.hostConfig;
                label.text = utils.isNullOrEmpty(this.title)
                    ? this.getJsonTypeName()
                    : this.title;
                label.useMarkdown =
                    AdaptiveCard.useMarkdownInRadioButtonAndCheckbox;
                var labelElement = label.render();
                labelElement.style.display = 'inline-block';
                labelElement.style.flex = '1 1 auto';
                labelElement.style.verticalAlign = 'middle';
                var spacerElement = document.createElement('div');
                spacerElement.style.width = '6px';
                utils.appendChild(element, spacerElement);
                utils.appendChild(element, labelElement);
            }
            return element;
        };
        ToggleInput.prototype.getJsonTypeName = function () {
            return 'Input.Toggle';
        };
        ToggleInput.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'valueOn', this.valueOn, 'true');
            utils.setProperty(result, 'valueOff', this.valueOff, 'false');
            return result;
        };
        ToggleInput.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.title = json['title'];
            this.valueOn = utils.getValueOrDefault(
                json['valueOn'],
                this.valueOn
            );
            this.valueOff = utils.getValueOrDefault(
                json['valueOff'],
                this.valueOff
            );
        };
        Object.defineProperty(ToggleInput.prototype, 'value', {
            get: function () {
                if (this._checkboxInputElement) {
                    return this._checkboxInputElement.checked
                        ? this.valueOn
                        : this.valueOff;
                } else {
                    return null;
                }
            },
            enumerable: true,
            configurable: true
        });
        return ToggleInput;
    })(Input);
    exports.ToggleInput = ToggleInput;
    var Choice = /** @class */ (function () {
        function Choice(title, value) {
            if (title === void 0) {
                title = undefined;
            }
            if (value === void 0) {
                value = undefined;
            }
            this.title = title;
            this.value = value;
        }
        Choice.prototype.toJSON = function () {
            return { title: this.title, value: this.value };
        };
        return Choice;
    })();
    exports.Choice = Choice;
    var ChoiceSetInput = /** @class */ (function (_super) {
        __extends(ChoiceSetInput, _super);
        function ChoiceSetInput() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.choices = [];
            return _this;
        }
        ChoiceSetInput.getUniqueCategoryName = function () {
            var uniqueCwtegoryName =
                '__ac-category' + ChoiceSetInput.uniqueCategoryCounter;
            ChoiceSetInput.uniqueCategoryCounter++;
            return uniqueCwtegoryName;
        };
        ChoiceSetInput.prototype.internalRender = function () {
            var _this = this;
            if (!this.isMultiSelect) {
                if (this.isCompact) {
                    // Render as a combo box
                    this._selectElement = document.createElement('select');
                    this._selectElement.className = this.hostConfig.makeCssClassName(
                        'ac-input',
                        'ac-multichoiceInput'
                    );
                    this._selectElement.style.width = '100%';
                    var option = document.createElement('option');
                    option.selected = true;
                    option.disabled = true;
                    option.hidden = true;
                    option.value = '';
                    if (this.placeholder) {
                        option.text = this.placeholder;
                    }
                    utils.appendChild(this._selectElement, option);
                    for (var i = 0; i < this.choices.length; i++) {
                        var option_1 = document.createElement('option');
                        option_1.value = this.choices[i].value;
                        option_1.text = this.choices[i].title;
                        option_1.setAttribute(
                            'aria-label',
                            this.choices[i].title
                        );
                        if (this.choices[i].value == this.defaultValue) {
                            option_1.selected = true;
                        }
                        utils.appendChild(this._selectElement, option_1);
                    }
                    this._selectElement.onchange = function () {
                        _this.valueChanged();
                    };
                    return this._selectElement;
                } else {
                    // Render as a series of radio buttons
                    var uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
                    var element = document.createElement('div');
                    element.className = this.hostConfig.makeCssClassName(
                        'ac-input'
                    );
                    element.style.width = '100%';
                    this._toggleInputs = [];
                    for (var i_1 = 0; i_1 < this.choices.length; i_1++) {
                        var radioInput = document.createElement('input');
                        radioInput.id = generateUniqueId();
                        radioInput.type = 'radio';
                        radioInput.style.margin = '0';
                        radioInput.style.display = 'inline-block';
                        radioInput.style.verticalAlign = 'middle';
                        radioInput.name = utils.isNullOrEmpty(this.id)
                            ? uniqueCategoryName
                            : this.id;
                        radioInput.value = this.choices[i_1].value;
                        radioInput.style.flex = '0 0 auto';
                        radioInput.setAttribute(
                            'aria-label',
                            this.choices[i_1].title
                        );
                        if (this.choices[i_1].value == this.defaultValue) {
                            radioInput.checked = true;
                        }
                        radioInput.onchange = function () {
                            _this.valueChanged();
                        };
                        this._toggleInputs.push(radioInput);
                        var label = new Label();
                        label.setParent(this);
                        label.forElementId = radioInput.id;
                        label.hostConfig = this.hostConfig;
                        label.text = utils.isNullOrEmpty(
                            this.choices[i_1].title
                        )
                            ? 'Choice ' + i_1
                            : this.choices[i_1].title;
                        label.useMarkdown =
                            AdaptiveCard.useMarkdownInRadioButtonAndCheckbox;
                        var labelElement = label.render();
                        labelElement.style.display = 'inline-block';
                        labelElement.style.flex = '1 1 auto';
                        labelElement.style.marginLeft = '6px';
                        labelElement.style.verticalAlign = 'middle';
                        var spacerElement = document.createElement('div');
                        spacerElement.style.width = '6px';
                        var compoundInput = document.createElement('div');
                        compoundInput.style.display = 'flex';
                        utils.appendChild(compoundInput, radioInput);
                        utils.appendChild(compoundInput, spacerElement);
                        utils.appendChild(compoundInput, labelElement);
                        utils.appendChild(element, compoundInput);
                    }
                    return element;
                }
            } else {
                // Render as a list of toggle inputs
                var defaultValues = this.defaultValue
                    ? this.defaultValue.split(
                        this.hostConfig.choiceSetInputValueSeparator
                    )
                    : null;
                var element = document.createElement('div');
                element.className = this.hostConfig.makeCssClassName(
                    'ac-input'
                );
                element.style.width = '100%';
                this._toggleInputs = [];
                for (var i_2 = 0; i_2 < this.choices.length; i_2++) {
                    var checkboxInput = document.createElement('input');
                    checkboxInput.id = generateUniqueId();
                    checkboxInput.type = 'checkbox';
                    checkboxInput.style.margin = '0';
                    checkboxInput.style.display = 'inline-block';
                    checkboxInput.style.verticalAlign = 'middle';
                    checkboxInput.value = this.choices[i_2].value;
                    checkboxInput.style.flex = '0 0 auto';
                    checkboxInput.setAttribute(
                        'aria-label',
                        this.choices[i_2].title
                    );
                    if (defaultValues) {
                        if (
                            defaultValues.indexOf(this.choices[i_2].value) >= 0
                        ) {
                            checkboxInput.checked = true;
                        }
                    }
                    checkboxInput.onchange = function () {
                        _this.valueChanged();
                    };
                    this._toggleInputs.push(checkboxInput);
                    var label = new Label();
                    label.setParent(this);
                    label.forElementId = checkboxInput.id;
                    label.hostConfig = this.hostConfig;
                    label.text = utils.isNullOrEmpty(this.choices[i_2].title)
                        ? 'Choice ' + i_2
                        : this.choices[i_2].title;
                    label.useMarkdown =
                        AdaptiveCard.useMarkdownInRadioButtonAndCheckbox;
                    var labelElement = label.render();
                    labelElement.style.display = 'inline-block';
                    labelElement.style.flex = '1 1 auto';
                    // labelElement.style.marginLeft = "6px";
                    labelElement.style.verticalAlign = 'middle';
                    var spacerElement = document.createElement('div');
                    spacerElement.style.width = '6px';
                    var compoundInput = document.createElement('div');
                    compoundInput.style.display = 'flex';
                    compoundInput.style.alignItems = 'center';
                    utils.appendChild(compoundInput, checkboxInput);
                    utils.appendChild(compoundInput, spacerElement);
                    utils.appendChild(compoundInput, labelElement);
                    utils.appendChild(element, compoundInput);
                }
                return element;
            }
        };
        ChoiceSetInput.prototype.getJsonTypeName = function () {
            return 'Input.ChoiceSet';
        };
        ChoiceSetInput.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'placeholder', this.placeholder);
            if (this.choices.length > 0) {
                var choices = [];
                for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
                    var choice = _a[_i];
                    choices.push(choice.toJSON());
                }
                utils.setProperty(result, 'choices', choices);
            }
            if (!this.isCompact) {
                utils.setProperty(result, 'style', 'expanded', false);
            }
            utils.setProperty(
                result,
                'isMultiSelect',
                this.isMultiSelect,
                false
            );
            return result;
        };
        ChoiceSetInput.prototype.validate = function () {
            var result = [];
            if (this.choices.length == 0) {
                result = [
                    {
                        error: enums.ValidationError.CollectionCantBeEmpty,
                        message:
                            'An Input.ChoiceSet must have at least one choice defined.'
                    }
                ];
            }
            for (var i = 0; i < this.choices.length; i++) {
                if (!this.choices[i].title || !this.choices[i].value) {
                    result = result.concat([
                        {
                            error: enums.ValidationError.PropertyCantBeNull,
                            message:
                                'All choices in an Input.ChoiceSet must have their title and value properties set.'
                        }
                    ]);
                    break;
                }
            }
            return result;
        };
        ChoiceSetInput.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.isCompact = !(json['style'] === 'expanded');
            this.isMultiSelect = json['isMultiSelect'];
            this.placeholder = json['placeholder'];
            this.choices = [];
            if (json['choices'] != undefined) {
                var choiceArray = json['choices'];
                for (var i = 0; i < choiceArray.length; i++) {
                    var choice = new Choice();
                    choice.title = choiceArray[i]['title'];
                    choice.value = choiceArray[i]['value'];
                    this.choices.push(choice);
                }
            }
        };
        Object.defineProperty(ChoiceSetInput.prototype, 'value', {
            get: function () {
                if (!this.isMultiSelect) {
                    if (this.isCompact) {
                        return this._selectElement
                            ? this._selectElement.value
                            : null;
                    } else {
                        if (
                            !this._toggleInputs ||
                            this._toggleInputs.length == 0
                        ) {
                            return null;
                        }
                        for (var i = 0; i < this._toggleInputs.length; i++) {
                            if (this._toggleInputs[i].checked) {
                                return this._toggleInputs[i].value;
                            }
                        }
                        return null;
                    }
                } else {
                    if (!this._toggleInputs || this._toggleInputs.length == 0) {
                        return null;
                    }
                    var result = '';
                    for (var i = 0; i < this._toggleInputs.length; i++) {
                        if (this._toggleInputs[i].checked) {
                            if (result != '') {
                                result += this.hostConfig
                                    .choiceSetInputValueSeparator;
                            }
                            result += this._toggleInputs[i].value;
                        }
                    }
                    return result == '' ? null : result;
                }
            },
            enumerable: true,
            configurable: true
        });
        ChoiceSetInput.uniqueCategoryCounter = 0;
        return ChoiceSetInput;
    })(Input);
    exports.ChoiceSetInput = ChoiceSetInput;
    var NumberInput = /** @class */ (function (_super) {
        __extends(NumberInput, _super);
        function NumberInput() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        NumberInput.prototype.internalRender = function () {
            var _this = this;
            this._numberInputElement = document.createElement('input');
            this._numberInputElement.setAttribute('type', 'number');
            this._numberInputElement.className = this.hostConfig.makeCssClassName(
                'ac-input',
                'ac-numberInput'
            );
            this._numberInputElement.setAttribute('min', this.min);
            this._numberInputElement.setAttribute('max', this.max);
            this._numberInputElement.style.width = '100%';
            this._numberInputElement.tabIndex = 0;
            if (!utils.isNullOrEmpty(this.defaultValue)) {
                this._numberInputElement.value = this.defaultValue;
            }
            if (!utils.isNullOrEmpty(this.placeholder)) {
                this._numberInputElement.placeholder = this.placeholder;
                this._numberInputElement.setAttribute(
                    'aria-label',
                    this.placeholder
                );
            }
            this._numberInputElement.oninput = function () {
                _this.valueChanged();
            };
            return this._numberInputElement;
        };
        NumberInput.prototype.getJsonTypeName = function () {
            return 'Input.Number';
        };
        NumberInput.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'placeholder', this.placeholder);
            utils.setProperty(result, 'min', this.min);
            utils.setProperty(result, 'max', this.max);
            return result;
        };
        NumberInput.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.placeholder = json['placeholder'];
            this.min = json['min'];
            this.max = json['max'];
        };
        Object.defineProperty(NumberInput.prototype, 'value', {
            get: function () {
                return this._numberInputElement
                    ? this._numberInputElement.value
                    : null;
            },
            enumerable: true,
            configurable: true
        });
        return NumberInput;
    })(Input);
    exports.NumberInput = NumberInput;
    var DateInput = /** @class */ (function (_super) {
        __extends(DateInput, _super);
        function DateInput() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        DateInput.prototype.internalRender = function () {
            this._dateInputElement = document.createElement('input');
            this._dateInputElement.setAttribute('type', 'date');
            this._dateInputElement.className = this.hostConfig.makeCssClassName(
                'ac-input',
                'ac-dateInput'
            );
            this._dateInputElement.style.width = '100%';
            if (!utils.isNullOrEmpty(this.defaultValue)) {
                this._dateInputElement.value = this.defaultValue;
            }
            return this._dateInputElement;
        };
        DateInput.prototype.getJsonTypeName = function () {
            return 'Input.Date';
        };
        Object.defineProperty(DateInput.prototype, 'value', {
            get: function () {
                return this._dateInputElement
                    ? this._dateInputElement.value
                    : null;
            },
            enumerable: true,
            configurable: true
        });
        return DateInput;
    })(Input);
    exports.DateInput = DateInput;
    var TimeInput = /** @class */ (function (_super) {
        __extends(TimeInput, _super);
        function TimeInput() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        TimeInput.prototype.internalRender = function () {
            this._timeInputElement = document.createElement('input');
            this._timeInputElement.setAttribute('type', 'time');
            this._timeInputElement.className = this.hostConfig.makeCssClassName(
                'ac-input',
                'ac-timeInput'
            );
            this._timeInputElement.style.width = '100%';
            if (!utils.isNullOrEmpty(this.defaultValue)) {
                this._timeInputElement.value = this.defaultValue;
            }
            return this._timeInputElement;
        };
        TimeInput.prototype.getJsonTypeName = function () {
            return 'Input.Time';
        };
        Object.defineProperty(TimeInput.prototype, 'value', {
            get: function () {
                return this._timeInputElement
                    ? this._timeInputElement.value
                    : null;
            },
            enumerable: true,
            configurable: true
        });
        return TimeInput;
    })(Input);
    exports.TimeInput = TimeInput;
    var ActionButtonState;
    (function (ActionButtonState) {
        ActionButtonState[(ActionButtonState['Normal'] = 0)] = 'Normal';
        ActionButtonState[(ActionButtonState['Expanded'] = 1)] = 'Expanded';
        ActionButtonState[(ActionButtonState['Subdued'] = 2)] = 'Subdued';
    })(ActionButtonState || (ActionButtonState = {}));
    var ActionButton = /** @class */ (function () {
        function ActionButton(action, parentContainerStyle) {
            this._element = null;
            this._state = ActionButtonState.Normal;
            this.onClick = null;
            this.action = action;
            this._parentContainerStyle = parentContainerStyle;
        }
        ActionButton.prototype.updateCssStyle = function () {
            var hostConfig = this.action.parent.hostConfig;
            this.action.renderedElement.className = hostConfig.makeCssClassName(
                'ac-pushButton'
            );
            this.action.renderedElement.classList.add(
                'style-' + this._parentContainerStyle
            );
            if (this.action instanceof ShowCardAction) {
                this.action.renderedElement.classList.add(
                    hostConfig.makeCssClassName('expandable')
                );
            }
            this.action.renderedElement.classList.remove(
                hostConfig.makeCssClassName('expanded')
            );
            this.action.renderedElement.classList.remove(
                hostConfig.makeCssClassName('subdued')
            );
            switch (this._state) {
                case ActionButtonState.Expanded:
                    this.action.renderedElement.classList.add(
                        hostConfig.makeCssClassName('expanded')
                    );
                    break;
                case ActionButtonState.Subdued:
                    this.action.renderedElement.classList.add(
                        hostConfig.makeCssClassName('subdued')
                    );
                    break;
            }
            if (this.action.isPrimary) {
                this.action.renderedElement.classList.add(
                    hostConfig.makeCssClassName('primary')
                );
            }
        };
        ActionButton.prototype.render = function (alignment) {
            var _this = this;
            this.action.render();
            this.action.renderedElement.style.flex =
                alignment === enums.ActionAlignment.Stretch
                    ? '0 1 100%'
                    : '0 1 auto';
            this.action.renderedElement.onclick = function (e) {
                _this.click();
            };
            this.updateCssStyle();
        };
        ActionButton.prototype.click = function () {
            if (this.onClick != null) {
                this.onClick(this);
            }
        };
        Object.defineProperty(ActionButton.prototype, 'state', {
            get: function () {
                return this._state;
            },
            set: function (value) {
                this._state = value;
                this.updateCssStyle();
            },
            enumerable: true,
            configurable: true
        });
        return ActionButton;
    })();
    var Action = /** @class */ (function () {
        function Action() {
            this._shouldFallback = false;
            this._parent = null;
            this._actionCollection = null; // hold the reference to its action collection
            this._renderedElement = null;
            this.requires = new hostConfig.HostCapabilities();
        }
        Action.prototype.setCollection = function (actionCollection) {
            this._actionCollection = actionCollection;
        };
        Action.prototype.addCssClasses = function (element) {
            // Do nothing in base implementation
        };
        Action.prototype.toJSON = function () {
            var result = {};
            utils.setProperty(result, 'type', this.getJsonTypeName());
            utils.setProperty(result, 'id', this.id);
            utils.setProperty(result, 'title', this.title);
            utils.setProperty(result, 'iconUrl', this.iconUrl);
            return result;
        };
        Action.prototype.render = function () {
            // Cache hostConfig for perf
            var hostConfig = this.parent.hostConfig;
            var buttonElement = document.createElement('button');
            buttonElement.className = hostConfig.makeCssClassName(
                'ac-pushButton'
            );
            this.addCssClasses(buttonElement);
            buttonElement.setAttribute('aria-label', this.title);
            buttonElement.type = 'button';
            buttonElement.style.display = 'flex';
            buttonElement.style.alignItems = 'center';
            buttonElement.style.justifyContent = 'center';
            var hasTitle = !utils.isNullOrEmpty(this.title);
            var titleElement = document.createElement('div');
            titleElement.style.overflow = 'hidden';
            titleElement.style.textOverflow = 'ellipsis';
            if (
                !(
                    hostConfig.actions.iconPlacement ==
                    enums.ActionIconPlacement.AboveTitle ||
                    hostConfig.actions.allowTitleToWrap
                )
            ) {
                titleElement.style.whiteSpace = 'nowrap';
            }
            if (hasTitle) {
                titleElement.innerText = this.title;
            }
            if (utils.isNullOrEmpty(this.iconUrl)) {
                buttonElement.classList.add('noIcon');
                buttonElement.appendChild(titleElement);
            } else {
                var iconElement = document.createElement('img');
                iconElement.src = this.iconUrl;
                iconElement.style.width = hostConfig.actions.iconSize + 'px';
                iconElement.style.height = hostConfig.actions.iconSize + 'px';
                iconElement.style.flex = '0 0 auto';
                if (
                    hostConfig.actions.iconPlacement ==
                    enums.ActionIconPlacement.AboveTitle
                ) {
                    buttonElement.classList.add('iconAbove');
                    buttonElement.style.flexDirection = 'column';
                    if (hasTitle) {
                        iconElement.style.marginBottom = '4px';
                    }
                } else {
                    buttonElement.classList.add('iconLeft');
                    if (hasTitle) {
                        iconElement.style.marginRight = '4px';
                    }
                }
                buttonElement.appendChild(iconElement);
                buttonElement.appendChild(titleElement);
            }
            this._renderedElement = buttonElement;
        };
        Action.prototype.setParent = function (value) {
            this._parent = value;
        };
        Action.prototype.execute = function () {
            if (this.onExecute) {
                this.onExecute(this);
            }
            raiseExecuteActionEvent(this);
        };
        // Expand the action card pane with a inline status card
        // Null status will clear the status bar
        Action.prototype.setStatus = function (status) {
            if (this._actionCollection == null) {
                return;
            }
            if (status) {
                var statusCard = new InlineAdaptiveCard();
                statusCard.parse(status);
                this._actionCollection.showStatusCard(statusCard);
            } else {
                this._actionCollection.hideStatusCard();
            }
        };
        Action.prototype.validate = function () {
            return [];
        };
        Action.prototype.prepare = function (inputs) {
            // Do nothing in base implementation
        };
        Action.prototype.parse = function (json, errors) {
            raiseParseActionEvent(this, json, errors);
            this.requires.parse(json['requires'], errors);
            this.id = json['id'];
            if (!json['title'] && json['title'] !== '') {
                raiseParseError(
                    {
                        error: enums.ValidationError.PropertyCantBeNull,
                        message: 'Actions should always have a title.'
                    },
                    errors
                );
            }
            this.title = json['title'];
            this.iconUrl = json['iconUrl'];
        };
        Action.prototype.remove = function () {
            if (this._actionCollection) {
                return this._actionCollection.removeAction(this);
            }
            return false;
        };
        Action.prototype.getAllInputs = function () {
            return [];
        };
        Action.prototype.getResourceInformation = function () {
            if (!utils.isNullOrEmpty(this.iconUrl)) {
                return [{ url: this.iconUrl, mimeType: 'image' }];
            } else {
                return [];
            }
        };
        Action.prototype.getActionById = function (id) {
            if (this.id == id) {
                return this;
            }
        };
        Object.defineProperty(Action.prototype, 'parent', {
            get: function () {
                return this._parent;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Action.prototype, 'renderedElement', {
            get: function () {
                return this._renderedElement;
            },
            enumerable: true,
            configurable: true
        });
        Action.prototype.shouldFallback = function () {
            return (
                this._shouldFallback ||
                !this.requires.areAllMet(
                    this.parent.hostConfig.hostCapabilities
                )
            );
        };
        return Action;
    })();
    exports.Action = Action;
    var SubmitAction = /** @class */ (function (_super) {
        __extends(SubmitAction, _super);
        function SubmitAction() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._isPrepared = false;
            return _this;
        }
        SubmitAction.prototype.getJsonTypeName = function () {
            return 'Action.Submit';
        };
        SubmitAction.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'data', this._originalData);
            return result;
        };
        SubmitAction.prototype.prepare = function (inputs) {
            if (this._originalData) {
                this._processedData = JSON.parse(
                    JSON.stringify(this._originalData)
                );
            } else {
                this._processedData = {};
            }
            for (var i = 0; i < inputs.length; i++) {
                var inputValue = inputs[i].value;
                if (inputValue != null) {
                    this._processedData[inputs[i].id] = inputs[i].value;
                }
            }
            this._isPrepared = true;
        };
        SubmitAction.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.data = json['data'];
        };
        Object.defineProperty(SubmitAction.prototype, 'data', {
            get: function () {
                return this._isPrepared
                    ? this._processedData
                    : this._originalData;
            },
            set: function (value) {
                this._originalData = value;
                this._isPrepared = false;
            },
            enumerable: true,
            configurable: true
        });
        return SubmitAction;
    })(Action);
    exports.SubmitAction = SubmitAction;
    var OpenUrlAction = /** @class */ (function (_super) {
        __extends(OpenUrlAction, _super);
        function OpenUrlAction() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        OpenUrlAction.prototype.getJsonTypeName = function () {
            return 'Action.OpenUrl';
        };
        OpenUrlAction.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'url', this.url);
            return result;
        };
        OpenUrlAction.prototype.validate = function () {
            if (!this.url) {
                return [
                    {
                        error: enums.ValidationError.PropertyCantBeNull,
                        message:
                            'An Action.OpenUrl must have its url property set.'
                    }
                ];
            } else {
                return [];
            }
        };
        OpenUrlAction.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.url = json['url'];
        };
        return OpenUrlAction;
    })(Action);
    exports.OpenUrlAction = OpenUrlAction;
    var HttpHeader = /** @class */ (function () {
        function HttpHeader(name, value) {
            if (name === void 0) {
                name = '';
            }
            if (value === void 0) {
                value = '';
            }
            this._value = new utils.StringWithSubstitutions();
            this.name = name;
            this.value = value;
        }
        HttpHeader.prototype.toJSON = function () {
            return { name: this.name, value: this._value.getOriginal() };
        };
        HttpHeader.prototype.prepare = function (inputs) {
            this._value.substituteInputValues(
                inputs,
                utils.ContentTypes.applicationXWwwFormUrlencoded
            );
        };
        Object.defineProperty(HttpHeader.prototype, 'value', {
            get: function () {
                return this._value.get();
            },
            set: function (newValue) {
                this._value.set(newValue);
            },
            enumerable: true,
            configurable: true
        });
        return HttpHeader;
    })();
    exports.HttpHeader = HttpHeader;
    var HttpAction = /** @class */ (function (_super) {
        __extends(HttpAction, _super);
        function HttpAction() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._url = new utils.StringWithSubstitutions();
            _this._body = new utils.StringWithSubstitutions();
            _this._headers = [];
            return _this;
        }
        HttpAction.prototype.getJsonTypeName = function () {
            return 'Action.Http';
        };
        HttpAction.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(result, 'method', this.method);
            utils.setProperty(result, 'url', this._url.getOriginal());
            utils.setProperty(result, 'body', this._body.getOriginal());
            if (this._headers.length > 0) {
                var headers = [];
                for (var _i = 0, _a = this._headers; _i < _a.length; _i++) {
                    var header = _a[_i];
                    headers.push(header.toJSON());
                }
                utils.setProperty(result, 'headers', headers);
            }
            return result;
        };
        HttpAction.prototype.validate = function () {
            var result = [];
            if (!this.url) {
                result = [
                    {
                        error: enums.ValidationError.PropertyCantBeNull,
                        message:
                            'An Action.Http must have its url property set.'
                    }
                ];
            }
            if (this.headers.length > 0) {
                for (var i = 0; i < this.headers.length; i++) {
                    if (!this.headers[i].name || !this.headers[i].value) {
                        result = result.concat([
                            {
                                error: enums.ValidationError.PropertyCantBeNull,
                                message:
                                    'All headers of an Action.Http must have their name and value properties set.'
                            }
                        ]);
                        break;
                    }
                }
            }
            return result;
        };
        HttpAction.prototype.prepare = function (inputs) {
            this._url.substituteInputValues(
                inputs,
                utils.ContentTypes.applicationXWwwFormUrlencoded
            );
            var contentType = utils.ContentTypes.applicationJson;
            for (var i = 0; i < this._headers.length; i++) {
                this._headers[i].prepare(inputs);
                if (
                    this._headers[i].name &&
                    this._headers[i].name.toLowerCase() == 'content-type'
                ) {
                    contentType = this._headers[i].value;
                }
            }
            this._body.substituteInputValues(inputs, contentType);
        };
        HttpAction.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.url = json['url'];
            this.method = json['method'];
            this.body = json['body'];
            this._headers = [];
            if (json['headers'] != null) {
                var jsonHeaders = json['headers'];
                for (var i = 0; i < jsonHeaders.length; i++) {
                    var httpHeader = new HttpHeader();
                    httpHeader.name = jsonHeaders[i]['name'];
                    httpHeader.value = jsonHeaders[i]['value'];
                    this.headers.push(httpHeader);
                }
            }
        };
        Object.defineProperty(HttpAction.prototype, 'url', {
            get: function () {
                return this._url.get();
            },
            set: function (value) {
                this._url.set(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(HttpAction.prototype, 'body', {
            get: function () {
                return this._body.get();
            },
            set: function (value) {
                this._body.set(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(HttpAction.prototype, 'headers', {
            get: function () {
                return this._headers ? this._headers : [];
            },
            set: function (value) {
                this._headers = value;
            },
            enumerable: true,
            configurable: true
        });
        return HttpAction;
    })(Action);
    exports.HttpAction = HttpAction;
    var ShowCardAction = /** @class */ (function (_super) {
        __extends(ShowCardAction, _super);
        function ShowCardAction() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.card = new InlineAdaptiveCard();
            return _this;
        }
        ShowCardAction.prototype.addCssClasses = function (element) {
            _super.prototype.addCssClasses.call(this, element);
            element.classList.add(
                this.parent.hostConfig.makeCssClassName('expandable')
            );
        };
        ShowCardAction.prototype.getJsonTypeName = function () {
            return 'Action.ShowCard';
        };
        ShowCardAction.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            if (this.card) {
                utils.setProperty(result, 'card', this.card.toJSON());
            }
            return result;
        };
        ShowCardAction.prototype.validate = function () {
            return this.card.validate();
        };
        ShowCardAction.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.card.parse(json['card'], errors);
        };
        ShowCardAction.prototype.setParent = function (value) {
            _super.prototype.setParent.call(this, value);
            this.card.setParent(value);
        };
        ShowCardAction.prototype.getAllInputs = function () {
            return this.card.getAllInputs();
        };
        ShowCardAction.prototype.getResourceInformation = function () {
            return _super.prototype.getResourceInformation
                .call(this)
                .concat(this.card.getResourceInformation());
        };
        ShowCardAction.prototype.getActionById = function (id) {
            var result = _super.prototype.getActionById.call(this, id);
            if (!result) {
                result = this.card.getActionById(id);
            }
            return result;
        };
        return ShowCardAction;
    })(Action);
    exports.ShowCardAction = ShowCardAction;
    var ActionCollection = /** @class */ (function () {
        function ActionCollection(owner) {
            this._expandedAction = null;
            this._renderedActionCount = 0;
            this._statusCard = null;
            this._actionCard = null;
            this.items = [];
            this.buttons = [];
            this._owner = owner;
        }
        ActionCollection.prototype.refreshContainer = function () {
            this._actionCardContainer.innerHTML = '';
            if (this._actionCard === null && this._statusCard === null) {
                this._actionCardContainer.style.padding = '0px';
                this._actionCardContainer.style.marginTop = '0px';
                return;
            }
            this._actionCardContainer.style.marginTop =
                this._renderedActionCount > 0
                    ? this._owner.hostConfig.actions.showCard.inlineTopMargin +
                    'px'
                    : '0px';
            var padding = this._owner
                .getNonZeroPadding()
                .toSpacingDefinition(this._owner.hostConfig);
            if (this._actionCard !== null) {
                this._actionCard.style.paddingLeft = padding.left + 'px';
                this._actionCard.style.paddingRight = padding.right + 'px';
                this._actionCard.style.marginLeft = '-' + padding.left + 'px';
                this._actionCard.style.marginRight = '-' + padding.right + 'px';
                utils.appendChild(this._actionCardContainer, this._actionCard);
            }
            if (this._statusCard !== null) {
                this._statusCard.style.paddingLeft = padding.left + 'px';
                this._statusCard.style.paddingRight = padding.right + 'px';
                this._statusCard.style.marginLeft = '-' + padding.left + 'px';
                this._statusCard.style.marginRight = '-' + padding.right + 'px';
                utils.appendChild(this._actionCardContainer, this._statusCard);
            }
        };
        ActionCollection.prototype.layoutChanged = function () {
            this._owner.getRootElement().updateLayout();
        };
        ActionCollection.prototype.hideActionCard = function () {
            var previouslyExpandedAction = this._expandedAction;
            this._expandedAction = null;
            this._actionCard = null;
            this.refreshContainer();
            if (previouslyExpandedAction) {
                this.layoutChanged();
                raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
            }
        };
        ActionCollection.prototype.showActionCard = function (
            action,
            suppressStyle,
            raiseEvent
        ) {
            if (suppressStyle === void 0) {
                suppressStyle = false;
            }
            if (raiseEvent === void 0) {
                raiseEvent = true;
            }
            if (action.card == null) {
                return;
            }
            action.card.suppressStyle = suppressStyle;
            var renderedCard = action.card.render();
            this._actionCard = renderedCard;
            this._expandedAction = action;
            this.refreshContainer();
            if (raiseEvent) {
                this.layoutChanged();
                raiseInlineCardExpandedEvent(action, true);
            }
        };
        ActionCollection.prototype.collapseExpandedAction = function () {
            for (var i = 0; i < this.buttons.length; i++) {
                this.buttons[i].state = ActionButtonState.Normal;
            }
            this.hideActionCard();
        };
        ActionCollection.prototype.expandShowCardAction = function (
            action,
            raiseEvent
        ) {
            for (var i = 0; i < this.buttons.length; i++) {
                if (this.buttons[i].action !== action) {
                    this.buttons[i].state = ActionButtonState.Subdued;
                } else {
                    this.buttons[i].state = ActionButtonState.Expanded;
                }
            }
            this.showActionCard(
                action,
                !(
                    this._owner.isAtTheVeryLeft() &&
                    this._owner.isAtTheVeryRight()
                ),
                raiseEvent
            );
        };
        ActionCollection.prototype.actionClicked = function (actionButton) {
            if (!(actionButton.action instanceof ShowCardAction)) {
                for (var i = 0; i < this.buttons.length; i++) {
                    this.buttons[i].state = ActionButtonState.Normal;
                }
                this.hideStatusCard();
                this.hideActionCard();
                actionButton.action.execute();
            } else {
                this.hideStatusCard();
                if (
                    this._owner.hostConfig.actions.showCard.actionMode ===
                    enums.ShowCardActionMode.Popup
                ) {
                    actionButton.action.execute();
                } else if (actionButton.action === this._expandedAction) {
                    this.collapseExpandedAction();
                } else {
                    this.expandShowCardAction(actionButton.action, true);
                }
            }
        };
        ActionCollection.prototype.getParentContainer = function () {
            if (this._owner instanceof Container) {
                return this._owner;
            } else {
                return this._owner.getParentContainer();
            }
        };
        ActionCollection.prototype.findActionButton = function (action) {
            for (var _i = 0, _a = this.buttons; _i < _a.length; _i++) {
                var actionButton = _a[_i];
                if (actionButton.action == action) {
                    return actionButton;
                }
            }
            return null;
        };
        ActionCollection.prototype.parse = function (json, errors) {
            this.clear();
            if (json && json instanceof Array) {
                for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
                    var jsonAction = json_1[_i];
                    var action = createActionInstance(
                        this._owner,
                        jsonAction,
                        errors
                    );
                    if (action) {
                        this.addAction(action);
                    }
                }
            }
        };
        ActionCollection.prototype.toJSON = function () {
            if (this.items.length > 0) {
                var result = [];
                for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                    var action = _a[_i];
                    result.push(action.toJSON());
                }
                return result;
            } else {
                return null;
            }
        };
        ActionCollection.prototype.showStatusCard = function (status) {
            status.setParent(this._owner);
            this._statusCard = status.render();
            this.refreshContainer();
        };
        ActionCollection.prototype.hideStatusCard = function () {
            this._statusCard = null;
            this.refreshContainer();
        };
        ActionCollection.prototype.getActionById = function (id) {
            var result = null;
            for (var i = 0; i < this.items.length; i++) {
                result = this.items[i].getActionById(id);
                if (result) {
                    break;
                }
            }
            return result;
        };
        ActionCollection.prototype.validate = function () {
            var result = [];
            if (
                this._owner.hostConfig.actions.maxActions &&
                this.items.length > this._owner.hostConfig.actions.maxActions
            ) {
                result.push({
                    error: enums.ValidationError.TooManyActions,
                    message:
                        'A maximum of ' +
                        this._owner.hostConfig.actions.maxActions +
                        ' actions are allowed.'
                });
            }
            if (
                this.items.length > 0 &&
                !this._owner.hostConfig.supportsInteractivity
            ) {
                result.push({
                    error: enums.ValidationError.InteractivityNotAllowed,
                    message: 'Interactivity is not allowed.'
                });
            }
            for (var i = 0; i < this.items.length; i++) {
                if (
                    !isActionAllowed(
                        this.items[i],
                        this._owner.getForbiddenActionTypes()
                    )
                ) {
                    result.push({
                        error: enums.ValidationError.ActionTypeNotAllowed,
                        message:
                            'Actions of type ' +
                            this.items[i].getJsonTypeName() +
                            ' are not allowe.'
                    });
                }
            }
            for (var i = 0; i < this.items.length; i++) {
                result = result.concat(this.items[i].validate());
            }
            return result;
        };
        ActionCollection.prototype.render = function (
            orientation,
            isDesignMode
        ) {
            var _this = this;
            if (!this._owner.hostConfig.supportsInteractivity) {
                return null;
            }
            var element = document.createElement('div');
            var maxActions = this._owner.hostConfig.actions.maxActions
                ? Math.min(
                    this._owner.hostConfig.actions.maxActions,
                    this.items.length
                )
                : this.items.length;
            var forbiddenActionTypes = this._owner.getForbiddenActionTypes();
            this._actionCardContainer = document.createElement('div');
            this._renderedActionCount = 0;
            if (
                this._owner.hostConfig.actions.preExpandSingleShowCardAction &&
                maxActions == 1 &&
                this.items[0] instanceof ShowCardAction &&
                isActionAllowed(this.items[0], forbiddenActionTypes)
            ) {
                this.showActionCard(this.items[0], true);
                this._renderedActionCount = 1;
            } else {
                var buttonStrip = document.createElement('div');
                buttonStrip.className = this._owner.hostConfig.makeCssClassName(
                    'ac-actionSet'
                );
                buttonStrip.style.display = 'flex';
                if (orientation == enums.Orientation.Horizontal) {
                    buttonStrip.style.flexDirection = 'row';
                    if (
                        this._owner.horizontalAlignment &&
                        this._owner.hostConfig.actions.actionAlignment !=
                        enums.ActionAlignment.Stretch
                    ) {
                        switch (this._owner.horizontalAlignment) {
                            case enums.HorizontalAlignment.Center:
                                buttonStrip.style.justifyContent = 'center';
                                break;
                            case enums.HorizontalAlignment.Right:
                                buttonStrip.style.justifyContent = 'flex-end';
                                break;
                            default:
                                buttonStrip.style.justifyContent = 'flex-start';
                                break;
                        }
                    } else {
                        switch (
                        this._owner.hostConfig.actions.actionAlignment
                        ) {
                            case enums.ActionAlignment.Center:
                                buttonStrip.style.justifyContent = 'center';
                                break;
                            case enums.ActionAlignment.Right:
                                buttonStrip.style.justifyContent = 'flex-end';
                                break;
                            default:
                                buttonStrip.style.justifyContent = 'flex-start';
                                break;
                        }
                    }
                } else {
                    buttonStrip.style.flexDirection = 'column';
                    if (
                        this._owner.horizontalAlignment &&
                        this._owner.hostConfig.actions.actionAlignment !=
                        enums.ActionAlignment.Stretch
                    ) {
                        switch (this._owner.horizontalAlignment) {
                            case enums.HorizontalAlignment.Center:
                                buttonStrip.style.alignItems = 'center';
                                break;
                            case enums.HorizontalAlignment.Right:
                                buttonStrip.style.alignItems = 'flex-end';
                                break;
                            default:
                                buttonStrip.style.alignItems = 'flex-start';
                                break;
                        }
                    } else {
                        switch (
                        this._owner.hostConfig.actions.actionAlignment
                        ) {
                            case enums.ActionAlignment.Center:
                                buttonStrip.style.alignItems = 'center';
                                break;
                            case enums.ActionAlignment.Right:
                                buttonStrip.style.alignItems = 'flex-end';
                                break;
                            case enums.ActionAlignment.Stretch:
                                buttonStrip.style.alignItems = 'stretch';
                                break;
                            default:
                                buttonStrip.style.alignItems = 'flex-start';
                                break;
                        }
                    }
                }
                var parentContainerStyle = this.getParentContainer().style;
                for (var i = 0; i < this.items.length; i++) {
                    if (isActionAllowed(this.items[i], forbiddenActionTypes)) {
                        var actionButton = this.findActionButton(this.items[i]);
                        if (!actionButton) {
                            actionButton = new ActionButton(
                                this.items[i],
                                parentContainerStyle
                            );
                            actionButton.onClick = function (ab) {
                                _this.actionClicked(ab);
                            };
                            this.buttons.push(actionButton);
                        }
                        actionButton.render(
                            this._owner.hostConfig.actions.actionAlignment
                        );
                        buttonStrip.appendChild(
                            actionButton.action.renderedElement
                        );
                        this._renderedActionCount++;
                        if (
                            this._renderedActionCount >=
                            this._owner.hostConfig.actions.maxActions ||
                            i == this.items.length - 1
                        ) {
                            break;
                        } else if (
                            this._owner.hostConfig.actions.buttonSpacing > 0
                        ) {
                            var spacer = document.createElement('div');
                            if (orientation === enums.Orientation.Horizontal) {
                                spacer.style.flex = '0 0 auto';
                                spacer.style.width =
                                    this._owner.hostConfig.actions
                                        .buttonSpacing + 'px';
                            } else {
                                spacer.style.height =
                                    this._owner.hostConfig.actions
                                        .buttonSpacing + 'px';
                            }
                            utils.appendChild(buttonStrip, spacer);
                        }
                    }
                }
                var buttonStripContainer = document.createElement('div');
                buttonStripContainer.style.overflow = 'hidden';
                buttonStripContainer.appendChild(buttonStrip);
                utils.appendChild(element, buttonStripContainer);
            }
            utils.appendChild(element, this._actionCardContainer);
            for (var i = 0; i < this.buttons.length; i++) {
                if (this.buttons[i].state == ActionButtonState.Expanded) {
                    this.expandShowCardAction(this.buttons[i].action, false);
                    break;
                }
            }
            return this._renderedActionCount > 0 ? element : null;
        };
        ActionCollection.prototype.addAction = function (action) {
            if (!action) {
                throw new Error('The action parameter cannot be null.');
            }
            if (
                (!action.parent || action.parent === this._owner) &&
                this.items.indexOf(action) < 0
            ) {
                this.items.push(action);
                if (!action.parent) {
                    action.setParent(this._owner);
                }
                invokeSetCollection(action, this);
            } else {
                throw new Error(
                    'The action already belongs to another element.'
                );
            }
        };
        ActionCollection.prototype.removeAction = function (action) {
            if (this.expandedAction && this._expandedAction == action) {
                this.collapseExpandedAction();
            }
            var actionIndex = this.items.indexOf(action);
            if (actionIndex >= 0) {
                this.items.splice(actionIndex, 1);
                action.setParent(null);
                invokeSetCollection(action, null);
                for (var i = 0; i < this.buttons.length; i++) {
                    if (this.buttons[i].action == action) {
                        this.buttons.splice(i, 1);
                        break;
                    }
                }
                return true;
            }
            return false;
        };
        ActionCollection.prototype.clear = function () {
            this.items = [];
            this.buttons = [];
            this._expandedAction = null;
            this._renderedActionCount = 0;
        };
        ActionCollection.prototype.getAllInputs = function () {
            var result = [];
            for (var i = 0; i < this.items.length; i++) {
                var action = this.items[i];
                result = result.concat(action.getAllInputs());
            }
            return result;
        };
        ActionCollection.prototype.getResourceInformation = function () {
            var result = [];
            for (var i = 0; i < this.items.length; i++) {
                result = result.concat(this.items[i].getResourceInformation());
            }
            return result;
        };
        Object.defineProperty(
            ActionCollection.prototype,
            'renderedActionCount',
            {
                get: function () {
                    return this._renderedActionCount;
                },
                enumerable: true,
                configurable: true
            }
        );
        Object.defineProperty(ActionCollection.prototype, 'expandedAction', {
            get: function () {
                return this._expandedAction;
            },
            enumerable: true,
            configurable: true
        });
        return ActionCollection;
    })();
    var ActionSet = /** @class */ (function (_super) {
        __extends(ActionSet, _super);
        function ActionSet() {
            var _this = _super.call(this) || this;
            _this.orientation = null;
            _this._actionCollection = new ActionCollection(_this);
            return _this;
        }
        ActionSet.prototype.internalRender = function () {
            return this._actionCollection.render(
                this.orientation
                    ? this.orientation
                    : this.hostConfig.actions.actionsOrientation,
                this.isDesignMode()
            );
        };
        ActionSet.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setEnumProperty(
                enums.Orientation,
                result,
                'orientation',
                this.orientation
            );
            utils.setProperty(
                result,
                'actions',
                this._actionCollection.toJSON()
            );
            return result;
        };
        ActionSet.prototype.isBleeding = function () {
            return this._actionCollection.expandedAction ? true : false;
        };
        ActionSet.prototype.getJsonTypeName = function () {
            return 'ActionSet';
        };
        ActionSet.prototype.getActionCount = function () {
            return this._actionCollection.items.length;
        };
        ActionSet.prototype.getActionAt = function (index) {
            if (index >= 0 && index < this.getActionCount()) {
                return this._actionCollection.items[index];
            } else {
                _super.prototype.getActionAt.call(this, index);
            }
        };
        ActionSet.prototype.validate = function () {
            return this._actionCollection.validate();
        };
        ActionSet.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            var jsonOrientation = json['orientation'];
            if (jsonOrientation) {
                this.orientation = utils.getEnumValueOrDefault(
                    enums.Orientation,
                    jsonOrientation,
                    enums.Orientation.Horizontal
                );
            }
            this._actionCollection.parse(json['actions'], errors);
        };
        ActionSet.prototype.addAction = function (action) {
            this._actionCollection.addAction(action);
        };
        ActionSet.prototype.getAllInputs = function () {
            return this._actionCollection.getAllInputs();
        };
        ActionSet.prototype.getResourceInformation = function () {
            return this._actionCollection.getResourceInformation();
        };
        ActionSet.prototype.renderSpeech = function () {
            // TODO: What's the right thing to do here?
            return '';
        };
        Object.defineProperty(ActionSet.prototype, 'isInteractive', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        return ActionSet;
    })(CardElement);
    exports.ActionSet = ActionSet;
    var BackgroundImage = /** @class */ (function () {
        function BackgroundImage() {
            this.mode = enums.BackgroundImageMode.Stretch;
            this.horizontalAlignment = enums.HorizontalAlignment.Left;
            this.verticalAlignment = enums.VerticalAlignment.Top;
        }
        BackgroundImage.prototype.parse = function (json, errors) {
            this.url = json['url'];
            this.mode = utils.getEnumValueOrDefault(
                enums.BackgroundImageMode,
                json['mode'],
                this.mode
            );
            this.horizontalAlignment = utils.getEnumValueOrDefault(
                enums.HorizontalAlignment,
                json['horizontalAlignment'],
                this.horizontalAlignment
            );
            this.verticalAlignment = utils.getEnumValueOrDefault(
                enums.VerticalAlignment,
                json['verticalAlignment'],
                this.verticalAlignment
            );
        };
        BackgroundImage.prototype.apply = function (element) {
            if (this.url) {
                element.style.backgroundImage = "url('" + this.url + "')";
                switch (this.mode) {
                    case enums.BackgroundImageMode.Repeat:
                        element.style.backgroundRepeat = 'repeat';
                        break;
                    case enums.BackgroundImageMode.RepeatHorizontally:
                        element.style.backgroundRepeat = 'repeat-x';
                        break;
                    case enums.BackgroundImageMode.RepeatVertically:
                        element.style.backgroundRepeat = 'repeat-y';
                        break;
                    case enums.BackgroundImageMode.Stretch:
                    default:
                        element.style.backgroundRepeat = 'no-repeat';
                        element.style.backgroundSize = 'cover';
                        break;
                }
                switch (this.horizontalAlignment) {
                    case enums.HorizontalAlignment.Center:
                        element.style.backgroundPositionX = 'center';
                        break;
                    case enums.HorizontalAlignment.Right:
                        element.style.backgroundPositionX = 'right';
                        break;
                }
                switch (this.verticalAlignment) {
                    case enums.VerticalAlignment.Center:
                        element.style.backgroundPositionY = 'center';
                        break;
                    case enums.VerticalAlignment.Bottom:
                        element.style.backgroundPositionY = 'bottom';
                        break;
                }
            }
        };
        return BackgroundImage;
    })();
    exports.BackgroundImage = BackgroundImage;
    var Container = /** @class */ (function (_super) {
        __extends(Container, _super);
        function Container() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._items = [];
            _this._renderedItems = [];
            _this._style = null;
            _this.verticalContentAlignment = enums.VerticalAlignment.Top;
            _this.rtl = null;
            return _this;
        }
        Container.prototype.isElementAllowed = function (
            element,
            forbiddenElementTypes
        ) {
            if (
                !this.hostConfig.supportsInteractivity &&
                element.isInteractive
            ) {
                return false;
            }
            if (forbiddenElementTypes) {
                for (var i = 0; i < forbiddenElementTypes.length; i++) {
                    if (
                        element.getJsonTypeName() === forbiddenElementTypes[i]
                    ) {
                        return false;
                    }
                }
            }
            return true;
        };
        Container.prototype.insertItemAt = function (item, index, forceInsert) {
            if (!item.parent || forceInsert) {
                if (item.isStandalone) {
                    if (index < 0 || index >= this._items.length) {
                        this._items.push(item);
                    } else {
                        this._items.splice(index, 0, item);
                    }
                    item.setParent(this);
                } else {
                    throw new Error(
                        'Elements of type ' +
                        item.getJsonTypeName() +
                        ' cannot be used as standalone elements.'
                    );
                }
            } else {
                throw new Error(
                    'The element already belongs to another container.'
                );
            }
        };
        Object.defineProperty(Container.prototype, 'hasExplicitStyle', {
            get: function () {
                return this._style != null;
            },
            enumerable: true,
            configurable: true
        });
        Container.prototype.getItemsCollectionPropertyName = function () {
            return 'items';
        };
        Container.prototype.isLastElementBleeding = function () {
            return this._renderedItems.length > 0
                ? this._renderedItems[
                    this._renderedItems.length - 1
                ].isBleeding()
                : false;
        };
        Container.prototype.applyPadding = function () {
            if (!this.renderedElement) {
                return;
            }
            if (this.padding) {
                var physicalPadding = this.padding.toSpacingDefinition(
                    this.hostConfig
                );
                this.renderedElement.style.paddingTop =
                    physicalPadding.top + 'px';
                this.renderedElement.style.paddingRight =
                    physicalPadding.right + 'px';
                this.renderedElement.style.paddingBottom =
                    physicalPadding.bottom + 'px';
                this.renderedElement.style.paddingLeft =
                    physicalPadding.left + 'px';
            } else if (this.hasBackground) {
                var physicalMargin = new SpacingDefinition();
                var physicalPadding = new SpacingDefinition();
                var useAutoPadding =
                    (this.parent ? this.parent.canContentBleed() : false) &&
                    AdaptiveCard.useAutomaticContainerBleeding;
                if (useAutoPadding) {
                    var effectivePadding = this.getNonZeroPadding();
                    var effectiveMargin = new PaddingDefinition(
                        effectivePadding.top,
                        effectivePadding.right,
                        effectivePadding.bottom,
                        effectivePadding.left
                    );
                    if (!this.isAtTheVeryTop()) {
                        effectivePadding.top = enums.Spacing.None;
                        effectiveMargin.top = enums.Spacing.None;
                    }
                    if (!this.isAtTheVeryBottom()) {
                        effectivePadding.bottom = enums.Spacing.None;
                        effectiveMargin.bottom = enums.Spacing.None;
                    }
                    if (!this.isAtTheVeryLeft()) {
                        effectivePadding.left = enums.Spacing.None;
                        effectiveMargin.left = enums.Spacing.None;
                    }
                    if (!this.isAtTheVeryRight()) {
                        effectivePadding.right = enums.Spacing.None;
                        effectiveMargin.right = enums.Spacing.None;
                    }
                    if (
                        effectivePadding.left != enums.Spacing.None ||
                        effectivePadding.right != enums.Spacing.None
                    ) {
                        if (effectivePadding.left == enums.Spacing.None) {
                            effectivePadding.left = effectivePadding.right;
                        }
                        if (effectivePadding.right == enums.Spacing.None) {
                            effectivePadding.right = effectivePadding.left;
                        }
                    }
                    if (
                        effectivePadding.top != enums.Spacing.None ||
                        effectivePadding.bottom != enums.Spacing.None
                    ) {
                        if (effectivePadding.top == enums.Spacing.None) {
                            effectivePadding.top = effectivePadding.bottom;
                        }
                        if (effectivePadding.bottom == enums.Spacing.None) {
                            effectivePadding.bottom = effectivePadding.top;
                        }
                    }
                    if (
                        effectivePadding.top != enums.Spacing.None ||
                        effectivePadding.right != enums.Spacing.None ||
                        effectivePadding.bottom != enums.Spacing.None ||
                        effectivePadding.left != enums.Spacing.None
                    ) {
                        if (effectivePadding.top == enums.Spacing.None) {
                            effectivePadding.top = enums.Spacing.Default;
                        }
                        if (effectivePadding.right == enums.Spacing.None) {
                            effectivePadding.right = enums.Spacing.Default;
                        }
                        if (effectivePadding.bottom == enums.Spacing.None) {
                            effectivePadding = Object.assign(
                                {},
                                effectivePadding,
                                { bottom: enums.Spacing.Default }
                            );
                        }
                        if (effectivePadding.left == enums.Spacing.None) {
                            effectivePadding = Object.assign(
                                {},
                                effectivePadding,
                                { left: enums.Spacing.Default }
                            );
                        }
                    }
                    if (
                        effectivePadding.top == enums.Spacing.None &&
                        effectivePadding.right == enums.Spacing.None &&
                        effectivePadding.bottom == enums.Spacing.None &&
                        effectivePadding.left == enums.Spacing.None
                    ) {
                        effectivePadding = new PaddingDefinition(
                            enums.Spacing.Padding,
                            enums.Spacing.Padding,
                            enums.Spacing.Padding,
                            enums.Spacing.Padding
                        );
                    }
                    physicalMargin = effectiveMargin.toSpacingDefinition(
                        this.hostConfig
                    );
                    physicalPadding = effectivePadding.toSpacingDefinition(
                        this.hostConfig
                    );
                } else {
                    physicalPadding = new PaddingDefinition(
                        enums.Spacing.Padding,
                        enums.Spacing.Padding,
                        enums.Spacing.Padding,
                        enums.Spacing.Padding
                    ).toSpacingDefinition(this.hostConfig);
                }
                this.renderedElement.style.marginTop =
                    '-' + physicalMargin.top + 'px';
                this.renderedElement.style.marginRight =
                    '-' + physicalMargin.right + 'px';
                this.renderedElement.style.marginBottom =
                    '-' + physicalMargin.bottom + 'px';
                this.renderedElement.style.marginLeft =
                    '-' + physicalMargin.left + 'px';
                this.renderedElement.style.paddingTop =
                    physicalPadding.top + 'px';
                this.renderedElement.style.paddingRight =
                    physicalPadding.right + 'px';
                this.renderedElement.style.paddingBottom =
                    physicalPadding.bottom + 'px';
                this.renderedElement.style.paddingLeft =
                    physicalPadding.left + 'px';
                if (this.separatorElement) {
                    if (
                        this.separatorOrientation ==
                        enums.Orientation.Horizontal
                    ) {
                        this.separatorElement.style.marginLeft =
                            '-' + physicalMargin.left + 'px';
                        this.separatorElement.style.marginRight =
                            '-' + physicalMargin.right + 'px';
                    } else {
                        this.separatorElement.style.marginTop =
                            '-' + physicalMargin.top + 'px';
                        this.separatorElement.style.marginBottom =
                            '-' + physicalMargin.bottom + 'px';
                    }
                }
            }
            if (this.isLastElementBleeding()) {
                this.renderedElement.style.paddingBottom = '0px';
            }
        };
        Container.prototype.internalRender = function () {
            var _this = this;
            this._renderedItems = [];
            // Cache hostConfig to avoid walking the parent hierarchy several times
            var hostConfig = this.hostConfig;
            var element = document.createElement('div');
            if (this.rtl != null && this.rtl) {
                element.dir = 'rtl';
            }
            element.classList.add(hostConfig.makeCssClassName('ac-container'));
            element.style.display = 'flex';
            element.style.flexDirection = 'column';
            if (AdaptiveCard.useAdvancedCardBottomTruncation) {
                // Forces the container to be at least as tall as its content.
                //
                // Fixes a quirk in Chrome where, for nested flex elements, the
                // inner element's height would never exceed the outer element's
                // height. This caused overflow truncation to break -- containers
                // would always be measured as not overflowing, since their heights
                // were constrained by their parents as opposed to truly reflecting
                // the height of their content.
                //
                // See the "Browser Rendering Notes" section of this answer:
                // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
                element.style.minHeight = '-webkit-min-content';
            }
            switch (this.verticalContentAlignment) {
                case enums.VerticalAlignment.Center:
                    element.style.justifyContent = 'center';
                    break;
                case enums.VerticalAlignment.Bottom:
                    element.style.justifyContent = 'flex-end';
                    break;
                default:
                    element.style.justifyContent = 'flex-start';
                    break;
            }
            if (this.hasBackground) {
                if (this.backgroundImage) {
                    this.backgroundImage.apply(element);
                }
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(
                    this.style,
                    this.hostConfig.containerStyles.getStyleByName(
                        this.defaultStyle
                    )
                );
                if (!utils.isNullOrEmpty(styleDefinition.backgroundColor)) {
                    element.style.backgroundColor = utils.stringToCssColor(
                        styleDefinition.backgroundColor
                    );
                }
            }
            if (this.selectAction && hostConfig.supportsInteractivity) {
                element.classList.add(
                    hostConfig.makeCssClassName('ac-selectable')
                );
                element.tabIndex = 0;
                element.setAttribute('role', 'button');
                element.setAttribute('aria-label', this.selectAction.title);
                element.onclick = function (e) {
                    if (_this.selectAction != null) {
                        _this.selectAction.execute();
                        e.cancelBubble = true;
                    }
                };
                element.onkeypress = function (e) {
                    if (_this.selectAction != null) {
                        // Enter or space pressed
                        if (e.keyCode == 13 || e.keyCode == 32) {
                            _this.selectAction.execute();
                        }
                    }
                };
            }
            if (this._items.length > 0) {
                for (var i = 0; i < this._items.length; i++) {
                    var renderedElement = this.isElementAllowed(
                        this._items[i],
                        this.getForbiddenElementTypes()
                    )
                        ? this._items[i].render()
                        : null;
                    if (renderedElement) {
                        if (
                            this._renderedItems.length > 0 &&
                            this._items[i].separatorElement
                        ) {
                            this._items[i].separatorElement.style.flex =
                                '0 0 auto';
                            utils.appendChild(
                                element,
                                this._items[i].separatorElement
                            );
                        }
                        utils.appendChild(element, renderedElement);
                        this._renderedItems.push(this._items[i]);
                    }
                }
            } else {
                if (this.isDesignMode()) {
                    var placeholderElement = this.createPlaceholderElement();
                    placeholderElement.style.width = '100%';
                    placeholderElement.style.height = '100%';
                    element.appendChild(placeholderElement);
                }
            }
            return element;
        };
        Container.prototype.truncateOverflow = function (maxHeight) {
            // Add 1 to account for rounding differences between browsers
            var boundary = this.renderedElement.offsetTop + maxHeight + 1;
            var handleElement = function (cardElement) {
                var elt = cardElement.renderedElement;
                if (elt) {
                    switch (utils.getFitStatus(elt, boundary)) {
                        case enums.ContainerFitStatus.FullyInContainer:
                            var sizeChanged = cardElement['resetOverflow']();
                            // If the element's size changed after resetting content,
                            // we have to check if it still fits fully in the card
                            if (sizeChanged) {
                                handleElement(cardElement);
                            }
                            break;
                        case enums.ContainerFitStatus.Overflowing:
                            var maxHeight_1 = boundary - elt.offsetTop;
                            cardElement['handleOverflow'](maxHeight_1);
                            break;
                        case enums.ContainerFitStatus.FullyOutOfContainer:
                            cardElement['handleOverflow'](0);
                            break;
                    }
                }
            };
            for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
                var item = _a[_i];
                handleElement(item);
            }
            return true;
        };
        Container.prototype.undoOverflowTruncation = function () {
            for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
                var item = _a[_i];
                item['resetOverflow']();
            }
        };
        Object.defineProperty(Container.prototype, 'hasBackground', {
            get: function () {
                var parentContainer = this.getParentContainer();
                return (
                    this.backgroundImage != undefined ||
                    (this.hasExplicitStyle &&
                        (parentContainer
                            ? parentContainer.style != this.style
                            : false))
                );
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Container.prototype, 'defaultStyle', {
            get: function () {
                return enums.ContainerStyle.Default;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Container.prototype, 'allowCustomStyle', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Container.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            if (this._selectAction) {
                utils.setProperty(
                    result,
                    'selectAction',
                    this._selectAction.toJSON()
                );
            }
            if (this.backgroundImage) {
                utils.setProperty(
                    result,
                    'backgroundImage',
                    this.backgroundImage.url
                );
            }
            utils.setProperty(result, 'style', this.style, 'default');
            utils.setEnumProperty(
                enums.VerticalAlignment,
                result,
                'verticalContentAlignment',
                this.verticalContentAlignment,
                enums.VerticalAlignment.Top
            );
            if (this._items.length > 0) {
                var elements = [];
                for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
                    var element = _a[_i];
                    elements.push(element.toJSON());
                }
                utils.setProperty(
                    result,
                    this.getItemsCollectionPropertyName(),
                    elements
                );
            }
            return result;
        };
        Container.prototype.getItemCount = function () {
            return this._items.length;
        };
        Container.prototype.getItemAt = function (index) {
            return this._items[index];
        };
        Container.prototype.getJsonTypeName = function () {
            return 'Container';
        };
        Container.prototype.isBleeding = function () {
            return this.isLastElementBleeding();
        };
        Container.prototype.isFirstElement = function (element) {
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].isVisible) {
                    return this._items[i] == element;
                }
            }
            return false;
        };
        Container.prototype.isLastElement = function (element) {
            for (var i = this._items.length - 1; i >= 0; i--) {
                if (this._items[i].isVisible) {
                    return this._items[i] == element;
                }
            }
            return false;
        };
        Container.prototype.isRtl = function () {
            if (this.rtl != null) {
                return this.rtl;
            } else {
                var parentContainer = this.getParentContainer();
                return parentContainer ? parentContainer.isRtl() : false;
            }
        };
        Container.prototype.validate = function () {
            var result = [];
            if (this._style) {
                var styleDefinition = this.hostConfig.containerStyles.getStyleByName(
                    this._style
                );
                if (!styleDefinition) {
                    result.push({
                        error: enums.ValidationError.InvalidPropertyValue,
                        message: 'Unknown container style: ' + this._style
                    });
                }
            }
            for (var i = 0; i < this._items.length; i++) {
                if (
                    !this.hostConfig.supportsInteractivity &&
                    this._items[i].isInteractive
                ) {
                    result.push({
                        error: enums.ValidationError.InteractivityNotAllowed,
                        message: 'Interactivity is not allowed.'
                    });
                }
                if (
                    !this.isElementAllowed(
                        this._items[i],
                        this.getForbiddenElementTypes()
                    )
                ) {
                    result.push({
                        error: enums.ValidationError.InteractivityNotAllowed,
                        message:
                            'Elements of type ' +
                            this._items[i].getJsonTypeName() +
                            ' are not allowed in this container.'
                    });
                }
                result = result.concat(this._items[i].validate());
            }
            return result;
        };
        Container.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.setShouldFallback(false);
            this._items = [];
            this._renderedItems = [];
            var jsonBackgroundImage = json['backgroundImage'];
            if (jsonBackgroundImage) {
                this.backgroundImage = new BackgroundImage();
                if (typeof jsonBackgroundImage === 'string') {
                    this.backgroundImage.url = jsonBackgroundImage;
                    this.backgroundImage.mode =
                        enums.BackgroundImageMode.Stretch;
                } else if (typeof jsonBackgroundImage === 'object') {
                    this.backgroundImage = new BackgroundImage();
                    this.backgroundImage.parse(json['backgroundImage'], errors);
                }
            }
            this.verticalContentAlignment = utils.getEnumValueOrDefault(
                enums.VerticalAlignment,
                json['verticalContentAlignment'],
                this.verticalContentAlignment
            );
            this._style = json['style'];
            this.selectAction = createActionInstance(
                this,
                json['selectAction'],
                errors
            );
            if (json[this.getItemsCollectionPropertyName()] != null) {
                var items = json[this.getItemsCollectionPropertyName()];
                this.clear();
                for (var i = 0; i < items.length; i++) {
                    var element = createElementInstance(this, items[i], errors);
                    if (element) {
                        this.insertItemAt(element, -1, true);
                    }
                }
            }
        };
        Container.prototype.indexOf = function (cardElement) {
            return this._items.indexOf(cardElement);
        };
        Container.prototype.addItem = function (item) {
            this.insertItemAt(item, -1, false);
        };
        Container.prototype.insertItemBefore = function (item, insertBefore) {
            this.insertItemAt(item, this._items.indexOf(insertBefore), false);
        };
        Container.prototype.insertItemAfter = function (item, insertAfter) {
            this.insertItemAt(
                item,
                this._items.indexOf(insertAfter) + 1,
                false
            );
        };
        Container.prototype.removeItem = function (item) {
            var itemIndex = this._items.indexOf(item);
            if (itemIndex >= 0) {
                this._items.splice(itemIndex, 1);
                item.setParent(null);
                this.updateLayout();
                return true;
            }
            return false;
        };
        Container.prototype.clear = function () {
            this._items = [];
        };
        Container.prototype.canContentBleed = function () {
            return this.hasBackground
                ? false
                : _super.prototype.canContentBleed.call(this);
        };
        Container.prototype.getAllInputs = function () {
            var result = [];
            for (var i = 0; i < this._items.length; i++) {
                var item = this._items[i];
                result = result.concat(item.getAllInputs());
            }
            return result;
        };
        Container.prototype.getResourceInformation = function () {
            var result = [];
            if (
                this.backgroundImage &&
                !utils.isNullOrEmpty(this.backgroundImage.url)
            ) {
                result.push({
                    url: this.backgroundImage.url,
                    mimeType: 'image'
                });
            }
            for (var i = 0; i < this.getItemCount(); i++) {
                result = result.concat(
                    this.getItemAt(i).getResourceInformation()
                );
            }
            return result;
        };
        Container.prototype.getElementById = function (id) {
            var result = _super.prototype.getElementById.call(this, id);
            if (!result) {
                for (var i = 0; i < this._items.length; i++) {
                    result = this._items[i].getElementById(id);
                    if (result) {
                        break;
                    }
                }
            }
            return result;
        };
        Container.prototype.getActionById = function (id) {
            var result = _super.prototype.getActionById.call(this, id);
            if (!result) {
                if (this.selectAction) {
                    result = this.selectAction.getActionById(id);
                }
                if (!result) {
                    for (var i = 0; i < this._items.length; i++) {
                        result = this._items[i].getActionById(id);
                        if (result) {
                            break;
                        }
                    }
                }
            }
            return result;
        };
        Container.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak;
            }
            // render each item
            var speak = null;
            if (this._items.length > 0) {
                speak = '';
                for (var i = 0; i < this._items.length; i++) {
                    var result = this._items[i].renderSpeech();
                    if (result) {
                        speak += result;
                    }
                }
            }
            return speak;
        };
        Container.prototype.updateLayout = function (processChildren) {
            if (processChildren === void 0) {
                processChildren = true;
            }
            _super.prototype.updateLayout.call(this, processChildren);
            this.applyPadding();
            if (processChildren) {
                for (var i = 0; i < this._items.length; i++) {
                    this._items[i].updateLayout();
                }
            }
        };
        Object.defineProperty(Container.prototype, 'style', {
            get: function () {
                if (this.allowCustomStyle) {
                    if (
                        this._style &&
                        this.hostConfig.containerStyles.getStyleByName(
                            this._style
                        )
                    ) {
                        return this._style;
                    }
                    return null;
                } else {
                    return this.defaultStyle;
                }
            },
            set: function (value) {
                this._style = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Container.prototype, 'padding', {
            get: function () {
                return this.getPadding();
            },
            set: function (value) {
                this.setPadding(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Container.prototype, 'selectAction', {
            get: function () {
                return this._selectAction;
            },
            set: function (value) {
                this._selectAction = value;
                if (this._selectAction) {
                    this._selectAction.setParent(this);
                }
            },
            enumerable: true,
            configurable: true
        });
        return Container;
    })(CardElementContainer);
    exports.Container = Container;
    var Column = /** @class */ (function (_super) {
        __extends(Column, _super);
        function Column(width) {
            if (width === void 0) {
                width = 'auto';
            }
            var _this = _super.call(this) || this;
            _this._computedWeight = 0;
            _this.width = 'auto';
            _this.width = width;
            return _this;
        }
        Column.prototype.adjustRenderedElementSize = function (renderedElement) {
            if (this.isDesignMode()) {
                renderedElement.style.minWidth = '20px';
                renderedElement.style.minHeight = '20px';
            } else {
                renderedElement.style.minWidth = '0';
            }
            if (this.width === 'auto') {
                renderedElement.style.flex = '0 1 auto';
            } else if (this.width === 'stretch') {
                renderedElement.style.flex = '1 1 50px';
            } else {
                var sizeAndUnit = this.width;
                if (sizeAndUnit.unit == enums.SizeUnit.Pixel) {
                    renderedElement.style.flex = '0 0 auto';
                    renderedElement.style.width =
                        sizeAndUnit.physicalSize + 'px';
                } else {
                    renderedElement.style.flex =
                        '1 1 ' +
                        (this._computedWeight > 0
                            ? this._computedWeight
                            : sizeAndUnit.physicalSize) +
                        '%';
                }
            }
        };
        Object.defineProperty(Column.prototype, 'separatorOrientation', {
            get: function () {
                return enums.Orientation.Vertical;
            },
            enumerable: true,
            configurable: true
        });
        Column.prototype.getJsonTypeName = function () {
            return 'Column';
        };
        Column.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            if (this.width instanceof utils.SizeAndUnit) {
                if (this.width.unit == enums.SizeUnit.Pixel) {
                    utils.setProperty(
                        result,
                        'width',
                        this.width.physicalSize + 'px'
                    );
                } else {
                    utils.setProperty(result, 'width', this.width.physicalSize);
                }
            } else {
                utils.setProperty(result, 'width', this.width);
            }
            return result;
        };
        Column.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            var jsonWidth = json['width'];
            if (jsonWidth === undefined) {
                jsonWidth = json['size'];
                if (jsonWidth !== undefined) {
                    raiseParseError(
                        {
                            error: enums.ValidationError.Deprecated,
                            message:
                                'The "Column.size" property is deprecated and will be removed. Use the "Column.width" property instead.'
                        },
                        errors
                    );
                }
            }
            var invalidWidth = false;
            try {
                this.width = utils.SizeAndUnit.parse(jsonWidth);
            } catch (e) {
                if (
                    typeof jsonWidth === 'string' &&
                    (jsonWidth === 'auto' || jsonWidth === 'stretch')
                ) {
                    this.width = jsonWidth;
                } else {
                    invalidWidth = true;
                }
            }
            if (invalidWidth) {
                raiseParseError(
                    {
                        error: enums.ValidationError.InvalidPropertyValue,
                        message:
                            'Invalid column width:' +
                            jsonWidth +
                            ' - defaulting to "auto"'
                    },
                    errors
                );
            }
        };
        Object.defineProperty(Column.prototype, 'hasVisibleSeparator', {
            get: function () {
                if (this.parent && this.parent instanceof ColumnSet) {
                    return (
                        this.separatorElement &&
                        !this.parent.isLeftMostElement(this)
                    );
                } else {
                    return false;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Column.prototype, 'isStandalone', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        return Column;
    })(Container);
    exports.Column = Column;
    var ColumnSet = /** @class */ (function (_super) {
        __extends(ColumnSet, _super);
        function ColumnSet() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._columns = [];
            return _this;
        }
        ColumnSet.prototype.applyPadding = function () {
            if (this.padding) {
                if (this.renderedElement) {
                    var physicalPadding = this.padding.toSpacingDefinition(
                        this.hostConfig
                    );
                    this.renderedElement.style.paddingTop =
                        physicalPadding.top + 'px';
                    this.renderedElement.style.paddingRight =
                        physicalPadding.right + 'px';
                    this.renderedElement.style.paddingBottom =
                        physicalPadding.bottom + 'px';
                    this.renderedElement.style.paddingLeft =
                        physicalPadding.left + 'px';
                }
            }
        };
        ColumnSet.prototype.internalRender = function () {
            var _this = this;
            if (this._columns.length > 0) {
                // Cache hostConfig to avoid walking the parent hierarchy several times
                var hostConfig = this.hostConfig;
                var element = document.createElement('div');
                element.className = hostConfig.makeCssClassName('ac-columnSet');
                element.style.display = 'flex';
                if (AdaptiveCard.useAdvancedCardBottomTruncation) {
                    // See comment in Container.internalRender()
                    element.style.minHeight = '-webkit-min-content';
                }
                if (this.selectAction && hostConfig.supportsInteractivity) {
                    element.classList.add(
                        hostConfig.makeCssClassName('ac-selectable')
                    );
                    element.onclick = function (e) {
                        _this.selectAction.execute();
                        e.cancelBubble = true;
                    };
                }
                switch (this.horizontalAlignment) {
                    case enums.HorizontalAlignment.Center:
                        element.style.justifyContent = 'center';
                        break;
                    case enums.HorizontalAlignment.Right:
                        element.style.justifyContent = 'flex-end';
                        break;
                    default:
                        element.style.justifyContent = 'flex-start';
                        break;
                }
                var totalWeight = 0;
                for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
                    var column = _a[_i];
                    if (
                        column.width instanceof utils.SizeAndUnit &&
                        column.width.unit == enums.SizeUnit.Weight
                    ) {
                        totalWeight += column.width.physicalSize;
                    }
                }
                var renderedColumnCount = 0;
                for (var _b = 0, _c = this._columns; _b < _c.length; _b++) {
                    var column = _c[_b];
                    if (
                        column.width instanceof utils.SizeAndUnit &&
                        column.width.unit == enums.SizeUnit.Weight &&
                        totalWeight > 0
                    ) {
                        var computedWeight =
                            (100 / totalWeight) * column.width.physicalSize;
                        // Best way to emulate "internal" access I know of
                        column['_computedWeight'] = computedWeight;
                    }
                    var renderedColumn = column.render();
                    if (renderedColumn) {
                        if (
                            renderedColumnCount > 0 &&
                            column.separatorElement
                        ) {
                            column.separatorElement.style.flex = '0 0 auto';
                            utils.appendChild(element, column.separatorElement);
                        }
                        utils.appendChild(element, renderedColumn);
                        renderedColumnCount++;
                    }
                }
                return renderedColumnCount > 0 ? element : null;
            } else {
                return null;
            }
        };
        ColumnSet.prototype.truncateOverflow = function (maxHeight) {
            for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
                var column = _a[_i];
                column['handleOverflow'](maxHeight);
            }
            return true;
        };
        ColumnSet.prototype.undoOverflowTruncation = function () {
            for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
                var column = _a[_i];
                column['resetOverflow']();
            }
        };
        ColumnSet.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            if (this._selectAction) {
                utils.setProperty(
                    result,
                    'selectAction',
                    this.selectAction.toJSON()
                );
            }
            if (this._columns.length > 0) {
                var columns = [];
                for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
                    var column = _a[_i];
                    columns.push(column.toJSON());
                }
                utils.setProperty(result, 'columns', columns);
            }
            return result;
        };
        ColumnSet.prototype.isFirstElement = function (element) {
            for (var i = 0; i < this._columns.length; i++) {
                if (this._columns[i].isVisible) {
                    return this._columns[i] == element;
                }
            }
            return false;
        };
        ColumnSet.prototype.getCount = function () {
            return this._columns.length;
        };
        ColumnSet.prototype.getItemCount = function () {
            return this.getCount();
        };
        ColumnSet.prototype.getColumnAt = function (index) {
            return this._columns[index];
        };
        ColumnSet.prototype.getItemAt = function (index) {
            return this.getColumnAt(index);
        };
        ColumnSet.prototype.getJsonTypeName = function () {
            return 'ColumnSet';
        };
        ColumnSet.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this.selectAction = createActionInstance(
                this,
                json['selectAction'],
                errors
            );
            if (json['columns'] != null) {
                var jsonColumns = json['columns'];
                this._columns = [];
                for (var i = 0; i < jsonColumns.length; i++) {
                    var column = new Column();
                    column.setParent(this);
                    column.parse(jsonColumns[i], errors);
                    this._columns.push(column);
                }
            }
        };
        ColumnSet.prototype.validate = function () {
            var result = [];
            var weightedColumns = 0;
            var stretchedColumns = 0;
            for (var i = 0; i < this._columns.length; i++) {
                if (typeof this._columns[i].width === 'number') {
                    weightedColumns++;
                } else if (this._columns[i].width === 'stretch') {
                    stretchedColumns++;
                }
                result = result.concat(this._columns[i].validate());
            }
            if (weightedColumns > 0 && stretchedColumns > 0) {
                result.push({
                    error: enums.ValidationError.Hint,
                    message:
                        'It is not recommended to use weighted and stretched columns in the same ColumnSet, because in such a situation stretched columns will always get the minimum amount of space.'
                });
            }
            return result;
        };
        ColumnSet.prototype.updateLayout = function (processChildren) {
            if (processChildren === void 0) {
                processChildren = true;
            }
            _super.prototype.updateLayout.call(this, processChildren);
            this.applyPadding();
            if (processChildren) {
                for (var i = 0; i < this._columns.length; i++) {
                    this._columns[i].updateLayout();
                }
            }
        };
        ColumnSet.prototype.addColumn = function (column) {
            if (!column.parent) {
                this._columns.push(column);
                column.setParent(this);
            } else {
                throw new Error(
                    'This column already belongs to another ColumnSet.'
                );
            }
        };
        ColumnSet.prototype.removeItem = function (item) {
            if (item instanceof Column) {
                var itemIndex = this._columns.indexOf(item);
                if (itemIndex >= 0) {
                    this._columns.splice(itemIndex, 1);
                    item.setParent(null);
                    this.updateLayout();
                    return true;
                }
            }
            return false;
        };
        ColumnSet.prototype.indexOf = function (cardElement) {
            return cardElement instanceof Column
                ? this._columns.indexOf(cardElement)
                : -1;
        };
        ColumnSet.prototype.isLeftMostElement = function (element) {
            return this._columns.indexOf(element) == 0;
        };
        ColumnSet.prototype.isRightMostElement = function (element) {
            return this._columns.indexOf(element) == this._columns.length - 1;
        };
        ColumnSet.prototype.getAllInputs = function () {
            var result = [];
            for (var i = 0; i < this._columns.length; i++) {
                result = result.concat(this._columns[i].getAllInputs());
            }
            return result;
        };
        ColumnSet.prototype.getResourceInformation = function () {
            var result = [];
            for (var i = 0; i < this._columns.length; i++) {
                result = result.concat(
                    this._columns[i].getResourceInformation()
                );
            }
            return result;
        };
        ColumnSet.prototype.getElementById = function (id) {
            var result = _super.prototype.getElementById.call(this, id);
            if (!result) {
                for (var i = 0; i < this._columns.length; i++) {
                    result = this._columns[i].getElementById(id);
                    if (result) {
                        break;
                    }
                }
            }
            return result;
        };
        ColumnSet.prototype.getActionById = function (id) {
            var result = null;
            for (var i = 0; i < this._columns.length; i++) {
                result = this._columns[i].getActionById(id);
                if (result) {
                    break;
                }
            }
            return result;
        };
        ColumnSet.prototype.renderSpeech = function () {
            if (this.speak != null) {
                return this.speak;
            }
            // render each item
            var speak = '';
            if (this._columns.length > 0) {
                for (var i = 0; i < this._columns.length; i++) {
                    speak += this._columns[i].renderSpeech();
                }
            }
            return speak;
        };
        Object.defineProperty(ColumnSet.prototype, 'padding', {
            get: function () {
                return this.getPadding();
            },
            set: function (value) {
                this.setPadding(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ColumnSet.prototype, 'selectAction', {
            get: function () {
                return this._selectAction;
            },
            set: function (value) {
                this._selectAction = value;
                if (this._selectAction) {
                    this._selectAction.setParent(this);
                }
            },
            enumerable: true,
            configurable: true
        });
        return ColumnSet;
    })(CardElementContainer);
    exports.ColumnSet = ColumnSet;
    function raiseImageLoadedEvent(image) {
        var card = image.getRootElement();
        var onImageLoadedHandler =
            card && card.onImageLoaded
                ? card.onImageLoaded
                : AdaptiveCard.onImageLoaded;
        if (onImageLoadedHandler) {
            onImageLoadedHandler(image);
        }
    }
    function raiseAnchorClickedEvent(element, anchor) {
        var card = element.getRootElement();
        var onAnchorClickedHandler =
            card && card.onAnchorClicked
                ? card.onAnchorClicked
                : AdaptiveCard.onAnchorClicked;
        return onAnchorClickedHandler != null
            ? onAnchorClickedHandler(element, anchor)
            : false;
    }
    function raiseExecuteActionEvent(action) {
        var card = action.parent.getRootElement();
        var onExecuteActionHandler =
            card && card.onExecuteAction
                ? card.onExecuteAction
                : AdaptiveCard.onExecuteAction;
        if (onExecuteActionHandler) {
            action.prepare(action.parent.getRootElement().getAllInputs());
            onExecuteActionHandler(action);
        }
    }
    function raiseInlineCardExpandedEvent(action, isExpanded) {
        var card = action.parent.getRootElement();
        var onInlineCardExpandedHandler =
            card && card.onInlineCardExpanded
                ? card.onInlineCardExpanded
                : AdaptiveCard.onInlineCardExpanded;
        if (onInlineCardExpandedHandler) {
            onInlineCardExpandedHandler(action, isExpanded);
        }
    }
    function raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
        if (shouldUpdateLayout === void 0) {
            shouldUpdateLayout = true;
        }
        var rootElement = element.getRootElement();
        if (shouldUpdateLayout) {
            rootElement.updateLayout();
        }
        var card = rootElement;
        var onElementVisibilityChangedHandler =
            card && card.onElementVisibilityChanged
                ? card.onElementVisibilityChanged
                : AdaptiveCard.onElementVisibilityChanged;
        if (onElementVisibilityChangedHandler != null) {
            onElementVisibilityChangedHandler(element);
        }
    }
    function raiseParseElementEvent(element, json, errors) {
        var card = element.getRootElement();
        var onParseElementHandler =
            card && card.onParseElement
                ? card.onParseElement
                : AdaptiveCard.onParseElement;
        if (onParseElementHandler != null) {
            onParseElementHandler(element, json, errors);
        }
    }
    function raiseParseActionEvent(action, json, errors) {
        var card = action.parent ? action.parent.getRootElement() : null;
        var onParseActionHandler =
            card && card.onParseAction
                ? card.onParseAction
                : AdaptiveCard.onParseAction;
        if (onParseActionHandler != null) {
            onParseActionHandler(action, json, errors);
        }
    }
    function raiseParseError(error, errors) {
        if (errors) {
            errors.push(error);
        }
        if (AdaptiveCard.onParseError != null) {
            AdaptiveCard.onParseError(error);
        }
    }
    var ContainerWithActions = /** @class */ (function (_super) {
        __extends(ContainerWithActions, _super);
        function ContainerWithActions() {
            var _this = _super.call(this) || this;
            _this._actionCollection = new ActionCollection(_this);
            return _this;
        }
        Object.defineProperty(ContainerWithActions.prototype, 'renderIfEmpty', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        ContainerWithActions.prototype.internalRender = function () {
            var element = _super.prototype.internalRender.call(this);
            var renderedActions = this._actionCollection.render(
                this.hostConfig.actions.actionsOrientation,
                false
            );
            if (renderedActions) {
                utils.appendChild(
                    element,
                    utils.renderSeparation(
                        {
                            spacing: this.hostConfig.getEffectiveSpacing(
                                this.hostConfig.actions.spacing
                            ),
                            lineThickness: null,
                            lineColor: null
                        },
                        enums.Orientation.Horizontal
                    )
                );
                utils.appendChild(element, renderedActions);
            }
            if (this.renderIfEmpty) {
                return element;
            } else {
                return element.children.length > 0 ? element : null;
            }
        };
        ContainerWithActions.prototype.isLastElementBleeding = function () {
            if (this._actionCollection.renderedActionCount == 0) {
                return _super.prototype.isLastElementBleeding.call(this)
                    ? !this.isDesignMode()
                    : false;
            } else {
                if (this._actionCollection.items.length == 1) {
                    return (
                        this._actionCollection.expandedAction != null &&
                        !this.hostConfig.actions.preExpandSingleShowCardAction
                    );
                } else {
                    return this._actionCollection.expandedAction != null;
                }
            }
        };
        ContainerWithActions.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(
                result,
                'actions',
                this._actionCollection.toJSON()
            );
            return result;
        };
        ContainerWithActions.prototype.getActionCount = function () {
            return this._actionCollection.items.length;
        };
        ContainerWithActions.prototype.getActionAt = function (index) {
            if (index >= 0 && index < this.getActionCount()) {
                return this._actionCollection.items[index];
            } else {
                _super.prototype.getActionAt.call(this, index);
            }
        };
        ContainerWithActions.prototype.getActionById = function (id) {
            var result = this._actionCollection.getActionById(id);
            return result
                ? result
                : _super.prototype.getActionById.call(this, id);
        };
        ContainerWithActions.prototype.parse = function (json, errors) {
            _super.prototype.parse.call(this, json, errors);
            this._actionCollection.parse(json['actions']);
        };
        ContainerWithActions.prototype.validate = function () {
            var result = _super.prototype.validate.call(this);
            if (this._actionCollection) {
                result = result.concat(this._actionCollection.validate());
            }
            return result;
        };
        ContainerWithActions.prototype.isLastElement = function (element) {
            return (
                _super.prototype.isLastElement.call(this, element) &&
                this._actionCollection.items.length == 0
            );
        };
        ContainerWithActions.prototype.addAction = function (action) {
            this._actionCollection.addAction(action);
        };
        ContainerWithActions.prototype.clear = function () {
            _super.prototype.clear.call(this);
            this._actionCollection.clear();
        };
        ContainerWithActions.prototype.getAllInputs = function () {
            return _super.prototype.getAllInputs
                .call(this)
                .concat(this._actionCollection.getAllInputs());
        };
        ContainerWithActions.prototype.getResourceInformation = function () {
            return _super.prototype.getResourceInformation
                .call(this)
                .concat(this._actionCollection.getResourceInformation());
        };
        Object.defineProperty(ContainerWithActions.prototype, 'isStandalone', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        return ContainerWithActions;
    })(Container);
    exports.ContainerWithActions = ContainerWithActions;
    var TypeRegistry = /** @class */ (function () {
        function TypeRegistry() {
            this._items = [];
            this.reset();
        }
        TypeRegistry.prototype.findTypeRegistration = function (typeName) {
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].typeName === typeName) {
                    return this._items[i];
                }
            }
            return null;
        };
        TypeRegistry.prototype.clear = function () {
            this._items = [];
        };
        TypeRegistry.prototype.registerType = function (
            typeName,
            createInstance
        ) {
            var registrationInfo = this.findTypeRegistration(typeName);
            if (registrationInfo != null) {
                registrationInfo.createInstance = createInstance;
            } else {
                registrationInfo = {
                    typeName: typeName,
                    createInstance: createInstance
                };
                this._items.push(registrationInfo);
            }
        };
        TypeRegistry.prototype.unregisterType = function (typeName) {
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].typeName === typeName) {
                    this._items.splice(i, 1);
                    return;
                }
            }
        };
        TypeRegistry.prototype.createInstance = function (typeName) {
            var registrationInfo = this.findTypeRegistration(typeName);
            return registrationInfo ? registrationInfo.createInstance() : null;
        };
        TypeRegistry.prototype.getItemCount = function () {
            return this._items.length;
        };
        TypeRegistry.prototype.getItemAt = function (index) {
            return this._items[index];
        };
        return TypeRegistry;
    })();
    exports.TypeRegistry = TypeRegistry;
    var ElementTypeRegistry = /** @class */ (function (_super) {
        __extends(ElementTypeRegistry, _super);
        function ElementTypeRegistry() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        ElementTypeRegistry.prototype.reset = function () {
            this.clear();
            this.registerType('Container', function () {
                return new Container();
            });
            this.registerType('TextBlock', function () {
                return new TextBlock();
            });
            this.registerType('Image', function () {
                return new Image();
            });
            this.registerType('ImageSet', function () {
                return new ImageSet();
            });
            this.registerType('Media', function () {
                return new Media();
            });
            this.registerType('FactSet', function () {
                return new FactSet();
            });
            this.registerType('ColumnSet', function () {
                return new ColumnSet();
            });
            this.registerType('Input.Text', function () {
                return new TextInput();
            });
            this.registerType('Input.Date', function () {
                return new DateInput();
            });
            this.registerType('Input.Time', function () {
                return new TimeInput();
            });
            this.registerType('Input.Number', function () {
                return new NumberInput();
            });
            this.registerType('Input.ChoiceSet', function () {
                return new ChoiceSetInput();
            });
            this.registerType('Input.Toggle', function () {
                return new ToggleInput();
            });
        };
        return ElementTypeRegistry;
    })(TypeRegistry);
    exports.ElementTypeRegistry = ElementTypeRegistry;
    var ActionTypeRegistry = /** @class */ (function (_super) {
        __extends(ActionTypeRegistry, _super);
        function ActionTypeRegistry() {
            return (_super !== null && _super.apply(this, arguments)) || this;
        }
        ActionTypeRegistry.prototype.reset = function () {
            this.clear();
            this.registerType('Action.OpenUrl', function () {
                return new OpenUrlAction();
            });
            this.registerType('Action.Submit', function () {
                return new SubmitAction();
            });
            this.registerType('Action.ShowCard', function () {
                return new ShowCardAction();
            });
        };
        return ActionTypeRegistry;
    })(TypeRegistry);
    exports.ActionTypeRegistry = ActionTypeRegistry;
    var AdaptiveCard = /** @class */ (function (_super) {
        __extends(AdaptiveCard, _super);
        function AdaptiveCard() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this._cardTypeName = 'AdaptiveCard';
            _this._fallbackCard = null;
            _this.onAnchorClicked = null;
            _this.onExecuteAction = null;
            _this.onElementVisibilityChanged = null;
            _this.onImageLoaded = null;
            _this.onInlineCardExpanded = null;
            _this.onParseElement = null;
            _this.onParseAction = null;
            _this.version = new hostConfig.Version(1, 0);
            _this.designMode = false;
            return _this;
        }
        Object.defineProperty(AdaptiveCard, 'processMarkdown', {
            get: function () {
                throw new Error(
                    'The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.'
                );
            },
            set: function (value) {
                throw new Error(
                    'The processMarkdown event has been removed. Please update your code and set onProcessMarkdown instead.'
                );
            },
            enumerable: true,
            configurable: true
        });
        AdaptiveCard.applyMarkdown = function (text) {
            var result = {
                didProcess: false
            };
            if (AdaptiveCard.onProcessMarkdown) {
                AdaptiveCard.onProcessMarkdown(text, result);
            } else if (window['markdownit']) {
                // Check for markdownit
                result.outputHtml = window['markdownit']().render(text);
                result.didProcess = true;
            } else {
                console.warn(
                    "Markdown processing isn't enabled. Please see https://www.npmjs.com/package/adaptivecards#supporting-markdown"
                );
            }
            return result;
        };
        AdaptiveCard.prototype.isVersionSupported = function () {
            if (this.bypassVersionCheck) {
                return true;
            } else {
                var unsupportedVersion =
                    !this.version ||
                    !this.version.isValid ||
                    AdaptiveCard.currentVersion.major < this.version.major ||
                    (AdaptiveCard.currentVersion.major == this.version.major &&
                        AdaptiveCard.currentVersion.minor < this.version.minor);
                return !unsupportedVersion;
            }
        };
        Object.defineProperty(AdaptiveCard.prototype, 'renderIfEmpty', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        AdaptiveCard.prototype.getItemsCollectionPropertyName = function () {
            return 'body';
        };
        AdaptiveCard.prototype.applyPadding = function () {
            if (!this.renderedElement) {
                return;
            }
            var effectivePadding = this.padding
                ? this.padding.toSpacingDefinition(this.hostConfig)
                : this.internalPadding.toSpacingDefinition(this.hostConfig);
            this.renderedElement.style.paddingTop = effectivePadding.top + 'px';
            this.renderedElement.style.paddingRight =
                effectivePadding.right + 'px';
            this.renderedElement.style.paddingBottom =
                effectivePadding.bottom + 'px';
            this.renderedElement.style.paddingLeft =
                effectivePadding.left + 'px';
            if (this.isLastElementBleeding()) {
                this.renderedElement.style.paddingBottom = '0px';
            }
        };
        AdaptiveCard.prototype.internalRender = function () {
            var renderedElement = _super.prototype.internalRender.call(this);
            if (AdaptiveCard.useAdvancedCardBottomTruncation) {
                // Unlike containers, the root card element should be allowed to
                // be shorter than its content (otherwise the overflow truncation
                // logic would never get triggered)
                renderedElement.style.minHeight = null;
            }
            return renderedElement;
        };
        Object.defineProperty(AdaptiveCard.prototype, 'bypassVersionCheck', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AdaptiveCard.prototype, 'defaultPadding', {
            get: function () {
                return new PaddingDefinition(
                    enums.Spacing.Padding,
                    enums.Spacing.Padding,
                    enums.Spacing.Padding,
                    enums.Spacing.Padding
                );
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AdaptiveCard.prototype, 'allowCustomPadding', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AdaptiveCard.prototype, 'allowCustomStyle', {
            get: function () {
                return (
                    this.hostConfig.adaptiveCard &&
                    this.hostConfig.adaptiveCard.allowCustomStyle
                );
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AdaptiveCard.prototype, 'hasBackground', {
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        AdaptiveCard.prototype.getJsonTypeName = function () {
            return 'AdaptiveCard';
        };
        AdaptiveCard.prototype.toJSON = function () {
            var result = _super.prototype.toJSON.call(this);
            utils.setProperty(
                result,
                '$schema',
                'http://adaptivecards.io/schemas/adaptive-card.json'
            );
            if (!this.bypassVersionCheck && this.version) {
                utils.setProperty(result, 'version', this.version.toString());
            }
            utils.setProperty(result, 'fallbackText', this.fallbackText);
            utils.setProperty(result, 'lang', this.lang);
            utils.setProperty(result, 'speak', this.speak);
            return result;
        };
        AdaptiveCard.prototype.validate = function () {
            var result = [];
            if (this._cardTypeName != 'AdaptiveCard') {
                result.push({
                    error: enums.ValidationError.MissingCardType,
                    message:
                        'Invalid or missing card type. Make sure the card\'s type property is set to "AdaptiveCard".'
                });
            }
            if (!this.bypassVersionCheck && !this.version) {
                result.push({
                    error: enums.ValidationError.PropertyCantBeNull,
                    message: 'The version property must be specified.'
                });
            } else if (!this.isVersionSupported()) {
                result.push({
                    error: enums.ValidationError.UnsupportedCardVersion,
                    message:
                        'The specified card version (' +
                        this.version +
                        ') is not supported. The maximum supported card version is ' +
                        AdaptiveCard.currentVersion
                });
            }
            return result.concat(_super.prototype.validate.call(this));
        };
        AdaptiveCard.prototype.parse = function (json, errors) {
            this._fallbackCard = null;
            this._cardTypeName = json['type'];
            var langId = json['lang'];
            if (langId && typeof langId === 'string') {
                try {
                    this.lang = langId;
                } catch (e) {
                    raiseParseError(
                        {
                            error: enums.ValidationError.InvalidPropertyValue,
                            message: e.message
                        },
                        errors
                    );
                }
            }
            this.version = hostConfig.Version.parse(json['version'], errors);
            this.fallbackText = json['fallbackText'];
            var fallbackElement = createElementInstance(
                null,
                json['fallback'],
                errors
            );
            if (fallbackElement) {
                this._fallbackCard = new AdaptiveCard();
                this._fallbackCard.addItem(fallbackElement);
            }
            _super.prototype.parse.call(this, json, errors);
        };
        AdaptiveCard.prototype.render = function (target) {
            var renderedCard;
            if (this.shouldFallback()) {
                if (this._fallbackCard) {
                    this._fallbackCard.hostConfig = this.hostConfig;
                    renderedCard = this._fallbackCard.render();
                } else {
                    var errorText = !utils.isNullOrEmpty(this.fallbackText)
                        ? this.fallbackText
                        : 'The card could not be rendered. It is either malformed or uses features not supported by this host.';
                    try {
                        var fallbackCard = new AdaptiveCard();
                        fallbackCard.hostConfig = this.hostConfig;
                        fallbackCard.parse({
                            type: 'AdaptiveCard',
                            version: '1.0',
                            body: [
                                {
                                    type: 'TextBlock',
                                    text: errorText,
                                    wrap: true
                                }
                            ]
                        });
                        renderedCard = fallbackCard.render();
                    } catch (e) {
                        renderedCard = document.createElement('div');
                        renderedCard.textContent = errorText;
                    }
                }
            } else {
                renderedCard = _super.prototype.render.call(this);
                if (renderedCard) {
                    renderedCard.tabIndex = 0;
                    if (!utils.isNullOrEmpty(this.speak)) {
                        renderedCard.setAttribute('aria-label', this.speak);
                    }
                }
            }
            if (target) {
                target.appendChild(renderedCard);
                this.updateLayout();
            }
            return renderedCard;
        };
        AdaptiveCard.prototype.updateLayout = function (processChildren) {
            if (processChildren === void 0) {
                processChildren = true;
            }
            _super.prototype.updateLayout.call(this, processChildren);
            if (
                AdaptiveCard.useAdvancedCardBottomTruncation &&
                this.isRendered()
            ) {
                var card = this.renderedElement;
                var padding = this.hostConfig.getEffectiveSpacing(
                    enums.Spacing.Default
                );
                this['handleOverflow'](card.offsetHeight - padding);
            }
        };
        AdaptiveCard.prototype.canContentBleed = function () {
            return true;
        };
        AdaptiveCard.prototype.shouldFallback = function () {
            return (
                _super.prototype.shouldFallback.call(this) ||
                !this.isVersionSupported()
            );
        };
        Object.defineProperty(AdaptiveCard.prototype, 'hasVisibleSeparator', {
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        AdaptiveCard.currentVersion = new hostConfig.Version(1, 1);
        AdaptiveCard.useAutomaticContainerBleeding = false;
        AdaptiveCard.useAdvancedTextBlockTruncation = true;
        AdaptiveCard.useAdvancedCardBottomTruncation = false;
        AdaptiveCard.useMarkdownInRadioButtonAndCheckbox = true;
        AdaptiveCard.allowMarkForTextHighlighting = false;
        AdaptiveCard.elementTypeRegistry = new ElementTypeRegistry();
        AdaptiveCard.actionTypeRegistry = new ActionTypeRegistry();
        AdaptiveCard.onAnchorClicked = null;
        AdaptiveCard.onExecuteAction = null;
        AdaptiveCard.onElementVisibilityChanged = null;
        AdaptiveCard.onImageLoaded = null;
        AdaptiveCard.onInlineCardExpanded = null;
        AdaptiveCard.onParseElement = null;
        AdaptiveCard.onParseAction = null;
        AdaptiveCard.onParseError = null;
        AdaptiveCard.onProcessMarkdown = null;
        return AdaptiveCard;
    })(ContainerWithActions);
    exports.AdaptiveCard = AdaptiveCard;
    var InlineAdaptiveCard = /** @class */ (function (_super) {
        __extends(InlineAdaptiveCard, _super);
        function InlineAdaptiveCard() {
            var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
            _this.suppressStyle = false;
            return _this;
        }
        Object.defineProperty(
            InlineAdaptiveCard.prototype,
            'bypassVersionCheck',
            {
                get: function () {
                    return true;
                },
                enumerable: true,
                configurable: true
            }
        );
        Object.defineProperty(InlineAdaptiveCard.prototype, 'defaultPadding', {
            get: function () {
                return new PaddingDefinition(
                    this.suppressStyle
                        ? enums.Spacing.None
                        : enums.Spacing.Padding,
                    enums.Spacing.Padding,
                    this.suppressStyle
                        ? enums.Spacing.None
                        : enums.Spacing.Padding,
                    enums.Spacing.Padding
                );
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InlineAdaptiveCard.prototype, 'defaultStyle', {
            get: function () {
                if (this.suppressStyle) {
                    return enums.ContainerStyle.Default;
                } else {
                    return this.hostConfig.actions.showCard.style
                        ? this.hostConfig.actions.showCard.style
                        : enums.ContainerStyle.Emphasis;
                }
            },
            enumerable: true,
            configurable: true
        });
        InlineAdaptiveCard.prototype.render = function (target) {
            var renderedCard = _super.prototype.render.call(this, target);
            renderedCard.setAttribute('aria-live', 'polite');
            renderedCard.removeAttribute('tabindex');
            return renderedCard;
        };
        InlineAdaptiveCard.prototype.getForbiddenActionTypes = function () {
            return [ShowCardAction];
        };
        return InlineAdaptiveCard;
    })(AdaptiveCard);
    var defaultHostConfig = new hostConfig.HostConfig({
        supportsInteractivity: true,
        fontFamily: 'Segoe UI',
        spacing: {
            small: 10,
            default: 20,
            medium: 30,
            large: 40,
            extraLarge: 50,
            padding: 20
        },
        separator: {
            lineThickness: 1,
            lineColor: '#EEEEEE'
        },
        fontSizes: {
            small: 12,
            default: 14,
            medium: 17,
            large: 21,
            extraLarge: 26
        },
        fontWeights: {
            lighter: 200,
            default: 400,
            bolder: 600
        },
        imageSizes: {
            small: 40,
            medium: 80,
            large: 160
        },
        containerStyles: {
            default: {
                backgroundColor: '#FFFFFF',
                foregroundColors: {
                    default: {
                        default: '#333333',
                        subtle: '#EE333333'
                    },
                    dark: {
                        default: '#000000',
                        subtle: '#66000000'
                    },
                    light: {
                        default: '#FFFFFF',
                        subtle: '#33000000'
                    },
                    accent: {
                        default: '#2E89FC',
                        subtle: '#882E89FC'
                    },
                    attention: {
                        default: '#cc3300',
                        subtle: '#DDcc3300'
                    },
                    good: {
                        default: '#54a254',
                        subtle: '#DD54a254'
                    },
                    warning: {
                        default: '#e69500',
                        subtle: '#DDe69500'
                    }
                }
            },
            emphasis: {
                backgroundColor: '#08000000',
                foregroundColors: {
                    default: {
                        default: '#333333',
                        subtle: '#EE333333'
                    },
                    dark: {
                        default: '#000000',
                        subtle: '#66000000'
                    },
                    light: {
                        default: '#FFFFFF',
                        subtle: '#33000000'
                    },
                    accent: {
                        default: '#2E89FC',
                        subtle: '#882E89FC'
                    },
                    attention: {
                        default: '#cc3300',
                        subtle: '#DDcc3300'
                    },
                    good: {
                        default: '#54a254',
                        subtle: '#DD54a254'
                    },
                    warning: {
                        default: '#e69500',
                        subtle: '#DDe69500'
                    }
                }
            }
        },
        actions: {
            maxActions: 5,
            spacing: enums.Spacing.Default,
            buttonSpacing: 10,
            showCard: {
                actionMode: enums.ShowCardActionMode.Inline,
                inlineTopMargin: 16
            },
            actionsOrientation: enums.Orientation.Horizontal,
            actionAlignment: enums.ActionAlignment.Left
        },
        adaptiveCard: {
            allowCustomStyle: false
        },
        imageSet: {
            imageSize: enums.Size.Medium,
            maxImageHeight: 100
        },
        factSet: {
            title: {
                color: enums.TextColor.Default,
                size: enums.TextSize.Default,
                isSubtle: false,
                weight: enums.TextWeight.Bolder,
                wrap: true,
                maxWidth: 150
            },
            value: {
                color: enums.TextColor.Default,
                size: enums.TextSize.Default,
                isSubtle: false,
                weight: enums.TextWeight.Default,
                wrap: true
            },
            spacing: 10
        }
    });
});

unwrapExports(cardElements);
var cardElements_1 = cardElements.createActionInstance;
var cardElements_2 = cardElements.createElementInstance;
var cardElements_3 = cardElements.SpacingDefinition;
var cardElements_4 = cardElements.PaddingDefinition;
var cardElements_5 = cardElements.SizeAndUnit;
var cardElements_6 = cardElements.CardElement;
var cardElements_7 = cardElements.CardElementContainer;
var cardElements_8 = cardElements.TextBlock;
var cardElements_9 = cardElements.Fact;
var cardElements_10 = cardElements.FactSet;
var cardElements_11 = cardElements.Image;
var cardElements_12 = cardElements.ImageSet;
var cardElements_13 = cardElements.MediaSource;
var cardElements_14 = cardElements.Media;
var cardElements_15 = cardElements.Input;
var cardElements_16 = cardElements.TextInput;
var cardElements_17 = cardElements.ToggleInput;
var cardElements_18 = cardElements.Choice;
var cardElements_19 = cardElements.ChoiceSetInput;
var cardElements_20 = cardElements.NumberInput;
var cardElements_21 = cardElements.DateInput;
var cardElements_22 = cardElements.TimeInput;
var cardElements_23 = cardElements.Action;
var cardElements_24 = cardElements.SubmitAction;
var cardElements_25 = cardElements.OpenUrlAction;
var cardElements_26 = cardElements.HttpHeader;
var cardElements_27 = cardElements.HttpAction;
var cardElements_28 = cardElements.ShowCardAction;
var cardElements_29 = cardElements.ActionSet;
var cardElements_30 = cardElements.BackgroundImage;
var cardElements_31 = cardElements.Container;
var cardElements_32 = cardElements.Column;
var cardElements_33 = cardElements.ColumnSet;
var cardElements_34 = cardElements.ContainerWithActions;
var cardElements_35 = cardElements.TypeRegistry;
var cardElements_36 = cardElements.ElementTypeRegistry;
var cardElements_37 = cardElements.ActionTypeRegistry;
var cardElements_38 = cardElements.AdaptiveCard;

var adaptivecards = createCommonjsModule(function (module, exports) {
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    Object.defineProperty(exports, '__esModule', { value: true });
    __export(cardElements);
    __export(enums);
    __export(hostConfig);

    exports.SizeAndUnit = utils.SizeAndUnit;
    exports.getEnumValueOrDefault = utils.getEnumValueOrDefault;
});

var AdaptiveCards = unwrapExports(adaptivecards);
var adaptivecards_1 = adaptivecards.SizeAndUnit;
var adaptivecards_2 = adaptivecards.getEnumValueOrDefault;

var CustomImage =
    /*#__PURE__*/
    (function (_Adaptivecards$Image) {
        _inherits(CustomImage, _Adaptivecards$Image);

        function CustomImage() {
            _classCallCheck(this, CustomImage);

            return _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomImage).call(this)
            );
        }

        _createClass(CustomImage, [
            {
                key: 'internalRender',
                value: function internalRender() {
                    var imageElement = _get(
                        _getPrototypeOf(CustomImage.prototype),
                        'internalRender',
                        this
                    ).call(this);

                    if (!imageElement) {
                        return imageElement;
                    }

                    var child = imageElement.children[0];

                    if (!child.alt || child.alt === 'undefined') {
                        // Add a default alt-text
                        child.alt = 'User defined image';
                    }

                    imageElement.removeChild(imageElement.lastChild);
                    var newChild = document.createElement('div');
                    newChild.style.display = 'flex';
                    newChild.style.alignItems = 'flex-start';
                    newChild.style.width = '100%';
                    newChild.style.justifyContent =
                        imageElement.style.justifyContent;
                    newChild.style.boxSizing = imageElement.style.boxSizing;
                    newChild.style.flex = imageElement.style.flex;
                    newChild.appendChild(child);
                    imageElement.appendChild(newChild);
                    return imageElement;
                }
            }
        ]);

        return CustomImage;
    })(AdaptiveCards.Image);

var CustomFactSet =
    /*#__PURE__*/
    (function (_AdaptiveCards$FactSe) {
        _inherits(CustomFactSet, _AdaptiveCards$FactSe);

        function CustomFactSet(clientManagerInstance) {
            var _this;

            _classCallCheck(this, CustomFactSet);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomFactSet).call(this)
            );
            _this.clientManagerInstance = clientManagerInstance;
            return _this;
        } // Customize FactSet action for Outlook Mobile

        _createClass(CustomFactSet, [
            {
                key: 'internalRender',
                value: function internalRender() {
                    var element = null;

                    if (this.facts.length > 0) {
                        //Create table element and fill style properties
                        element = document.createElement('div');
                        element.style.borderWidth = '0px';
                        element.style.borderSpacing = '0px';
                        element.style.borderStyle = 'none';
                        element.style.borderCollapse = 'collapse';
                        element.style.display = 'block';
                        element.style.overflow = 'hidden';

                        for (var i = 0; i < this.facts.length; i++) {
                            // Ignore the fact if either of title or value is not present
                            if (!this.facts[i].name || !this.facts[i].value) {
                                continue;
                            } //Create AdaptiveCard TextBlock for factKey and convert it into html

                            var textBlock = this.createTextBlock(
                                this.hostConfig,
                                this.facts[i].name,
                                this.hostConfig.factSet.title.size,
                                this.hostConfig.factSet.title.color,
                                this.hostConfig.factSet.title.isSubtle,
                                this.hostConfig.factSet.title.weight,
                                this.hostConfig.factSet.title.wrap,
                                AdaptiveCards.Spacing.None
                            );
                            var renderedElement = textBlock.render(); //Insert separator element(spacing between facts)

                            if (i > 0) {
                                renderedElement.style.marginTop =
                                    this.clientManagerInstance
                                        .factKeyTopPadding + 'px';
                            } //Insert factKey into table

                            element.appendChild(renderedElement); //Create AdaptiveCard TextBlock for factValue and convert it into html

                            textBlock = this.createTextBlock(
                                this.hostConfig,
                                this.facts[i].value,
                                this.hostConfig.factSet.value.size,
                                this.hostConfig.factSet.value.color,
                                this.hostConfig.factSet.value.isSubtle,
                                this.hostConfig.factSet.value.weight,
                                this.hostConfig.factSet.value.wrap,
                                AdaptiveCards.Spacing.None
                            );
                            renderedElement = textBlock.render();
                            renderedElement.style.marginTop =
                                this.clientManagerInstance.factValueTopPadding +
                                'px'; //Insert factValue into table

                            element.appendChild(renderedElement);
                        }
                    }

                    return element;
                }
            },
            {
                key: 'createTextBlock',
                value: function createTextBlock(
                    hostConfig,
                    text,
                    size,
                    color,
                    isSubtle,
                    weight,
                    wrap,
                    spacing
                ) {
                    var textBlock = new AdaptiveCards.TextBlock();
                    textBlock.hostConfig = hostConfig;
                    textBlock.text = text;
                    textBlock.size = size;
                    textBlock.color = color;
                    textBlock.isSubtle = isSubtle;
                    textBlock.weight = weight;
                    textBlock.wrap = wrap;
                    textBlock.spacing = spacing;
                    return textBlock;
                }
            }
        ]);

        return CustomFactSet;
    })(AdaptiveCards.FactSet);

var CustomImageSet =
    /*#__PURE__*/
    (function (_AdaptiveCards$ImageS) {
        _inherits(CustomImageSet, _AdaptiveCards$ImageS);

        function CustomImageSet(clientManagerInstance) {
            var _this;

            _classCallCheck(this, CustomImageSet);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomImageSet).call(this)
            );
            _this.clientManagerInstance = clientManagerInstance;
            return _this;
        }

        _createClass(CustomImageSet, [
            {
                key: 'parse',
                value: function parse(json, errors) {
                    this.imageSize = AdaptiveCards.getEnumValueOrDefault(
                        AdaptiveCards.Size,
                        json['imageSize'],
                        AdaptiveCards.Size.Medium
                    );

                    if (json['images']) {
                        var jsonImages = json['images'];
                        this._images = [];

                        for (var i = 0; i < jsonImages.length; i++) {
                            var image = new this.clientManagerInstance.ImageClass();
                            image.parse(jsonImages[i], errors);
                            this.addImage(image);
                        }
                    }
                } // Customize Image Set Rendering for outlook mobile
            },
            {
                key: 'internalRender',
                value: function internalRender() {
                    var element = null; // max image width in case of auto and stretch

                    var maxImageWidth =
                        (this.clientManagerInstance.getContainerWidth() -
                            2 * 4) /
                        2;

                    if (this._images.length > 0) {
                        element = document.createElement('div');
                        element.style.margin =
                            '-' + this.clientManagerInstance.imageMargin + 'px';
                        element.style.display = 'flex';
                        element.style.flexWrap = 'wrap';

                        for (var i = 0; i < this._images.length; i++) {
                            this._images[i].size = this.imageSize;

                            var renderedImage = this._images[i].render();

                            renderedImage.style.display = 'inline-flex'; // Image element is grandchild of renderedImage div. This is required to done to set width of image element

                            var imageElement =
                                renderedImage.children[0].children[0];
                            renderedImage.style.margin =
                                this.clientManagerInstance.imageMargin + 'px';
                            imageElement.style.maxHeight =
                                this.hostConfig.imageSet.maxImageHeight + 'px';

                            switch (this.imageSize) {
                                case AdaptiveCards.Size.Auto:
                                    imageElement.style.width = 'auto'; // Set the maxWidth to half of screen width

                                    imageElement.style.maxWidth =
                                        maxImageWidth + 'px';
                                    break;

                                case AdaptiveCards.Size.Stretch:
                                    imageElement.style.width =
                                        maxImageWidth + 'px'; // Set the maxWidth to half of screen width

                                    imageElement.style.maxWidth =
                                        maxImageWidth + 'px';
                                    break;
                            }

                            element.appendChild(renderedImage);
                        }
                    }

                    return element;
                }
            }
        ]);

        return CustomImageSet;
    })(AdaptiveCards.ImageSet);

var CustomDateInput =
    /*#__PURE__*/
    (function (_AdaptiveCards$DateIn) {
        _inherits(CustomDateInput, _AdaptiveCards$DateIn);

        function CustomDateInput(clientManagerInstance) {
            var _this2;

            _classCallCheck(this, CustomDateInput);

            _this2 = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomDateInput).call(this)
            );
            _this2.clientManagerInstance = clientManagerInstance;
            return _this2;
        } // on user click this is called, native method is called to open a native popup

        _createClass(CustomDateInput, [
            {
                key: 'openDatePicker',
                value: function openDatePicker() {
                    if (this.clientManagerInstance != null) {
                        this.clientManagerInstance.openDatePicker(
                            this.id,
                            this.selectedDateWithTimeZone,
                            this.placeholder,
                            this.isRequired
                        );
                    }
                } // sets text by selected date. called when user selects a date.
            },
            {
                key: 'setSpanText',
                value: function setSpanText(
                    selectedDate,
                    selectedDateWithTimeZone
                ) {
                    this.dateInputElement.innerText = selectedDate;
                    this.dateInputElement.classList.remove('input-placeholder');
                    this.selectedDate = selectedDate;
                    this.selectedDateWithTimeZone = selectedDateWithTimeZone;
                    this.valueChanged();
                } // return value during action submission
            },
            {
                key: 'getAriaLabel',
                value: function getAriaLabel(placeHolder, value) {
                    return (
                        'Date Input ' +
                        placeHolder +
                        ' ' +
                        value +
                        ' Double tap to edit'
                    );
                }
            },
            {
                key: 'internalRender',
                value: function internalRender() {
                    var _this = this;

                    if (this.defaultValue) {
                        this.selectedDateWithTimeZone = new Date(
                            this.defaultValue
                        ).toISOString();
                        this.selectedDate = this.clientManagerInstance.UtilsClass.formatDate(
                            this.defaultValue
                        );
                    } else {
                        this.selectedDateWithTimeZone = null;
                        this.selectedDate = null;
                    }

                    this.getRestoredState();
                    this.placeholder =
                        this.placeholder ||
                        this.clientManagerInstance
                            .dateInputDefaultPlaceHolderText;

                    if (this.isRequired) {
                        if (
                            this.placeholder[this.placeholder.length - 1] !==
                            '*'
                        )
                            this.placeholder = this.placeholder + '*';
                    }

                    this.dateInputElement = document.createElement('div');
                    this.dateInputElement.className = 'date-input-value';

                    if (this.placeholder) {
                        this.dateInputElement.innerText = this.placeholder;
                        this.dateInputElement.classList.add(
                            'input-placeholder'
                        );
                    }

                    if (this.selectedDate) {
                        this.dateInputElement.innerText = this.selectedDate;
                        this.dateInputElement.classList.remove(
                            'input-placeholder'
                        );
                    }

                    var inputElement = document.createElement('div');
                    inputElement.appendChild(this.dateInputElement);
                    inputElement.className = 'ac-input ac-dateInput';
                    inputElement.id = this.id;
                    inputElement.dateInputInstance = this;

                    inputElement.onclick = function () {
                        _this.openDatePicker();
                    };

                    inputElement.style.display = 'flex';
                    inputElement.style.justifyContent = 'space-between';
                    var calendarIconElement = document.createElement('img');
                    calendarIconElement.classList.add('calendar-icon');
                    calendarIconElement.src =
                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANtJREFUSA3tVV0KwjAMbqbHcJ7HkygIPmwHGQwRFA/igeY11mgYgaSE1pbtRe1Lfr4kX5qwzrn/SUwAJN73l533/o7oNtL/uQ4DQHVomuODcypWSI4jXsuLUwWsEf2NND6KAMBtGSiXWMtcRSCBufTFCdZWp217Usu3Yixf150x9C9+gygBdSS7Stlh92QrAkQsGo1VmH3mDhgMd5GyOU9KdQMJzKVHCVIzD3GrqSiBlZDr+/Id5I7Dilcjer+mT3qu5cdlJcV9MEg8WPJqTyQyIE+ffjh5OT8f/QKw008G3fZYoQAAAABJRU5ErkJggg==';
                    inputElement.appendChild(calendarIconElement); // For Accessibility

                    inputElement.setAttribute('role', 'button');
                    inputElement.setAttribute(
                        'aria-label',
                        this.getAriaLabel(
                            this.placeholder,
                            this.selectedDate ? this.selectedDate : ''
                        )
                    );
                    var compoundElement = document.createElement('div');

                    if (
                        this.clientManagerInstance
                            .showPlaceholderDivOnInputFocus
                    ) {
                        this.placeHolderElement = document.createElement('div');
                        this.placeHolderElement.className = 'ac-placeHolder';
                        this.placeHolderElement.innerText = this.placeholder;
                        this.placeHolderElement.style.display = this.value
                            ? 'block'
                            : 'none';
                        compoundElement.appendChild(this.placeHolderElement);
                    }

                    compoundElement.appendChild(inputElement);
                    return compoundElement;
                }
            },
            {
                key: 'getRestoredState',
                value: function getRestoredState() {
                    if (
                        this.clientManagerInstance.restoredInputs &&
                        this.clientManagerInstance.restoredInputs.hasOwnProperty(
                            this.id
                        )
                    ) {
                        var val = this.clientManagerInstance.restoredInputs[
                            this.id
                        ];
                        this.selectedDateWithTimeZone = new Date(
                            val
                        ).toISOString();
                        this.selectedDate = this.clientManagerInstance.UtilsClass.formatDate(
                            val
                        );
                    }
                }
            },
            {
                key: 'value',
                get: function get() {
                    return this.selectedDateWithTimeZone;
                }
            }
        ]);

        return CustomDateInput;
    })(AdaptiveCards.DateInput);

var CustomNumberInput =
    /*#__PURE__*/
    (function (_AdaptiveCards$Number) {
        _inherits(CustomNumberInput, _AdaptiveCards$Number);

        function CustomNumberInput(clientManagerInstance) {
            var _this2;

            _classCallCheck(this, CustomNumberInput);

            _this2 = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomNumberInput).call(this)
            );
            _this2.clientManagerInstance = clientManagerInstance;
            _this2.utils = _this2.clientManagerInstance.UtilsClass;
            return _this2;
        }

        _createClass(CustomNumberInput, [
            {
                key: 'openNumberPop',
                value: function openNumberPop() {
                    if (this.clientManagerInstance != null) {
                        var numberInputProperties = {
                            id: this.id,
                            placeholder: this.placeholder,
                            isRequired: this.isRequired,
                            min: this.min,
                            max: this.max,
                            value: this.value
                        };
                        this.clientManagerInstance.openNumberPop(
                            numberInputProperties
                        );
                    }
                } // sets number typed in popup to input element
            },
            {
                key: 'setNumber',
                value: function setNumber(value) {
                    this._numberInputElement.value = value;

                    if (this.handleInputChanged) {
                        this.handleInputChanged();
                    }
                } // customize Text Input for mobile
            },
            {
                key: 'internalRender',
                value: function internalRender() {
                    var _this = this;

                    this.placeholder =
                        this.placeholder ||
                        this.clientManagerInstance
                            .numberInputDefaultPlaceHolderText;

                    if (this.isRequired) {
                        if (
                            this.placeholder[this.placeholder.length - 1] !==
                            '*'
                        )
                            this.placeholder = this.placeholder + '*';
                    }

                    var numberInputElement = _get(
                        _getPrototypeOf(CustomNumberInput.prototype),
                        'internalRender',
                        this
                    ).call(this);

                    numberInputElement.addEventListener('keydown', function (
                        event
                    ) {
                        var isNumberValue = function isNumberValue(key) {
                            return !Number.isNaN(parseInt(key));
                        };

                        var isSpecialKey = function isSpecialKey(keyCode) {
                            return (
                                keyCode === 8 ||
                                keyCode === 9 ||
                                keyCode === 13 ||
                                keyCode === 27 ||
                                (keyCode >= 35 && keyCode <= 40) ||
                                keyCode === 46 ||
                                keyCode === 189
                            );
                        };

                        var isCutCopyPaste = function isCutCopyPaste(event) {
                            return (
                                (event.ctrlKey || event.metaKey) &&
                                (event.keyCode === 67 ||
                                    event.keyCode === 88 ||
                                    event.keyCode === 86)
                            );
                        };

                        if (
                            !isNumberValue(event.key) &&
                            !isSpecialKey(event.keyCode) &&
                            !isCutCopyPaste(event)
                        ) {
                            event.preventDefault();
                        }
                    });
                    numberInputElement.addEventListener('paste', function (
                        event
                    ) {
                        var text = event.clipboardData.getData('text/plain');

                        if (Number.isNaN(parseInt(text))) {
                            event.preventDefault();
                        }
                    });
                    numberInputElement.addEventListener('input', function (
                        event
                    ) {
                        var minValue = parseInt(
                            event.target.getAttribute('min')
                        );
                        var maxValue = parseInt(
                            event.target.getAttribute('max')
                        );
                        var value = event.target.value;
                        var isInRange = false; //empty input is not an error condition

                        if (value == '') isInRange = true;
                        else {
                            if (
                                !Number.isNaN(minValue) &&
                                !Number.isNaN(maxValue)
                            ) {
                                isInRange =
                                    value >= minValue && value <= maxValue;
                            } else if (!Number.isNaN(minValue)) {
                                isInRange = value >= minValue;
                            } else if (!Number.isNaN(maxValue)) {
                                isInRange = value <= maxValue;
                            } else {
                                isInRange = true;
                            }
                        }

                        if (!isInRange) {
                            numberInputElement.classList.add('error');

                            var errorElement = _this.inputElement.querySelector(
                                '#numberErrorElement'
                            );

                            if (errorElement === null) {
                                errorElement = document.createElement('div');
                                errorElement.id = 'numberErrorElement';
                                errorElement.className = 'numberErrorElement';
                                errorElement.innerText =
                                    'Select a value between ' +
                                    minValue +
                                    ' and ' +
                                    maxValue;

                                _this.inputElement.appendChild(errorElement);

                                _this.hasSomeError = true;
                            }
                        } else {
                            var errorElement = _this.inputElement.querySelector(
                                '#numberErrorElement'
                            );

                            if (errorElement) {
                                numberInputElement.classList.remove('error');
                                errorElement.remove();
                            }

                            _this.hasSomeError = true;
                        }
                    });
                    this.getRestoredState(numberInputElement);
                    this.inputElement = document.createElement('div');

                    if (
                        this.clientManagerInstance.supportInputPop &&
                        !(
                            this.clientManagerInstance.context &&
                            this.clientManagerInstance.context.isShowCardJson
                        )
                    ) {
                        this.handleInputChanged = numberInputElement.oninput;
                        numberInputElement.readOnly = 'true';

                        numberInputElement.onfocus = function () {
                            numberInputElement.blur();

                            _this.openNumberPop();
                        };

                        numberInputElement.numberInputInstance = this;
                        numberInputElement.id = this.id;
                    }

                    if (
                        this.clientManagerInstance
                            .showPlaceholderDivOnInputFocus
                    ) {
                        this.placeHolderElement = document.createElement(
                            'span'
                        );
                        this.placeHolderElement.className = 'ac-placeHolder';
                        this.placeHolderElement.innerText = this.placeholder;
                        this.placeHolderElement.style.display = this.value
                            ? 'block'
                            : 'none';
                        this.inputElement.appendChild(this.placeHolderElement);
                    }

                    this.inputElement.appendChild(numberInputElement);
                    return this.inputElement;
                }
            },
            {
                key: 'validate',
                value: function validate() {
                    // If isRequired is false, dont validate if input is empty
                    if (!this.value && !this.isRequired) {
                        return [];
                    }

                    var valueNum = Number(this.value);
                    var minNum = this.min ? Number(this.min) : undefined;
                    var maxNum = this.max ? Number(this.max) : undefined;

                    if (minNum && valueNum < minNum) {
                        return [
                            {
                                error:
                                    AdaptiveCards.ValidationError
                                        .InvalidPropertyValue,
                                message: this.utils.format(
                                    this.clientManagerInstance
                                        .VALUE_TOO_SMALL_STRING_KEY,
                                    this.placeholder,
                                    minNum
                                )
                            }
                        ];
                    } else if (maxNum && valueNum > maxNum) {
                        return [
                            {
                                error:
                                    AdaptiveCards.ValidationError
                                        .InvalidPropertyValue,
                                message: this.utils.format(
                                    this.clientManagerInstance
                                        .VALUE_TOO_LARGE_STRING_KEY,
                                    this.placeholder,
                                    maxNum
                                )
                            }
                        ];
                    }

                    return [];
                }
            },
            {
                key: 'getRestoredState',
                value: function getRestoredState(numberInputElement) {
                    if (
                        this.clientManagerInstance.restoredInputs &&
                        this.clientManagerInstance.restoredInputs.hasOwnProperty(
                            this.id
                        )
                    ) {
                        numberInputElement.value = this.clientManagerInstance.restoredInputs[
                            this.id
                        ];
                    }
                }
            }
        ]);

        return CustomNumberInput;
    })(AdaptiveCards.NumberInput);

var CustomTextInput =
    /*#__PURE__*/
    (function (_AdaptiveCards$TextIn) {
        _inherits(CustomTextInput, _AdaptiveCards$TextIn);

        function CustomTextInput(clientManagerInstance) {
            var _this;

            _classCallCheck(this, CustomTextInput);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomTextInput).call(this)
            );
            _this.clientManagerInstance = clientManagerInstance;
            return _this;
        }

        _createClass(CustomTextInput, [
            {
                key: 'openTextPop',
                value: function openTextPop(isMultiline) {
                    if (this.clientManagerInstance != null) {
                        this.actualValue = this.actualValue
                            ? this.actualValue
                            : this.value;
                        var textInputProperties = {
                            id: this.id,
                            placeholder: this.placeholder,
                            isRequired: this.isRequired,
                            isMultiline: isMultiline,
                            maxLength: this.maxLength,
                            style: this.style,
                            value: this.actualValue
                        };
                        this.clientManagerInstance.openTextPop(
                            textInputProperties
                        );
                    }
                } // sets text to input element
            },
            {
                key: 'setText',
                value: function setText(actualValue, displayValue) {
                    this.actualValue = actualValue;
                    this._inputElement.value = displayValue;

                    if (this.handleInputChanged) {
                        this.handleInputChanged();
                    }
                } // customize Text Input for mobile
            },
            {
                key: 'internalRender',
                value: function internalRender() {
                    var _this2 = this;

                    var actualMultiline = this.isMultiline;
                    this.placeholder =
                        this.placeholder ||
                        this.clientManagerInstance
                            .textInputDefaultPlaceHolderText;

                    if (this.isRequired) {
                        if (
                            this.placeholder[this.placeholder.length - 1] !==
                            '*'
                        )
                            this.placeholder = this.placeholder + '*';
                    }

                    if (
                        this.clientManagerInstance.supportInputPop &&
                        !(
                            this.clientManagerInstance.context &&
                            this.clientManagerInstance.context.isShowCardJson
                        )
                    ) {
                        this.isMultiline = false;
                    }

                    var textInputElement = _get(
                        _getPrototypeOf(CustomTextInput.prototype),
                        'internalRender',
                        this
                    ).call(this);

                    this.getRestoredState(textInputElement);

                    if (
                        this.clientManagerInstance.supportInputPop &&
                        !(
                            this.clientManagerInstance.context &&
                            this.clientManagerInstance.context.isShowCardJson
                        )
                    ) {
                        this.handleInputChanged = textInputElement.oninput;
                        textInputElement.readOnly = 'true';

                        textInputElement.onfocus = function () {
                            textInputElement.blur();

                            _this2.openTextPop(actualMultiline);
                        };

                        textInputElement.textInputInstance = this;
                        textInputElement.id = this.id;
                    }

                    var inputElement = document.createElement('div');

                    if (
                        this.clientManagerInstance
                            .showPlaceholderDivOnInputFocus
                    ) {
                        this.placeHolderElement = document.createElement(
                            'span'
                        );
                        this.placeHolderElement.className = 'ac-placeHolder';
                        this.placeHolderElement.innerText = this.placeholder;
                        this.placeHolderElement.style.display = this.value
                            ? 'block'
                            : 'none';
                        inputElement.appendChild(this.placeHolderElement);
                    }

                    if (
                        this.clientManagerInstance.supportDynamicTextArea &&
                        this.isMultiline
                    ) {
                        textInputElement.rows = '1';
                        textInputElement.style.overflowY = 'hidden';
                        textInputElement.resize = 'none';
                        textInputElement.style.boxSizing = 'border-box'; // 41 = height of a single line (lineheight(24) + paddingTop(8) + paddingBottom(8) + bottomBorder(1))

                        var minHeight = 41; //90 = height of 3 lines (3*lineheight(24) + paddingTop(8) + paddingBottom(8) + bottomBorder(1)).

                        var maxHeight = 90;
                        document.addEventListener(
                            'input',
                            function (event) {
                                if (
                                    event.target.tagName.toLowerCase() !==
                                    'textarea'
                                )
                                    return;
                                textInputElement.style.height = 0;

                                _this2.autoExpand(
                                    event.target,
                                    minHeight,
                                    maxHeight
                                );
                            },
                            false
                        );
                    }

                    inputElement.appendChild(textInputElement);
                    return inputElement;
                }
            },
            {
                key: 'autoExpand',
                value: function autoExpand(field, minHeight, maxHeight) {
                    var outerHeight = parseInt(
                        window.getComputedStyle(field).height
                    );
                    var diff = outerHeight - field.clientHeight; // set the height to 0 in case of it has to be shrinked

                    field.style.height = 0;
                    field.style.overflowY = 'hidden'; // set the correct height

                    var totalHeight = field.scrollHeight + diff;

                    if (totalHeight < minHeight) {
                        totalHeight = minHeight;
                    }

                    if (totalHeight > maxHeight) {
                        field.style.overflowY = 'visible';
                        totalHeight = maxHeight;
                    }

                    field.style.height = totalHeight + 'px';
                }
            },
            {
                key: 'getRestoredState',
                value: function getRestoredState(textInputElement) {
                    if (
                        this.clientManagerInstance.restoredInputs &&
                        this.clientManagerInstance.restoredInputs.hasOwnProperty(
                            this.id
                        )
                    ) {
                        this.actualValue = this.clientManagerInstance.restoredInputs[
                            this.id
                        ];
                        textInputElement.value = this.clientManagerInstance.UtilsClass.replaceAll(
                            this.actualValue,
                            '\n',
                            ' '
                        );
                    }
                }
            }
        ]);

        return CustomTextInput;
    })(AdaptiveCards.TextInput);

var CustomChoiceSetInput =
    /*#__PURE__*/
    (function (_AdaptiveCards$Choice) {
        _inherits(CustomChoiceSetInput, _AdaptiveCards$Choice);

        function CustomChoiceSetInput(clientManagerInstance) {
            var _this2;

            _classCallCheck(this, CustomChoiceSetInput);

            _this2 = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomChoiceSetInput).call(this)
            );
            _this2.clientManagerInstance = clientManagerInstance;
            return _this2;
        } // on user click this is called, native method is called to open a native popup

        _createClass(CustomChoiceSetInput, [
            {
                key: 'openChoicePicker',
                value: function openChoicePicker() {
                    var selectedChoices = [];

                    if (this.selectedChoice) {
                        selectedChoices.push(this.selectedChoice);
                    }

                    if (this.clientManagerInstance != null) {
                        this.clientManagerInstance.openChoicePicker(
                            this.id,
                            this.placeholder,
                            this.choiceList,
                            selectedChoices,
                            false,
                            this.isRequired
                        );
                    }
                } // sets text by choice display value. called when user selects a choice.
            },
            {
                key: 'setSpanText',
                value: function setSpanText(choice) {
                    this.spanElement.innerText = choice.display
                        ? choice.display
                        : choice.title;
                    this.spanElement.classList.remove('input-placeholder');
                    this.selectedChoice = choice;
                    this.inputElement.setAttribute(
                        'aria-label',
                        this.getAriaLabel(
                            this.placeholder,
                            this.spanElement.innerText
                        )
                    );
                    this.valueChanged();
                }
            },
            {
                key: 'getAriaLabel',
                value: function getAriaLabel(placeHolder, value) {
                    if (value) {
                        return (
                            value + ' list item selected. Double tap to edit'
                        );
                    } else {
                        return (
                            'Choice Input ' +
                            placeHolder +
                            ' ' +
                            value +
                            ' Double tap to edit'
                        );
                    }
                } // customize choice Set Input for mobile
            },
            {
                key: 'internalRender',
                value: function internalRender() {
                    var _this = this;

                    if (!this.isMultiSelect) {
                        // In case of compact, non multi select, display div and on click call a native method
                        if (this.isCompact) {
                            this.placeholder =
                                this.placeholder ||
                                this.clientManagerInstance
                                    .choiceInputDefaultPlaceHolderText;

                            if (this.isRequired) {
                                if (
                                    this.placeholder[
                                    this.placeholder.length - 1
                                    ] !== '*'
                                )
                                    this.placeholder = this.placeholder + '*';
                            }

                            this.spanElement = document.createElement('span');

                            if (this.placeholder) {
                                this.spanElement.innerText = this.placeholder;
                                this.spanElement.classList.add(
                                    'input-placeholder'
                                );
                            }

                            if (this.defaultValue) {
                                for (var i = 0; i < this.choices.length; i++) {
                                    if (
                                        this.choices[i].value ===
                                        this.defaultValue
                                    ) {
                                        this.selectedChoice = this.choices[i];
                                        this.spanElement.innerText = this.selectedChoice.title;
                                        this.spanElement.classList.remove(
                                            'input-placeholder'
                                        );
                                    }
                                }
                            }

                            for (var i = 0; i < this.choices.length; i++) {
                                if (
                                    this.choices[i].value ===
                                    this.getRestoredState()
                                ) {
                                    this.selectedChoice = this.choices[i];
                                    this.spanElement.innerText = this.selectedChoice.title;
                                    this.spanElement.classList.remove(
                                        'input-placeholder'
                                    );
                                }
                            }

                            this.inputElement = document.createElement('div');
                            this.inputElement.appendChild(this.spanElement);
                            this.inputElement.className =
                                'ac-input ac-dropdown';

                            this.inputElement.onclick = function () {
                                _this.openChoicePicker();
                            };

                            this.inputElement.choiceSetInputInstance = this;
                            this.inputElement.id = this.id;
                            this.inputElement.style.display = 'flex';
                            this.inputElement.style.justifyContent =
                                'space-between';
                            var chevronIconElement = document.createElement(
                                'img'
                            );
                            chevronIconElement.classList.add('chevron-icon');
                            chevronIconElement.style.marginTop = '5px';
                            chevronIconElement.src =
                                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAwCAYAAABwrHhvAAAAAXNSR0IArs4c6QAAAfhJREFUWAnFmEtOwzAURW0XdQZ0MZTfHBjCICwGNsBWqjSQMqPtCpBYDDBrlcS8W8lRSu38/IkHtewkvSfX7zm2OftX0jSdbLdFPBodPUfR/de/y86bvPqPEN9s8jX1nXHOvwnixjdECVAVV1AhIHYAOvFQELxOPASEoICbY8yVmK6WUk7yPFsnyXvtfbpnm/oEBdoTxrrpRl8QAlEuJbvlnP0MAVFmwWz2OuVcrgnmtAnEZXaUABCN4/RcynwVEmIPYAiIA4DQEFoAQCTJ4oJSb+l7OATEdCWKHj4pRe/o2q/uerXPJkWNDigBOJFl2YraJ6rPVPfJDqMDSgROMMa9OdHogAKheeKSMbmktlMnWgMAxAdEJwBAxPHbFQUdZYc8RruutImJzgAQdAnRC8AlRG8AQMzni+uiyD9shsMKwAWENYAtRONEBAGfxdoB2ziwAnCRjr0BXIhjaHsBuBLvBeD6e9DJAdfinRzwIQ6AVvMAVkU+1gKtHBh0SaZWxkTqdBWEN1fFGIShdklagFDicOEAIKQ4AEb4UYVSbcpYEXSHXDoA8SG257t5AEcvdEARdFuuXOcQx/kP9neq01S3WWabnjX1CxJ/GUocUGI8Fo9U1x7J+nhz5cguCOvOCn2KA6LMAh2Eb/E9ADSqECHEDwAURMjj+j9j2tNK6yaphgAAAABJRU5ErkJggg==';
                            this.inputElement.appendChild(chevronIconElement); // For Accessibility

                            this.inputElement.setAttribute('role', 'button');
                            this.inputElement.setAttribute(
                                'aria-label',
                                this.getAriaLabel(
                                    this.placeholder,
                                    this.selectedChoice
                                        ? this.selectedChoice.value
                                        : ''
                                )
                            );
                            var compoundElement = document.createElement('div');

                            if (
                                this.clientManagerInstance
                                    .showPlaceholderDivOnInputFocus
                            ) {
                                this.placeHolderElement = document.createElement(
                                    'span'
                                );
                                this.placeHolderElement.className =
                                    'ac-placeHolder';
                                this.placeHolderElement.innerText = this.placeholder;
                                this.placeHolderElement.style.display = this
                                    .value
                                    ? 'block'
                                    : 'none';
                                compoundElement.appendChild(
                                    this.placeHolderElement
                                );
                            }

                            compoundElement.appendChild(this.inputElement);
                            return compoundElement;
                        } else {
                            // Render as a series of radio buttons
                            var element = document.createElement('div');
                            element.className = 'ac-input ac-singleInput';
                            element.style.width = '100%';
                            this._toggleInputs = [];

                            for (var i = 0; i < this.choices.length; i++) {
                                element.appendChild(
                                    this.getRadioElement(this.choices[i])
                                );

                                if (this.clientManagerInstance != null) {
                                    var separator = this.clientManagerInstance.getSeparatorForChoicePicker();

                                    if (separator != null) {
                                        element.appendChild(separator);
                                    }
                                }
                            }

                            if (this.isRequired) {
                                this.isRequiredElement = document.createElement(
                                    'span'
                                );
                                this.isRequiredElement.className =
                                    'ac-requiredPlaceHolder';
                                this.isRequiredElement.innerText = '*Required';
                                element.appendChild(this.isRequiredElement);
                            }

                            return element;
                        }
                    } else {
                        // Render as a list of toggle inputs
                        var defaultValues = this.defaultValue
                            ? this.defaultValue.split(
                                this.hostConfig.choiceSetInputValueSeparator
                            )
                            : null;
                        var element = document.createElement('div');
                        element.className = 'ac-input ac-multiInput';
                        element.style.width = '100%';
                        this._toggleInputs = [];

                        for (var i = 0; i < this.choices.length; i++) {
                            element.appendChild(
                                this.getCheckboxElement(
                                    this.choices[i],
                                    defaultValues
                                )
                            );

                            if (this.clientManagerInstance != null) {
                                var separator = this.clientManagerInstance.getSeparatorForToggleInputs();

                                if (separator != null) {
                                    element.appendChild(separator);
                                }
                            }
                        }

                        if (this.isRequired) {
                            this.isRequiredElement = document.createElement(
                                'span'
                            );
                            this.isRequiredElement.className =
                                'ac-requiredPlaceHolder';
                            this.isRequiredElement.innerText = '*Required';
                            element.appendChild(this.isRequiredElement);
                        }

                        return element;
                    }
                }
            },
            {
                key: 'getCheckboxElement',
                value: function getCheckboxElement(choice, defaultValues) {
                    var _this = this;

                    var checkboxInput = document.createElement('input');
                    checkboxInput.type = 'checkbox';
                    checkboxInput.style.margin = '0';
                    checkboxInput.style.display = 'inline-block';
                    checkboxInput.style.verticalAlign = 'middle';
                    checkboxInput.value = choice.value;
                    checkboxInput.style.flex = '0 0 auto';
                    checkboxInput.style.marginRight =
                        this.clientManagerInstance.checkboxRightMargin + 'px';
                    checkboxInput.setAttribute('aria-label', choice.title);
                    checkboxInput.onchange = checkboxInput.onclick;

                    checkboxInput.onclick = function (e) {
                        e.stopPropagation();

                        _this.valueChanged();
                    };

                    if (this.getRestoredState() != null) {
                        if (
                            this.getRestoredState()
                                .split(',')
                                .includes(choice.value)
                        ) {
                            checkboxInput.checked = true;
                        }
                    } else {
                        // we don't want to consider default values if restored state is present
                        if (
                            defaultValues &&
                            defaultValues.indexOf(choice.value) >= 0
                        ) {
                            checkboxInput.checked = true;
                        }
                    }

                    this._toggleInputs.push(checkboxInput);

                    var label = new AdaptiveCards.TextBlock();
                    label.hostConfig = this.hostConfig;
                    label.text = choice.title;
                    label.useMarkdown =
                        AdaptiveCards.AdaptiveCard.useMarkdownInRadioButtonAndCheckbox;
                    label.wrap = true;
                    var labelElement = label.render();
                    labelElement.style.display = 'inline-block';
                    labelElement.style.flex = '1 1 auto';
                    labelElement.style.verticalAlign = 'middle';
                    labelElement.style.marginRight = '16px';
                    labelElement.style.marginLeft = '10px';
                    labelElement.style.textAlign = 'unset';
                    var compoundInput = document.createElement('div');
                    compoundInput.style.display = 'flex';

                    if (this.clientManagerInstance.checkboxPaddding) {
                        compoundInput.style.paddingBottom =
                            this.clientManagerInstance.checkboxPaddding + 'px';
                        compoundInput.style.paddingTop =
                            this.clientManagerInstance.checkboxPaddding + 'px';
                    }

                    if (
                        this.clientManagerInstance &&
                        this.clientManagerInstance.supportReverseRowForChoiceSet
                    ) {
                        compoundInput.style.flexDirection = 'row-reverse';
                    }

                    compoundInput.style.alignItems = 'center';
                    compoundInput.appendChild(checkboxInput);
                    compoundInput.appendChild(labelElement);
                    compoundInput.setAttribute('label', choice.title);
                    compoundInput.setAttribute('aria-label', choice.title);
                    compoundInput.setAttribute('role', 'checkbox');
                    compoundInput.tabIndex = 0;
                    compoundInput.children[0].checked
                        ? compoundInput.setAttribute('aria-checked', 'true')
                        : compoundInput.setAttribute('aria-checked', 'false');
                    compoundInput.style.outline = 'none';

                    compoundInput.onclick = function () {
                        _this.valueChanged();

                        this.children[0].checked = !this.children[0].checked;
                        compoundInput.children[0].checked
                            ? compoundInput.setAttribute('aria-checked', 'true')
                            : compoundInput.setAttribute(
                                'aria-checked',
                                'false'
                            );
                    };

                    return compoundInput;
                }
            },
            {
                key: 'getRadioElement',
                value: function getRadioElement(choice) {
                    var _this = this;

                    var radioInput = document.createElement('input');
                    radioInput.type = 'radio';
                    radioInput.style.margin = '0';
                    radioInput.style.display = 'inline-block';
                    radioInput.style.verticalAlign = 'middle';
                    radioInput.name = this.id;
                    radioInput.value = choice.value;
                    radioInput.style.flex = '0 0 auto';
                    radioInput.style.marginRight =
                        this.clientManagerInstance.checkboxRightMargin + 'px';
                    radioInput.setAttribute('aria-hidden', 'true');
                    radioInput.setAttribute('aria-label', choice.title);
                    radioInput.onchange = radioInput.onclick;

                    radioInput.onclick = function (e) {
                        e.stopPropagation();

                        _this.valueChanged();
                    };

                    if (choice.value === this.defaultValue) {
                        radioInput.checked = true;
                    }

                    if (choice.value === this.getRestoredState()) {
                        radioInput.checked = true;
                    }

                    this._toggleInputs.push(radioInput);

                    var label = new AdaptiveCards.TextBlock();
                    label.hostConfig = this.hostConfig;
                    label.text = choice.title;
                    label.wrap = true;
                    label.useMarkdown =
                        AdaptiveCards.AdaptiveCard.useMarkdownInRadioButtonAndCheckbox;
                    var labelElement = label.render();
                    labelElement.style.display = 'inline-block';
                    labelElement.style.flex = '1 1 auto';
                    labelElement.style.verticalAlign = 'middle';
                    labelElement.style.marginRight = '16px';
                    labelElement.style.marginLeft = '10px';
                    labelElement.setAttribute('aria-hidden', 'true');
                    labelElement.style.textAlign = 'unset';
                    var compoundInput = document.createElement('div');
                    compoundInput.style.display = 'flex';

                    if (this.clientManagerInstance.checkboxPaddding) {
                        compoundInput.style.paddingBottom =
                            this.clientManagerInstance.checkboxPaddding + 'px';
                        compoundInput.style.paddingTop =
                            this.clientManagerInstance.checkboxPaddding + 'px';
                    }

                    if (
                        this.clientManagerInstance &&
                        this.clientManagerInstance.supportReverseRowForChoiceSet
                    ) {
                        compoundInput.style.flexDirection = 'row-reverse';
                    }

                    compoundInput.style.alignItems = 'center';
                    compoundInput.appendChild(radioInput);
                    compoundInput.appendChild(labelElement);
                    compoundInput.setAttribute('label', choice.title);
                    compoundInput.setAttribute('aria-label', choice.title);
                    compoundInput.setAttribute('role', 'radio');
                    compoundInput.tabIndex = 0;
                    compoundInput.children[0].checked
                        ? compoundInput.setAttribute('aria-checked', 'true')
                        : compoundInput.setAttribute('aria-checked', 'false');
                    compoundInput.style.outline = 'none';

                    compoundInput.onclick = function () {
                        _this.valueChanged();

                        this.children[0].checked = true;
                    };

                    return compoundInput;
                }
            },
            {
                key: 'getRestoredState',
                value: function getRestoredState() {
                    if (
                        this.clientManagerInstance.restoredInputs &&
                        this.clientManagerInstance.restoredInputs.hasOwnProperty(
                            this.id
                        )
                    ) {
                        console.log(
                            'mahak--restored inputs',
                            this.clientManagerInstance.restoredInputs[this.id]
                        );
                        return this.clientManagerInstance.restoredInputs[
                            this.id
                        ];
                    }

                    return null;
                }
            },
            {
                key: 'value',
                get: function get() {
                    if (!this.isMultiSelect) {
                        if (this.isCompact) {
                            return this.selectedChoice
                                ? this.selectedChoice.value
                                : null;
                        } else {
                            if (
                                !this._toggleInputs ||
                                this._toggleInputs.length == 0
                            ) {
                                return null;
                            }

                            for (
                                var i = 0;
                                i < this._toggleInputs.length;
                                i++
                            ) {
                                if (this._toggleInputs[i].checked) {
                                    return this._toggleInputs[i].value;
                                }
                            }

                            return null;
                        }
                    } else {
                        if (
                            !this._toggleInputs ||
                            this._toggleInputs.length == 0
                        ) {
                            return null;
                        }

                        var result = '';

                        for (var i = 0; i < this._toggleInputs.length; i++) {
                            if (this._toggleInputs[i].checked) {
                                if (result != '') {
                                    result += this.hostConfig
                                        .choiceSetInputValueSeparator;
                                }

                                result += this._toggleInputs[i].value;
                            }
                        }

                        return result == '' ? null : result;
                    }
                }
            }
        ]);

        return CustomChoiceSetInput;
    })(AdaptiveCards.ChoiceSetInput);

var CustomToggleInput =
    /*#__PURE__*/
    (function (_AdaptiveCards$Toggle) {
        _inherits(CustomToggleInput, _AdaptiveCards$Toggle);

        function CustomToggleInput(clientManagerInstance) {
            var _this2;

            _classCallCheck(this, CustomToggleInput);

            _this2 = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomToggleInput).call(this)
            );
            _this2.clientManagerInstance = clientManagerInstance;
            return _this2;
        } // customize Toggle Input for mobile

        _createClass(CustomToggleInput, [
            {
                key: 'internalRender',
                value: function internalRender() {
                    var _this = this;

                    var element = document.createElement('div');
                    element.style.alignItems = 'center'; //we don't want border for toggle input

                    element.className = this.hostConfig.makeCssClassName(
                        'ac-input'
                    );

                    element.style.width = '100%';
                    element.style.display = 'flex';
                    this._checkboxInputElement = document.createElement(
                        'input'
                    );
                    this._checkboxInputElement.type = 'checkbox';
                    this._checkboxInputElement.style.display = 'inline-block';
                    this._checkboxInputElement.style.verticalAlign = 'middle';
                    this._checkboxInputElement.style.margin = '0';
                    this._checkboxInputElement.style.flex = '0 0 auto';

                    this._checkboxInputElement.setAttribute(
                        'aria-label',
                        this.title ? this.title : this.getJsonTypeName()
                    );

                    this._checkboxInputElement.tabIndex = 0;

                    if (this.defaultValue == this.valueOn) {
                        this._checkboxInputElement.checked = true;
                    }

                    this.getRestoredState();

                    this._checkboxInputElement.onchange = function () {
                        _this.valueChanged();
                    };

                    element.appendChild(this._checkboxInputElement); // label will exist only incase of a title

                    if (this.title) {
                        var label = new AdaptiveCards.TextBlock();
                        label.hostConfig = this.hostConfig;
                        label.text = this.title;
                        label.useMarkdown =
                            AdaptiveCards.AdaptiveCard.useMarkdownInRadioButtonAndCheckbox;
                        label.wrap = true;
                        var labelElement = label.render();
                        labelElement.style.display = 'inline-block';
                        labelElement.style.flex = '1 1 auto';
                        labelElement.style.verticalAlign = 'middle';
                        labelElement.style.textAlign = 'unset'; //add padding for mac
                        element.appendChild(labelElement);
                        this._checkboxInputElement.style.marginRight =
                            this.clientManagerInstance.checkboxRightMargin +
                            'px';
                    }

                    return element;
                }
            },
            {
                key: 'getRestoredState',
                value: function getRestoredState() {
                    if (
                        this.clientManagerInstance.restoredInputs &&
                        this.clientManagerInstance.restoredInputs.hasOwnProperty(
                            this.id
                        )
                    ) {
                        var val = this.clientManagerInstance.restoredInputs[
                            this.id
                        ];

                        if (val === this.valueOn) {
                            this._checkboxInputElement.checked = true;
                        } else {
                            this._checkboxInputElement.checked = false;
                        }
                    }
                }
            }
        ]);

        return CustomToggleInput;
    })(AdaptiveCards.ToggleInput);

var CustomHttpAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$HttpAc) {
        _inherits(CustomHttpAction, _AdaptiveCards$HttpAc);

        function CustomHttpAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, CustomHttpAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(CustomHttpAction).call(this)
            );
            _this.hideCardOnInvoke = false;
            _this.constants = clientManagerInstance.constants;
            _this.inputIds = [];
            return _this;
        }

        _createClass(CustomHttpAction, [
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(CustomHttpAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    this.inputIds = this.extractInputIds(json);
                } // parse action json
            },
            {
                key: 'parseMessageCardAction',
                value: function parseMessageCardAction(json) {
                    this.method = 'POST';
                    this.body = json[this.constants.BodyProperty];
                    this.title = json[this.constants.NameProperty];
                    this.url = json[this.constants.TargetProperty];
                    this.id = json[this.constants.IdProperty];
                    this.isPrimary =
                        json[this.constants.IsPrimaryAction] || false;

                    if (json[this.constants.HeadersProperty] != undefined) {
                        var headers = json[this.constants.HeadersProperty];

                        for (var i = 0; i < headers.length; i++) {
                            var httpHeader = new AdaptiveCards.HttpHeader();
                            httpHeader.name =
                                headers[i][this.constants.NameProperty];
                            httpHeader.value =
                                headers[i][this.constants.ValueProperty];
                            this.headers.push(httpHeader);
                        }
                    }

                    if (
                        json[this.constants.BodyContentTypeProperty] !=
                        undefined
                    ) {
                        this.bodyContentType =
                            json[this.constants.BodyContentTypeProperty];
                    }

                    if (
                        json[this.constants.HideCardOnInvokeProperty] !=
                        undefined
                    ) {
                        this.hideCardOnInvoke =
                            json[this.constants.HideCardOnInvokeProperty];
                    }

                    this.inputIds = this.extractInputIds(json);
                } // prepares data to be sent to the client
            },
            {
                key: 'prepare',
                value: function prepare(inputs) {
                    this.data = [];

                    for (var i = 0; i < inputs.length; i++) {
                        if (this.inputIds.indexOf(inputs[i].id) == -1) {
                            continue;
                        }

                        var value = null;

                        if (inputs[i].value != null) {
                            value = inputs[i].actualValue
                                ? inputs[i].actualValue
                                : inputs[i].value;
                            var validationErrors = inputs[i].validate();
                            var preparedInput = {
                                id: inputs[i].id,
                                value: value
                            };

                            if (
                                validationErrors &&
                                validationErrors.length > 0
                            ) {
                                preparedInput[
                                    'validationErrors'
                                ] = validationErrors;
                            }

                            this.data.push(preparedInput);
                        }
                    }
                } //extract input ids from url,body and header
            },
            {
                key: 'extractInputIds',
                value: function extractInputIds(httpActionJson) {
                    var regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi;
                    var matches;
                    var inputs = [];

                    while ((matches = regEx.exec(httpActionJson.url)) != null) {
                        inputs.push(matches[1]);
                    }

                    while (
                        (matches = regEx.exec(httpActionJson.body)) != null
                    ) {
                        inputs.push(matches[1]);
                    }

                    if (httpActionJson.headers != null) {
                        var headers = httpActionJson.headers;

                        for (var i = 0; i < headers.length; i++) {
                            var header = headers[i];

                            if (header.value) {
                                while (
                                    (matches = regEx.exec(header.value)) != null
                                ) {
                                    inputs.push(matches[1]);
                                }
                            }
                        }
                    }

                    return inputs;
                }
            }
        ]);

        return CustomHttpAction;
    })(AdaptiveCards.HttpAction);

var MoreAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$Action) {
        _inherits(MoreAction, _AdaptiveCards$Action);

        function MoreAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, MoreAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(MoreAction).call(this)
            );
            _this.items = [];
            _this.constants = clientManagerInstance.constants;
            return _this;
        } // get TypeName of action

        _createClass(MoreAction, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Action.More';
                }
            },
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(MoreAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (
                            var _iterator = json[
                                this.constants.ActionsProperty
                            ][Symbol.iterator](),
                            _step;
                            !(_iteratorNormalCompletion = (_step = _iterator.next())
                                .done);
                            _iteratorNormalCompletion = true
                        ) {
                            var actionJson = _step.value;
                            var action = AdaptiveCards.createActionInstance(
                                this.parent,
                                actionJson
                            );
                            this.addAction(action);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (
                                !_iteratorNormalCompletion &&
                                _iterator['return'] != null
                            ) {
                                _iterator['return']();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    this.potentialAction = json[this.constants.ActionsProperty];
                } // add an action to moreaction list
            },
            {
                key: 'addAction',
                value: function addAction(action) {
                    if (action != null) {
                        this.items.push(action);
                    }
                } // get all inputs
            },
            {
                key: 'getAllInputs',
                value: function getAllInputs() {
                    var result = [];

                    for (var i = 0; i < this.items.length; i++) {
                        var item = this.items[i];
                        result = result.concat(item.getAllInputs());
                    }

                    return result;
                }
            }
        ]);

        return MoreAction;
    })(AdaptiveCards.Action);

var ToggleVisibilityAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$Action) {
        _inherits(ToggleVisibilityAction, _AdaptiveCards$Action);

        function ToggleVisibilityAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, ToggleVisibilityAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(ToggleVisibilityAction).call(this)
            );
            _this.targetElements = [];
            _this.constants = clientManagerInstance.constants;
            return _this;
        }

        _createClass(ToggleVisibilityAction, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Action.ToggleVisibility';
                }
            },
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(ToggleVisibilityAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    this.targetElements = json[this.constants.TargetElements];
                }
            },
            {
                key: 'execute',
                value: function execute() {
                    _get(
                        _getPrototypeOf(ToggleVisibilityAction.prototype),
                        'execute',
                        this
                    ).call(this);

                    if (this.targetElements) {
                        for (var i = 0; i < this.targetElements.length; i++) {
                            var element = this.targetElements[i];
                            var targetElement;

                            if (typeof element === 'string') {
                                targetElement = this.parent
                                    .getRootElement()
                                    .getElementById(element);

                                if (targetElement) {
                                    targetElement.isVisible = !targetElement.isVisible;
                                }
                            } else if (
                                _typeof(element) === 'object' &&
                                element.hasOwnProperty(
                                    this.constants.ElementId
                                ) &&
                                element.hasOwnProperty(this.constants.IsVisible)
                            ) {
                                targetElement = this.parent
                                    .getRootElement()
                                    .getElementById(
                                        element[this.constants.ElementId]
                                    );

                                if (targetElement) {
                                    targetElement.isVisible = element.isVisible;
                                }
                            }
                        }
                    }
                }
            }
        ]);

        return ToggleVisibilityAction;
    })(AdaptiveCards.Action);

var InvokeAddinAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$Action) {
        _inherits(InvokeAddinAction, _AdaptiveCards$Action);

        function InvokeAddinAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, InvokeAddinAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(InvokeAddinAction).call(this)
            );
            _this.constants = clientManagerInstance.constants;
            return _this;
        }

        _createClass(InvokeAddinAction, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Action.InvokeAddInCommand';
                }
            },
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(InvokeAddinAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    this.addinId = json[this.constants.AddInId];
                    this.desktopCommandId =
                        json[this.constants.DesktopCommandId];
                    this.initializationContext =
                        json[this.constants.InitializationContext];
                }
            }
        ]);

        return InvokeAddinAction;
    })(AdaptiveCards.Action);

var DisplayAppointmentFormAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$Action) {
        _inherits(DisplayAppointmentFormAction, _AdaptiveCards$Action);

        function DisplayAppointmentFormAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, DisplayAppointmentFormAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(DisplayAppointmentFormAction).call(this)
            );
            _this.constants = clientManagerInstance.constants;
            return _this;
        }

        _createClass(DisplayAppointmentFormAction, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Action.DisplayAppointmentForm';
                }
            },
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(DisplayAppointmentFormAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    this.itemId = json[this.constants.ItemId];
                }
            }
        ]);

        return DisplayAppointmentFormAction;
    })(AdaptiveCards.Action);

var DisplayMessageFormAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$Action) {
        _inherits(DisplayMessageFormAction, _AdaptiveCards$Action);

        function DisplayMessageFormAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, DisplayMessageFormAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(DisplayMessageFormAction).call(this)
            );
            _this.constants = clientManagerInstance.constants;
            return _this;
        }

        _createClass(DisplayMessageFormAction, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Action.DisplayMessageForm';
                }
            },
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(DisplayMessageFormAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    this.itemId = json[this.constants.ItemId];
                }
            }
        ]);

        return DisplayMessageFormAction;
    })(AdaptiveCards.Action);

var TransactionAction =
    /*#__PURE__*/
    (function (_AdaptiveCards$Action) {
        _inherits(TransactionAction, _AdaptiveCards$Action);

        function TransactionAction(clientManagerInstance) {
            var _this;

            _classCallCheck(this, TransactionAction);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(TransactionAction).call(this)
            );
            _this.constants = clientManagerInstance.constants;
            return _this;
        }

        _createClass(TransactionAction, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Action.Transaction';
                }
            },
            {
                key: 'parse',
                value: function parse(json) {
                    _get(
                        _getPrototypeOf(TransactionAction.prototype),
                        'parse',
                        this
                    ).call(this, json);

                    if (json[this.constants.InitializationContext]) {
                        this.merchantId =
                            json[this.constants.InitializationContext][
                            this.constants.MerchantId
                            ];
                        this.displayId =
                            json[this.constants.InitializationContext][
                            this.constants.DisplayId
                            ];
                        this.productContext =
                            json[this.constants.InitializationContext][
                            this.constants.ProductContext
                            ];
                    }
                }
            }
        ]);

        return TransactionAction;
    })(AdaptiveCards.Action);

// Theme class to define different themes
var Theme =
    /* summary
   Creates a new Theme with given params.
   style: Style of the theme
   hostConfigJson: hostConfig json which defines the style sheet for the card.
   client: client name
   allowCardTitle: bool flag which indicates if CardTitle needs to be displayed in this theme.
   allowFacts: bool flag which indicates whether facts needs to be displayed in this theme.
   allowHeroImage: bool flag which indicates whether hero image needs to be displayed in this theme.
   allowImages: bool flag which indicates whether images needs to be displayed in this theme.
   allowActionCard: bool flag which indicates whether action card needs to be displayed in this theme
   allowAutoInvokeAction: bool flag which indicates whether autoInvokeAction needs to honored
   allowDisplayMoreAction: bool flag which indicates whether More Action needs to be shown*/
    function Theme(
        style,
        hostConfigJson,
        client,
        allowCardTitle,
        allowFacts,
        allowHeroImage,
        allowImages,
        allowActionCard,
        allowAutoInvokeAction,
        allowDisplayMoreAction
    ) {
        _classCallCheck(this, Theme);

        this.style = style;
        this.hostConfig = hostConfigJson;
        this.client = client;
        this.allowCardTitle = allowCardTitle;
        this.allowFacts = allowFacts;
        this.allowHeroImage = allowHeroImage;
        this.allowImages = allowImages;
        this.allowActionCard = allowActionCard;
        this.allowAutoInvokeAction = allowAutoInvokeAction;
        this.allowDisplayMoreAction = allowDisplayMoreAction;
    };

var _Utils$Constants;

var Utils = function Utils() {
    _classCallCheck(this, Utils);
}; // Constants used in the library

Utils.Constants =
    ((_Utils$Constants = {
        ActionCardAction: 'actioncard',
        ActionId: 'actionId',
        ActionContext: 'actionContext',
        ActionsProperty: 'actions',
        ActivityImageProperty: 'activityImage',
        ActivitySubtitleProperty: 'activitySubtitle',
        ActivityTextProperty: 'activityText',
        ActivityTitleProperty: 'activityTitle',
        AdaptiveCard: 'adaptiveCard',
        AdaptiveCardSerializedProperty: 'AdaptiveCardSerialized',
        AddInId: 'addInId',
        AndroidClient: 'android',
        AuthenticationUrl: 'authenticationUrl',
        AutoInvokeAction: 'autoInvokeAction',
        AutoInvokeOptions: 'autoInvokeOptions',
        BackgroundColor: 'backgroundColor',
        BackgroundImage: 'backgroundImage',
        BodyContentTypeProperty: 'bodyContentType',
        BodyProperty: 'body',
        Bottom: 'bottom',
        ChoiceSetInput: 'ChoiceSetInput',
        ChoicesProperty: 'choices',
        ClientTelemetry: 'clientTelemetry',
        ClientType: 'clientType',
        ClientVersion: 'clientVersion',
        ConstrainWidth: 'constrainWidth',
        CompactProperty: 'compact',
        ConnectedAccountNotErrorString: 'ConnectedAccountNotFoundError',
        ConnectorMessage: 'connectorMessage',
        ConnectorSenderGuidProperty: 'ConnectorSenderGuid',
        connectorSenderGuidProperty: 'connectorSenderGuid',
        ConsentPromptDisplayed: 'ConsentPromptDisplayed',
        ConversationId: 'conversationId',
        Culture: 'culture',
        DataProperty: 'data',
        DateInput: 'dateinput',
        DefaultStyle: 'default',
        DesktopCommandId: 'desktopCommandId',
        DisplayId: 'displayId',
        DisplayMessageProperty: 'displayMessage',
        DisplayProperty: 'display',
        ElementId: 'elementId',
        ErrorCode: 'errorCode',
        EnableBodyTogglingProperty: 'enableBodyToggling',
        Expanded: 'expanded',
        EventName: 'eventName',
        FactSet: 'FactSet',
        FactsProperty: 'facts',
        GroupMailbox: 'Group',
        HasSucceeded: 'hasSucceeded',
        HeadersProperty: 'headers',
        HeroImageProperty: 'heroImage',
        HideCardOnInvokeProperty: 'hideCardOnInvoke',
        HideCardProperty: 'hideCard',
        HideOriginalBodyProperty: 'hideOriginalBody',
        Href: 'href',
        HttpAction: 'HttpAction',
        HttpPostAction: 'httppost',
        IdProperty: '@id',
        IncludeTimeProperty: 'includeTime',
        InitializationContext: 'initializationContext',
        ImageProperty: 'image',
        ImageSet: 'ImageSet',
        ImagesProperty: 'images'
    }),
        _defineProperty(_Utils$Constants, 'IncludeTimeProperty', 'includeTime'),
        _defineProperty(
            _Utils$Constants,
            'InnerErrorCodeProperty',
            'innerErrorCode'
        ),
        _defineProperty(_Utils$Constants, 'InputIdProperty', 'id'),
        _defineProperty(_Utils$Constants, 'InputsProperty', 'inputs'),
        _defineProperty(_Utils$Constants, 'IOsClient', 'iOS'),
        _defineProperty(
            _Utils$Constants,
            'IsAdaptiveCardAction',
            'isAdaptiveCardAction'
        ),
        _defineProperty(
            _Utils$Constants,
            'IsAutoInvokeAction',
            'isAutoInvokeAction'
        ),
        _defineProperty(
            _Utils$Constants,
            'IsGroupEscalationMessage',
            'isGroupEscalationMessage'
        ),
        _defineProperty(_Utils$Constants, 'IsVisible', 'isVisible'),
        _defineProperty(_Utils$Constants, 'IsMoreAction', 'isMoreAction'),
        _defineProperty(
            _Utils$Constants,
            'IsEphemeralRefreshCardProperty',
            'isEphemeralRefreshCard'
        ),
        _defineProperty(_Utils$Constants, 'IsMultiSelectProperty', 'isMultiSelect'),
        _defineProperty(_Utils$Constants, 'IsMultilineProperty', 'isMultiline'),
        _defineProperty(_Utils$Constants, 'IsPrimaryAction', 'isPrimary'),
        _defineProperty(_Utils$Constants, 'IsRequiredProperty', 'isRequired'),
        _defineProperty(
            _Utils$Constants,
            'IsShowCardExpanded',
            'isShowCardExpanded'
        ),
        _defineProperty(
            _Utils$Constants,
            'IsHttpPostActionAvailableProperty',
            'isHttpPostActionAvailable'
        ),
        _defineProperty(_Utils$Constants, 'ItemId', 'itemId'),
        _defineProperty(_Utils$Constants, 'Left', 'left'),
        _defineProperty(_Utils$Constants, 'MacClient', 'mac'),
        _defineProperty(_Utils$Constants, 'MailboxType', 'mailboxType'),
        _defineProperty(_Utils$Constants, 'MarkdownProperty', 'markdown'),
        _defineProperty(_Utils$Constants, 'MaxLengthProperty', 'maxLength'),
        _defineProperty(_Utils$Constants, 'MerchantId', 'merchantId'),
        _defineProperty(
            _Utils$Constants,
            'MessageCardSerializedProperty',
            'MessageCardSerialized'
        ),
        _defineProperty(
            _Utils$Constants,
            'MessageCardContextProperty',
            'messageCardContext'
        ),
        _defineProperty(
            _Utils$Constants,
            'MessageCardExtensionContextProperty',
            'MessageCardExtensionContext'
        ),
        _defineProperty(
            _Utils$Constants,
            'messageCardExtensionContextProperty',
            'messageCardExtensionContext'
        ),
        _defineProperty(_Utils$Constants, 'MessageCardHidden', 'MessageCardHidden'),
        _defineProperty(
            _Utils$Constants,
            'MessageCardRemoved',
            'MessageCardRemoved'
        ),
        _defineProperty(
            _Utils$Constants,
            'MessageCardRendered',
            'MessageCardRendered'
        ),
        _defineProperty(_Utils$Constants, 'MessageId', 'messageId'),
        _defineProperty(_Utils$Constants, 'MessageType', 'messageType'),
        _defineProperty(_Utils$Constants, 'MoreAction', 'MoreAction'),
        _defineProperty(_Utils$Constants, 'MultiChoiceInput', 'multichoiceinput'),
        _defineProperty(_Utils$Constants, 'NameProperty', 'name'),
        _defineProperty(_Utils$Constants, 'OpenUriAction', 'openuri'),
        _defineProperty(_Utils$Constants, 'OriginatorProperty', 'originator'),
        _defineProperty(_Utils$Constants, 'Padding', 'padding'),
        _defineProperty(_Utils$Constants, 'PerformedAtProperty', 'performedAt'),
        _defineProperty(
            _Utils$Constants,
            'PerformedActionsProperty',
            'performedActions'
        ),
        _defineProperty(
            _Utils$Constants,
            'PerformedActionsSerializedProperty',
            'PerformedActionsSerialized'
        ),
        _defineProperty(_Utils$Constants, 'PixelWidth', 'pixelWidth'),
        _defineProperty(_Utils$Constants, 'PlaceHolderProperty', 'placeholder'),
        _defineProperty(_Utils$Constants, 'PostId', 'postId'),
        _defineProperty(
            _Utils$Constants,
            'PotentialActionProperty',
            'potentialAction'
        ),
        _defineProperty(_Utils$Constants, 'ProductContext', 'productContext'),
        _defineProperty(
            _Utils$Constants,
            'ProviderAccountUniqueId',
            'ProviderAccountUniqueId'
        ),
        _defineProperty(
            _Utils$Constants,
            'providerAccountUniqueId',
            'providerAccountUniqueId'
        ),
        _defineProperty(
            _Utils$Constants,
            'RefreshCardSerializedProperty',
            'refreshCardSerialized'
        ),
        _defineProperty(_Utils$Constants, 'Response', 'response'),
        _defineProperty(_Utils$Constants, 'Resources', 'resources'),
        _defineProperty(
            _Utils$Constants,
            'ResponseSerialized',
            'responseSerialized'
        ),
        _defineProperty(_Utils$Constants, 'RemoveCardProperty', 'removeCard'),
        _defineProperty(_Utils$Constants, 'Right', 'right'),
        _defineProperty(_Utils$Constants, 'SectionsProperty', 'sections'),
        _defineProperty(_Utils$Constants, 'Separator', 'separator'),
        _defineProperty(_Utils$Constants, 'ShowCardOnFailure', 'showCardOnFailure'),
        _defineProperty(
            _Utils$Constants,
            'ShowOriginalCardProperty',
            'showOriginalCard'
        ),
        _defineProperty(_Utils$Constants, 'SourceProperty', 'source'),
        _defineProperty(_Utils$Constants, 'StartGroupProperty', 'startGroup'),
        _defineProperty(_Utils$Constants, 'StatusProperty', 'status'),
        _defineProperty(_Utils$Constants, 'StyleProperty', 'style'),
        _defineProperty(_Utils$Constants, 'TargetDomId', 'targetDom'),
        _defineProperty(_Utils$Constants, 'TargetElements', 'targetElements'),
        _defineProperty(_Utils$Constants, 'TargetProperty', 'target'),
        _defineProperty(_Utils$Constants, 'TargetsProperty', 'targets'),
        _defineProperty(_Utils$Constants, 'TextInput', 'textinput'),
        _defineProperty(_Utils$Constants, 'TextProperty', 'text'),
        _defineProperty(_Utils$Constants, 'ThreadId', 'threadId'),
        _defineProperty(_Utils$Constants, 'TimeZone', 'timeZone'),
        _defineProperty(_Utils$Constants, 'TitleProperty', 'title'),
        _defineProperty(_Utils$Constants, 'Top', 'top'),
        _defineProperty(_Utils$Constants, 'TypeProperty', '@type'),
        _defineProperty(_Utils$Constants, 'UiCulture', 'uiCulture'),
        _defineProperty(_Utils$Constants, 'Url', 'url'),
        _defineProperty(_Utils$Constants, 'UserMailbox', 'User'),
        _defineProperty(
            _Utils$Constants,
            'UserPerformedActionsProperty',
            'userPerformedActions'
        ),
        _defineProperty(_Utils$Constants, 'ValueProperty', 'value'),
        _defineProperty(_Utils$Constants, 'ViewAction', 'viewaction'),
        _defineProperty(_Utils$Constants, 'WinClient', 'windows'),
        _defineProperty(_Utils$Constants, 'RTL', 'rtl'),
        _defineProperty(
            _Utils$Constants,
            'InitialCardProcessing',
            'InitialCardProcessing'
        ),
        _defineProperty(
            _Utils$Constants,
            'FinalCardProcessing',
            'FinalCardProcessing'
        ),
        _defineProperty(
            _Utils$Constants,
            'InitialCardRendering',
            'InitialCardRendering'
        ),
        _defineProperty(
            _Utils$Constants,
            'FinalCardRendering',
            'FinalCardRendering'
        ),
        _defineProperty(
            _Utils$Constants,
            'ShowCardCloseButtonAriaLabel',
            'Click here to close the show card dialog'
        ),
        _defineProperty(_Utils$Constants, 'InputParameters', 'InputParameters'),
        _defineProperty(_Utils$Constants, 'DialogParameters', 'DialogParameters'),
        _Utils$Constants);

Utils.getImageProxyUrl = function (
    url,
    supportImageProxy,
    imageAttachmentBaseUrl
) {
    var proxyUrl =
        supportImageProxy &&
            url &&
            url.toLowerCase().indexOf(imageAttachmentBaseUrl) !== 0 && //not outlook mobile attachment
            url
                .toLowerCase()
                .indexOf(
                    'adaptive-image://outlook.office.com/actions/images/th?u='
                ) !== 0 &&
            (url.toLowerCase().indexOf('http://') === 0 ||
                url.toLowerCase().indexOf('https://') === 0) // ignore relative image url
            ? 'adaptive-image://outlook.office.com/actions/images/th?u=' + url
            : url;
    return proxyUrl;
};

Utils.format = function (formatString) {
    if (!formatString) {
        return undefined;
    }

    for (
        var _len = arguments.length,
        values = new Array(_len > 1 ? _len - 1 : 0),
        _key = 1;
        _key < _len;
        _key++
    ) {
        values[_key - 1] = arguments[_key];
    }

    var args = values; // Regex that finds { and } so they can be removed on a lookup for string format

    var FORMAT_ARGS_REGEX = /[{}]/g; // Regex that finds {#} so it can be replaced by the arguments in string format

    var FORMAT_REGEX = /\{\d+\}/g; // Callback match function

    function replaceFunc(match) {
        // looks up in the args
        var replacement = args[match.replace(FORMAT_ARGS_REGEX, '')]; // catches undefined in nondebug and null in debug and nondebug

        if (replacement === null || replacement === undefined) {
            replacement = '';
        }

        return replacement;
    }

    return formatString.replace(FORMAT_REGEX, replaceFunc);
};

Utils.htmlDecode = function (encoded) {
    var elem = document.createElement('textarea');
    elem.innerHTML = encoded;
    return elem.value;
};

Utils.formatDate = function (date) {
    if (!date) {
        return null;
    }

    var month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var isoDate = new Date(date);
    var year = isoDate.getFullYear();
    var date = isoDate.getDate();
    var day = days[isoDate.getDay()];
    var month = month[isoDate.getMonth()];
    return Utils.format('{0}, {1} {2}, {3}', day, month, date, year);
};

Utils.replaceAll = function (value, search, replacement) {
    return value.replace(new RegExp(search, 'g'), replacement);
};

Utils.applyCSS = function (fileName) {
    var head = document.head;
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = fileName;
    head.appendChild(link);
};

var Separator =
    /*#__PURE__*/
    (function (_AdaptiveCards$CardEl) {
        _inherits(Separator, _AdaptiveCards$CardEl);

        function Separator(clientManagerInstance) {
            var _this;

            _classCallCheck(this, Separator);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(Separator).call(this)
            );
            _this.thickness = 1;
            return _this;
        } // get TypeName of action

        _createClass(Separator, [
            {
                key: 'getJsonTypeName',
                value: function getJsonTypeName() {
                    return 'Separator';
                } // Rendering of separator for outlook mobile
            },
            {
                key: 'internalRender',
                value: function internalRender() {
                    var element = document.createElement('div');
                    element.style.paddingTop = '0.25px';
                    element.style.paddingBottom = '0.25px';
                    element.style.borderTop =
                        this.thickness + 'px solid rgb(225, 225, 225)';
                    element.style.marginRight = '-16px';
                    element.style.marginLeft = '-16px';
                    return element;
                }
            }
        ]);

        return Separator;
    })(AdaptiveCards.CardElement);

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
        return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }

    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css =
    '.nativeInput {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n}\r\n\r\n.inputContentWrapper {\r\n    padding: 16px;\r\n    background-color: #ffffff;\r\n    border-radius: 5px;\r\n    width: 100%;\r\n    margin: 24px;\r\n}\r\n\r\n.submitInput {\r\n    color: #0078d4;\r\n    float: right;\r\n    margin-top: 29px;\r\n}';
styleInject(css);

var NativeInput =
    /*#__PURE__*/
    (function (_React$Component) {
        _inherits(NativeInput, _React$Component);

        function NativeInput(props) {
            var _this;

            _classCallCheck(this, NativeInput);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(NativeInput).call(this, props)
            );

            _defineProperty(_assertThisInitialized(_this), 'onChange', function (
                event,
                newValue
            ) {
                if (
                    !_this.props.maxLength ||
                    newValue.length <= _this.props.maxLength
                ) {
                    _this.setState({
                        value: newValue || ''
                    });
                }
            });

            _defineProperty(
                _assertThisInitialized(_this),
                'onNonDismiss',
                function (event) {
                    event.stopPropagation();
                }
            );

            _defineProperty(_assertThisInitialized(_this), 'onClose', function (
                event
            ) {
                event.stopPropagation();

                _this.props.submitCallback(null);
            });

            _defineProperty(_assertThisInitialized(_this), 'onSubmit', function (
                event
            ) {
                _this.props.submitCallback(_this.state.value);
            });

            _this.state = {
                value: _this.props.value
            };
            return _this;
        }

        _createClass(NativeInput, [
            {
                key: 'render',
                value: function render() {
                    return React.createElement(
                        'div',
                        {
                            className: 'nativeInput',
                            onClick: this.onClose
                        },
                        React.createElement(
                            'div',
                            {
                                className: 'inputContentWrapper',
                                onClick: this.onNonDismiss
                            },
                            React.createElement(TextField, {
                                underlined: true,
                                onChange: this.onChange,
                                placeholder: this.props.placeholder,
                                type: this.props.type
                                    ? this.props.type
                                    : 'text',
                                value: this.state.value,
                                resizable: false,
                                multiline: !!this.props.isMultiline,
                                max: this.props.max,
                                min: this.props.min
                            }),
                            React.createElement(
                                'div',
                                {
                                    className: 'submitInput',
                                    onClick: this.onSubmit
                                },
                                'SUBMIT'
                            )
                        )
                    );
                }
            }
        ]);

        return NativeInput;
    })(React.Component);

var DayPickerStrings = {
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
};

var NativeCalender =
    /*#__PURE__*/
    (function (_React$Component) {
        _inherits(NativeCalender, _React$Component);

        function NativeCalender() {
            var _getPrototypeOf2;

            var _this;

            _classCallCheck(this, NativeCalender);

            for (
                var _len = arguments.length, args = new Array(_len), _key = 0;
                _key < _len;
                _key++
            ) {
                args[_key] = arguments[_key];
            }

            _this = _possibleConstructorReturn(
                this,
                (_getPrototypeOf2 = _getPrototypeOf(NativeCalender)).call.apply(
                    _getPrototypeOf2,
                    [this].concat(args)
                )
            );

            _defineProperty(
                _assertThisInitialized(_this),
                'onSelectDate',
                function (date) {
                    _this.props.submitCallback(date);
                }
            );

            _defineProperty(
                _assertThisInitialized(_this),
                'onNonDismiss',
                function (event) {
                    event.stopPropagation();
                }
            );

            _defineProperty(
                _assertThisInitialized(_this),
                'onDismiss',
                function (event) {
                    event.stopPropagation();

                    _this.props.submitCallback(null);
                }
            );

            return _this;
        }

        _createClass(NativeCalender, [
            {
                key: 'render',
                value: function render() {
                    return React.createElement(
                        'div',
                        {
                            className: 'nativeInput',
                            onClick: this.onDismiss
                        },
                        this.props.placeHolder &&
                        React.createElement(
                            Label,
                            {
                                id: 'nativeCalendar',
                                required: true
                            },
                            'this.props.placeholder'
                        ),
                        React.createElement(Calendar, {
                            onClick: this.onNonDismiss,
                            className: 'nativeCalendar',
                            onSelectDate: this.onSelectDate,
                            today: this.props.selectedDate,
                            isMonthPickerVisible: false,
                            firstDayOfWeek: DayOfWeek.Sunday,
                            strings: DayPickerStrings,
                            showMonthPickerAsOverlay: true,
                            showGoToToday: false
                        })
                    );
                }
            }
        ]);

        return NativeCalender;
    })(React.Component);

var NativeChoiceGroup =
    /*#__PURE__*/
    (function (_React$Component) {
        _inherits(NativeChoiceGroup, _React$Component);

        function NativeChoiceGroup(props) {
            var _this;

            _classCallCheck(this, NativeChoiceGroup);

            _this = _possibleConstructorReturn(
                this,
                _getPrototypeOf(NativeChoiceGroup).call(this, props)
            );

            _defineProperty(_assertThisInitialized(_this), 'onChange', function (
                event,
                selectedOption
            ) {
                _this.setState({
                    selectedOption: selectedOption
                });
            });

            _defineProperty(_assertThisInitialized(_this), 'onSubmit', function (
                event
            ) {
                _this.props.submitCallback(_this.state.selectedOption);
            });

            _defineProperty(
                _assertThisInitialized(_this),
                'onNonDismiss',
                function (event) {
                    event.stopPropagation();
                }
            );

            _defineProperty(
                _assertThisInitialized(_this),
                'onDismiss',
                function (event) {
                    event.stopPropagation();

                    _this.props.submitCallback(null);
                }
            );

            _this.state = {
                selectedOption: _this.props.selectedChoice
            };
            return _this;
        }

        _createClass(NativeChoiceGroup, [
            {
                key: 'render',
                value: function render() {
                    return React.createElement(
                        'div',
                        {
                            className: 'nativeInput',
                            onClick: this.onDismiss
                        },
                        React.createElement(
                            'div',
                            {
                                className: 'inputContentWrapper',
                                onClick: this.onNonDismiss
                            },
                            React.createElement(
                                Label$1,
                                {
                                    id: 'nativeChoiceGroupLabel'
                                },
                                this.props.placeHolder
                            ),
                            React.createElement(ChoiceGroup, {
                                defaultSelectedKey:
                                    this.props.selectedChoice &&
                                    this.props.selectedChoice.key,
                                options: this.props.choicesList,
                                onChange: this.onChange
                            }),
                            React.createElement(
                                'div',
                                {
                                    className: 'submitInput',
                                    onClick: this.onSubmit
                                },
                                'SUBMIT'
                            )
                        )
                    );
                }
            }
        ]);

        return NativeChoiceGroup;
    })(React.Component);

var ShortMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var ShortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

var ClientManager =
    /*#__PURE__*/
    (function () {
        function ClientManager(context, inputOverlay) {
            _classCallCheck(this, ClientManager);

            var defaultCardConfig = {
                supportsInteractivity: true,
                fontFamily: 'Roboto-Regular',
                spacing: {
                    small: 2,
                    default: 16,
                    medium: 12,
                    large: 8,
                    extraLarge: 12,
                    padding: 16
                },
                separator: {
                    lineThickness: 1,
                    lineColor: '#E1E1E1'
                },
                fontSizes: {
                    small: 12,
                    default: 14,
                    medium: 16,
                    large: 18,
                    extraLarge: 20
                },
                // lineHeights: {
                // 	small: 18,
                // 	default: 20,
                // 	medium: 24,
                // 	large: 28,
                // 	extraLarge: 30
                // },
                fontWeights: {
                    lighter: 300,
                    default: 400,
                    bolder: 500
                },
                imageSizes: {
                    small: 40,
                    medium: 80,
                    large: 160
                },
                containerStyles: {
                    default: {
                        foregroundColors: {
                            default: {
                                default: '#212121',
                                subtle: '#EE333333'
                            },
                            dark: {
                                default: '#000000',
                                subtle: '#66000000'
                            },
                            light: {
                                default: '#FFFFFF',
                                subtle: '#33000000'
                            },
                            accent: {
                                default: '#8E8E93',
                                subtle: '#882E89FC'
                            },
                            good: {
                                default: '#777777',
                                subtle: '#DD54a254'
                            },
                            warning: {
                                default: '#e69500',
                                subtle: '#DDe69500'
                            },
                            attention: {
                                default: '#cc3300',
                                subtle: '#DDcc3300'
                            }
                        },
                        backgroundColor: '#FFFFFF'
                    },
                    emphasis: {
                        foregroundColors: {
                            default: {
                                default: '#333333',
                                subtle: '#EE333333'
                            },
                            dark: {
                                default: '#000000',
                                subtle: '#66000000'
                            },
                            light: {
                                default: '#FFFFFF',
                                subtle: '#33000000'
                            },
                            accent: {
                                default: '#2E89FC',
                                subtle: '#882E89FC'
                            },
                            good: {
                                default: '#777777',
                                subtle: '#DD54a254'
                            },
                            warning: {
                                default: '#e69500',
                                subtle: '#DDe69500'
                            },
                            attention: {
                                default: '#cc3300',
                                subtle: '#DDcc3300'
                            }
                        },
                        backgroundColor: '#F1F1F1'
                    }
                },
                actions: {
                    maxActions: 5,
                    spacing: 'Default',
                    buttonSpacing: 8,
                    showCard: {
                        actionMode: 'Popup',
                        inlineTopMargin: 0,
                        style: 'Default'
                    },
                    preExpandSingleShowCardAction: true,
                    actionsOrientation: 'Vertical',
                    actionAlignment: ''
                },
                adaptiveCard: {
                    allowCustomStyle: true
                },
                imageSet: {
                    imageSize: 'Medium',
                    maxImageHeight: '100'
                },
                factSet: {
                    title: {
                        size: 'Default',
                        color: 'Accent',
                        isSubtle: false,
                        weight: 'Default',
                        warp: true
                    },
                    value: {
                        size: 'Medium',
                        color: 'Default',
                        isSubtle: false,
                        weight: 'Default',
                        warp: true
                    },
                    spacing: 10
                }
            };
            var compactCardConfig = {
                supportsInteractivity: true,
                fontFamily: 'Roboto-Regular',
                fontSizes: {
                    small: 12,
                    default: 14,
                    medium: 14,
                    large: 16,
                    extraLarge: 20
                },
                // lineHeights: {
                // 	small: 18,
                // 	default: 20,
                // 	medium: 20,
                // 	large: 24,
                // 	extraLarge: 30
                // },
                fontWeights: {
                    lighter: 300,
                    default: 400,
                    bolder: 500
                },
                imageSizes: {
                    small: 32,
                    medium: 64,
                    large: 128
                },
                containerStyles: {
                    default: {
                        foregroundColors: {
                            default: {
                                default: '#212121',
                                subtle: '#EE333333'
                            },
                            dark: {
                                default: '#000000',
                                subtle: '#66000000'
                            },
                            light: {
                                default: '#FFFFFF',
                                subtle: '#33000000'
                            },
                            accent: {
                                default: '#8E8E93',
                                subtle: '#882E89FC'
                            },
                            good: {
                                default: '#777777',
                                subtle: '#DD00FF00'
                            },
                            warning: {
                                default: '#FF0000',
                                subtle: '#DDFF0000'
                            },
                            attention: {
                                default: '#FFD800',
                                subtle: '#DDFFD800'
                            }
                        },
                        backgroundColor: '#FFFFFF'
                    },
                    emphasis: {
                        foregroundColors: {
                            default: {
                                default: '#333333',
                                subtle: '#EE333333'
                            },
                            dark: {
                                default: '#000000',
                                subtle: '#66000000'
                            },
                            light: {
                                default: '#FFFFFF',
                                subtle: '#33000000'
                            },
                            accent: {
                                default: '#2E89FC',
                                subtle: '#882E89FC'
                            },
                            good: {
                                default: '#777777',
                                subtle: '#DD00FF00'
                            },
                            warning: {
                                default: '#FF0000',
                                subtle: '#DDFF0000'
                            },
                            attention: {
                                default: '#FFD800',
                                subtle: '#DDFFD800'
                            }
                        },
                        backgroundColor: '#F1F1F1'
                    }
                },
                spacing: {
                    small: 2,
                    default: 8,
                    medium: 6,
                    large: 24,
                    extraLarge: 40,
                    padding: 20
                },
                separator: {
                    lineThickness: 1,
                    lineColor: '#E1E1E1'
                },
                actions: {
                    maxActions: 5,
                    spacing: 'Default',
                    buttonSpacing: 10,
                    showCard: {
                        actionMode: 'Popup',
                        inlineTopMargin: 16,
                        style: 'Default'
                    },
                    preExpandSingleShowCardAction: true,
                    actionsOrientation: 'Vertical',
                    actionAlignment: ''
                },
                adaptiveCard: {
                    allowCustomStyle: true
                },
                imageSet: {
                    imageSize: 'Medium',
                    maxImageHeight: 'maxImageHeight'
                },
                factSet: {
                    title: {
                        size: 'Default',
                        color: 'Accent',
                        isSubtle: false,
                        weight: 'Default',
                        warp: true
                    },
                    value: {
                        size: 'Medium',
                        color: 'Default',
                        isSubtle: false,
                        weight: 'Default',
                        warp: true
                    },
                    spacing: 10
                }
            };
            this.adaptiveCardHostConfig = {
                choiceSetInputValueSeparator: ',',
                supportsInteractivity: true,
                fontFamily: 'Roboto',
                spacing: {
                    small: 8,
                    default: 16,
                    medium: 16,
                    large: 24,
                    extraLarge: 32,
                    padding: 16
                },
                separator: {
                    lineThickness: 1,
                    lineColor: '#c8c8c8'
                },
                fontSizes: {
                    small: 14,
                    default: 16,
                    medium: 18,
                    large: 20,
                    extraLarge: 22
                },
                // lineHeights: {
                // 	small: 20,
                // 	default: 24,
                // 	medium: 26,
                // 	large: 28,
                // 	extraLarge: 28
                // },
                fontWeights: {
                    lighter: 300,
                    default: 400,
                    bolder: 500
                },
                imageSizes: {
                    small: 40,
                    medium: 80,
                    large: 160
                },
                containerStyles: {
                    default: {
                        foregroundColors: {
                            default: {
                                default: '#212121',
                                subtle: '#616161'
                            },
                            dark: {
                                default: '#212121',
                                subtle: '#616161'
                            },
                            light: {
                                default: '#616161',
                                subtle: '#616161'
                            },
                            accent: {
                                default: '#005A9E',
                                subtle: '#005A9E'
                            },
                            good: {
                                default: '#107C10',
                                subtle: '#107C10'
                            },
                            warning: {
                                default: '#8F6A00',
                                subtle: '#8F6A00'
                            },
                            attention: {
                                default: '#C8191F',
                                subtle: '#C8191F'
                            },
                            hyperlink: {
                                default: '#FF000000',
                                subtle: '#DD000000'
                            },
                            white: {
                                default: '#FFFFFF',
                                subtle: '#FFFFFF'
                            }
                        },
                        backgroundColor: '#FFFFFF'
                    },
                    emphasis: {
                        foregroundColors: {
                            default: {
                                default: '#212121',
                                subtle: '#616161'
                            },
                            dark: {
                                default: '#212121',
                                subtle: '#616161'
                            },
                            light: {
                                default: '#616161',
                                subtle: '#616161'
                            },
                            accent: {
                                default: '#005A9E',
                                subtle: '#005A9E'
                            },
                            good: {
                                default: '#107C10',
                                subtle: '#107C10'
                            },
                            warning: {
                                default: '#8F6A00',
                                subtle: '#8F6A00'
                            },
                            attention: {
                                default: '#C8191F',
                                subtle: '#C8191F'
                            },
                            hyperlink: {
                                default: '#FF000000',
                                subtle: '#DD000000'
                            },
                            white: {
                                default: '#FFFFFF',
                                subtle: '#FFFFFF'
                            }
                        },
                        backgroundColor: '#f8f8f8'
                    }
                },
                actions: {
                    maxActions: 5,
                    spacing: 'Default',
                    buttonSpacing: 8,
                    showCard: {
                        actionMode: 'Inline',
                        style: 'default'
                    },
                    preExpandSingleShowCardAction: false,
                    actionsOrientation: 'Vertical',
                    actionAlignment: ''
                },
                adaptiveCard: {
                    allowCustomStyle: true
                },
                imageSet: {
                    imageSize: 'Large',
                    maxImageHeight: 148
                },
                factSet: {
                    title: {
                        size: 'small',
                        color: 'Default',
                        isSubtle: true,
                        weight: 'Default',
                        wrap: true
                    },
                    value: {
                        size: 'Default',
                        color: 'Default',
                        isSubtle: false,
                        weight: 'Default',
                        wrap: true
                    },
                    spacing: 10
                }
            };
            this.supportMoreAction = true;
            this.supportInvokeAddinAction = false;
            this.supportDisplayAppointmentFormAction = true;
            this.supportDisplayMessageFormAction = true;
            this.supportTransactionAction = false;
            this.supportImageProxy = false;
            this.showPlaceholderDivOnInputFocus = false;
            this.supportMessageCard = false;
            this.supportInputPop = true;
            this.supportDynamicTextArea = true;
            this.supportReverseRowForChoiceSet = false;
            this.supportInlineShowCard = true;
            this.supportSavingState = false;
            this.supportDynamicTheming = true;
            this.context = context;
            this.inputOverlayElement = inputOverlay
                ? document.querySelector(inputOverlay)
                : null;
            this.resolveDependencies();
            this.themeConfigs = []; // this will only be present incase of android to handle rotation scenario

            this.restoredInputs = {};
            this.themeConfigs.push(
                new this.ThemeClass(
                    this.constants.DefaultStyle, //style
                    defaultCardConfig, //hostConfigJson
                    this.constants.AndroidClient, //client
                    true, //allowCardTitle
                    true, //allowFacts
                    true, //allowHeroImage
                    true, //allowImages
                    true, //allowActionCard
                    true, //allowAutoInvokeAction
                    true //allowDisplayMoreAction
                )
            );
            this.themeConfigs.push(
                new this.ThemeClass(
                    this.constants.CompactStyle, //style
                    compactCardConfig, //hostConfigJson
                    this.constants.AndroidClient, //client
                    false, //allowCardTitle
                    false, //allowFacts
                    false, //allowHeroImage
                    false, //allowImages
                    true, //allowActionCard
                    true, //allowAutoInvokeAction
                    true //allowDisplayMoreAction
                )
            ); //ToDo: Bundle these assets in client

            this.spinnerUrl =
                'https://messagecarddemo.blob.core.windows.net/messagecard/LoadingSpinner.gif';
            this.successStatusImageUrl =
                'https://messagecarddemo.blob.core.windows.net/messagecard/success_android.png';
            this.errorStatusImageUrl =
                'https://messagecarddemo.blob.core.windows.net/messagecard/error_android.png';
            this.imageAttachmentBaseUrl = 'olm://attachment';
            this.choiceInputDefaultPlaceHolderText = 'Select an option';
            this.dateInputDefaultPlaceHolderText = 'Select a date';
            this.numberInputDefaultPlaceHolderText = 'Enter a number';
            this.textInputDefaultPlaceHolderText = 'Type here';
            this.VALUE_TOO_SMALL_STRING_KEY =
                "The number in '{0}' must be greater than {1}";
            this.VALUE_TOO_LARGE_STRING_KEY =
                "The number in '{0}' must be less than {1}";
            this.bodyPadding = 8;
            this.containerPadding = 16;
            this.factKeyTopPadding = 12;
            this.factValueTopPadding = 2;
            this.checkboxRightMargin = 10;
            this.checkboxPaddding = 12;
            this.imageMargin = 4;
            this.containerWidth = this.getContainerWidth();
            this.actionButtonsCount = 0;
            this.setHostCapabilities();
        }

        _createClass(ClientManager, [
            {
                key: 'setHostCapabilities',
                value: function setHostCapabilities() {
                    var hostCapabilityMap = {
                        AADAuthentication: '*'
                    };
                    this.capabilities = new AdaptiveCards.HostCapabilities();
                    this.capabilities.parse(hostCapabilityMap, null);
                } // resolve internal dependencies
            },
            {
                key: 'resolveDependencies',
                value: function resolveDependencies() {
                    var _this = this;

                    this.ImageClass = CustomImage;
                    this.FactSetClass = CustomFactSet;
                    this.ImageSetClass = CustomImageSet;
                    this.DateInputClass = CustomDateInput;
                    this.NumberInputClass = CustomNumberInput;
                    this.TextInputClass = CustomTextInput;
                    this.ChoiceSetInputClass = CustomChoiceSetInput;
                    this.ToggleInputClass = CustomToggleInput;
                    this.HttpActionClass = CustomHttpAction;
                    this.MoreActionClass = MoreAction;
                    this.ToggleVisibilityActionClass = ToggleVisibilityAction;
                    this.InvokeAddinActionClass = InvokeAddinAction;
                    this.DisplayAppointmentFormActionClass = DisplayAppointmentFormAction;
                    this.DisplayMessageFormActionClass = DisplayMessageFormAction;
                    this.TransactionActionClass = TransactionAction;
                    this.ThemeClass = Theme;
                    this.UtilsClass = Utils;
                    this.Separator = Separator;
                    this.constants = this.UtilsClass.Constants; // Add Separator Class for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Separator',
                        function () {
                            return new _this.Separator(_this);
                        }
                    ); // Add Image Class for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Image',
                        function () {
                            return new _this.ImageClass();
                        }
                    ); // Input.Time is not supported in Outlook

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.unregisterType(
                        'Input.Time'
                    ); // Customize Text Input for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Input.Text',
                        function () {
                            return new _this.TextInputClass(_this);
                        }
                    ); // Customize Number Input for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Input.Number',
                        function () {
                            return new _this.NumberInputClass(_this);
                        }
                    ); // Customize Date Input for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Input.Date',
                        function () {
                            return new _this.DateInputClass(_this);
                        }
                    ); // Customize Choice Set Input for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Input.ChoiceSet',
                        function () {
                            return new _this.ChoiceSetInputClass(_this);
                        }
                    ); // Customize ChoiceSet Input for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'Input.Toggle',
                        function () {
                            return new _this.ToggleInputClass(_this);
                        }
                    ); // Customize FactSet for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'FactSet',
                        function () {
                            return new _this.FactSetClass(_this);
                        }
                    ); // Customize ImageSet for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'ImageSet',
                        function () {
                            return new _this.ImageSetClass(_this);
                        }
                    ); // Action.Submit is not supported in Outlook

                    AdaptiveCards.AdaptiveCard.actionTypeRegistry.unregisterType(
                        'Action.Submit'
                    ); // Customize http action for Outlook

                    AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                        'Action.Http',
                        function () {
                            return new _this.HttpActionClass(_this);
                        }
                    ); // Add More Action for Android

                    AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                        'Action.More',
                        function () {
                            return new _this.MoreActionClass(_this);
                        }
                    ); // Support Toggle Visibility Action for Android

                    AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                        'Action.ToggleVisibility',
                        function () {
                            return new _this.ToggleVisibilityActionClass(_this);
                        }
                    ); // Support Invoke AddIn Action for Android

                    if (this.supportInvokeAddinAction) {
                        AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                            'Action.InvokeAddInCommand',
                            function () {
                                return new _this.InvokeAddinActionClass(_this);
                            }
                        );
                    } // Support Display AppointmentForm Action for Android

                    if (this.supportDisplayAppointmentFormAction) {
                        AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                            'Action.DisplayAppointmentForm',
                            function () {
                                return new _this.DisplayAppointmentFormActionClass(
                                    _this
                                );
                            }
                        );
                    } // Support Display MessageForm Action for Android

                    if (this.supportDisplayMessageFormAction) {
                        AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                            'Action.DisplayMessageForm',
                            function () {
                                return new _this.DisplayMessageFormActionClass(
                                    _this
                                );
                            }
                        );
                    } // Support Transaction Action for Android

                    if (this.supportTransactionAction) {
                        AdaptiveCards.AdaptiveCard.actionTypeRegistry.registerType(
                            'Action.Transaction',
                            function () {
                                return new _this.TransactionActionClass(_this);
                            }
                        );
                    } // Support ActionSet for Android

                    AdaptiveCards.AdaptiveCard.elementTypeRegistry.registerType(
                        'ActionSet',
                        function () {
                            return new AdaptiveCards.ActionSet();
                        }
                    );
                } // return instance based on the input
            },
            {
                key: 'getElementInstance',
                value: function getElementInstance(element) {
                    var instance = null;

                    switch (element) {
                        case this.constants.ImageSet:
                            instance = new this.ImageSetClass(this);
                            break;

                        case this.constants.FactSet:
                            instance = new this.FactSetClass(this);
                            break;

                        case this.constants.DateInput:
                            instance = new this.DateInputClass(this);
                            break;

                        case this.constants.ChoiceSetInput:
                            instance = new this.ChoiceSetInputClass(this);
                            break;

                        case this.constants.HttpAction:
                            instance = new this.HttpActionClass(this);
                            break;

                        case this.constants.MoreAction:
                            instance = new this.MoreActionClass(this);
                            break;

                        case this.constants.Separator:
                            instance = new this.Separator(this);
                            break;
                    }

                    return instance;
                } // get all the Swift Card themes
            },
            {
                key: 'getThemeConfigs',
                value: function getThemeConfigs() {
                    return this.themeConfigs;
                } // Get Adaptive Card Host Configs
            },
            {
                key: 'getACHostConfigs',
                value: function getACHostConfigs(context) {
                    if (this.supportDynamicTheming) {
                        if (context != null) {
                            if (context.stylesheet) {
                                this.UtilsClass.applyCSS(
                                    this.context.stylesheet
                                );
                            }

                            if (context.hostConfig) {
                                var hostConfig = JSON.parse(
                                    this.context.hostConfig
                                );

                                if (hostConfig) {
                                    return [hostConfig];
                                }
                            }
                        }
                    }

                    return [this.adaptiveCardHostConfig];
                } // get width of the div
            },
            {
                key: 'getContainerWidth',
                value: function getContainerWidth() {
                    var screenWidth =
                        window.innerWidth || document.body.clientWidth;
                    var containerWidth =
                        screenWidth -
                        2 * this.bodyPadding -
                        2 * this.containerPadding -
                        4;
                    return containerWidth;
                } // process raw Data
            },
            {
                key: 'processData',
                value: function processData(rawExtendedPropertyJson) {
                    // htmlDecode doesn't work on objects.
                    rawExtendedPropertyJson = JSON.stringify(
                        rawExtendedPropertyJson
                    );
                    return JSON.parse(
                        this.UtilsClass.htmlDecode(rawExtendedPropertyJson)
                    );
                } // execute this after rendering
            },
            {
                key: 'postRender',
                value: function postRender() { } // this is not required incase of android
                // Store client Telemetry Properties
            },
            {
                key: 'storeClientTelemetryProperties',
                value: function storeClientTelemetryProperties(
                    clientTelemetryJson
                ) { } // if (window.amNativeRenderer) {
                // 	amNativeRenderer.storeClientTelemetryProperties(
                // 		JSON.stringify(clientTelemetryJson)
                // 	);
                // }
                // open Native date picker from here
            },
            {
                key: 'openDatePicker',
                value: function openDatePicker(
                    id,
                    selectedDate,
                    placeholder,
                    isRequired
                ) {
                    var _this2 = this;

                    if (!this.inputOverlayElement) {
                        return;
                    }

                    var submitCallback = function submitCallback(date) {
                        if (date !== null) {
                            var dateString = ''
                                .concat(ShortDays[date.getDay()], ', ')
                                .concat(ShortMonths[date.getMonth()], ' ')
                                .concat(date.getDate(), ', ')
                                .concat(date.getFullYear());

                            _this2.parseSelectedDateInput(id, dateString, date);
                        }
                        const overlayRoot = createRoot(_this2.inputOverlayElement);
                        overlayRoot.render(null);

                        // ReactDOM.render(null, _this2.inputOverlayElement);
                        _this2.inputOverlayElement.style.display = null;
                    };

                    this.inputOverlayElement.style.display = 'block';
                    const overlayRoot = createRoot(this.inputOverlayElement);
                    overlayRoot.render(React.createElement(NativeCalender, {
                        placeholder: placeholder,
                        selectedDate: selectedDate,
                        submitCallback: submitCallback
                    }));
                    // ReactDOM.render(
                    //     React.createElement(NativeCalender, {
                    //         placeholder: placeholder,
                    //         selectedDate: selectedDate,
                    //         submitCallback: submitCallback
                    //     }),
                    //     this.inputOverlayElement
                    // );
                } // parse User selected date and call appropriate class to set the text
            },
            {
                key: 'parseSelectedDateInput',
                value: function parseSelectedDateInput(
                    id,
                    selectedDate,
                    selectedDateWithTimeZone
                ) {
                    var element = document.getElementById(id);
                    element.dateInputInstance.setSpanText(
                        selectedDate,
                        selectedDateWithTimeZone
                    );
                }
            },
            {
                key: 'openTextPop',
                value: function openTextPop(textInputProperties) {
                    var _this3 = this;

                    if (!this.inputOverlayElement) {
                        return;
                    }

                    var submitCallback = function submitCallback() {
                        var value =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : '';

                        if (value !== null) {
                            _this3.setTextInputValue(
                                textInputProperties.id,
                                value
                            );
                        }
                        const overlayRoot = createRoot(_this3.inputOverlayElement);
                        overlayRoot.render(null);
                        // ReactDOM.render(null, _this3.inputOverlayElement);
                        _this3.inputOverlayElement.style.display = null;
                    };

                    this.inputOverlayElement.style.display = 'block';
                    const overlayRoot = createRoot(this.inputOverlayElement);
                    overlayRoot.render(React.createElement(
                        NativeInput,
                        _objectSpread2(
                            {
                                type: 'text',
                                submitCallback: submitCallback
                            },
                            textInputProperties
                        )
                    ));
                    // ReactDOM.render(
                    //     React.createElement(
                    //         NativeInput,
                    //         _objectSpread2(
                    //             {
                    //                 type: 'text',
                    //                 submitCallback: submitCallback
                    //             },
                    //             textInputProperties
                    //         )
                    //     ),
                    //     this.inputOverlayElement
                    // );
                }
            },
            {
                key: 'setTextInputValue',
                value: function setTextInputValue(id, value) {
                    var element = document.getElementById(id);
                    var actualValue = this.UtilsClass.htmlDecode(value);
                    var displayValue = this.UtilsClass.replaceAll(
                        actualValue,
                        '\n',
                        ' '
                    );
                    element.textInputInstance.setText(
                        actualValue,
                        displayValue
                    );
                }
            },
            {
                key: 'openNumberPop',
                value: function openNumberPop(numberInputProperties) {
                    var _this4 = this;

                    if (!this.inputOverlayElement) {
                        return;
                    }

                    var submitCallback = function submitCallback() {
                        var value =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : '';

                        if (value !== null) {
                            _this4.setNumberInputValue(
                                numberInputProperties.id,
                                value
                            );
                        }
                        const overlayRoot = createRoot(_this4.inputOverlayElement);
                        overlayRoot.render(null);
                        // ReactDOM.render(null, _this4.inputOverlayElement);
                        _this4.inputOverlayElement.style.display = null;
                    };

                    this.inputOverlayElement.style.display = 'block';
                    const overlayRoot = createRoot(this.inputOverlayElement);
                    overlayRoot.render(React.createElement(
                        NativeInput,
                        _objectSpread2(
                            {
                                type: 'number',
                                submitCallback: submitCallback
                            },
                            numberInputProperties
                        )
                    ));
                    // ReactDOM.render(
                    //     React.createElement(
                    //         NativeInput,
                    //         _objectSpread2(
                    //             {
                    //                 type: 'number',
                    //                 submitCallback: submitCallback
                    //             },
                    //             numberInputProperties
                    //         )
                    //     ),
                    //     this.inputOverlayElement
                    // );
                }
            },
            {
                key: 'setNumberInputValue',
                value: function setNumberInputValue(id, value) {
                    var element = document.getElementById(id);
                    element.numberInputInstance.setNumber(
                        this.UtilsClass.htmlDecode(value)
                    );
                } // open native choice picker from here
            },
            {
                key: 'openChoicePicker',
                value: function openChoicePicker(
                    id,
                    placeHolder,
                    choicesList,
                    selectedChoices,
                    isMultiChoice,
                    isRequired
                ) {
                    var _this5 = this;

                    if (!this.inputOverlayElement) {
                        return;
                    }

                    var submitCallback = function submitCallback(
                        selectedChoice
                    ) {
                        if (selectedChoice) {
                            var _selChoices = {
                                value: selectedChoice.key,
                                title: selectedChoice.text
                            };

                            _this5.parseSelectedChoiceSetInput(id, _selChoices);
                        }
                        const overlayRoot = createRoot(_this5.inputOverlayElement);
                        overlayRoot.render(null);
                        // ReactDOM.render(null, _this5.inputOverlayElement);
                        _this5.inputOverlayElement.style.display = null;
                    };

                    this.inputOverlayElement.style.display = 'block';
                    var choices = choicesList.map(function (option) {
                        return {
                            key: option.value,
                            text: option.title
                        };
                    });
                    var selChoices = selectedChoices.map(function (option) {
                        return {
                            key: option.value,
                            text: option.title
                        };
                    });
                    const overlayRoot = createRoot(this.inputOverlayElement);
                    overlayRoot.render(React.createElement(NativeChoiceGroup, {
                        placeHolder: placeHolder,
                        choicesList: choices,
                        selectedChoice: selChoices[0],
                        submitCallback: submitCallback
                    }));
                    // ReactDOM.render(
                    //     React.createElement(NativeChoiceGroup, {
                    //         placeHolder: placeHolder,
                    //         choicesList: choices,
                    //         selectedChoice: selChoices[0],
                    //         submitCallback: submitCallback
                    //     }),
                    //     this.inputOverlayElement
                    // );
                } // gets the separator between choices
            },
            {
                key: 'getSeparatorForChoicePicker',
                value: function getSeparatorForChoicePicker() {
                    return null;
                } // gets the separator between toggle inputs
            },
            {
                key: 'getSeparatorForToggleInputs',
                value: function getSeparatorForToggleInputs() {
                    return null;
                } // parse User selected choice picker and call appropriate class to set the text
            },
            {
                key: 'parseSelectedChoiceSetInput',
                value: function parseSelectedChoiceSetInput(
                    id,
                    selectedChoice
                ) {
                    var element = document.getElementById(id);
                    element.choiceSetInputInstance.setSpanText(selectedChoice);
                } // set visibility of appropriate component from here
            },
            {
                key: 'setComponentVisibility',
                value: function setComponentVisibility(
                    showCard,
                    showToggle,
                    showHtmlMessage,
                    constraintWidth
                ) {
                    var amContainerDiv = document.getElementById(
                        'amContentWrapper'
                    );
                    var cardDiv = document.getElementById('androidContainer');
                    var bodyDiv = document.getElementById('htmlMailDiv');

                    if (amContainerDiv) {
                        amContainerDiv.style.display = showCard
                            ? 'block'
                            : 'none';
                    }

                    if (cardDiv) {
                        cardDiv.style.display = showCard ? 'block' : 'none';
                    }

                    if (bodyDiv) {
                        bodyDiv.style.display = showHtmlMessage
                            ? 'block'
                            : 'none';

                        if (
                            showCard === false &&
                            showToggle === false &&
                            showHtmlMessage === true
                        ) {
                            bodyDiv.style.backgroundColor = '#white';
                        }
                    }
                } // Display Login Message to the user
            },
            {
                key: 'displayLoginMessage',
                value: function displayLoginMessage(
                    displayMessage,
                    linkText,
                    link
                ) { } // if (window.amNativeRenderer) {
                // 	amNativeRenderer.displayLoginMessage(
                // 		displayMessage,
                // 		linkText,
                // 		link
                // 	);
                // }
                // Display Snack Message to the user
            },
            {
                key: 'displaySnackMessage',
                value: function displaySnackMessage(
                    displayMessage,
                    hasSucceeded
                ) { } // if (window.amNativeRenderer) {
                // 	amNativeRenderer.displaySnackMessage(displayMessage, hasSucceeded);
                // }
                // Called when users clicks on any action
            },
            {
                key: 'executeAction',
                value: function executeAction(
                    action,
                    isAdaptiveCardAction,
                    source
                ) {
                    var message = 'Action executed\n';
                    message += '    Title: ' + action.title + '\n';

                    if (action instanceof AdaptiveCards.OpenUrlAction) {
                        message += '    Type: OpenUrl\n';
                        message += '    Url: ' + action.url + '\n';
                    } else if (action instanceof AdaptiveCards.SubmitAction) {
                        message += '    Type: Submit';
                        message += '    Data: ' + JSON.stringify(action.data);
                    } else if (action instanceof AdaptiveCards.HttpAction) {
                        var httpAction = action;
                        message += '    Type: Http\n';
                        message += '    Url: ' + httpAction.url + '\n';
                        message += '    Method: ' + httpAction.method + '\n';
                        message += '    Headers:\n';

                        for (var i = 0; i < httpAction.headers.length; i++) {
                            message +=
                                '        ' +
                                httpAction.headers[i].name +
                                ': ' +
                                httpAction.headers[i].value +
                                '\n';
                        }

                        message += '    Body: ' + httpAction.body + '\n';
                    } else {
                        return;
                    }

                    alert(message);
                } // Update Client HxCache
            },
            {
                key: 'updateExplicitMessageCardProperty',
                value: function updateExplicitMessageCardProperty() { } // ToDo after HxIntegrations: Call native method to delete message card property
                // from cache
                // Log telemetry event
            },
            {
                key: 'logEventTelemetry',
                value: function logEventTelemetry(eventName) { } // if (window.amNativeRenderer) {
                // 	amNativeRenderer.logEventTelemetry(eventName);
                // }
                // Log TimeStamp of various events
            },
            {
                key: 'logTimeStamp',
                value: function logTimeStamp(activityName, time) { } //ToDo: Call native method if required
                // Log javascript exception
            },
            {
                key: 'logException',
                value: function logException(e) { } // if (window.amNativeRenderer) {
                // 	amNativeRenderer.logException(e.message, e.stack);
                // }
                // Notify client about the height change whenever needed
            },
            {
                key: 'notifyHeightChange',
                value: function notifyHeightChange() {
                    // if (window.amNativeRenderer) {
                    // 	amNativeRenderer.setHeightToWrapContent();
                    // }
                }
            },
            {
                key: 'notifyRefreshCardResponse',
                value: function notifyRefreshCardResponse(responseJson) {
                    // if (window.amNativeRenderer) {
                    // 	amNativeRenderer.notifyRefreshCardResponse(responseJson);
                    // }
                }
            },
            {
                key: 'executeShowCardAction',
                value: function executeShowCardAction(
                    action,
                    isAdaptiveCardAction,
                    isExpanded
                ) {
                    //send the isExpanded card to native function if required
                }
            },
            {
                key: 'logInitialCardProcessingEnd',
                value: function logInitialCardProcessingEnd() {
                    // if (window.amNativeRenderer) {
                    // 	amNativeRenderer.logInitialCardProcessingEnd();
                    // }
                }
            },
            {
                key: 'logInitialCardRenderingEnd',
                value: function logInitialCardRenderingEnd() {
                    // if (window.amNativeRenderer) {
                    // 	amNativeRenderer.logInitialCardRenderingEnd();
                    // }
                }
            },
            {
                key: 'logFinalCardProcessingEnd',
                value: function logFinalCardProcessingEnd() {
                    // if (window.amNativeRenderer) {
                    // 	amNativeRenderer.logFinalCardProcessingEnd();
                    // }
                }
            },
            {
                key: 'logFinalCardRenderingEnd',
                value: function logFinalCardRenderingEnd() {
                    // if (window.amNativeRenderer) {
                    // 	amNativeRenderer.logFinalCardRenderingEnd();
                    // }
                }
            }
        ]);

        return ClientManager;
    })();

var MessageCardConverter =
    /*#__PURE__*/
    (function () {
        function MessageCardConverter(clientManagerInstance, utils) {
            _classCallCheck(this, MessageCardConverter);

            if (clientManagerInstance == null) {
                throw new Error('null clientManagerInstance');
            }

            this.clientManagerInstance = clientManagerInstance;
            this.UtilsClass = utils;
            this.constants = this.UtilsClass.Constants;
            this.themes = this.clientManagerInstance.getThemeConfigs();
            this.containerWidth = this.clientManagerInstance.getContainerWidth();
        } // parse Message card json and returns adaptiveCardInstance

        _createClass(MessageCardConverter, [
            {
                key: 'parseMessageCard',
                value: function parseMessageCard(messageCardJson) {
                    // create instance of adaptive card
                    this.adaptiveCardInstance = new AdaptiveCards.AdaptiveCard(); // default values

                    this.style = this.constants.DefaultStyle;
                    this.adaptiveCardInstance.hideOriginalBody = false;
                    this.adaptiveCardInstance.enableBodyToggling = false;
                    this.adaptiveCardInstance.isHttpPostActionAvailable = false; // parse messageCardContext property

                    if (
                        messageCardJson[
                        this.constants.MessageCardContextProperty
                        ] != undefined
                    ) {
                        this.adaptiveCardInstance.messageCardContext =
                            messageCardJson[
                            this.constants.MessageCardContextProperty
                            ];
                    } // parse originator property

                    if (
                        messageCardJson[this.constants.OriginatorProperty] !=
                        undefined
                    ) {
                        this.adaptiveCardInstance.originator =
                            messageCardJson[this.constants.OriginatorProperty];
                    } // parse card style

                    if (
                        messageCardJson[this.constants.StyleProperty] !=
                        undefined
                    ) {
                        this.style =
                            messageCardJson[this.constants.StyleProperty];
                    } // parse hideOriginalBody

                    if (
                        messageCardJson[
                        this.constants.HideOriginalBodyProperty
                        ] != undefined
                    ) {
                        this.adaptiveCardInstance.hideOriginalBody =
                            messageCardJson[
                            this.constants.HideOriginalBodyProperty
                            ];
                    } // parse enableBodyToggling

                    if (
                        messageCardJson[
                        this.constants.EnableBodyTogglingProperty
                        ] != undefined
                    ) {
                        this.adaptiveCardInstance.enableBodyToggling =
                            messageCardJson[
                            this.constants.EnableBodyTogglingProperty
                            ];
                    }

                    this.theme = this.getThemeByStyle(this.style);
                    this.adaptiveCardInstance.hostConfig = new AdaptiveCards.HostConfig(
                        this.theme.hostConfig
                    ); // parse card title

                    if (
                        this.theme.allowCardTitle &&
                        messageCardJson[this.constants.TitleProperty] !=
                        undefined
                    ) {
                        this.adaptiveCardInstance.addItem(
                            this.createTextBlock(
                                messageCardJson[this.constants.TitleProperty],
                                AdaptiveCards.TextSize.Large,
                                AdaptiveCards.TextColor.Default,
                                AdaptiveCards.Spacing.Default,
                                true
                            )
                        );
                    } // parse card text

                    if (
                        messageCardJson[this.constants.TextProperty] !=
                        undefined
                    ) {
                        this.adaptiveCardInstance.addItem(
                            this.createTextBlock(
                                messageCardJson[this.constants.TextProperty],
                                AdaptiveCards.TextSize.Medium,
                                AdaptiveCards.TextColor.Default,
                                AdaptiveCards.Spacing.Default,
                                true
                            )
                        );
                    } // parse AutoInvoke Action if theme allows autoInvokeAction

                    if (
                        this.theme.allowAutoInvokeAction &&
                        messageCardJson[this.constants.AutoInvokeAction] !=
                        undefined
                    ) {
                        this.adaptiveCardInstance.autoInvokeAction = this.parseHttpAction(
                            messageCardJson[this.constants.AutoInvokeAction]
                        );
                        this.adaptiveCardInstance.autoInvokeAction.potentialAction =
                            messageCardJson[this.constants.AutoInvokeAction];
                        this.adaptiveCardInstance.autoInvokeAction.isAutoInvokeAction = true;
                    } // parse autoInvokeOptions

                    if (
                        this.theme.allowAutoInvokeAction &&
                        messageCardJson[this.constants.AutoInvokeOptions] !=
                        undefined
                    ) {
                        this.adaptiveCardInstance.autoInvokeOptions =
                            messageCardJson[this.constants.AutoInvokeOptions];
                    } // parse sections

                    if (
                        messageCardJson[this.constants.SectionsProperty] !=
                        undefined
                    ) {
                        var sectionArray =
                            messageCardJson[this.constants.SectionsProperty];

                        for (var i = 0; i < sectionArray.length; i++) {
                            var section = this.parseSection(sectionArray[i]);
                            this.adaptiveCardInstance.addItem(section);

                            var lastElement = section._items.slice(-1)[0];

                            var separatorPresent =
                                i + 1 < sectionArray.length &&
                                sectionArray[i + 1][
                                this.constants.StartGroupProperty
                                ] === true;
                            var actionSetPresent =
                                this.isUserFacingActionPresent(
                                    lastElement,
                                    true
                                ) && i + 1 < sectionArray.length;

                            if (separatorPresent && actionSetPresent) {
                                var separator = this.clientManagerInstance.getElementInstance(
                                    'separator'
                                );
                                separator.thickness = 1.5;
                                separator.spacing = AdaptiveCards.Spacing.None;
                                this.adaptiveCardInstance.addItem(separator);
                            } else if (separatorPresent && !actionSetPresent) {
                                var separator = this.clientManagerInstance.getElementInstance(
                                    'separator'
                                );
                                separator.thickness = 1;
                                this.adaptiveCardInstance.addItem(separator);
                            } else if (!separatorPresent && actionSetPresent) {
                                var separator = this.clientManagerInstance.getElementInstance(
                                    'separator'
                                );
                                separator.spacing = AdaptiveCards.Spacing.None;
                                this.adaptiveCardInstance.addItem(separator);
                            }
                        }
                    } // parse potentialActions

                    if (
                        messageCardJson[
                        this.constants.PotentialActionProperty
                        ] != undefined
                    ) {
                        var separator1 = this.clientManagerInstance.getElementInstance(
                            'separator'
                        );
                        this.adaptiveCardInstance.addItem(separator1);
                        var actionSet = this.parseActionSet(
                            messageCardJson[
                            this.constants.PotentialActionProperty
                            ],
                            true
                        );
                        actionSet.spacing = AdaptiveCards.Spacing.None;
                        this.adaptiveCardInstance.addItem(actionSet);
                    }

                    var paddingBottom = AdaptiveCards.Spacing.Default;

                    var lastElement = this.adaptiveCardInstance._items.slice(
                        -1
                    )[0];

                    if (lastElement instanceof AdaptiveCards.Container) {
                        lastElement = lastElement._items.slice(-1)[0];
                    }

                    if (lastElement instanceof AdaptiveCards.ActionSet) {
                        paddingBottom = AdaptiveCards.Spacing.None;
                    }

                    this.adaptiveCardInstance.padding = new AdaptiveCards.PaddingDefinition(
                        AdaptiveCards.Spacing.Default,
                        AdaptiveCards.Spacing.Default,
                        paddingBottom,
                        AdaptiveCards.Spacing.Default
                    );
                    return this.adaptiveCardInstance;
                } // Parse section of message card
            },
            {
                key: 'parseSection',
                value: function parseSection(sectionJson) {
                    var section = new AdaptiveCards.Container();
                    var useMarkdown = true;
                    section.spacing = AdaptiveCards.Spacing.Default;

                    if (
                        sectionJson[this.constants.MarkdownProperty] === false
                    ) {
                        useMarkdown = false;
                    } // parse section title

                    if (
                        sectionJson[this.constants.TitleProperty] != undefined
                    ) {
                        section.addItem(
                            this.createTextBlock(
                                sectionJson[this.constants.TitleProperty],
                                AdaptiveCards.TextSize.Large,
                                AdaptiveCards.TextColor.Default,
                                AdaptiveCards.Spacing.Default,
                                useMarkdown
                            )
                        );
                    }

                    if (
                        sectionJson[this.constants.ActivityTitleProperty] !=
                        undefined ||
                        sectionJson[this.constants.ActivitySubtitleProperty] !=
                        undefined ||
                        sectionJson[this.constants.ActivityTextProperty] !=
                        undefined ||
                        sectionJson[this.constants.ActivityImageProperty] !=
                        undefined
                    ) {
                        var columnSet = new AdaptiveCards.ColumnSet();
                        var column; // parse activityImage

                        if (
                            sectionJson[this.constants.ActivityImageProperty] !=
                            null &&
                            sectionJson[this.constants.ActivityImageProperty] !=
                            ''
                        ) {
                            var activityImage = new AdaptiveCards.Image();
                            activityImage.size = AdaptiveCards.Size.Small;
                            activityImage.style =
                                AdaptiveCards.ImageStyle.Person;
                            activityImage.url = this.UtilsClass.getImageProxyUrl(
                                sectionJson[
                                this.constants.ActivityImageProperty
                                ],
                                this.clientManagerInstance.supportImageProxy,
                                this.clientManagerInstance
                                    .imageAttachmentBaseUrl
                            );
                            column = new AdaptiveCards.Column();
                            column.spacing = AdaptiveCards.Spacing.ExtraLarge;
                            column.addItem(activityImage);
                            columnSet.addColumn(column);
                        }

                        column = new AdaptiveCards.Column();
                        column.width = 'stretch';
                        column.spacing = AdaptiveCards.Spacing.ExtraLarge; // parse activityTitle

                        if (
                            sectionJson[this.constants.ActivityTitleProperty] !=
                            null
                        ) {
                            column.addItem(
                                this.createTextBlock(
                                    sectionJson[
                                    this.constants.ActivityTitleProperty
                                    ],
                                    AdaptiveCards.TextSize.Medium,
                                    AdaptiveCards.TextColor.Default,
                                    AdaptiveCards.Spacing.Default,
                                    useMarkdown
                                )
                            );
                        } // parse activity SubTitle

                        if (
                            sectionJson[
                            this.constants.ActivitySubtitleProperty
                            ] != null
                        ) {
                            column.addItem(
                                this.createTextBlock(
                                    sectionJson[
                                    this.constants.ActivitySubtitleProperty
                                    ],
                                    AdaptiveCards.TextSize.Default,
                                    AdaptiveCards.TextColor.Accent,
                                    AdaptiveCards.Spacing.None,
                                    useMarkdown
                                )
                            );
                        } // parse activity Text

                        if (
                            sectionJson[this.constants.ActivityTextProperty] !=
                            null
                        ) {
                            column.addItem(
                                this.createTextBlock(
                                    sectionJson[
                                    this.constants.ActivityTextProperty
                                    ],
                                    AdaptiveCards.TextSize.Default,
                                    AdaptiveCards.TextColor.Default,
                                    AdaptiveCards.Spacing.None,
                                    useMarkdown
                                )
                            );
                        }

                        columnSet.addColumn(column);
                        section.addItem(columnSet);
                    } // parse heroImage

                    if (
                        this.theme.allowHeroImage &&
                        sectionJson[this.constants.HeroImageProperty] !=
                        undefined
                    ) {
                        var heroImage = this.parseImage(
                            sectionJson[this.constants.HeroImageProperty]
                        );
                        heroImage.size = AdaptiveCards.Size.Stretch;
                        section.addItem(heroImage);
                    } // parse section text

                    if (sectionJson[this.constants.TextProperty] != undefined) {
                        section.addItem(
                            this.createTextBlock(
                                sectionJson[this.constants.TextProperty],
                                AdaptiveCards.TextSize.Medium,
                                AdaptiveCards.TextColor.Default,
                                AdaptiveCards.Spacing.Default,
                                useMarkdown
                            )
                        );
                    } // parse facts

                    if (
                        this.theme.allowFacts &&
                        sectionJson[this.constants.FactsProperty] != undefined
                    ) {
                        var factGroup = this.parseFactSet(
                            sectionJson[this.constants.FactsProperty]
                        );
                        factGroup.useMarkdown = useMarkdown;
                        section.addItem(factGroup);
                    } // parse imageSet

                    if (
                        this.theme.allowImages &&
                        sectionJson[this.constants.ImagesProperty] != undefined
                    ) {
                        var pictureGallery = this.parseImageSet(
                            sectionJson[this.constants.ImagesProperty]
                        );
                        section.addItem(pictureGallery);
                    } // parse potentialActions

                    if (
                        sectionJson[this.constants.PotentialActionProperty] !=
                        undefined
                    ) {
                        var actionSet = this.parseActionSet(
                            sectionJson[this.constants.PotentialActionProperty],
                            true
                        );

                        if (this.isUserFacingActionPresent(actionSet, false)) {
                            var separator = this.clientManagerInstance.getElementInstance(
                                'separator'
                            );
                            section.addItem(separator);
                            actionSet.spacing = AdaptiveCards.Spacing.None;
                        }

                        section.addItem(actionSet);
                    }

                    return section;
                } // parse image
            },
            {
                key: 'parseImage',
                value: function parseImage(imageJson) {
                    var image = new AdaptiveCards.Image();
                    image.url = this.UtilsClass.getImageProxyUrl(
                        imageJson[this.constants.ImageProperty],
                        this.clientManagerInstance.supportImageProxy,
                        this.clientManagerInstance.imageAttachmentBaseUrl
                    );
                    return image;
                } // parse image set
            },
            {
                key: 'parseImageSet',
                value: function parseImageSet(ImagesJson) {
                    var imageSet = this.clientManagerInstance.getElementInstance(
                        this.constants.ImageSet
                    );
                    var imageArray = ImagesJson;
                    var imageWidth = 0; // If image Set contains single image, single image should be rendered in one row else 2 images per row.

                    if (imageArray.length == 1) {
                        imageWidth = this.containerWidth;
                    } else {
                        imageWidth =
                            (this.containerWidth -
                                this.clientManagerInstance.imageMargin) /
                            2;
                    }

                    for (var i = 0; i < imageArray.length; i++) {
                        var image = this.parseImage(imageArray[i]);
                        image.pixelWidth = imageWidth;
                        imageSet.addImage(image);
                    }

                    return imageSet;
                } // parse Fact Set
            },
            {
                key: 'parseFactSet',
                value: function parseFactSet(factSetJson) {
                    var factSet = this.clientManagerInstance.getElementInstance(
                        this.constants.FactSet
                    );
                    var factArray = factSetJson; // parse Fact Key/Value pair

                    for (var i = 0; i < factArray.length; i++) {
                        var fact = new AdaptiveCards.Fact();
                        fact.name = factArray[i][this.constants.NameProperty];
                        fact.value = factArray[i][this.constants.ValueProperty];
                        factSet.facts.push(fact);
                    }

                    return factSet;
                } // parse Open Url Action
            },
            {
                key: 'parseOpenUrlAction',
                value: function parseOpenUrlAction(openUrlJson) {
                    var action = new AdaptiveCards.OpenUrlAction();
                    action.title = openUrlJson[this.constants.NameProperty];
                    action.id = openUrlJson[this.constants.IdProperty];
                    action.isPrimary =
                        openUrlJson[this.constants.IsPrimaryAction] || false;

                    if (openUrlJson[this.constants.TargetsProperty] != null) {
                        action.url = this.getClientSpecificUri(
                            openUrlJson[this.constants.TargetsProperty]
                        );
                    }

                    return action;
                } // parse View Action
            },
            {
                key: 'parseViewAction',
                value: function parseViewAction(viewActionJson) {
                    var action = new AdaptiveCards.OpenUrlAction();
                    action.title = viewActionJson[this.constants.NameProperty];
                    action.id = viewActionJson[this.constants.IdProperty];
                    action.isPrimary =
                        viewActionJson[this.constants.IsPrimaryAction] || false;

                    if (viewActionJson[this.constants.TargetProperty] != null) {
                        action.url = this.getClientSpecificUri(
                            viewActionJson[this.constants.TargetProperty]
                        );
                    }

                    return action;
                } // parse HttpAction
            },
            {
                key: 'parseHttpAction',
                value: function parseHttpAction(httpActionJson) {
                    var action = this.clientManagerInstance.getElementInstance(
                        this.constants.HttpAction
                    );
                    this.adaptiveCardInstance.isHttpPostActionAvailable = true;
                    action.parseMessageCardAction(httpActionJson);
                    return action;
                } // parse Input
            },
            {
                key: 'parseInput',
                value: function parseInput(input, json) {
                    input.id = json[this.constants.InputIdProperty];
                    input.defaultValue = json[this.constants.ValueProperty];
                    input.placeholder = json[this.constants.TitleProperty];
                    input.isRequired =
                        json[this.constants.IsRequiredProperty] || false;
                } // parse Text Input
            },
            {
                key: 'parseTextInput',
                value: function parseTextInput(textInputJson) {
                    var input = new AdaptiveCards.TextInput();
                    this.parseInput(input, textInputJson);
                    input.isMultiline =
                        textInputJson[this.constants.IsMultilineProperty];
                    input.maxLength =
                        textInputJson[this.constants.MaxLengthProperty];
                    return input;
                } // parse Date Input
            },
            {
                key: 'parseDateInput',
                value: function parseDateInput(dateInputJson) {
                    var input = this.clientManagerInstance.getElementInstance(
                        this.constants.DateInput
                    );
                    this.parseInput(input, dateInputJson);
                    input.includeTime = false;

                    if (dateInputJson[this.constants.IncludeTimeProperty]) {
                        input.includeTime = true;
                    }

                    return input;
                } // parse Choice Set Input
            },
            {
                key: 'parseChoiceSetInput',
                value: function parseChoiceSetInput(choiceSetJson) {
                    var input = this.clientManagerInstance.getElementInstance(
                        this.constants.ChoiceSetInput
                    );
                    this.parseInput(input, choiceSetJson);
                    input.placeholder =
                        choiceSetJson[this.constants.TitleProperty];
                    var choiceArray =
                        choiceSetJson[this.constants.ChoicesProperty];
                    input.choiceList = choiceArray;

                    if (choiceArray) {
                        for (var i = 0; i < choiceArray.length; i++) {
                            var choice = new AdaptiveCards.Choice();
                            choice.display =
                                choiceArray[i][this.constants.DisplayProperty];
                            choice.title =
                                choiceArray[i][this.constants.DisplayProperty];
                            choice.value =
                                choiceArray[i][this.constants.ValueProperty];
                            input.choices.push(choice);
                        }
                    }

                    input.isMultiSelect =
                        choiceSetJson[this.constants.IsMultiSelectProperty];
                    input.isCompact = !(
                        choiceSetJson[this.constants.StyleProperty] ===
                        this.constants.Expanded
                    );
                    return input;
                } // parse Show Card Action
            },
            {
                key: 'parseShowCardAction',
                value: function parseShowCardAction(showCardJson) {
                    var showCardAction = new AdaptiveCards.ShowCardAction();
                    showCardAction.isUserFacingActionPresent = false;
                    showCardAction.id = showCardJson[this.constants.IdProperty];
                    showCardAction.title =
                        showCardJson[this.constants.NameProperty];
                    showCardAction.isPrimary =
                        showCardJson[this.constants.IsPrimaryAction] || false;
                    showCardAction.card.actionStyle = 'button';
                    var inputArray =
                        showCardJson[this.constants.InputsProperty];

                    if (inputArray) {
                        for (var i = 0; i < inputArray.length; i++) {
                            var jsonInput = inputArray[i];
                            var input = null;

                            switch (
                            jsonInput[
                                this.constants.TypeProperty
                            ].toLowerCase()
                            ) {
                                case this.constants.TextInput:
                                    input = this.parseTextInput(jsonInput);
                                    break;

                                case this.constants.DateInput:
                                    input = this.parseDateInput(jsonInput);
                                    break;

                                case this.constants.MultiChoiceInput:
                                    input = this.parseChoiceSetInput(jsonInput);
                                    break;
                            }

                            if (input) {
                                showCardAction.card.addItem(input);
                            }
                        }
                    }

                    var actionArray =
                        showCardJson[this.constants.ActionsProperty];

                    if (actionArray) {
                        var separator = this.clientManagerInstance.getElementInstance(
                            'separator'
                        );
                        showCardAction.card.addItem(separator);
                        showCardAction.isUserFacingActionPresent =
                            actionArray.isUserFacingActionPresent;
                        var actionSet = this.parseActionSet(actionArray, false);
                        actionSet.spacing = AdaptiveCards.Spacing.None;
                        showCardAction.card.addItem(actionSet);
                    }

                    return showCardAction;
                } // parse Action Set
            },
            {
                key: 'parseActionSet',
                value: function parseActionSet(actionSetJson, allowMoreAction) {
                    var actionSet = new AdaptiveCards.ActionSet();
                    actionSet.isUserFacingActionPresent = false;
                    var actionArray = actionSetJson;

                    for (var i = 0; i < actionArray.length; i++) {
                        var jsonAction = actionArray[i];
                        var action = null;

                        switch (
                        jsonAction[
                            this.constants.TypeProperty
                        ].toLowerCase()
                        ) {
                            case this.constants.OpenUriAction:
                                action = this.parseOpenUrlAction(jsonAction);
                                actionSet.isUserFacingActionPresent = true;
                                break;

                            case this.constants.ViewAction:
                                action = this.parseViewAction(jsonAction);
                                actionSet.isUserFacingActionPresent = true;
                                break;

                            case this.constants.HttpPostAction:
                                action = this.parseHttpAction(jsonAction);
                                actionSet.isUserFacingActionPresent = true;
                                break;

                            case this.constants.ActionCardAction:
                                if (this.theme.allowActionCard) {
                                    action = this.parseShowCardAction(
                                        jsonAction
                                    );
                                    actionSet.isUserFacingActionPresent =
                                        action.isUserFacingActionPresent;
                                }

                                break;
                        }

                        if (action) {
                            if (
                                jsonAction[
                                this.constants.HideCardOnInvokeProperty
                                ] != undefined
                            ) {
                                action.hideCardOnInvoke =
                                    jsonAction[
                                    this.constants.HideCardOnInvokeProperty
                                    ];
                            }

                            action.potentialAction = jsonAction;
                            action.isAutoInvokeAction = false;
                            actionSet.addAction(action);
                        }
                    }

                    var finalActionSet = actionSet; // add more action button based on space if theme supports displaying it.

                    if (
                        this.theme.allowDisplayMoreAction &&
                        allowMoreAction == true
                    ) {
                        finalActionSet = this.getActionSet(
                            actionSet,
                            this.theme
                        );
                    }

                    return finalActionSet;
                }
            },
            {
                key: 'getActionSet',
                value: function getActionSet(actionSet, theme) {
                    var actionCollection = actionSet._actionCollection.items;

                    if (actionCollection.length > 2) {
                        var moreAction = this.clientManagerInstance.getElementInstance(
                            this.constants.MoreAction
                        );
                        moreAction.title = 'More Action';
                        moreAction.potentialAction = [];
                        moreAction.isAutoInvokeAction = false;

                        for (var i = 2; i < actionCollection.length; i++) {
                            moreAction.addAction(actionCollection[i]);
                            moreAction.potentialAction.push(
                                actionCollection[i].potentialAction
                            );
                        }

                        actionSet._actionCollection.items.splice(2);

                        actionSet.addAction(moreAction);
                    }

                    return actionSet;
                } // helper method to search them by style
            },
            {
                key: 'getThemeByStyle',
                value: function getThemeByStyle(style) {
                    for (var i = 0; i < this.themes.length; i++) {
                        if (this.themes[i].style == style) {
                            return this.themes[i];
                        }
                    }

                    for (var i = 0; i < this.themes.length; i++) {
                        if (
                            this.themes[i].style == this.constants.DefaultStyle
                        ) {
                            return this.themes[i];
                        }
                    }
                } // helper method to search client specific uri for a httpaction
            },
            {
                key: 'getClientSpecificUri',
                value: function getClientSpecificUri(targets) {
                    for (var i = 0; i < targets.length; i++) {
                        if (targets[i].os == this.theme.client) {
                            return targets[i].uri;
                        }
                    }

                    for (var i = 0; i < targets.length; i++) {
                        if (targets[i].os == this.constants.DefaultStyle) {
                            return targets[i].uri;
                        }
                    }
                } // helper method to create AdaptiveCard TextBlock
            },
            {
                key: 'createTextBlock',
                value: function createTextBlock(
                    textContent,
                    textSize,
                    textColor,
                    textSpacing,
                    useMarkdown
                ) {
                    var textBlock = new AdaptiveCards.TextBlock();
                    textBlock.text = textContent;
                    textBlock.size = textSize;
                    textBlock.color = textColor;
                    textBlock.spacing = textSpacing;
                    textBlock.wrap = true;
                    textBlock.useMarkdown = useMarkdown;
                    return textBlock;
                }
            },
            {
                key: 'isUserFacingActionPresent',
                value: function isUserFacingActionPresent(
                    actionSet,
                    ignorePreExpandedCard
                ) {
                    if (!(actionSet instanceof AdaptiveCards.ActionSet)) {
                        return false;
                    } else if (actionSet._actionCollection.items.length === 0) {
                        return false;
                    } else if (actionSet.isUserFacingActionPresent === false) {
                        return false;
                    } else if (
                        !ignorePreExpandedCard &&
                        actionSet._actionCollection.items.length === 1 &&
                        actionSet._actionCollection.items[0] instanceof
                        AdaptiveCards.ShowCardAction
                    ) {
                        return false;
                    }

                    return true;
                }
            }
        ]);

        return MessageCardConverter;
    })();

var css$1 =
    '.moreActionWrapper {\r\n    display: block;\r\n    height: 100%;\r\n    position: relative;\r\n}\r\n\r\n.moreActionContent{\r\n    width: 358px;\r\n    position: absolute;\r\n    bottom: 0px;\r\n    cursor: pointer;\r\n    border-left: 1px solid #c8c8c8;\r\n    border-right: 1px solid #c8c8c8;\r\n}\r\n\r\n.titleDiv{\r\n    background-color: #ffffff;\r\n    height: 40px;\r\n}\r\n\r\n.title{\r\n    padding: 10px 0px 10px 20px;\r\n    margin: 0px;\r\n}\r\n\r\n.showCardContentWrapper{\r\n    padding: 16px;\r\n    margin: auto;\r\n    height: 475px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    border-left: 1px solid #c8c8c8;\r\n    border-right: 1px solid #c8c8c8;\r\n}\r\n\r\n.chevron-icon{\r\n    width: 8px;\r\n    height: 12px;\r\n}\r\n\r\n.calendar-icon{\r\n    size: initial;\r\n}';
styleInject(css$1);

var CLIENT = 'android';

var CardRender =
    /*#__PURE__*/
    (function () {
        function CardRender(targetDom) {
            var _this = this;

            var context =
                arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : null;
            var inputOverlay =
                arguments.length > 2 && arguments[2] !== undefined
                    ? arguments[2]
                    : null;

            _classCallCheck(this, CardRender);

            try {
                this.logTimeStamp('constructor-start');
                this.ClientManagerClass = ClientManager;
                this.MessageCardConverterClass = MessageCardConverter;
                this.UtilsClass = Utils; // initialize the required instances

                this.clientManagerInstance = new this.ClientManagerClass(
                    context,
                    inputOverlay
                );
                this.context = context;
                this.constants = this.UtilsClass.Constants;

                if (
                    this.clientManagerInstance.supportSavingState &&
                    this.context
                ) {
                    this.onRestoreInstanceState(
                        this.context.messageId,
                        this.context.isShowCardJson
                    );
                }

                this.messageCardConverterInstance = new this.MessageCardConverterClass(
                    this.clientManagerInstance,
                    this.UtilsClass
                );
                this.targetDom = targetDom;
                this.currentAction = this.constants.InitialCardProcessing;
                this.isAutoInvokeSpinnerVisible = false; // Set the callbacks
                // Callback for on showcard action (used for mac and windows)

                if (this.clientManagerInstance.supportInlineShowCard) {
                    AdaptiveCards.AdaptiveCard.onInlineCardExpanded = function (
                        action,
                        isExpanded
                    ) {
                        _this.onInlineCardExpanded(action, isExpanded);
                    };
                }

                AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (
                    text,
                    result
                ) {
                    result.outputHtml = markdown().render(text);
                    result.didProcess = true;
                }; // Callback for on action click

                AdaptiveCards.AdaptiveCard.onExecuteAction = function (action) {
                    _this.onExecuteAction(action);
                }; // Callback for parsing element

                AdaptiveCards.AdaptiveCard.onParseElement = function (
                    element,
                    json
                ) {
                    _this.onParseElement(element, json);
                }; // Callback for parsing action

                AdaptiveCards.AdaptiveCard.onParseAction = function (
                    action,
                    json
                ) {
                    _this.onParseAction(action, json);
                }; // Callback for anchor click

                AdaptiveCards.AdaptiveCard.onAnchorClicked = function (
                    element,
                    anchor
                ) {
                    _this.onAnchorClicked(element, anchor);
                }; // Disable markdown for choice inputs

                AdaptiveCards.AdaptiveCard.useMarkdownInRadioButtonAndCheckbox = false; // Enable support for separators bleeding

                AdaptiveCards.AdaptiveCard.alwaysBleedSeparators = true; // Enable support for <mark>..</mark> tag

                AdaptiveCards.AdaptiveCard.allowMarkForTextHighlighting = true; // User facing messages

                this.WorkingStatusMessage = 'Working on it';
                this.ActionFailureStatusMessage =
                    'Action could not be completed';
                this.ACFailureStatusMessage =
                    'Something went wrong. Please try again later.';
                this.PleaseLoginStatusMessage =
                    ' [Please login to continue](https://outlook.office.com';
                this.PleaseLoginContinueMessage = 'LOG IN';
                this.OutlookBaseUrl = 'https://outlook.office.com';
                this.logTimeStamp('constructor-end');
            } catch (e) {
                console.log(e.message);
                console.log(e.stack);

                if (this.clientManagerInstance != null) {
                    this.clientManagerInstance.logException(e);
                } else {
                    throw e;
                }
            }
        } // extract and render appropriate card

        _createClass(CardRender, [
            {
                key: 'renderCard',
                value: function renderCard(rawExtendedPropertyJson) {
                    try {
                        this.logTimeStamp('renderCard-start'); // this.extendedPropertyJson = this.clientManagerInstance.processData(rawExtendedPropertyJson);

                        this.extendedPropertyJson = JSON.parse(
                            rawExtendedPropertyJson
                        ); // console.log(JSON.stringify(this.extendedPropertyJson));
                        // Consolidate all the previous performed actions(only for message cards)

                        this.allPerformedActions = []; // If extendedProperty contains AdaptiveCardSerialized Property

                        if (
                            this.extendedPropertyJson[
                            this.constants.AdaptiveCardSerializedProperty
                            ] != null
                        ) {
                            this.adaptiveCardJson = JSON.parse(
                                this.extendedPropertyJson[
                                this.constants
                                    .AdaptiveCardSerializedProperty
                                ]
                            );
                            this.generateAdaptiveCardInstance(false);
                        } else if (
                            this.context != null &&
                            this.context.isShowCardJson === true &&
                            this.extendedPropertyJson['type'] == 'AdaptiveCard'
                        ) {
                            this.adaptiveCardJson = this.extendedPropertyJson;
                            this.adaptiveCardJson.version = this.context.version;
                            var amContainerDiv = document.querySelector(
                                this.targetDom
                            );

                            if (amContainerDiv != null) {
                                amContainerDiv.style.padding = '0px';
                                amContainerDiv.style.border = '0px';
                                amContainerDiv.classList.add('ac-showCard');
                            }

                            this.generateAdaptiveCardInstance(true);
                        } //ToDo: Remove this. this block is used only for testing.
                        else if (
                            this.extendedPropertyJson['type'] == 'AdaptiveCard'
                        ) {
                            this.adaptiveCardJson = this.extendedPropertyJson;
                            this.generateAdaptiveCardInstance(false);
                        } else if (
                            this.clientManagerInstance.supportMessageCard &&
                            this.extendedPropertyJson[
                            this.constants.MessageCardSerializedProperty
                            ] != null
                        ) {
                            this.messageCardJson = JSON.parse(
                                this.extendedPropertyJson[
                                this.constants.MessageCardSerializedProperty
                                ]
                            );

                            if (
                                this.extendedPropertyJson[
                                this.constants
                                    .PerformedActionsSerializedProperty
                                ] != undefined
                            ) {
                                var performedActions = JSON.parse(
                                    this.extendedPropertyJson[
                                    this.constants
                                        .PerformedActionsSerializedProperty
                                    ]
                                );
                                var userPerformedActions =
                                    performedActions[
                                    this.constants
                                        .UserPerformedActionsProperty
                                    ];

                                for (
                                    var i = 0;
                                    i < userPerformedActions.length;
                                    i++
                                ) {
                                    this.allPerformedActions = this.allPerformedActions.concat(
                                        userPerformedActions[i][
                                        this.constants
                                            .PerformedActionsProperty
                                        ]
                                    );
                                }

                                this.allPerformedActions.sort(
                                    this.sortFunction
                                );
                            }

                            this.convertToAdaptiveCardInstance(false);
                        }

                        this.logTimeStamp('renderCard-end');
                    } catch (e) {
                        console.log(e.message);
                        console.log(e.stack);
                        this.clientManagerInstance.logException(e);
                        this.setCardVisible(false);
                    }
                }
            },
            {
                key: 'convertToAdaptiveCardInstance',
                value: function convertToAdaptiveCardInstance(
                    ignoreAutoInvokeAction
                ) {
                    this.logTimeStamp('conversion-start');
                    this.adaptiveCardInstance = this.messageCardConverterInstance.parseMessageCard(
                        this.messageCardJson
                    );
                    this.logTimeStamp('conversion-end');
                    this.httpActionList = [];
                    var setCardVisibility = true;
                    this.populateClientTelemetryObject();

                    if (
                        ignoreAutoInvokeAction === false &&
                        this.adaptiveCardInstance.autoInvokeAction !=
                        undefined &&
                        this.adaptiveCardInstance.autoInvokeAction
                            .hideCardOnInvoke === true
                    ) {
                        setCardVisibility = false;
                    }

                    var renderedCard = this.getRenderedAdaptiveCard(); // This can happen for message cards if it only contains summary
                    // and no title / text or sections.

                    if (renderedCard == null) {
                        setCardVisibility = false;
                    }

                    this.setCardVisible(setCardVisibility);
                    this.renderAsHtml(renderedCard);

                    if (
                        ignoreAutoInvokeAction === false &&
                        this.adaptiveCardInstance.autoInvokeAction != undefined
                    ) {
                        this.onExecuteAction(
                            this.adaptiveCardInstance.autoInvokeAction
                        );
                    }
                }
            },
            {
                key: 'generateAdaptiveCardInstance',
                value: function generateAdaptiveCardInstance(
                    ignoreAutoInvokeAction
                ) {
                    this.logTimeStamp('conversion-start');
                    this.adaptiveCardInstance = new AdaptiveCards.AdaptiveCard();
                    this.adaptiveCardInstance.hideOriginalBody =
                        this.adaptiveCardJson[
                        this.constants.HideOriginalBodyProperty
                        ] || false;
                    this.adaptiveCardInstance.enableBodyToggling =
                        this.adaptiveCardJson[
                        this.constants.EnableBodyTogglingProperty
                        ] || false;
                    this.adaptiveCardInstance.isHttpPostActionAvailable = false; //check if the card has constraint width set

                    this.adaptiveCardInstance.isConstrainWidth =
                        this.adaptiveCardJson[this.constants.ConstrainWidth] ||
                        false;
                    this.adaptiveCardInstance.rtl =
                        this.adaptiveCardJson[this.constants.RTL] || false;

                    if (
                        this.adaptiveCardJson[
                        this.constants.MessageCardContextProperty
                        ] != undefined
                    ) {
                        this.adaptiveCardInstance.messageCardContext = this.adaptiveCardJson[
                            this.constants.MessageCardContextProperty
                        ];
                    } //ToDo: Change this logic to accomodate dynamic theming

                    this.httpActionList = [];
                    this.openUrlList = [];
                    this.adaptiveCardInstance.hostConfig = new AdaptiveCards.HostConfig(
                        this.clientManagerInstance.getACHostConfigs(
                            this.context
                        )[0]
                    );

                    if (this.context && this.context['hostCapabilities']) {
                        try {
                            var capabilities = new AdaptiveCards.HostCapabilities();
                            capabilities.parse(
                                this.context['hostCapabilities'],
                                null
                            );
                            this.adaptiveCardInstance.hostConfig.hostCapabilities = capabilities;
                        } catch (e) {
                            console.log(e.message);
                        }
                    } else if (this.clientManagerInstance.capabilities) {
                        this.adaptiveCardInstance.hostConfig.hostCapabilities = this.clientManagerInstance.capabilities;
                    }

                    this.adaptiveCardInstance.parse(this.adaptiveCardJson);

                    if (
                        this.adaptiveCardJson[
                        this.constants.AutoInvokeAction
                        ] != undefined
                    ) {
                        this.adaptiveCardInstance.autoInvokeAction = this.createInstance(
                            'Action.Http',
                            this.adaptiveCardInstance
                        );
                        this.adaptiveCardInstance.autoInvokeAction.setParent(
                            this.adaptiveCardInstance
                        );
                        this.adaptiveCardInstance.autoInvokeAction.parse(
                            this.adaptiveCardJson[
                            this.constants.AutoInvokeAction
                            ]
                        );
                        this.adaptiveCardInstance.autoInvokeAction.isAutoInvokeAction = true;
                    }

                    if (
                        this.adaptiveCardJson[
                        this.constants.AutoInvokeOptions
                        ] != undefined
                    ) {
                        this.adaptiveCardInstance.autoInvokeOptions = this.adaptiveCardJson[
                            this.constants.AutoInvokeOptions
                        ];
                    }

                    this.logTimeStamp('conversion-end');

                    if (
                        this.context == null ||
                        (this.context != null &&
                            this.context.isShowCardJson === false)
                    ) {
                        this.populateClientTelemetryObject();
                        this.clientManagerInstance.storeClientTelemetryProperties(
                            this.clientTelemetryJson
                        );
                    }

                    var renderedCard = this.getRenderedAdaptiveCard();

                    if (
                        this.currentAction ===
                        this.constants.InitialCardProcessing
                    ) {
                        this.clientManagerInstance.logInitialCardProcessingEnd();
                        this.currentAction = this.constants.InitialCardRendering;
                    } else if (
                        this.currentAction ===
                        this.constants.FinalCardProcessing
                    ) {
                        this.clientManagerInstance.logFinalCardProcessingEnd();
                        this.currentAction = this.constants.FinalCardRendering;
                    } // Check for required host capability

                    if (
                        this.adaptiveCardJson &&
                        this.adaptiveCardJson['requires'] &&
                        this.clientManagerInstance &&
                        this.clientManagerInstance.capabilities
                    ) {
                        var requires = this.adaptiveCardJson['requires'];
                        var requiredCapability = new AdaptiveCards.HostCapabilities();
                        requiredCapability.parse(requires, null);

                        if (
                            !requiredCapability.areAllMet(
                                this.clientManagerInstance.capabilities
                            )
                        ) {
                            renderedCard = null;
                        }
                    } // If there is nothing to render, mark the visibility as false.

                    if (renderedCard == null) {
                        this.setCardVisible(false);

                        if (
                            this.currentAction ===
                            this.constants.InitialCardRendering
                        ) {
                            this.clientManagerInstance.loginitialCardRenderingEnd();

                            if (
                                this.ignoreAutoInvokeAction === true ||
                                this.adaptiveCardInstance.autoInvokeAction ===
                                undefined
                            ) {
                                this.clientManagerInstance.logFinalCardRenderingEnd();
                            }
                        } else if (
                            this.currentAction ===
                            this.constants.FinalCardRendering
                        ) {
                            this.clientManagerInstance.logFinalCardRenderingEnd();
                            this.currentAction = '';
                        }
                    } else {
                        this.setCardVisible(true);
                        this.renderAsHtml(renderedCard);
                    }

                    if (
                        ignoreAutoInvokeAction === false &&
                        this.adaptiveCardInstance.autoInvokeAction != undefined
                    ) {
                        this.adaptiveCardInstance.autoInvokeAction.execute();
                    }
                } // sort Function used to sort all the previous successfully performed actions
            },
            {
                key: 'sortFunction',
                value: function sortFunction(elementOne, elementTwo) {
                    if (
                        elementOne[this.constants.performedAtProperty] >
                        elementTwo[this.constants.performedAtProperty]
                    ) {
                        return 1;
                    } else if (
                        elementTwo[this.constants.performedAtProperty] >
                        elementOne[this.constants.performedAtProperty]
                    ) {
                        return -1;
                    } else {
                        return 0;
                    }
                } // Search for the actionId and show the status for the corresponding action
                // isUserFacingElement says whether element is visible to user.
                // Status is shown for the corresponding userFacing element.
            },
            {
                key: 'showStatusMessage',
                value: function showStatusMessage(
                    actionId,
                    statusJson,
                    cardElement,
                    isUserFacingElement
                ) {
                    // If card element is any element not related to Action
                    if (cardElement._items != undefined) {
                        for (var i = 0; i < cardElement._items.length; i++) {
                            if (
                                this.showStatusMessage(
                                    actionId,
                                    statusJson,
                                    cardElement._items[i],
                                    isUserFacingElement
                                )
                            ) {
                                return true;
                            }
                        }
                    } // If card element is instance of ActionSet

                    if (
                        cardElement instanceof AdaptiveCards.ActionSet &&
                        cardElement._actionCollection != undefined &&
                        cardElement._actionCollection.items != undefined
                    ) {
                        for (
                            var i = 0;
                            i < cardElement._actionCollection.items.length;
                            i++
                        ) {
                            if (
                                this.showStatusMessage(
                                    actionId,
                                    statusJson,
                                    cardElement._actionCollection.items[i],
                                    isUserFacingElement
                                )
                            ) {
                                return true;
                            }
                        }
                    }

                    if (
                        cardElement instanceof AdaptiveCards.ActionSet &&
                        cardElement._actionCollection != undefined &&
                        cardElement._actionCollection.items != undefined
                    ) {
                        for (
                            var i = 0;
                            i < cardElement._actionCollection.items.length;
                            i++
                        ) {
                            if (
                                this.showStatusMessage(
                                    actionId,
                                    statusJson,
                                    cardElement._actionCollection.items[i],
                                    isUserFacingElement
                                )
                            ) {
                                return true;
                            }
                        }
                    } // If card element is instance of More Action

                    if (
                        this.clientManagerInstance.MoreActionClass != null &&
                        cardElement instanceof
                        this.clientManagerInstance.MoreActionClass &&
                        cardElement.items != undefined
                    ) {
                        for (var i = 0; i < cardElement.items.length; i++) {
                            if (
                                this.showStatusMessage(
                                    actionId,
                                    statusJson,
                                    cardElement.items[i],
                                    false
                                )
                            ) {
                                cardElement.setStatus(statusJson);
                                return true;
                            }
                        }
                    } // If card element is instance of ShowCard Action

                    if (
                        cardElement instanceof AdaptiveCards.ShowCardAction &&
                        cardElement.card != null &&
                        cardElement.card._items != null
                    ) {
                        for (
                            var i = 0;
                            i < cardElement.card._items.length;
                            i++
                        ) {
                            if (
                                this.showStatusMessage(
                                    actionId,
                                    statusJson,
                                    cardElement.card._items[i],
                                    false
                                )
                            ) {
                                cardElement.setStatus(statusJson);
                                return true;
                            }
                        }
                    } // For any other action

                    if (
                        cardElement instanceof AdaptiveCards.Action &&
                        cardElement.id != null &&
                        cardElement.id === actionId
                    ) {
                        if (isUserFacingElement === true) {
                            cardElement.setStatus(statusJson);
                        }

                        return true;
                    }

                    return false;
                } //populate client telemetry object
            },
            {
                key: 'populateClientTelemetryObject',
                value: function populateClientTelemetryObject() {
                    this.clientTelemetryJson = {}; // Read ConnectorSenderGuid property
                    // default value of connector sender guid

                    var connectorSenderGuid =
                        '00000000-0000-0000-0000-000000000000';

                    if (
                        this.extendedPropertyJson[
                        this.constants.ConnectorSenderGuidProperty
                        ]
                    ) {
                        connectorSenderGuid = this.extendedPropertyJson[
                            this.constants.ConnectorSenderGuidProperty
                        ];
                    }

                    this.clientTelemetryJson[
                        this.constants.connectorSenderGuidProperty
                    ] = connectorSenderGuid; // Read ProviderAccountUniqueId if it is present

                    if (
                        this.extendedPropertyJson[
                        this.constants.ProviderAccountUniqueId
                        ]
                    ) {
                        this.clientTelemetryJson[
                            this.constants.providerAccountUniqueId
                        ] = this.extendedPropertyJson[
                            this.constants.ProviderAccountUniqueId
                            ];
                    } // Stamp IshttpPostActionAvailable

                    this.clientTelemetryJson[
                        this.constants.IsHttpPostActionAvailableProperty
                    ] = this.adaptiveCardInstance.isHttpPostActionAvailable; // Stamp messageCardContext Property if it is present

                    if (this.adaptiveCardInstance.messageCardContext) {
                        this.clientTelemetryJson[
                            this.constants.MessageCardContextProperty
                        ] = this.adaptiveCardInstance.messageCardContext;
                    } // Read MessageCardExtensionContext Property if it is present

                    if (
                        this.extendedPropertyJson[
                        this.constants.MessageCardExtensionContextProperty
                        ]
                    ) {
                        this.clientTelemetryJson[
                            this.constants.messageCardExtensionContextProperty
                        ] = this.extendedPropertyJson[
                            this.constants.MessageCardExtensionContextProperty
                            ];
                    } //ToDo: Add logic to accomodate explicitMessageCard

                    if (
                        this.adaptiveCardInstance != null &&
                        this.messageCardJson != null
                    ) {
                        this.clientTelemetryJson[
                            this.constants.MessageType
                        ] = this.constants.ConnectorMessage;
                    } else if (this.adaptiveCardInstance != null) {
                        this.clientTelemetryJson[
                            this.constants.MessageType
                        ] = this.constants.AdaptiveCard;
                    } // Stamp originator Property

                    if (this.adaptiveCardInstance.originator != null) {
                        this.clientTelemetryJson[
                            this.constants.OriginatorProperty
                        ] = this.adaptiveCardInstance.originator;
                    }
                } // Render Card as html using adaptiveCards.js
            },
            {
                key: 'renderAsHtml',
                value: function renderAsHtml(renderedCard) {
                    var parent = document.querySelector(this.targetDom);

                    if (parent && renderedCard) {
                        parent.innerHTML = '';
                        parent.appendChild(renderedCard);
                        this.allInputInstances = this.adaptiveCardInstance.getAllInputs();
                        this.handleInputValueChanged(this.allInputInstances);
                        this.adaptiveCardInstance.updateLayout();
                    }

                    for (var i = 0; i < this.allPerformedActions.length; i++) {
                        var performedAction = this.allPerformedActions[i];

                        if (
                            performedAction[
                            this.constants.DisplayMessageProperty
                            ] != null &&
                            performedAction[this.constants.ActionId] != null
                        ) {
                            this.showStatusMessage(
                                performedAction[this.constants.ActionId],
                                this.getStatusMessageJson(
                                    performedAction[
                                    this.constants.DisplayMessageProperty
                                    ]
                                ),
                                this.adaptiveCardInstance,
                                true
                            );
                        }
                    }

                    this.addOpenUrlIcon(); // call native methods to update about card render to set the height

                    this.clientManagerInstance.postRender();

                    if (
                        this.currentAction ===
                        this.constants.InitialCardRendering
                    ) {
                        this.clientManagerInstance.logInitialCardRenderingEnd();

                        if (
                            this.ignoreAutoInvokeAction === true ||
                            this.adaptiveCardInstance.autoInvokeAction ===
                            undefined
                        ) {
                            this.clientManagerInstance.logFinalCardRenderingEnd();
                        }
                    } else if (
                        this.currentAction === this.constants.FinalCardRendering
                    ) {
                        this.clientManagerInstance.logFinalCardRenderingEnd();
                        this.currentAction = '';
                    }
                }
            },
            {
                key: 'handleActionsIncaseOfAutoInvoke',
                value: function handleActionsIncaseOfAutoInvoke() {
                    var _this2 = this;

                    var allButtons = document.getElementsByClassName(
                        'ac-pushButton'
                    ); //enable the buttons only if there's no spinner

                    if (allButtons) {
                        Array.from(allButtons).map(function (button) {
                            return (button.disabled =
                                _this2.isAutoInvokeSpinnerVisible);
                        });
                    }
                } // This function adds link icon to OpenUrl action buttons
            },
            {
                key: 'addOpenUrlIcon',
                value: function addOpenUrlIcon() {
                    if (this.openUrlList) {
                        for (var i = 0; i < this.openUrlList.length; i++) {
                            var renderedElement = this.openUrlList[i]
                                .renderedElement;

                            if (
                                renderedElement &&
                                renderedElement.classList &&
                                renderedElement.innerText
                            ) {
                                var innerText = renderedElement.innerText.trim();
                                renderedElement.innerText = '';

                                if (
                                    renderedElement.querySelector(
                                        '#openUrlButton'
                                    ) === null
                                ) {
                                    var openUrlDummyIcon = document.createElement(
                                        'span'
                                    );
                                    openUrlDummyIcon.id = 'iconDummyOpenUrl';
                                    openUrlDummyIcon.style.display =
                                        'inline-block';
                                    openUrlDummyIcon.innerText = ' ';
                                    renderedElement.appendChild(
                                        openUrlDummyIcon
                                    );
                                    var buttonText = document.createElement(
                                        'span'
                                    );
                                    buttonText.id = 'openUrlButton';
                                    buttonText.classList.add('openUrlButton');
                                    buttonText.style.margin = 'auto';
                                    buttonText.innerText = innerText;
                                    buttonText.style.overflow = 'hidden';
                                    buttonText.style.textOverflow = 'ellipsis';
                                    buttonText.style.whiteSpace = 'nowrap';
                                    renderedElement.appendChild(buttonText);
                                    var openUrlIcon = document.createElement(
                                        'span'
                                    );
                                    openUrlIcon.id = 'iconOpenUrl';
                                    openUrlIcon.style.display = 'inline-block';
                                    openUrlIcon.innerText = ' ';
                                    renderedElement.appendChild(openUrlIcon); //to fix the issue that disabled open url buttons in main card are having the blue icon

                                    if (renderedElement.disabled == true) {
                                        openUrlIcon.classList.add(
                                            'ac-openUrlIconDisabled'
                                        );
                                        openUrlDummyIcon.classList.add(
                                            'iconDummyOpenUrlDisabled'
                                        );
                                    } else {
                                        if (
                                            this.clientManagerInstance
                                                .actionButtonsCount === 1 ||
                                            this.openUrlList[i].isPrimary
                                        ) {
                                            // Link icon of white color in case of primary openurl button
                                            openUrlIcon.classList.add(
                                                'ac-openUrlIconNonPrimary'
                                            );
                                            openUrlDummyIcon.classList.add(
                                                'iconDummyOpenUrlNonPrimary'
                                            );
                                        } else {
                                            // Link icon of blue color in case of openurl button with white background
                                            openUrlIcon.classList.add(
                                                'ac-openUrlIconPrimary'
                                            );
                                            openUrlDummyIcon.classList.add(
                                                'iconDummyOpenUrlPrimary'
                                            );

                                            renderedElement.onmouseover = function () {
                                                openUrlIcon.classList.add(
                                                    'ac-openUrlIconNonPrimary'
                                                );
                                                openUrlIcon.classList.remove(
                                                    'ac-openUrlIconPrimary'
                                                );
                                                openUrlDummyIcon.classList.add(
                                                    'iconDummyOpenUrlNonPrimary'
                                                );
                                                openUrlDummyIcon.classList.remove(
                                                    'iconDummyOpenUrlPrimary'
                                                );
                                            };

                                            renderedElement.onmouseout = function () {
                                                openUrlIcon.classList.add(
                                                    'ac-openUrlIconPrimary'
                                                );
                                                openUrlIcon.classList.remove(
                                                    'ac-openUrlIconNonPrimary'
                                                );
                                                openUrlDummyIcon.classList.add(
                                                    'iconDummyOpenUrlPrimary'
                                                );
                                                openUrlDummyIcon.classList.remove(
                                                    'iconDummyOpenUrlNonPrimary'
                                                );
                                            };
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            {
                key: 'displayErrorMessage',
                value: function displayErrorMessage(action) {
                    if (!action.isAutoInvokeAction && action.data) {
                        for (var i = 0; i < action.data.length; i++) {
                            if (
                                action.data[i].validationErrors &&
                                action.data[i].validationErrors.length > 0
                            ) {
                                this.clientManagerInstance.displaySnackMessage(
                                    action.data[i].validationErrors[0].message,
                                    false
                                );
                                return true;
                            }
                        }
                    }

                    return false;
                }
            },
            {
                key: 'showAutoInvokeSpinner',
                value: function showAutoInvokeSpinner() {
                    this.isAutoInvokeSpinnerVisible = true;
                    this.handleActionsIncaseOfAutoInvoke();
                    var targetDomElement = document.querySelector(
                        this.targetDom
                    );
                    var spinnerElement = document.createElement('div');
                    spinnerElement.className = 'ac-overlay-spinner';
                    targetDomElement.parentElement.prepend(spinnerElement); // Set Timeout

                    setTimeout(function () {
                        this.hideAutoInvokeSpinner();
                    }, 6000);
                }
            },
            {
                key: 'hideAutoInvokeSpinner',
                value: function hideAutoInvokeSpinner() {
                    this.isAutoInvokeSpinnerVisible = false;
                    this.handleActionsIncaseOfAutoInvoke();
                    var overlayElement = document.getElementsByClassName(
                        'ac-overlay-spinner'
                    )[0];

                    if (overlayElement) {
                        overlayElement.parentNode.removeChild(overlayElement);
                    }
                }
            },
            {
                key: 'onInlineCardExpanded',
                value: function onInlineCardExpanded(action, isExpanded) {
                    var _this3 = this;

                    // check if its show card
                    if (action instanceof AdaptiveCards.ShowCardAction) {
                        // Create a wraper div for child of ac-container representing show card dialog
                        if (
                            isExpanded &&
                            action.card &&
                            action.card._renderedElement
                        ) {
                            this.showCardActionRef = action;
                            var parent = action.card._renderedElement;
                            var childNodes = parent.childNodes;
                            var wrapperDiv = document.createElement('div');
                            wrapperDiv.className = 'inlineExpandedShowCard';
                            wrapperDiv.id = 'inlineExpandedShowCard'; // Create a header with action title on left and close icon on right

                            var headerDiv = document.createElement('div');
                            headerDiv.className = 'showCardHeaderDiv';
                            var headerCloseButton = document.createElement(
                                'div'
                            );
                            headerCloseButton.className = 'showCardCloseButton';
                            headerCloseButton.setAttribute('role', 'button');
                            headerCloseButton.setAttribute(
                                'aria-label',
                                this.constants.ShowCardCloseButtonAriaLabel
                            );

                            headerCloseButton.onclick = function () {
                                _this3.CollapseExpandedShowCardDialog();
                            };

                            headerDiv.appendChild(headerCloseButton);
                            var haeaderTitle = document.createElement('span');
                            haeaderTitle.className = 'showCardHeaderTitle';
                            haeaderTitle.textContent = action.title; 
                            headerDiv.appendChild(haeaderTitle);
                            wrapperDiv.appendChild(headerDiv);
                            var showCardContentWrapper = document.createElement(
                                'div'
                            );
                            showCardContentWrapper.className =
                                'showCardContentWrapper';
                            showCardContentWrapper.id =
                                'showCardContentWrapper'; // Move child nodes from parent to new wrapper div

                            while (parent.hasChildNodes()) {
                                showCardContentWrapper.appendChild(
                                    parent.firstChild
                                );
                            }

                            wrapperDiv.appendChild(showCardContentWrapper); //to fix the issue that if the showcard has style emphasis, then the emphasis container appears like extended shadow of the showcard

                            parent.style.padding = '0px';
                            var mobileMailWrapper = document.getElementById(
                                'mobileMailWrapper'
                            );
                            mobileMailWrapper.style.display = 'none';
                            var mobileShowCardWrapper = document.getElementById(
                                'mobileShowCardWrapper'
                            );
                            mobileShowCardWrapper.appendChild(wrapperDiv);
                            mobileShowCardWrapper.style.display = null; // Disable all the buttons except the ones in this parent.

                            var buttonsToDisable = document.querySelectorAll(
                                '.ac-pushButton'
                            );
                            var inlineExpandedShowCard = document.getElementById(
                                'inlineExpandedShowCard'
                            );
                            Array.prototype.forEach.call(
                                buttonsToDisable,
                                function (button) {
                                    if (
                                        inlineExpandedShowCard &&
                                        !inlineExpandedShowCard.contains(button)
                                    ) {
                                        //check of the button is of openurltype. If yes, change the icon to disabled
                                        if (
                                            button.querySelector(
                                                '#openUrlButton'
                                            )
                                        ) {
                                            var iconOpenUrl = button.querySelector(
                                                '#iconOpenUrl'
                                            );
                                            iconOpenUrl.classList = null;
                                            iconOpenUrl.classList.add(
                                                'ac-openUrlIconDisabled'
                                            );
                                            var openUrlDummyIcon = button.querySelector(
                                                '#iconDummyOpenUrl'
                                            );
                                            openUrlDummyIcon.classList = null;
                                            openUrlDummyIcon.classList.add(
                                                'iconDummyOpenUrlDisabled'
                                            );
                                        }

                                        button.disabled = true;
                                    }
                                }
                            ); //if the showcard has any openurl buttons, make sure that they have the icon

                            this.addOpenUrlIcon(); // added to honor the 'isRequired' flag in show cards

                            this.handleInputValueChanged(
                                this.allInputInstances
                            );
                        }

                        this.clientManagerInstance.executeShowCardAction(
                            action,
                            this.adaptiveCardJson != null,
                            isExpanded
                        );
                    }
                }
            },
            {
                key: 'showMoreActions',
                value: function showMoreActions(moreAction) {
                    var mobileOverlay = document.getElementById(
                        'mobileOverlay'
                    );

                    mobileOverlay.onclick = function () {
                        mobileOverlay.innerHTML = '';
                        mobileOverlay.style.display = null;
                        mobileOverlay.onclick = null;
                    };

                    var moreActionWrapper = document.createElement('div');
                    moreActionWrapper.id = 'moreActionWrapper';
                    moreActionWrapper.classList.add('moreActionWrapper');
                    var moreActionContent = document.createElement('div');
                    moreActionContent.classList.add('moreActionContent');
                    var actions = moreAction.potentialAction;

                    var _loop = function _loop(i) {
                        var titleDiv = document.createElement('div');
                        titleDiv.classList.add('titleDiv');
                        var title = document.createElement('p');
                        title.classList.add('title');
                        title.innerText = actions[i]['title'];

                        title.onclick = function () {
                            if (
                                moreAction['items'][i] instanceof
                                AdaptiveCards.ShowCardAction
                            ) {
                                moreAction['_actionCollection'].showActionCard(
                                    moreAction['items'][i]
                                );
                            } else {
                                moreAction['items'][i].execute();
                            }

                            mobileOverlay.innerHTML = '';
                            mobileOverlay.style.display = null;
                            mobileOverlay.onclick = null;
                        };

                        titleDiv.appendChild(title);
                        moreActionContent.appendChild(titleDiv);
                    };

                    for (var i = 0; i < actions.length; i++) {
                        _loop(i);
                    }

                    moreActionWrapper.appendChild(moreActionContent);
                    mobileOverlay.appendChild(moreActionWrapper);
                    mobileOverlay.style.display = 'block';
                } // Called when user clicks on a action
            },
            {
                key: 'onExecuteAction',
                value: function onExecuteAction(action) {
                    if (this.displayErrorMessage(action)) {
                        return;
                    }

                    if (action.isAutoInvokeAction) {
                        this.showAutoInvokeSpinner();
                    }

                    if (action instanceof MoreAction) {
                        this.showMoreActions(action);
                    }

                    if (
                        action instanceof AdaptiveCards.HttpAction ||
                        action instanceof AdaptiveCards.ShowCardAction
                    ) {
                        // Add inputParameters in action
                        this.addInputParameters(action);
                    }

                    var source = null;

                    if (
                        action.renderedElement != null &&
                        action.renderedElement.type === 'button'
                    ) {
                        source = 'button';

                        if (
                            this.clientManagerInstance.actionButtonsCount == 1
                        ) {
                            action.renderedElement.classList.add('primary');
                        }

                        this.addOpenUrlIcon();
                    } else if (
                        action.parent instanceof AdaptiveCards.TextBlock
                    ) {
                        source = 'inline';
                    } else if (!action.isAutoInvokeAction) {
                        source = 'selectAction';
                    }

                    if (this.adaptiveCardJson != null) {
                        // If previous action executing then return
                        if (this.previousActionExecuting) {
                            return;
                        } // If action is More Action just store previous action, dont mark it as executing

                        if (
                            this.clientManagerInstance.MoreActionClass &&
                            action instanceof
                            this.clientManagerInstance.MoreActionClass
                        ) {
                            this.previousAction = action;
                        } else if (this.actionNeedsSpinner(action)) {
                            this.previousActionExecuting = true;
                            this.previousAction = action;
                        }
                    } // If card is of adaptiveCard type and if action is
                    // of HttpAction or native actions then need to show spinner status

                    if (
                        this.adaptiveCardJson != null &&
                        this.actionNeedsSpinner(action)
                    ) {
                        // If executed action is via button
                        if (
                            action.renderedElement != null &&
                            action.renderedElement.type === 'button'
                        ) {
                            for (
                                var i = 0;
                                i < action.renderedElement.children.length;
                                i++
                            ) {
                                action.renderedElement.children[
                                    i
                                ].style.display = 'none';
                            }

                            var iconElement = document.createElement('div');
                            iconElement.className = 'ac-spinner';
                            action.renderedElement.appendChild(iconElement);
                            action.renderedElement.setAttribute(
                                'aria-live',
                                'assertive'
                            );
                            action.renderedElement.setAttribute(
                                'aria-label',
                                'loading'
                            );
                            action.renderedElement.setAttribute(
                                'aria-relevant',
                                'additions'
                            );
                        } // Else if action is a select action/inline action
                        else if (
                            action.parent instanceof AdaptiveCards.TextBlock ||
                            action.parent instanceof AdaptiveCards.Image ||
                            action.parent instanceof AdaptiveCards.ColumnSet ||
                            action.parent instanceof AdaptiveCards.Column ||
                            action.parent instanceof AdaptiveCards.Container
                        ) {
                            //Create a overlay element and show spinner
                            var compoundElement = document.createElement('div');
                            compoundElement.className = 'ac-overlayDiv';
                            compoundElement.style.width = '16px';
                            compoundElement.style.height = '16px';
                            compoundElement.style.position = 'absolute';
                            compoundElement.style.margin = 'auto';
                            compoundElement.style.left = '0px';
                            compoundElement.style.right = '0px';
                            compoundElement.style.top = '0px';
                            compoundElement.style.bottom = '0px';
                            var spinnerElement = document.createElement('div');
                            spinnerElement.className = 'ac-spinner';
                            spinnerElement.classList.add('ac-inline-spinner');
                            spinnerElement.style.width = '16px';
                            spinnerElement.style.height = '16px';
                            compoundElement.appendChild(spinnerElement);
                            var baseElement = action.parent.renderedElement;

                            if (action.parent instanceof AdaptiveCards.Image) {
                                baseElement =
                                    action.parent.renderedElement.children[0];
                            } // Set the opacity of all childNodes as 0.25

                            var nodes = baseElement.childNodes;

                            for (var i = 0; i < nodes.length; i++) {
                                if (nodes[i].style)
                                    nodes[i].style.opacity = 0.25;
                            }

                            baseElement.appendChild(compoundElement);
                            baseElement.style.position = 'relative';
                        }
                    }

                    this.clientManagerInstance.executeAction(
                        action,
                        this.adaptiveCardJson != null,
                        source
                    );
                } // Add inputParameters in action
            },
            {
                key: 'addInputParameters',
                value: function addInputParameters(action) {
                    var map = {}; // Use inputParameters from parent

                    if (this.context) {
                        var inputParameters = this.context['inputParameters'];

                        if (inputParameters) {
                            for (
                                var _i = 0;
                                _i < inputParameters.length;
                                _i++
                            ) {
                                map[inputParameters[_i]['id']] =
                                    inputParameters[_i]['value'];
                            }
                        }
                    }

                    var inputs = this.adaptiveCardInstance.getAllInputs();

                    if (inputs) {
                        for (var i = 0; i < inputs.length; i++) {
                            var value = null;

                            if (inputs[i].value != null) {
                                value = inputs[i].actualValue
                                    ? inputs[i].actualValue
                                    : inputs[i].value;
                                var validationErrors = inputs[i].validate
                                    ? inputs[i].validate()
                                    : null;
                                var preparedInput = {
                                    id: inputs[i].id,
                                    value: value
                                };

                                if (
                                    validationErrors &&
                                    validationErrors.length > 0
                                ) {
                                    preparedInput[
                                        'validationErrors'
                                    ] = validationErrors;
                                }

                                map[preparedInput['id']] =
                                    preparedInput['value'];
                            }
                        }
                    }

                    action.data = [];

                    for (var key in map) {
                        action.data.push({
                            id: key,
                            value: map[key]
                        });
                    }
                } // Callback function for parsing element
            },
            {
                key: 'onParseElement',
                value: function onParseElement(element, json) {
                    var _this4 = this;

                    try {
                        if (
                            typeof json[this.constants.IsVisible] === 'boolean'
                        ) {
                            element.isVisible = json[this.constants.IsVisible];
                        }

                        var elementType = element.getJsonTypeName();

                        if (elementType === 'Image') {
                            element.backgroundColor =
                                json[this.constants.BackgroundColor];
                            json[
                                this.constants.Url
                            ] = this.UtilsClass.getImageProxyUrl(
                                json[this.constants.Url],
                                this.clientManagerInstance.supportImageProxy,
                                this.clientManagerInstance
                                    .imageAttachmentBaseUrl
                            );
                        }

                        if (elementType === 'BackgroundImage') {
                            json[
                                this.constants.Url
                            ] = this.UtilsClass.getImageProxyUrl(
                                json[this.constants.Url],
                                this.clientManagerInstance.supportImageProxy,
                                this.clientManagerInstance
                                    .imageAttachmentBaseUrl
                            );
                        }

                        if (element instanceof AdaptiveCards.Input) {
                            element.isRequired =
                                json[this.constants.IsRequiredProperty] ||
                                false;

                            element.onValueChanged = function (input) {
                                _this4.onInputValueChanged(input);
                            };
                        }

                        if (element instanceof AdaptiveCards.DateInput) {
                            element.placeholder =
                                json[this.constants.PlaceHolderProperty];
                        }

                        if (element instanceof AdaptiveCards.ChoiceSetInput) {
                            element.choiceList =
                                json[this.constants.ChoicesProperty];
                        }

                        if (
                            element instanceof AdaptiveCards.Container ||
                            element instanceof AdaptiveCards.ColumnSet
                        ) {
                            var jsonPadding = json[this.constants.Padding];

                            if (jsonPadding) {
                                if (typeof jsonPadding === 'string') {
                                    var uniformPadding = AdaptiveCards.getEnumValueOrDefault(
                                        AdaptiveCards.Spacing,
                                        jsonPadding,
                                        AdaptiveCards.Spacing.None
                                    );
                                    element.padding = new AdaptiveCards.PaddingDefinition(
                                        uniformPadding,
                                        uniformPadding,
                                        uniformPadding,
                                        uniformPadding
                                    );
                                } else if (_typeof(jsonPadding) === 'object') {
                                    element.padding = new AdaptiveCards.PaddingDefinition(
                                        AdaptiveCards.getEnumValueOrDefault(
                                            AdaptiveCards.Spacing,
                                            jsonPadding[this.constants.Top],
                                            AdaptiveCards.Spacing.None
                                        ),
                                        AdaptiveCards.getEnumValueOrDefault(
                                            AdaptiveCards.Spacing,
                                            jsonPadding[this.constants.Right],
                                            AdaptiveCards.Spacing.None
                                        ),
                                        AdaptiveCards.getEnumValueOrDefault(
                                            AdaptiveCards.Spacing,
                                            jsonPadding[this.constants.Bottom],
                                            AdaptiveCards.Spacing.None
                                        ),
                                        AdaptiveCards.getEnumValueOrDefault(
                                            AdaptiveCards.Spacing,
                                            jsonPadding[this.constants.Left],
                                            AdaptiveCards.Spacing.None
                                        )
                                    );
                                }
                            }
                        }

                        if (
                            (element instanceof
                                AdaptiveCards.ContainerWithActions ||
                                element instanceof AdaptiveCards.ActionSet) &&
                            this.clientManagerInstance.supportMoreAction ===
                            true
                        ) {
                            var actions = json[this.constants.ActionsProperty];
                            var length = actions.length;

                            if (
                                actions.length > 2 &&
                                actions[actions.length - 1].type !==
                                'Action.More'
                            ) {
                                var removedActions = actions.splice(1);
                                var moreAction = {
                                    type: 'Action.More',
                                    title: length - 1 + ' More Actions',
                                    actions: removedActions
                                };
                                actions.push(moreAction);
                                json[this.constants.ActionsProperty] = actions;
                            }
                        }
                    } catch (e) {
                        this.clientManagerInstance.logException(e);
                    }
                } // Callback function for parsing action
            },
            {
                key: 'onParseAction',
                value: function onParseAction(action, json) {
                    try {
                        if (action instanceof AdaptiveCards.OpenUrlAction) {
                            this.openUrlList.push(action);
                        }

                        action.potentialAction = json;
                        action.isAutoInvokeAction = false;
                        action.hideCardOnInvoke =
                            json[this.constants.HideCardOnInvokeProperty] ||
                            false;
                        action.isPrimary =
                            json[this.constants.IsPrimaryAction] || false; // json[this.constants.TitleProperty] = json[this.constants.TitleProperty].toLowerCase();

                        if (action instanceof AdaptiveCards.HttpAction) {
                            this.httpActionList.push(action);
                            this.adaptiveCardInstance.isHttpPostActionAvailable = true;
                        }
                    } catch (e) {
                        this.clientManagerInstance.logException(e);
                    }
                } // Called when input value changes
            },
            {
                key: 'onInputValueChanged',
                value: function onInputValueChanged(input) {
                    if (input.placeHolderElement) {
                        input.placeHolderElement.style.display = input.value
                            ? 'block'
                            : 'none';
                    }

                    if (input.isRequired === false) {
                        return;
                    }

                    this.handleInputValueChanged(this.allInputInstances);
                }
            },
            {
                key: 'handleInputValueChanged',
                value: function handleInputValueChanged(inputs) {
                    this.logTimeStamp('handleInputValueChanged-start'); // iterate over the httpActionList

                    for (var actionIndex in this.httpActionList) {
                        var action = this.httpActionList[actionIndex];

                        if (!action.renderedElement) {
                            continue;
                        }

                        var inputIds = action.inputIds;
                        var requiredInputFilled = true; //iterate over all the inputIds for httpAction

                        for (var idIndex in inputIds) {
                            var value = null;
                            var input = null; //Search input id in inputs list

                            for (var inputIndex in inputs) {
                                if (
                                    inputIds[idIndex] === inputs[inputIndex].id
                                ) {
                                    input = inputs[inputIndex];
                                    value = inputs[inputIndex].value;
                                    break;
                                }
                            }

                            if (input === null) {
                                continue;
                            }

                            if (input.isRequired === false) {
                                continue;
                            } // If input is required and value is null/empty disable button

                            if (
                                input.isRequired === true &&
                                this.StringIsNullOrEmpty(value)
                            ) {
                                requiredInputFilled = false;
                                break;
                            }
                        }

                        if (requiredInputFilled === false) {
                            action.renderedElement.disabled = true;
                        } else {
                            //if its a required input and its filled, enable associcated action if we don't have any showcard (i.e. we are in the main card)
                            //if there is a showcard, then only enable the action if its child of showcard
                            var inlineExpandedShowCard = document.getElementById(
                                'inlineExpandedShowCard'
                            ); // if client is not mac, we don't check for these things. Just do what we were doing before.

                            action.renderedElement.disabled = false;
                        }
                    }

                    this.logTimeStamp('handleInputValueChanged-end');
                } // Callback function for anchor click
            },
            {
                key: 'onAnchorClicked',
                value: function onAnchorClicked(element, anchor) {
                    var anchorHref = anchor[this.constants.Href] || '';

                    if (anchorHref.toLowerCase().indexOf('action:') === 0) {
                        /* inline actions triggered */
                        var actionId = anchorHref.split(':')[1];
                        var inlineAction = this.findInlineActionById(
                            actionId,
                            element
                        );

                        if (inlineAction == null) {
                            // Todo : log inline action look up failure
                            return false;
                        }

                        inlineAction.execute();
                        return true;
                    }
                } // Find action by id
            },
            {
                key: 'findInlineActionById',
                value: function findInlineActionById(actionId, element) {
                    var inlineAction = null;

                    if (actionId === undefined || actionId === null) {
                        return inlineAction;
                    }

                    var resources = this.adaptiveCardJson[
                        this.constants.Resources
                    ];

                    if (resources === null) {
                        return inlineAction;
                    }

                    var inlineActions =
                        resources[this.constants.ActionsProperty];

                    if (inlineActions == null) {
                        return inlineAction;
                    }

                    for (var i = 0; i < inlineActions.length; i++) {
                        if (inlineActions[i]['id'] === actionId) {
                            var inlineActionJson = inlineActions[i];
                            inlineAction = this.createInstance(
                                inlineActionJson['type'],
                                element
                            );

                            if (inlineAction) {
                                inlineAction.parse(inlineActionJson);
                            }

                            break;
                        }
                    }

                    return inlineAction;
                } // Set the visibility of the card
            },
            {
                key: 'setCardVisible',
                value: function setCardVisible(isVisible) {
                    if (isVisible === false) {
                        this.clientManagerInstance.setComponentVisibility(
                            false,
                            /* showCard */
                            false,
                            /*showBodyToggler */
                            true,
                            /*showOriginalBody */
                            false
                            /*constraintWidth*/
                        );
                    } else {
                        this.clientManagerInstance.setComponentVisibility(
                            true,
                            /* showCard */
                            this.adaptiveCardInstance.enableBodyToggling,
                            /*showBodyToggler */
                            !this.adaptiveCardInstance.hideOriginalBody,
                            /*showOriginalBody */
                            this.adaptiveCardInstance.isConstrainWidth
                            /*constraintWidth*/
                        );
                    }
                }
            },
            {
                key: 'showMoreActionWorkingStatus',
                value: function showMoreActionWorkingStatus() {
                    if (this.adaptiveCardJson != null) {
                        if (this.previousAction) {
                            this.previousActionExecuting = true;
                        }

                        for (
                            var i = 0;
                            i <
                            this.previousAction.renderedElement.children.length;
                            i++
                        ) {
                            this.previousAction.renderedElement.children[
                                i
                            ].style.display = 'none';
                        }

                        var iconElement = document.createElement('div');
                        iconElement.className = 'ac-spinner';
                        this.previousAction.renderedElement.appendChild(
                            iconElement
                        );
                    }
                }
            },
            {
                key: 'updateActionStatus',
                value: function updateActionStatus() {
                    // Clear previous action
                    if (this.previousAction != null) {
                        // If previous action is clicked via button
                        if (
                            this.previousAction.renderedElement != null &&
                            this.previousAction.renderedElement.type ===
                            'button'
                        ) {
                            this.previousAction.renderedElement.setAttribute(
                                'aria-label',
                                this.previousAction.title
                            );
                            var imgElements = this.previousAction.renderedElement.getElementsByClassName(
                                'ac-spinner'
                            );

                            if (imgElements.length > 0) {
                                this.previousAction.renderedElement.removeChild(
                                    imgElements[0]
                                );
                            }

                            for (
                                var i = 0;
                                i <
                                this.previousAction.renderedElement.children
                                    .length;
                                i++
                            ) {
                                this.previousAction.renderedElement.children[
                                    i
                                ].style.display = 'block';
                            }
                        } else if (
                            this.previousAction.parent instanceof
                            AdaptiveCards.TextBlock ||
                            this.previousAction.parent instanceof
                            AdaptiveCards.Image ||
                            this.previousAction.parent instanceof
                            AdaptiveCards.ColumnSet ||
                            this.previousAction.parent instanceof
                            AdaptiveCards.Column ||
                            this.previousAction.parent instanceof
                            AdaptiveCards.Container
                        ) {
                            var overlayElements = this.previousAction.parent.renderedElement.getElementsByClassName(
                                'ac-overlayDiv'
                            );

                            if (overlayElements.length > 0) {
                                var parentNode = overlayElements[0].parentNode;
                                parentNode.removeChild(overlayElements[0]); // Change the opacity of all child Nodes

                                var nodes = parentNode.childNodes;

                                for (var i = 0; i < nodes.length; i++) {
                                    if (nodes[i].style)
                                        nodes[i].style.opacity = 1;
                                }
                            }
                        } // Check to see if we need to collapse already expanded showCard dialog

                        this.CollapseExpandedShowCardDialog();
                    }

                    this.previousActionExecuting = false;
                } // actionResponseJson =
                //    {
                //      isAutoInvokeAction : indicates whether action is AutoInvoke,
                //      hasSucceeeded : indicates whether action execution succeeeded,
                //      responseSerialized: response from the server,
                //      actionId: action Id
                //    }
            },
            {
                key: 'processMessageCardActionResponse',
                value: function processMessageCardActionResponse(
                    rawActionResponseJson
                ) {
                    // var actionResponseJson = this.clientManagerInstance.processData(rawActionResponseJson);
                    var actionResponseJson = JSON.parse(rawActionResponseJson);

                    if (
                        actionResponseJson[
                        this.constants.IsAutoInvokeAction
                        ] === true
                    ) {
                        this.processMessageCardAutoInvokeActionResponse(
                            actionResponseJson
                        );
                    } else {
                        this.processMessageCardHttpActionResponse(
                            actionResponseJson
                        );
                    }
                } // process Non Auto Action Response for MessageCard
            },
            {
                key: 'processMessageCardHttpActionResponse',
                value: function processMessageCardHttpActionResponse(
                    actionResponseJson
                ) {
                    try {
                        try {
                            var showGenericError = false;
                            var actionId =
                                actionResponseJson[this.constants.ActionId];

                            if (
                                this.isJsonString(
                                    actionResponseJson[
                                    this.constants.ResponseSerialized
                                    ]
                                )
                            ) {
                                var responseJson = JSON.parse(
                                    actionResponseJson[
                                    this.constants.ResponseSerialized
                                    ]
                                );

                                if (
                                    responseJson[
                                    this.constants.RemoveCardProperty
                                    ] === true
                                ) {
                                    this.setCardVisible(false);
                                    this.clientManagerInstance.updateExplicitMessageCardProperty(); // Log event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.MessageCardRemoved
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.HideCardProperty
                                    ] === true
                                ) {
                                    this.setCardVisible(false); // Log event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.MessageCardHidden
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.InnerErrorCodeProperty
                                    ] != null &&
                                    responseJson[
                                    this.constants.InnerErrorCodeProperty
                                    ] ===
                                    this.constants
                                        .ConnectedAccountNotErrorString
                                ) {
                                    var displayText =
                                        responseJson[
                                        this.constants
                                            .DisplayMessageProperty
                                        ] +
                                        this.PleaseLoginStatusMessage +
                                        responseJson[
                                        this.constants.AuthenticationUrl
                                        ] +
                                        ')';
                                    this.showStatusMessage(
                                        actionId,
                                        this.getStatusMessageJson(displayText),
                                        this.adaptiveCardInstance,
                                        true
                                    ); // Log ConsentShown event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.ConsentPromptDisplayed
                                    );
                                    this.errorMessageActionId = actionId;
                                } else if (
                                    !this.StringIsNullOrEmpty(
                                        responseJson[
                                        this.constants
                                            .RefreshCardSerializedProperty
                                        ]
                                    )
                                ) {
                                    this.handleRefreshCard(
                                        responseJson[
                                        this.constants
                                            .RefreshCardSerializedProperty
                                        ]
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.ShowOriginalCardProperty
                                    ] === true
                                ) {
                                    this.renderAsHtml(
                                        this.getRenderedAdaptiveCard()
                                    );
                                    this.setCardVisible(true);
                                } else if (
                                    responseJson[
                                    this.constants.DisplayMessageProperty
                                    ] != null
                                ) {
                                    var statusMessageJson = null;

                                    if (
                                        responseJson[
                                        this.constants
                                            .InnerErrorCodeProperty
                                        ]
                                    ) {
                                        statusMessageJson = this.getStatusMessageJson(
                                            responseJson[
                                            this.constants
                                                .DisplayMessageProperty
                                            ],
                                            this.clientManagerInstance
                                                .errorStatusImageUrl
                                        );
                                    } else {
                                        statusMessageJson = this.getStatusMessageJson(
                                            responseJson[
                                            this.constants
                                                .DisplayMessageProperty
                                            ],
                                            this.clientManagerInstance
                                                .successStatusImageUrl
                                        );
                                    }

                                    this.showStatusMessage(
                                        actionId,
                                        statusMessageJson,
                                        this.adaptiveCardInstance,
                                        true
                                    );
                                }
                            } else {
                                showGenericError = true;
                            }
                        } catch (e) {
                            console.log(e.message);
                            console.log(e.stack);
                            showGenericError = true;
                            this.clientManagerInstance.logException(e);
                        }

                        if (showGenericError === true && actionId != null) {
                            this.showStatusMessage(
                                actionId,
                                this.getStatusMessageJson(
                                    this.ActionFailureStatusMessage,
                                    this.clientManagerInstance
                                        .errorStatusImageUrl
                                ),
                                this.adaptiveCardInstance,
                                true
                            );
                        }
                    } catch (e) {
                        console.log(e.message);
                        console.log(e.stack);
                        this.clientManagerInstance.logException(e);
                    }
                } // Process Auto Invoke Action Response
            },
            {
                key: 'processMessageCardAutoInvokeActionResponse',
                value: function processMessageCardAutoInvokeActionResponse(
                    actionResponseJson
                ) {
                    try {
                        var showCardOnFailure = true;

                        if (
                            this.messageCardJson[
                            this.constants.AutoInvokeOptions
                            ] != undefined &&
                            this.messageCardJson[
                            this.constants.AutoInvokeOptions
                            ][this.constants.ShowCardOnFailure] != undefined
                        ) {
                            showCardOnFailure = this.messageCardJson[
                                this.constants.AutoInvokeOptions
                            ][this.constants.ShowCardOnFailure];
                        }

                        if (
                            this.isJsonString(
                                actionResponseJson[
                                this.constants.ResponseSerialized
                                ]
                            )
                        ) {
                            var responseJson = JSON.parse(
                                actionResponseJson[
                                this.constants.ResponseSerialized
                                ]
                            );

                            if (
                                !responseJson[
                                this.constants.InnerErrorCodeProperty
                                ] &&
                                !responseJson[this.constants.AuthenticationUrl]
                            ) {
                                if (
                                    responseJson[
                                    this.constants.RemoveCardProperty
                                    ] === true
                                ) {
                                    this.setCardVisible(false);
                                    this.clientManagerInstance.updateExplicitMessageCardProperty(); // Log messageCard Removed event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.MessageCardRemoved
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.HideCardProperty
                                    ] === true
                                ) {
                                    this.setCardVisible(false); // Log messageCard Hidden event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.MessageCardHidden
                                    );
                                } else if (
                                    !this.StringIsNullOrEmpty(
                                        responseJson[
                                        this.constants
                                            .RefreshCardSerializedProperty
                                        ]
                                    )
                                ) {
                                    this.handleRefreshCard(
                                        responseJson[
                                        this.constants
                                            .RefreshCardSerializedProperty
                                        ]
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.ShowOriginalCardProperty
                                    ] === true
                                ) {
                                    this.renderAsHtml(
                                        this.getRenderedAdaptiveCard()
                                    );
                                    this.setCardVisible(true);
                                } else if (
                                    responseJson[
                                    this.constants.ShowOriginalCardProperty
                                    ] === false
                                ) {
                                    this.setCardVisible(false);
                                }
                            } else {
                                this.setCardVisible(showCardOnFailure);
                            }
                        } else {
                            this.setCardVisible(showCardOnFailure);
                        }
                    } catch (e) {
                        console.log(e.message);
                        console.log(e.stack);
                        this.setCardVisible(false);
                        this.clientManagerInstance.logException(e);
                    }
                } // actionResponseJson =
                //    {
                //      isAutoInvokeAction : indicates whether action is AutoInvoke,
                //      hasSucceeeded : indicates whether action execution succeeeded,
                //      responseSerialized: response from the server,
                //    }
            },
            {
                key: 'processAdaptiveCardActionResponse',
                value: function processAdaptiveCardActionResponse(
                    rawActionResponseJson
                ) {
                    var errorMessage =
                        arguments.length > 1 && arguments[1] !== undefined
                            ? arguments[1]
                            : null;
                    this.updateActionStatus(); // var actionResponseJson = this.clientManagerInstance.processData(rawActionResponseJson);

                    var actionResponseJson = JSON.parse(rawActionResponseJson);
                    this.hasCardUpdates = false;

                    if (
                        actionResponseJson[
                        this.constants.IsAutoInvokeAction
                        ] === true
                    ) {
                        this.processAdaptiveCardAutoInvokeActionResponse(
                            actionResponseJson
                        );
                    } else {
                        this.processAdaptiveCardHttpActionResponse(
                            actionResponseJson,
                            errorMessage
                        );
                    }
                } // process Http Action Response for AdaptiveCard
            },
            {
                key: 'processAdaptiveCardHttpActionResponse',
                value: function processAdaptiveCardHttpActionResponse(
                    actionResponseJson
                ) {
                    var errorMessage =
                        arguments.length > 1 && arguments[1] !== undefined
                            ? arguments[1]
                            : null;

                    try {
                        try {
                            var showGenericError = false;

                            if (
                                this.isJsonString(
                                    actionResponseJson[
                                    this.constants.ResponseSerialized
                                    ]
                                )
                            ) {
                                var responseJson = JSON.parse(
                                    actionResponseJson[
                                    this.constants.ResponseSerialized
                                    ]
                                );

                                if (
                                    (CLIENT === 'iOS' || CLIENT === 'mac') &&
                                    responseJson['cardUpdates'] &&
                                    responseJson['cardUpdates'].length
                                ) {
                                    this.hasCardUpdates = true;
                                    actionResponseJson['noScrollToTop'] = true;
                                }

                                if (
                                    responseJson[
                                    this.constants.RemoveCardProperty
                                    ] === true
                                ) {
                                    this.setCardVisible(false);
                                    this.clientManagerInstance.updateExplicitMessageCardProperty(); // Log CardRemoved event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.MessageCardRemoved
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.HideCardProperty
                                    ] === true
                                ) {
                                    this.setCardVisible(false);
                                    this.clientManagerInstance.notifyRefreshCardResponse(
                                        JSON.stringify(actionResponseJson)
                                    ); // Log CardHidden event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.MessageCardHidden
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.InnerErrorCodeProperty
                                    ] != null &&
                                    responseJson[
                                    this.constants.InnerErrorCodeProperty
                                    ] ===
                                    this.constants
                                        .ConnectedAccountNotErrorString
                                ) {
                                    this.clientManagerInstance.displayLoginMessage(
                                        responseJson[
                                        this.constants
                                            .DisplayMessageProperty
                                        ],
                                        this.PleaseLoginContinueMessage,
                                        this.OutlookBaseUrl +
                                        responseJson[
                                        this.constants.AuthenticationUrl
                                        ]
                                    ); // Log ConsentShown event

                                    this.clientManagerInstance.logEventTelemetry(
                                        this.constants.ConsentPromptDisplayed
                                    );
                                } else if (
                                    !this.StringIsNullOrEmpty(
                                        responseJson[
                                        this.constants
                                            .RefreshCardSerializedProperty
                                        ]
                                    )
                                ) {
                                    this.clientManagerInstance.notifyRefreshCardResponse(
                                        JSON.stringify(actionResponseJson)
                                    );
                                    this.handleRefreshCard(
                                        responseJson[
                                        this.constants
                                            .RefreshCardSerializedProperty
                                        ]
                                    );
                                } else if (
                                    responseJson[
                                    this.constants.ShowOriginalCardProperty
                                    ] === true
                                ) {
                                    this.renderAsHtml(
                                        this.getRenderedAdaptiveCard()
                                    );
                                    this.setCardVisible(true);
                                } else if (
                                    responseJson[
                                    this.constants.DisplayMessageProperty
                                    ] != null
                                ) {
                                    if (
                                        responseJson[
                                        this.constants
                                            .InnerErrorCodeProperty
                                        ] ||
                                        responseJson[
                                        this.constants.StatusProperty
                                        ] === 'Failed'
                                    ) {
                                        this.clientManagerInstance.displaySnackMessage(
                                            responseJson[
                                            this.constants
                                                .DisplayMessageProperty
                                            ],
                                            false
                                        );
                                    } else {
                                        this.clientManagerInstance.displaySnackMessage(
                                            responseJson[
                                            this.constants
                                                .DisplayMessageProperty
                                            ],
                                            true
                                        );
                                    }
                                }
                            } else if (errorMessage) {
                                this.clientManagerInstance.displaySnackMessage(
                                    errorMessage,
                                    false
                                );
                            } else {
                                showGenericError = true;
                            }
                        } catch (e) {
                            console.log(e.message);
                            console.log(e.stack);
                            showGenericError = true;
                            this.clientManagerInstance.logException(e);
                        }

                        if (showGenericError === true) {
                            this.clientManagerInstance.displaySnackMessage(
                                this.ACFailureStatusMessage,
                                false
                            );
                        }
                    } catch (e) {
                        console.log(e.message);
                        console.log(e.stack);
                        this.clientManagerInstance.logException(e);
                    }
                } // Process Auto Invoke Action Response
            },
            {
                key: 'processAdaptiveCardAutoInvokeActionResponse',
                value: function processAdaptiveCardAutoInvokeActionResponse(
                    actionResponseJson
                ) {
                    // discard the auto-invoke processing if spinner is not getting shown
                    // it is assumed that it must have been stopped due to a timeout
                    // otherwise this is the only place from where it should stop
                    if (this.isAutoInvokeSpinnerVisible === false) {
                        return;
                    }

                    try {
                        this.currentAction = this.constants.FinalCardProcessing;
                        var showCardOnFailure = true;

                        if (
                            this.adaptiveCardInstance.autoInvokeOptions !=
                            undefined &&
                            this.adaptiveCardInstance.autoInvokeOptions[
                            this.constants.ShowCardOnFailure
                            ] != undefined
                        ) {
                            showCardOnFailure = this.adaptiveCardInstance
                                .autoInvokeOptions[
                                this.constants.ShowCardOnFailure
                            ];
                        }

                        if (
                            this.isJsonString(
                                actionResponseJson[
                                this.constants.ResponseSerialized
                                ]
                            )
                        ) {
                            var responseJson = JSON.parse(
                                actionResponseJson[
                                this.constants.ResponseSerialized
                                ]
                            );

                            if (
                                (CLIENT === 'iOS' || CLIENT === 'mac') &&
                                responseJson['cardUpdates'] &&
                                responseJson['cardUpdates'].length
                            ) {
                                this.hasCardUpdates = true;
                                actionResponseJson['noScrollToTop'] = true;
                            }

                            if (
                                responseJson[
                                this.constants.RemoveCardProperty
                                ] === true
                            ) {
                                this.setCardVisible(false);
                                this.clientManagerInstance.updateExplicitMessageCardProperty(); // Log adaptiveCard Removed event

                                this.clientManagerInstance.logEventTelemetry(
                                    this.constants.MessageCardRemoved
                                );
                                this.clientManagerInstance.logFinalCardProcessingEnd();
                                this.clientManagerInstance.logFinalCardRenderingEnd();
                                this.currentAction = '';
                            } else if (
                                responseJson[
                                this.constants.HideCardProperty
                                ] === true
                            ) {
                                this.setCardVisible(false); // Log adaptiveCard Hidden event

                                this.clientManagerInstance.logEventTelemetry(
                                    this.constants.MessageCardHidden
                                );
                                this.clientManagerInstance.logFinalCardProcessingEnd();
                                this.clientManagerInstance.logFinalCardRenderingEnd();
                                this.currentAction = '';
                            } else if (
                                !this.StringIsNullOrEmpty(
                                    responseJson[
                                    this.constants
                                        .RefreshCardSerializedProperty
                                    ]
                                )
                            ) {
                                this.handleRefreshCard(
                                    responseJson[
                                    this.constants
                                        .RefreshCardSerializedProperty
                                    ]
                                );
                            } else if (
                                responseJson[
                                this.constants.ShowOriginalCardProperty
                                ] === true
                            ) {
                                this.clientManagerInstance.logFinalCardProcessingEnd();
                                this.currentAction = this.constants.FinalCardRendering;
                                this.renderAsHtml(
                                    this.getRenderedAdaptiveCard()
                                );
                                this.setCardVisible(true);
                            } else if (
                                responseJson[this.constants.StatusProperty] ===
                                'Failed' ||
                                responseJson[
                                this.constants.InnerErrorCodeProperty
                                ]
                            ) {
                                this.setCardVisible(showCardOnFailure);
                                this.clientManagerInstance.logFinalCardProcessingEnd();
                                this.clientManagerInstance.logFinalCardRenderingEnd();
                                this.currentAction = '';
                            }
                        } else {
                            this.setCardVisible(showCardOnFailure);
                            this.clientManagerInstance.logFinalCardProcessingEnd();
                            this.clientManagerInstance.logFinalCardRenderingEnd();
                            this.currentAction = '';
                        }
                    } catch (e) {
                        console.log(e.message);
                        console.log(e.stack);
                        this.setCardVisible(false);
                        this.clientManagerInstance.logException(e);
                        this.clientManagerInstance.logFinalCardProcessingEnd();
                        this.clientManagerInstance.logFinalCardRenderingEnd();
                        this.currentAction = '';
                    }

                    this.hideAutoInvokeSpinner();
                }
            },
            {
                key: 'handleRefreshCard',
                value: function handleRefreshCard(refreshCardSerializedString) {
                    var refreshCardJson = JSON.parse(
                        refreshCardSerializedString
                    );

                    if (refreshCardJson['type'] === 'AdaptiveCard') {
                        this.adaptiveCardJson = refreshCardJson;
                        this.generateAdaptiveCardInstance(true);
                    } else if (refreshCardJson['@type'] === 'MessageCard') {
                        this.messageCardJson = refreshCardJson;
                        this.allPerformedActions = [];
                        this.convertToAdaptiveCardInstance(true);
                    }

                    {
                        this.clientManagerInstance.notifyHeightChange();
                    }
                } // returns status Json (for swift card)
            },
            {
                key: 'getStatusMessageJson',
                value: function getStatusMessageJson(text, imageUrl) {
                    var statusJson = null;

                    if (imageUrl) {
                        statusJson = {
                            $schema:
                                'http://adaptivecards.io/schemas/adaptive-card.json',
                            type: 'AdaptiveCard',
                            padding: {
                                top: 'large',
                                right: 'default',
                                bottom: 'large',
                                left: 'default'
                            },
                            version: '1.0',
                            style: 'emphasis',
                            body: [
                                {
                                    type: 'ColumnSet',
                                    columns: [
                                        {
                                            type: 'Column',
                                            width: 'stretch',
                                            items: [
                                                {
                                                    type: 'TextBlock',
                                                    text: text,
                                                    size: 'default',
                                                    spacing: 'small',
                                                    color: 'good',
                                                    wrap: true
                                                }
                                            ]
                                        },
                                        {
                                            type: 'Column',
                                            width: 'auto',
                                            items: [
                                                {
                                                    type: 'Image',
                                                    url: imageUrl,
                                                    pixelWidth: 18
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        };
                    } else {
                        statusJson = {
                            $schema:
                                'http://adaptivecards.io/schemas/adaptive-card.json',
                            type: 'AdaptiveCard',
                            padding: {
                                top: 'large',
                                right: 'default',
                                bottom: 'large',
                                left: 'default'
                            },
                            version: '1.0',
                            style: 'emphasis',
                            body: [
                                {
                                    type: 'TextBlock',
                                    text: text,
                                    size: 'default',
                                    spacing: 'small',
                                    color: 'good',
                                    wrap: true
                                }
                            ]
                        };
                    }

                    return statusJson;
                } // Hide previous error Message actionId (for swift Card)
            },
            {
                key: 'hideCardStatusMessage',
                value: function hideCardStatusMessage() {
                    if (this.errorMessageActionId != null) {
                        this.showStatusMessage(
                            this.errorMessageActionId,
                            null,
                            this.adaptiveCardInstance,
                            true
                        );
                    }
                } // show working status message (for swift card)
            },
            {
                key: 'showWorkingStatusMessage',
                value: function showWorkingStatusMessage(actionId) {
                    if (actionId != null) {
                        this.showStatusMessage(
                            actionId,
                            this.getStatusMessageJson(
                                this.WorkingStatusMessage,
                                this.clientManagerInstance.spinnerUrl
                            ),
                            this.adaptiveCardInstance,
                            true
                        );
                    }
                } // Checks if a string is Json string or not
            },
            {
                key: 'isJsonString',
                value: function isJsonString(str) {
                    try {
                        JSON.parse(str);
                    } catch (e) {
                        return false;
                    }

                    return true;
                } // Log time stamp
            },
            {
                key: 'logTimeStamp',
                value: function logTimeStamp(activityName) {
                    var time = performance.now();

                    if (this.clientManagerInstance != null) {
                        this.clientManagerInstance.logTimeStamp(
                            activityName,
                            time
                        );
                    }
                } // Get Adaptive Card converted HTML
            },
            {
                key: 'getRenderedAdaptiveCard',
                value: function getRenderedAdaptiveCard() {
                    if (this.adaptiveCardInstance == null) {
                        return null;
                    }

                    this.logTimeStamp('renderHTML-start');
                    var renderedCard = this.adaptiveCardInstance.render();

                    if (renderedCard) {
                        var headings = renderedCard.querySelectorAll(
                            'h1, h2, h3, h4, h5, h6'
                        );
                        Array.prototype.forEach.call(headings, function (
                            heading
                        ) {
                            heading.style.lineHeight = 1.33;
                        }); // Check if clientManager has `actionButtonsCount` to ensure this logic only on mobile only

                        if (
                            this.clientManagerInstance.actionButtonsCount !=
                            undefined
                        ) {
                            var buttons = renderedCard.querySelectorAll(
                                '.ac-pushButton'
                            );
                            this.clientManagerInstance.actionButtonsCount =
                                buttons.length;

                            if (buttons.length == 1) {
                                var button = buttons[0];
                                button.classList.add('primary');
                            }
                        }
                    }

                    this.logTimeStamp('renderHTML-end');
                    return renderedCard;
                }
            },
            {
                key: 'actionNeedsSpinner',
                value: function actionNeedsSpinner(action) {
                    return false;
                } // Create instance of type
            },
            {
                key: 'createInstance',
                value: function createInstance(typeName, parent) {
                    var element = AdaptiveCards.AdaptiveCard.actionTypeRegistry.createInstance(
                        typeName
                    );

                    if (element) {
                        element.setParent(parent);
                    }

                    return element;
                } // Helper function to check if string is empty of null
            },
            {
                key: 'StringIsNullOrEmpty',
                value: function StringIsNullOrEmpty(value) {
                    return !value;
                } // Collapse the expanded show card and enable rest of the buttons
            },
            {
                key: 'CollapseExpandedShowCardDialog',
                value: function CollapseExpandedShowCardDialog() {
                    if (!this.showCardActionRef) {
                        return;
                    }

                    var mobileShowCardWrapper = document.getElementById(
                        'mobileShowCardWrapper'
                    );
                    mobileShowCardWrapper.innerHTML = '';
                    mobileShowCardWrapper.style.display = 'none';
                    var mobileMailWrapper = document.getElementById(
                        'mobileMailWrapper'
                    );
                    mobileMailWrapper.style.display = null;
                    var buttonsToEnable = document.querySelectorAll(
                        '.ac-pushButton'
                    );

                    if (buttonsToEnable) {
                        Array.prototype.forEach.call(buttonsToEnable, function (
                            button
                        ) {
                            button.disabled = false;

                            if (button.querySelector('#openUrlButton')) {
                                var iconOpenUrl = button.querySelector(
                                    '#iconOpenUrl'
                                );
                                var openUrlDummyIcon = button.querySelector(
                                    '#iconDummyOpenUrl'
                                );
                                openUrlDummyIcon.classList = null;
                                iconOpenUrl.classList = null;

                                if (button.isPrimary) {
                                    // Link icon of white color in case of primary openurl button
                                    iconOpenUrl.classList.add(
                                        'ac-openUrlIconNonPrimary'
                                    );
                                    openUrlDummyIcon.classList.add(
                                        'iconDummyOpenUrlNonPrimary'
                                    );
                                } else {
                                    // Link icon of blue color in case of openurl button with white background
                                    iconOpenUrl.classList.add(
                                        'ac-openUrlIconPrimary'
                                    );
                                    openUrlDummyIcon.classList.add(
                                        'iconDummyOpenUrlPrimary'
                                    );
                                }
                            }
                        });
                    } // Disable the buttons which doesnt meet the required input criterion

                    this.handleInputValueChanged(this.allInputInstances); // Fake the collapse showcard event

                    if (this.showCardActionRef._actionCollection)
                        this.showCardActionRef._actionCollection.collapseExpandedAction();
                    this.showCardActionRef = null;
                } // this function is called by native to store the state of the card just before rotation
                // sample saved sate:
                // {
                //     "InputParameters": {
                //         "choiceinputid": "List 2"
                //     },
                //     "DialogParameters": [
                //         {
                //             "params": "{\"id\":\"choiceinputid\",\"title\":\"Pick a list*\",\"choices\":\"[{\\\"title\\\":\\\"List 1\\\",\\\"value\\\":\\\"List 1\\\"}, {\\\"title\\\":\\\"List 2\\\",\\\"value\\\":\\\"List 2\\\"}]\",\"selectedChoices\":\"[{\\\"title\\\":\\\"List 2\\\",\\\"value\\\":\\\"List 2\\\"}]\",\"isMultiChoice\":\"SINGLE\",\"isRequired\":true}",
                //             "type": "CHOICE_PICKER"
                //         }
                //         ]
                // }
            },
            {
                key: 'onSaveInstanceState',
                value: function onSaveInstanceState(messageId, isShowCard) {
                    var dialogState =
                        arguments.length > 2 && arguments[2] !== undefined
                            ? arguments[2]
                            : null;
                    var key;

                    if (!this.clientManagerInstance.supportSavingState) {
                        return;
                    }

                    var inputs = {};

                    for (key in this.allInputInstances) {
                        var input = this.allInputInstances[key]; // this will be present for text inputs

                        if (input.actualValue) {
                            inputs[input.id] = input.actualValue;
                        } // we store an empty value incase value does not exist because there can be cases when user removes values and then rotate

                        var value = input.value ? input.value : '';
                        inputs[input.id] = value;
                    }

                    var state = {};
                    state[this.constants.InputParameters] = inputs;
                    state[this.constants.DialogParameters] = dialogState;
                    key = isShowCard ? messageId + isShowCard : messageId; // window.localStorage.setItem(key, JSON.stringify(state));
                } // this function is called to restore the state after rotation
            },
            {
                key: 'onRestoreInstanceState',
                value: function onRestoreInstanceState(messageId, isShowCard) {
                    if (!this.clientManagerInstance.supportSavingState) {
                        return;
                    }
                }
            }
        ]);

        return CardRender;
    })();

export default CardRender;
